/******/ (function(modules) { // webpackBootstrap
/******/ 	// install a JSONP callback for chunk loading
/******/ 	var parentJsonpFunction = window["webpackJsonp"];
/******/ 	window["webpackJsonp"] = function webpackJsonpCallback(chunkIds, moreModules, executeModules) {
/******/ 		// add "moreModules" to the modules object,
/******/ 		// then flag all "chunkIds" as loaded and fire callback
/******/ 		var moduleId, chunkId, i = 0, resolves = [], result;
/******/ 		for(;i < chunkIds.length; i++) {
/******/ 			chunkId = chunkIds[i];
/******/ 			if(installedChunks[chunkId]) {
/******/ 				resolves.push(installedChunks[chunkId][0]);
/******/ 			}
/******/ 			installedChunks[chunkId] = 0;
/******/ 		}
/******/ 		for(moduleId in moreModules) {
/******/ 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
/******/ 				modules[moduleId] = moreModules[moduleId];
/******/ 			}
/******/ 		}
/******/ 		if(parentJsonpFunction) parentJsonpFunction(chunkIds, moreModules, executeModules);
/******/ 		while(resolves.length) {
/******/ 			resolves.shift()();
/******/ 		}
/******/ 		if(executeModules) {
/******/ 			for(i=0; i < executeModules.length; i++) {
/******/ 				result = __webpack_require__(__webpack_require__.s = executeModules[i]);
/******/ 			}
/******/ 		}
/******/ 		return result;
/******/ 	};
/******/
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// objects to store loaded and loading chunks
/******/ 	var installedChunks = {
/******/ 		49: 0,
/******/ 		57: 0
/******/ 	};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/ 	// This file contains only the entry chunk.
/******/ 	// The chunk loading function for additional chunks
/******/ 	__webpack_require__.e = function requireEnsure(chunkId) {
/******/ 		var installedChunkData = installedChunks[chunkId];
/******/ 		if(installedChunkData === 0) {
/******/ 			return new Promise(function(resolve) { resolve(); });
/******/ 		}
/******/
/******/ 		// a Promise means "currently loading".
/******/ 		if(installedChunkData) {
/******/ 			return installedChunkData[2];
/******/ 		}
/******/
/******/ 		// setup Promise in chunk cache
/******/ 		var promise = new Promise(function(resolve, reject) {
/******/ 			installedChunkData = installedChunks[chunkId] = [resolve, reject];
/******/ 		});
/******/ 		installedChunkData[2] = promise;
/******/
/******/ 		// start chunk loading
/******/ 		var head = document.getElementsByTagName('head')[0];
/******/ 		var script = document.createElement('script');
/******/ 		script.type = 'text/javascript';
/******/ 		script.charset = 'utf-8';
/******/ 		script.async = true;
/******/ 		script.timeout = 120000;
/******/
/******/ 		if (__webpack_require__.nc) {
/******/ 			script.setAttribute("nonce", __webpack_require__.nc);
/******/ 		}
/******/ 		script.src = __webpack_require__.p + "" + chunkId + "-" + {"0":"bb25bb2a3ceaa46d8f26","1":"16bed07e2b7a566d2ddd","2":"ee0526733161653dcce2","3":"1321c2cecdf4ceac91ce","4":"369eab932ffd59a5586e","5":"94d208f959a4b7b4f553","6":"b913056f9cb452ad8024","7":"a7c2de8cb5b72c8546eb","8":"1e2b657abe8ab542c5fe","9":"bf5d16b0b3c9c7c17579","10":"37fb8ab25bc3b440846d","11":"04f869404c17d90a00cf","12":"9fe159c444f3629b16a7","13":"6683b605e93b86d6c703","14":"e33fbdf102dcf21a0328","15":"66703801f7984da4ccf7","16":"0017b99c99d660e94dc1","17":"b0597d032a4ddae12309","18":"e091a44ed639ce497bec","19":"ad8f2f864b3ed588af19","20":"d38f25063c4edb4c3db3","21":"afac31dd53406e2aca91","22":"5393235346e0a5627dac","23":"3be7bb5ed05f52186085","24":"24affd8ab0e33b76317c","25":"a62860265e1d03b10010","26":"47429345dcb29049ba38","27":"1ec84f9e4c8c1cc47bf5","28":"684ad87e233ec40fd272","29":"4da4d69b15402a125461","30":"6bcb11f62d6b2b347684","31":"dbb37c3cf5f0db9c99d0","32":"cc30cae57a2cf52c1696","33":"63dbf38512261ab490e7","34":"bb24568730c81cddee8a","35":"ec75192ae3347c7d0bb9","36":"63119aa7adbad262b11c","37":"3b4d08bc7dc6824a4d42","38":"e0b9385264b65ee05e4a","39":"5ede8133b11b33b60daa","40":"4f8604224a446337a1c1","41":"dd189e6ba2779e527620","42":"1fcd1ab22397c7207ce3","43":"3167ee8533e9a95d520a","44":"5c1fc2deace93b0fe76a","45":"55ef195fcca46a7cd064","46":"2a1707d1fc031947acfd","47":"8a68a96010e1719d42c9"}[chunkId] + ".js";
/******/ 		var timeout = setTimeout(onScriptComplete, 120000);
/******/ 		script.onerror = script.onload = onScriptComplete;
/******/ 		function onScriptComplete() {
/******/ 			// avoid mem leaks in IE.
/******/ 			script.onerror = script.onload = null;
/******/ 			clearTimeout(timeout);
/******/ 			var chunk = installedChunks[chunkId];
/******/ 			if(chunk !== 0) {
/******/ 				if(chunk) {
/******/ 					chunk[1](new Error('Loading chunk ' + chunkId + ' failed.'));
/******/ 				}
/******/ 				installedChunks[chunkId] = undefined;
/******/ 			}
/******/ 		};
/******/ 		head.appendChild(script);
/******/
/******/ 		return promise;
/******/ 	};
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/assets/packs/";
/******/
/******/ 	// on error function for async loading
/******/ 	__webpack_require__.oe = function(err) { console.error(err); throw err; };
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 26);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["_"] = __webpack_require__(619);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),

/***/ 1007:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery Cookie Plugin v1.4.1
 * https://github.com/carhartl/jquery-cookie
 *
 * Copyright 2013 Klaus Hartl
 * Released under the MIT license
 */
(function (factory) {
	if (true) {
		// AMD
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [__webpack_require__(33)], __WEBPACK_AMD_DEFINE_FACTORY__ = (factory),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else if (typeof exports === 'object') {
		// CommonJS
		factory(require('jquery'));
	} else {
		// Browser globals
		factory(jQuery);
	}
}(function ($) {

	var pluses = /\+/g;

	function encode(s) {
		return config.raw ? s : encodeURIComponent(s);
	}

	function decode(s) {
		return config.raw ? s : decodeURIComponent(s);
	}

	function stringifyCookieValue(value) {
		return encode(config.json ? JSON.stringify(value) : String(value));
	}

	function parseCookieValue(s) {
		if (s.indexOf('"') === 0) {
			// This is a quoted cookie as according to RFC2068, unescape...
			s = s.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, '\\');
		}

		try {
			// Replace server-side written pluses with spaces.
			// If we can't decode the cookie, ignore it, it's unusable.
			// If we can't parse the cookie, ignore it, it's unusable.
			s = decodeURIComponent(s.replace(pluses, ' '));
			return config.json ? JSON.parse(s) : s;
		} catch(e) {}
	}

	function read(s, converter) {
		var value = config.raw ? s : parseCookieValue(s);
		return $.isFunction(converter) ? converter(value) : value;
	}

	var config = $.cookie = function (key, value, options) {

		// Write

		if (value !== undefined && !$.isFunction(value)) {
			options = $.extend({}, config.defaults, options);

			if (typeof options.expires === 'number') {
				var days = options.expires, t = options.expires = new Date();
				t.setTime(+t + days * 864e+5);
			}

			return (document.cookie = [
				encode(key), '=', stringifyCookieValue(value),
				options.expires ? '; expires=' + options.expires.toUTCString() : '', // use expires attribute, max-age is not supported by IE
				options.path    ? '; path=' + options.path : '',
				options.domain  ? '; domain=' + options.domain : '',
				options.secure  ? '; secure' : ''
			].join(''));
		}

		// Read

		var result = key ? undefined : {};

		// To prevent the for loop in the first place assign an empty array
		// in case there are no cookies at all. Also prevents odd result when
		// calling $.cookie().
		var cookies = document.cookie ? document.cookie.split('; ') : [];

		for (var i = 0, l = cookies.length; i < l; i++) {
			var parts = cookies[i].split('=');
			var name = decode(parts.shift());
			var cookie = parts.join('=');

			if (key && key === name) {
				// If second argument (value) is a function it's a converter...
				result = read(cookie, value);
				break;
			}

			// Prevent storing a cookie that we couldn't decode.
			if (!key && (cookie = read(cookie)) !== undefined) {
				result[name] = cookie;
			}
		}

		return result;
	};

	config.defaults = {};

	$.removeCookie = function (key, options) {
		if ($.cookie(key) === undefined) {
			return false;
		}

		// Must not alter options, thus extending a fresh object...
		$.cookie(key, '', $.extend({}, options, { expires: -1 }));
		return !$.cookie(key);
	};

}));


/***/ }),

/***/ 1008:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return rawMapConfig; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return config; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_critical_store__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_underscore__);



var keys = {
  clientId: 'google_maps_client_id',
  apiKey: 'google_maps_api_key',
  version: 'google_maps_version',
  channel: 'google_map_api_channel',
  environment: 'google_maps_environment'
};

var rawMapConfig = __WEBPACK_IMPORTED_MODULE_0_shared_critical_store__["a" /* DataStore */].getData('mapConfiguration');

var getConfig = function getConfig() {
  if (rawMapConfig) return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_underscore__["mapObject"])(keys, function (key) {
    return rawMapConfig[key];
  });
};

var config = getConfig();

/***/ }),

/***/ 1009:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setupLdpClickTracking; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_clicks__ = __webpack_require__(96);


// Bootstrap page specific clicks here if need be before passing off to main click file.

var setupLdpClickTracking = function setupLdpClickTracking(pageStatus) {
  if (!window.rdcTrackingInitialized) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_clicks__["a" /* setupClickTracking */])(pageStatus);
  }
};

/***/ }),

/***/ 1010:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getPageName; });
var getPageName = function getPageName(pageType, propertyStatus) {
  var returnStatusOnly = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var status;
  if (pageType === 'ldp' || pageType === 'ldp-quickview') {
    switch (propertyStatus) {
      case 'for_sale':
        status = 'for_sale';
        break;
      case 'new_community':
        status = 'for_sale';
        break;
      case 'for_rent':
        status = 'for_rent';
        break;
      case 'not_for_sale':
        status = 'not_for_sale';
        break;
      default:
        status = 'for_sale';
        break;
    }
  } else if (pageType === 'bdp') {
    status = 'for_sale';
  }
  return returnStatusOnly ? status : status + ':' + pageType;
};

/***/ }),

/***/ 102:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fireLeadTracking; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__leads__ = __webpack_require__(162);


// All updates here to MOVE_DATA.adobeDTM/leadAdobeDTM/modal here are temporary until migration is done.

// Locations where we need to pass the click tracking tag to the submit btn of the modal itself.

var modalSubmitLocations = ['#request-private-showing', '#gallery_request_more_details', '#secondary_request_more_details_mobile_sticky', '#homes-around-card'];

var fireLeadTracking = function fireLeadTracking($widget, pd, data, ldpPropertyDetails) {

  if (!MOVE_DATA.leadAdobeDTM) {
    MOVE_DATA.leadAdobeDTM = {};
  }
  var leadData = {};
  var leadPlacement = $widget.find(".submit").attr("data-omtrack");

  if (pd.property_type === 'not_for_sale') {
    leadData = prepareSellerLeadTracking(data.lead.id, $widget);
  } else {
    leadData = prepareLeadTracking($widget, data.lead.id, data.lead_value, data.initial_lead_value, pd);
  }

  //setting leadPlacement to adobeDTM object in addition to leadData for now. This is temporary until tracking migration is done.
  if (isValidModalSubmitLocation($widget.selector)) {
    MOVE_DATA.leadAdobeDTM.leadPlacement = MOVE_DATA.adobeDTM.leadCtaClickSource;
    leadData.placementData = MOVE_DATA.adobeDTM.leadCtaClickSource;
  } else if (leadPlacement) {
    MOVE_DATA.leadAdobeDTM.leadPlacement = leadPlacement;
    leadData.placementData = leadPlacement;
  }
  //Updates the leadAdobeDTM object. This will be removed when tracking migration is complete.
  MOVE.Helper.updateOmnitureLeadJson(leadData);

  var additionalData = { productType: MOVE_DATA.adobeDTM.productType, rentalDataSource: MOVE_DATA.adobeDTM.dataSourceType || 'unknown' };
  var trackingData = Object.assign({}, ldpPropertyDetails || pd, leadData, additionalData);

  if (pd.is_nearby_home_card) {
    //nearby property cards need to submit lead info about the property itself instead of the LDP property
    Object.assign(trackingData, pd);
  }

  //LGWEB-834: Image CTR
  MOVE_DATA.leadAdobeDTM.imageSwapped = MOVE_DATA.qv_imgctr_swapped;
  //END

  __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__leads__["b" /* trackLead */])(trackingData);
};

var isValidModalSubmitLocation = function isValidModalSubmitLocation(selector) {
  var isValid = false;
  if (MOVE_DATA.adobeDTM.leadCtaClickSource) {
    modalSubmitLocations.forEach(function (id) {
      if (selector.includes(id)) {
        isValid = true;
      }
    });
  }
  return isValid;
};

var prepareSellerLeadTracking = function prepareSellerLeadTracking(guid, $widget) {
  // Prepare lead tracking object with the guid returned from LCS
  var agentSelectionsCt = $widget.find('.js-seller-agent:checked').length;
  var selectedSellerAgents = $widget.find('.js-seller-agent:checked').closest('.seller-enabled-lead-form');
  var leadJson = {
    leadGuid: guid,
    selectionsCt: agentSelectionsCt,
    listing_advertiser_ids: mapDataAttrForSellerLead(selectedSellerAgents, 'data-advertiserID'),
    selAgentPosition: mapDataAttrForSellerLead(selectedSellerAgents, 'data-selPosition'),
    roleType: MOVE_DATA.adobeDTM.roleType,
    paidType: MOVE_DATA.adobeDTM.roleType.length ? 'paid' : 'courtesy'
  };
  leadJson = $.extend(leadJson, addABTestAttributes($widget));
  return leadJson;
};

var prepareLeadTracking = function prepareLeadTracking($widget, leadGuid, leadValue, initialLeadValue, pd) {
  var moveInDate = $widget.find("input[name='leads_form_data[move_in_date]']").val() || '';
  var leadAdditions = moveInDate !== '' ? 'move' : '';
  var leadCreditScore = pd.creditScore;
  leadAdditions = leadAdditions || pd.isMilitaryChecked ? 'military' : 'rcm';

  if ($("#primary_lead_register").prop('checked')) {
    leadAdditions = leadAdditions === "" ? "marketing" : leadAdditions + ",marketing";
  }
  return { leadGuid: leadGuid,
    moveInDate: moveInDate,
    leadAdditions: leadAdditions,
    leadCreditScore: leadCreditScore,
    leadValue: leadValue,
    initialLeadValue: initialLeadValue
  };
};

var mapDataAttrForSellerLead = function mapDataAttrForSellerLead(selectedSellerAgents, dataAttr) {
  return selectedSellerAgents.map(function () {
    return $(this).attr(dataAttr);
  }).get().join();
};

// Add additional attributes related to A/B test for NFS lead form
var addABTestAttributes = function addABTestAttributes($widget) {
  var $sellDateSelectBox = $widget.find('.js-sell-date');
  var $homeOwnerCheckBox = $widget.find('.js-home-owner-option input:radio:checked');
  var leadJson = {};
  if ($sellDateSelectBox.find('option').length === 7 || $homeOwnerCheckBox.length > 0) {
    // Variation 1 -- Add not home owner option to dropdown
    if ($sellDateSelectBox.find('option').length === 7) {
      leadJson.lookingToSell = $sellDateSelectBox.val();
      leadJson.homeOwner = $sellDateSelectBox.val() !== 'I am not the Homeowner';
    } else {
      // Variation 2 -- Add radio button for home owner
      var isHomeOwner = $homeOwnerCheckBox.val() === 'home-owner';
      leadJson.lookingToSell = isHomeOwner ? $sellDateSelectBox.val() : '';
      leadJson.homeOwner = isHomeOwner;
    }
  }
  // for control
  else {
      leadJson.lookingToSell = $sellDateSelectBox.val();
      leadJson.homeOwner = 'unknown';
    }
  return leadJson;
};

/***/ }),

/***/ 1024:
/***/ (function(module, exports, __webpack_require__) {

/* global __webpack_require__ */
// patch for dynamic imports

var hasProtocol = function hasProtocol(host) {
  return (/^http/i.test(host)
  );
};

if (MOVE_DATA.assetHost) {
  // patch for sandboxes
  var protocol = window.location.protocol,
      assetHost = hasProtocol(MOVE_DATA.assetHost) ? MOVE_DATA.assetHost : protocol + "//" + MOVE_DATA.assetHost,
      assetPath = __webpack_require__.p;
  __webpack_require__.p = assetHost + assetPath;
}

/***/ }),

/***/ 1027:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export detectInstantApp */
/*global google*/

var IA_SCRIPT = "https://www.gstatic.com/instantapps/js/1/library.js";

var detectInstantApp = function detectInstantApp(loadScript) {
  if (window.sessionStorage && !window.sessionStorage.getItem('iaFlag')) {
    loadScript(IA_SCRIPT).then(
    // If script loads successfully, still need to try catch the response from the provided function.
    function () {
      try {
        google.aia.classifyVisitor(function (res) {
          idInstantApp((!!res.eligible).toString());
        });
      } catch (e) {
        idInstantApp('scriptFailed');
      }
    },
    // If script fails to load, trigger fail tracking response.
    function () {
      idInstantApp('scriptFailed');
    });
  }
};

var idInstantApp = function idInstantApp(instantAppEligibilityFlag) {
  if (window.RdcTracking) {
    window.RdcTracking.trackEvent('instantAppEligibilityFlagEvent', { instantAppEligibilityFlag: instantAppEligibilityFlag });
  }
  if (instantAppEligibilityFlag !== 'scriptFailed' && window.sessionStorage) {
    window.sessionStorage.setItem('iaFlag', true);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (detectInstantApp);

/***/ }),

/***/ 1196:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["$"] = __webpack_require__(1233);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),

/***/ 123:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BLANK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return COMMA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return QUESTION_MARK; });
var BLANK = '';
var COMMA = ',';
var QUESTION_MARK = '?';

/***/ }),

/***/ 1233:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v2.2.4
 * http://jquery.com/
 *
 * Includes Sizzle.js
 * http://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2016-05-20T17:23Z
 */

(function( global, factory ) {

	if ( typeof module === "object" && typeof module.exports === "object" ) {
		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket #14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
}(typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Support: Firefox 18+
// Can't be in strict mode, several libs including ASP.NET trace
// the stack via arguments.caller.callee and Firefox dies if
// you try to trace through "use strict" call chains. (#13335)
//"use strict";
var arr = [];

var document = window.document;

var slice = arr.slice;

var concat = arr.concat;

var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var support = {};



var
	version = "2.2.4",

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	},

	// Support: Android<4.1
	// Make sure we trim BOM and NBSP
	rtrim = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g,

	// Matches dashed string for camelizing
	rmsPrefix = /^-ms-/,
	rdashAlpha = /-([\da-z])/gi,

	// Used by jQuery.camelCase as callback to replace()
	fcamelCase = function( all, letter ) {
		return letter.toUpperCase();
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// Start with an empty selector
	selector: "",

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {
		return num != null ?

			// Return just the one element from the set
			( num < 0 ? this[ num + this.length ] : this[ num ] ) :

			// Return all the elements in a clean array
			slice.call( this );
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;
		ret.context = this.context;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !jQuery.isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				src = target[ name ];
				copy = options[ name ];

				// Prevent never-ending loop
				if ( target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = jQuery.isArray( copy ) ) ) ) {

					if ( copyIsArray ) {
						copyIsArray = false;
						clone = src && jQuery.isArray( src ) ? src : [];

					} else {
						clone = src && jQuery.isPlainObject( src ) ? src : {};
					}

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isFunction: function( obj ) {
		return jQuery.type( obj ) === "function";
	},

	isArray: Array.isArray,

	isWindow: function( obj ) {
		return obj != null && obj === obj.window;
	},

	isNumeric: function( obj ) {

		// parseFloat NaNs numeric-cast false positives (null|true|false|"")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		// adding 1 corrects loss of precision from parseFloat (#15100)
		var realStringObj = obj && obj.toString();
		return !jQuery.isArray( obj ) && ( realStringObj - parseFloat( realStringObj ) + 1 ) >= 0;
	},

	isPlainObject: function( obj ) {
		var key;

		// Not plain objects:
		// - Any object or value whose internal [[Class]] property is not "[object Object]"
		// - DOM nodes
		// - window
		if ( jQuery.type( obj ) !== "object" || obj.nodeType || jQuery.isWindow( obj ) ) {
			return false;
		}

		// Not own constructor property must be Object
		if ( obj.constructor &&
				!hasOwn.call( obj, "constructor" ) &&
				!hasOwn.call( obj.constructor.prototype || {}, "isPrototypeOf" ) ) {
			return false;
		}

		// Own properties are enumerated firstly, so to speed up,
		// if last one is own, then all properties are own
		for ( key in obj ) {}

		return key === undefined || hasOwn.call( obj, key );
	},

	isEmptyObject: function( obj ) {
		var name;
		for ( name in obj ) {
			return false;
		}
		return true;
	},

	type: function( obj ) {
		if ( obj == null ) {
			return obj + "";
		}

		// Support: Android<4.0, iOS<6 (functionish RegExp)
		return typeof obj === "object" || typeof obj === "function" ?
			class2type[ toString.call( obj ) ] || "object" :
			typeof obj;
	},

	// Evaluates a script in a global context
	globalEval: function( code ) {
		var script,
			indirect = eval;

		code = jQuery.trim( code );

		if ( code ) {

			// If the code includes a valid, prologue position
			// strict mode pragma, execute code by injecting a
			// script tag into the document.
			if ( code.indexOf( "use strict" ) === 1 ) {
				script = document.createElement( "script" );
				script.text = code;
				document.head.appendChild( script ).parentNode.removeChild( script );
			} else {

				// Otherwise, avoid the DOM node creation, insertion
				// and removal by using an indirect global eval

				indirect( code );
			}
		}
	},

	// Convert dashed to camelCase; used by the css and data modules
	// Support: IE9-11+
	// Microsoft forgot to hump their vendor prefix (#9572)
	camelCase: function( string ) {
		return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
	},

	nodeName: function( elem, name ) {
		return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},

	// Support: Android<4.1
	trim: function( text ) {
		return text == null ?
			"" :
			( text + "" ).replace( rtrim, "" );
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
					[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return concat.apply( [], ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// Bind a function to a context, optionally partially applying any
	// arguments.
	proxy: function( fn, context ) {
		var tmp, args, proxy;

		if ( typeof context === "string" ) {
			tmp = fn[ context ];
			context = fn;
			fn = tmp;
		}

		// Quick check to determine if target is callable, in the spec
		// this throws a TypeError, but we will just return undefined.
		if ( !jQuery.isFunction( fn ) ) {
			return undefined;
		}

		// Simulated bind
		args = slice.call( arguments, 2 );
		proxy = function() {
			return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
		};

		// Set the guid of unique handler to the same of original handler, so it can be removed
		proxy.guid = fn.guid = fn.guid || jQuery.guid++;

		return proxy;
	},

	now: Date.now,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

// JSHint would error on this code due to the Symbol not being defined in ES5.
// Defining this global in .jshintrc would create a danger of using the global
// unguarded in another place, it seems safer to just disable JSHint for these
// three lines.
/* jshint ignore: start */
if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}
/* jshint ignore: end */

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
function( i, name ) {
	class2type[ "[object " + name + "]" ] = name.toLowerCase();
} );

function isArrayLike( obj ) {

	// Support: iOS 8.2 (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = jQuery.type( obj );

	if ( type === "function" || jQuery.isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}
var Sizzle =
/*!
 * Sizzle CSS Selector Engine v2.2.1
 * http://sizzlejs.com/
 *
 * Copyright jQuery Foundation and other contributors
 * Released under the MIT license
 * http://jquery.org/license
 *
 * Date: 2015-10-17
 */
(function( window ) {

var i,
	support,
	Expr,
	getText,
	isXML,
	tokenize,
	compile,
	select,
	outermostContext,
	sortInput,
	hasDuplicate,

	// Local document vars
	setDocument,
	document,
	docElem,
	documentIsHTML,
	rbuggyQSA,
	rbuggyMatches,
	matches,
	contains,

	// Instance-specific data
	expando = "sizzle" + 1 * new Date(),
	preferredDoc = window.document,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	// General-purpose constants
	MAX_NEGATIVE = 1 << 31,

	// Instance methods
	hasOwn = ({}).hasOwnProperty,
	arr = [],
	pop = arr.pop,
	push_native = arr.push,
	push = arr.push,
	slice = arr.slice,
	// Use a stripped-down indexOf as it's faster than native
	// http://jsperf.com/thor-indexof-vs-for/5
	indexOf = function( list, elem ) {
		var i = 0,
			len = list.length;
		for ( ; i < len; i++ ) {
			if ( list[i] === elem ) {
				return i;
			}
		}
		return -1;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// http://www.w3.org/TR/css3-selectors/#whitespace
	whitespace = "[\\x20\\t\\r\\n\\f]",

	// http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	identifier = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",

	// Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +
		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
		"*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +
		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),
	rtrim = new RegExp( "^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rcombinators = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*" ),

	rattributeQuotes = new RegExp( "=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		"ID": new RegExp( "^#(" + identifier + ")" ),
		"CLASS": new RegExp( "^\\.(" + identifier + ")" ),
		"TAG": new RegExp( "^(" + identifier + "|[*])" ),
		"ATTR": new RegExp( "^" + attributes ),
		"PSEUDO": new RegExp( "^" + pseudos ),
		"CHILD": new RegExp( "^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
			"*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
			"*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		"bool": new RegExp( "^(?:" + booleans + ")$", "i" ),
		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		"needsContext": new RegExp( "^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
			whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	rnative = /^[^{]+\{\s*\[native \w/,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,
	rescape = /'|\\/g,

	// CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig" ),
	funescape = function( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox<24
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			high < 0 ?
				// BMP codepoint
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes
	// See setDocument()
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE
	unloadHandler = function() {
		setDocument();
	};

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		(arr = slice.call( preferredDoc.childNodes )),
		preferredDoc.childNodes
	);
	// Support: Android<4.0
	// Detect silently failing push.apply
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = { apply: arr.length ?

		// Leverage slice if possible
		function( target, els ) {
			push_native.apply( target, slice.call(els) );
		} :

		// Support: IE<9
		// Otherwise append directly
		function( target, els ) {
			var j = target.length,
				i = 0;
			// Can't trust NodeList.length
			while ( (target[j++] = els[i++]) ) {}
			target.length = j - 1;
		}
	};
}

function Sizzle( selector, context, results, seed ) {
	var m, i, elem, nid, nidselect, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {

		if ( ( context ? context.ownerDocument || context : preferredDoc ) !== document ) {
			setDocument( context );
		}
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && (match = rquickExpr.exec( selector )) ) {

				// ID selector
				if ( (m = match[1]) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( (elem = context.getElementById( m )) ) {

							// Support: IE, Opera, Webkit
							// TODO: identify versions
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								results.push( elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE, Opera, Webkit
						// TODO: identify versions
						// getElementById can match elements by name instead of ID
						if ( newContext && (elem = newContext.getElementById( m )) &&
							contains( context, elem ) &&
							elem.id === m ) {

							results.push( elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[2] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( (m = match[3]) && support.getElementsByClassName &&
					context.getElementsByClassName ) {

					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( support.qsa &&
				!compilerCache[ selector + " " ] &&
				(!rbuggyQSA || !rbuggyQSA.test( selector )) ) {

				if ( nodeType !== 1 ) {
					newContext = context;
					newSelector = selector;

				// qSA looks outside Element context, which is not what we want
				// Thanks to Andrew Dupont for this workaround technique
				// Support: IE <=8
				// Exclude object elements
				} else if ( context.nodeName.toLowerCase() !== "object" ) {

					// Capture the context ID, setting it first if necessary
					if ( (nid = context.getAttribute( "id" )) ) {
						nid = nid.replace( rescape, "\\$&" );
					} else {
						context.setAttribute( "id", (nid = expando) );
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					nidselect = ridentifier.test( nid ) ? "#" + nid : "[id='" + nid + "']";
					while ( i-- ) {
						groups[i] = nidselect + " " + toSelector( groups[i] );
					}
					newSelector = groups.join( "," );

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;
				}

				if ( newSelector ) {
					try {
						push.apply( results,
							newContext.querySelectorAll( newSelector )
						);
						return results;
					} catch ( qsaError ) {
					} finally {
						if ( nid === expando ) {
							context.removeAttribute( "id" );
						}
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrim, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {
		// Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {
			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return (cache[ key + " " ] = value);
	}
	return cache;
}

/**
 * Mark a function for special use by Sizzle
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created div and expects a boolean result
 */
function assert( fn ) {
	var div = document.createElement("div");

	try {
		return !!fn( div );
	} catch (e) {
		return false;
	} finally {
		// Remove from its parent by default
		if ( div.parentNode ) {
			div.parentNode.removeChild( div );
		}
		// release memory in IE
		div = null;
	}
}

/**
 * Adds the same handler for all of the specified attrs
 * @param {String} attrs Pipe-separated list of attributes
 * @param {Function} handler The method that will be applied
 */
function addHandle( attrs, handler ) {
	var arr = attrs.split("|"),
		i = arr.length;

	while ( i-- ) {
		Expr.attrHandle[ arr[i] ] = handler;
	}
}

/**
 * Checks document order of two siblings
 * @param {Element} a
 * @param {Element} b
 * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
 */
function siblingCheck( a, b ) {
	var cur = b && a,
		diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
			( ~b.sourceIndex || MAX_NEGATIVE ) -
			( ~a.sourceIndex || MAX_NEGATIVE );

	// Use IE sourceIndex if available on both nodes
	if ( diff ) {
		return diff;
	}

	// Check if b follows a
	if ( cur ) {
		while ( (cur = cur.nextSibling) ) {
			if ( cur === b ) {
				return -1;
			}
		}
	}

	return a ? 1 : -1;
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return name === "input" && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		var name = elem.nodeName.toLowerCase();
		return (name === "input" || name === "button") && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction(function( argument ) {
		argument = +argument;
		return markFunction(function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ (j = matchIndexes[i]) ] ) {
					seed[j] = !(matches[j] = seed[j]);
				}
			}
		});
	});
}

/**
 * Checks a node for validity as a Sizzle context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

// Expose support vars for convenience
support = Sizzle.support = {};

/**
 * Detects XML nodes
 * @param {Element|Object} elem An element or a document
 * @returns {Boolean} True iff elem is a non-HTML XML node
 */
isXML = Sizzle.isXML = function( elem ) {
	// documentElement is verified for cases where it doesn't yet exist
	// (such as loading iframes in IE - #4833)
	var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	return documentElement ? documentElement.nodeName !== "HTML" : false;
};

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [doc] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
setDocument = Sizzle.setDocument = function( node ) {
	var hasCompare, parent,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	if ( doc === document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	docElem = document.documentElement;
	documentIsHTML = !isXML( document );

	// Support: IE 9-11, Edge
	// Accessing iframe documents after unload throws "permission denied" errors (jQuery #13936)
	if ( (parent = document.defaultView) && parent.top !== parent ) {
		// Support: IE 11
		if ( parent.addEventListener ) {
			parent.addEventListener( "unload", unloadHandler, false );

		// Support: IE 9 - 10 only
		} else if ( parent.attachEvent ) {
			parent.attachEvent( "onunload", unloadHandler );
		}
	}

	/* Attributes
	---------------------------------------------------------------------- */

	// Support: IE<8
	// Verify that getAttribute really returns attributes and not properties
	// (excepting IE8 booleans)
	support.attributes = assert(function( div ) {
		div.className = "i";
		return !div.getAttribute("className");
	});

	/* getElement(s)By*
	---------------------------------------------------------------------- */

	// Check if getElementsByTagName("*") returns only elements
	support.getElementsByTagName = assert(function( div ) {
		div.appendChild( document.createComment("") );
		return !div.getElementsByTagName("*").length;
	});

	// Support: IE<9
	support.getElementsByClassName = rnative.test( document.getElementsByClassName );

	// Support: IE<10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert(function( div ) {
		docElem.appendChild( div ).id = expando;
		return !document.getElementsByName || !document.getElementsByName( expando ).length;
	});

	// ID find and filter
	if ( support.getById ) {
		Expr.find["ID"] = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var m = context.getElementById( id );
				return m ? [ m ] : [];
			}
		};
		Expr.filter["ID"] = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute("id") === attrId;
			};
		};
	} else {
		// Support: IE6/7
		// getElementById is not reliable as a find shortcut
		delete Expr.find["ID"];

		Expr.filter["ID"] =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode("id");
				return node && node.value === attrId;
			};
		};
	}

	// Tag
	Expr.find["TAG"] = support.getElementsByTagName ?
		function( tag, context ) {
			if ( typeof context.getElementsByTagName !== "undefined" ) {
				return context.getElementsByTagName( tag );

			// DocumentFragment nodes don't have gEBTN
			} else if ( support.qsa ) {
				return context.querySelectorAll( tag );
			}
		} :

		function( tag, context ) {
			var elem,
				tmp = [],
				i = 0,
				// By happy coincidence, a (broken) gEBTN appears on DocumentFragment nodes too
				results = context.getElementsByTagName( tag );

			// Filter out possible comments
			if ( tag === "*" ) {
				while ( (elem = results[i++]) ) {
					if ( elem.nodeType === 1 ) {
						tmp.push( elem );
					}
				}

				return tmp;
			}
			return results;
		};

	// Class
	Expr.find["CLASS"] = support.getElementsByClassName && function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	// matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	rbuggyMatches = [];

	// qSa(:focus) reports false when true (Chrome 21)
	// We allow this because of a bug in IE8/9 that throws an error
	// whenever `document.activeElement` is accessed on an iframe
	// So, we allow :focus to pass through QSA all the time to avoid the IE error
	// See http://bugs.jquery.com/ticket/13378
	rbuggyQSA = [];

	if ( (support.qsa = rnative.test( document.querySelectorAll )) ) {
		// Build QSA regex
		// Regex strategy adopted from Diego Perini
		assert(function( div ) {
			// Select is set to empty string on purpose
			// This is to test IE's treatment of not explicitly
			// setting a boolean content attribute,
			// since its presence should be enough
			// http://bugs.jquery.com/ticket/12359
			docElem.appendChild( div ).innerHTML = "<a id='" + expando + "'></a>" +
				"<select id='" + expando + "-\r\\' msallowcapture=''>" +
				"<option selected=''></option></select>";

			// Support: IE8, Opera 11-12.16
			// Nothing should be selected when empty strings follow ^= or $= or *=
			// The test attribute must be unknown in Opera but "safe" for WinRT
			// http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
			if ( div.querySelectorAll("[msallowcapture^='']").length ) {
				rbuggyQSA.push( "[*^$]=" + whitespace + "*(?:''|\"\")" );
			}

			// Support: IE8
			// Boolean attributes and "value" are not treated correctly
			if ( !div.querySelectorAll("[selected]").length ) {
				rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
			}

			// Support: Chrome<29, Android<4.4, Safari<7.0+, iOS<7.0+, PhantomJS<1.9.8+
			if ( !div.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
				rbuggyQSA.push("~=");
			}

			// Webkit/Opera - :checked should return selected option elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":checked").length ) {
				rbuggyQSA.push(":checked");
			}

			// Support: Safari 8+, iOS 8+
			// https://bugs.webkit.org/show_bug.cgi?id=136851
			// In-page `selector#id sibing-combinator selector` fails
			if ( !div.querySelectorAll( "a#" + expando + "+*" ).length ) {
				rbuggyQSA.push(".#.+[+~]");
			}
		});

		assert(function( div ) {
			// Support: Windows 8 Native Apps
			// The type and name attributes are restricted during .innerHTML assignment
			var input = document.createElement("input");
			input.setAttribute( "type", "hidden" );
			div.appendChild( input ).setAttribute( "name", "D" );

			// Support: IE8
			// Enforce case-sensitivity of name attribute
			if ( div.querySelectorAll("[name=d]").length ) {
				rbuggyQSA.push( "name" + whitespace + "*[*^$|!~]?=" );
			}

			// FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
			// IE8 throws error here and will not see later tests
			if ( !div.querySelectorAll(":enabled").length ) {
				rbuggyQSA.push( ":enabled", ":disabled" );
			}

			// Opera 10-11 does not throw on post-comma invalid pseudos
			div.querySelectorAll("*,:x");
			rbuggyQSA.push(",.*:");
		});
	}

	if ( (support.matchesSelector = rnative.test( (matches = docElem.matches ||
		docElem.webkitMatchesSelector ||
		docElem.mozMatchesSelector ||
		docElem.oMatchesSelector ||
		docElem.msMatchesSelector) )) ) {

		assert(function( div ) {
			// Check to see if it's possible to do matchesSelector
			// on a disconnected node (IE 9)
			support.disconnectedMatch = matches.call( div, "div" );

			// This should fail with an exception
			// Gecko does not error, returns false instead
			matches.call( div, "[s!='']:x" );
			rbuggyMatches.push( "!=", pseudos );
		});
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join("|") );
	rbuggyMatches = rbuggyMatches.length && new RegExp( rbuggyMatches.join("|") );

	/* Contains
	---------------------------------------------------------------------- */
	hasCompare = rnative.test( docElem.compareDocumentPosition );

	// Element contains another
	// Purposefully self-exclusive
	// As in, an element does not contain itself
	contains = hasCompare || rnative.test( docElem.contains ) ?
		function( a, b ) {
			var adown = a.nodeType === 9 ? a.documentElement : a,
				bup = b && b.parentNode;
			return a === bup || !!( bup && bup.nodeType === 1 && (
				adown.contains ?
					adown.contains( bup ) :
					a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
			));
		} :
		function( a, b ) {
			if ( b ) {
				while ( (b = b.parentNode) ) {
					if ( b === a ) {
						return true;
					}
				}
			}
			return false;
		};

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = hasCompare ?
	function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		compare = ( a.ownerDocument || a ) === ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			(!support.sortDetached && b.compareDocumentPosition( a ) === compare) ) {

			// Choose the first element that is related to our preferred document
			if ( a === document || a.ownerDocument === preferredDoc && contains(preferredDoc, a) ) {
				return -1;
			}
			if ( b === document || b.ownerDocument === preferredDoc && contains(preferredDoc, b) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	} :
	function( a, b ) {
		// Exit early if the nodes are identical
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		var cur,
			i = 0,
			aup = a.parentNode,
			bup = b.parentNode,
			ap = [ a ],
			bp = [ b ];

		// Parentless nodes are either documents or disconnected
		if ( !aup || !bup ) {
			return a === document ? -1 :
				b === document ? 1 :
				aup ? -1 :
				bup ? 1 :
				sortInput ?
				( indexOf( sortInput, a ) - indexOf( sortInput, b ) ) :
				0;

		// If the nodes are siblings, we can do a quick check
		} else if ( aup === bup ) {
			return siblingCheck( a, b );
		}

		// Otherwise we need full lists of their ancestors for comparison
		cur = a;
		while ( (cur = cur.parentNode) ) {
			ap.unshift( cur );
		}
		cur = b;
		while ( (cur = cur.parentNode) ) {
			bp.unshift( cur );
		}

		// Walk down the tree looking for a discrepancy
		while ( ap[i] === bp[i] ) {
			i++;
		}

		return i ?
			// Do a sibling check if the nodes have a common ancestor
			siblingCheck( ap[i], bp[i] ) :

			// Otherwise nodes in our document sort first
			ap[i] === preferredDoc ? -1 :
			bp[i] === preferredDoc ? 1 :
			0;
	};

	return document;
};

Sizzle.matches = function( expr, elements ) {
	return Sizzle( expr, null, null, elements );
};

Sizzle.matchesSelector = function( elem, expr ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	// Make sure that attribute selectors are quoted
	expr = expr.replace( rattributeQuotes, "='$1']" );

	if ( support.matchesSelector && documentIsHTML &&
		!compilerCache[ expr + " " ] &&
		( !rbuggyMatches || !rbuggyMatches.test( expr ) ) &&
		( !rbuggyQSA     || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||
					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch (e) {}
	}

	return Sizzle( expr, document, null, [ elem ] ).length > 0;
};

Sizzle.contains = function( context, elem ) {
	// Set document vars if needed
	if ( ( context.ownerDocument || context ) !== document ) {
		setDocument( context );
	}
	return contains( context, elem );
};

Sizzle.attr = function( elem, name ) {
	// Set document vars if needed
	if ( ( elem.ownerDocument || elem ) !== document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],
		// Don't get fooled by Object.prototype properties (jQuery #13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	return val !== undefined ?
		val :
		support.attributes || !documentIsHTML ?
			elem.getAttribute( name ) :
			(val = elem.getAttributeNode(name)) && val.specified ?
				val.value :
				null;
};

Sizzle.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
Sizzle.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	hasDuplicate = !support.detectDuplicates;
	sortInput = !support.sortStable && results.slice( 0 );
	results.sort( sortOrder );

	if ( hasDuplicate ) {
		while ( (elem = results[i++]) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			results.splice( duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

/**
 * Utility function for retrieving the text value of an array of DOM nodes
 * @param {Array|Element} elem
 */
getText = Sizzle.getText = function( elem ) {
	var node,
		ret = "",
		i = 0,
		nodeType = elem.nodeType;

	if ( !nodeType ) {
		// If no nodeType, this is expected to be an array
		while ( (node = elem[i++]) ) {
			// Do not traverse comment nodes
			ret += getText( node );
		}
	} else if ( nodeType === 1 || nodeType === 9 || nodeType === 11 ) {
		// Use textContent for elements
		// innerText usage removed for consistency of new lines (jQuery #11153)
		if ( typeof elem.textContent === "string" ) {
			return elem.textContent;
		} else {
			// Traverse its children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				ret += getText( elem );
			}
		}
	} else if ( nodeType === 3 || nodeType === 4 ) {
		return elem.nodeValue;
	}
	// Do not include comment or processing instruction nodes

	return ret;
};

Expr = Sizzle.selectors = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		"ATTR": function( match ) {
			match[1] = match[1].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[3] = ( match[3] || match[4] || match[5] || "" ).replace( runescape, funescape );

			if ( match[2] === "~=" ) {
				match[3] = " " + match[3] + " ";
			}

			return match.slice( 0, 4 );
		},

		"CHILD": function( match ) {
			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[1] = match[1].toLowerCase();

			if ( match[1].slice( 0, 3 ) === "nth" ) {
				// nth-* requires argument
				if ( !match[3] ) {
					Sizzle.error( match[0] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[4] = +( match[4] ? match[5] + (match[6] || 1) : 2 * ( match[3] === "even" || match[3] === "odd" ) );
				match[5] = +( ( match[7] + match[8] ) || match[3] === "odd" );

			// other types prohibit arguments
			} else if ( match[3] ) {
				Sizzle.error( match[0] );
			}

			return match;
		},

		"PSEUDO": function( match ) {
			var excess,
				unquoted = !match[6] && match[2];

			if ( matchExpr["CHILD"].test( match[0] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[3] ) {
				match[2] = match[4] || match[5] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&
				// Get excess from tokenize (recursively)
				(excess = tokenize( unquoted, true )) &&
				// advance to the next closing parenthesis
				(excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length) ) {

				// excess is a negative index
				match[0] = match[0].slice( 0, excess );
				match[2] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		"TAG": function( nodeNameSelector ) {
			var nodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() { return true; } :
				function( elem ) {
					return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
				};
		},

		"CLASS": function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				(pattern = new RegExp( "(^|" + whitespace + ")" + className + "(" + whitespace + "|$)" )) &&
				classCache( className, function( elem ) {
					return pattern.test( typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "" );
				});
		},

		"ATTR": function( name, operator, check ) {
			return function( elem ) {
				var result = Sizzle.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				return operator === "=" ? result === check :
					operator === "!=" ? result !== check :
					operator === "^=" ? check && result.indexOf( check ) === 0 :
					operator === "*=" ? check && result.indexOf( check ) > -1 :
					operator === "$=" ? check && result.slice( -check.length ) === check :
					operator === "~=" ? ( " " + result.replace( rwhitespace, " " ) + " " ).indexOf( check ) > -1 :
					operator === "|=" ? result === check || result.slice( 0, check.length + 1 ) === check + "-" :
					false;
			};
		},

		"CHILD": function( type, what, argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, context, xml ) {
					var cache, uniqueCache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( (node = node[ dir ]) ) {
									if ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) {

										return false;
									}
								}
								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index

							// ...in a gzip-friendly way
							node = parent;
							outerCache = node[ expando ] || (node[ expando ] = {});

							// Support: IE <9 only
							// Defend against cloned attroperties (jQuery gh-1709)
							uniqueCache = outerCache[ node.uniqueID ] ||
								(outerCache[ node.uniqueID ] = {});

							cache = uniqueCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( (node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								(diff = nodeIndex = 0) || start.pop()) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									uniqueCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {
							// Use previously-cached element index if available
							if ( useCache ) {
								// ...in a gzip-friendly way
								node = elem;
								outerCache = node[ expando ] || (node[ expando ] = {});

								// Support: IE <9 only
								// Defend against cloned attroperties (jQuery gh-1709)
								uniqueCache = outerCache[ node.uniqueID ] ||
									(outerCache[ node.uniqueID ] = {});

								cache = uniqueCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {
								// Use the same loop as above to seek `elem` from the start
								while ( (node = ++nodeIndex && node && node[ dir ] ||
									(diff = nodeIndex = 0) || start.pop()) ) {

									if ( ( ofType ?
										node.nodeName.toLowerCase() === name :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] || (node[ expando ] = {});

											// Support: IE <9 only
											// Defend against cloned attroperties (jQuery gh-1709)
											uniqueCache = outerCache[ node.uniqueID ] ||
												(outerCache[ node.uniqueID ] = {});

											uniqueCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		"PSEUDO": function( pseudo, argument ) {
			// pseudo-class names are case-insensitive
			// http://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					Sizzle.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as Sizzle does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction(function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf( seed, matched[i] );
							seed[ idx ] = !( matches[ idx ] = matched[i] );
						}
					}) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {
		// Potentially complex pseudos
		"not": markFunction(function( selector ) {
			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrim, "$1" ) );

			return matcher[ expando ] ?
				markFunction(function( seed, matches, context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( (elem = unmatched[i]) ) {
							seed[i] = !(matches[i] = elem);
						}
					}
				}) :
				function( elem, context, xml ) {
					input[0] = elem;
					matcher( input, null, xml, results );
					// Don't keep the element (issue #299)
					input[0] = null;
					return !results.pop();
				};
		}),

		"has": markFunction(function( selector ) {
			return function( elem ) {
				return Sizzle( selector, elem ).length > 0;
			};
		}),

		"contains": markFunction(function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || elem.innerText || getText( elem ) ).indexOf( text ) > -1;
			};
		}),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// http://www.w3.org/TR/selectors/#lang-pseudo
		"lang": markFunction( function( lang ) {
			// lang value must be a valid identifier
			if ( !ridentifier.test(lang || "") ) {
				Sizzle.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( (elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute("xml:lang") || elem.getAttribute("lang")) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( (elem = elem.parentNode) && elem.nodeType === 1 );
				return false;
			};
		}),

		// Miscellaneous
		"target": function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		"root": function( elem ) {
			return elem === docElem;
		},

		"focus": function( elem ) {
			return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
		},

		// Boolean properties
		"enabled": function( elem ) {
			return elem.disabled === false;
		},

		"disabled": function( elem ) {
			return elem.disabled === true;
		},

		"checked": function( elem ) {
			// In CSS3, :checked should return both checked and selected elements
			// http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			var nodeName = elem.nodeName.toLowerCase();
			return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
		},

		"selected": function( elem ) {
			// Accessing this property makes selected-by-default
			// options in Safari work properly
			if ( elem.parentNode ) {
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		"empty": function( elem ) {
			// http://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		"parent": function( elem ) {
			return !Expr.pseudos["empty"]( elem );
		},

		// Element/input types
		"header": function( elem ) {
			return rheader.test( elem.nodeName );
		},

		"input": function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		"button": function( elem ) {
			var name = elem.nodeName.toLowerCase();
			return name === "input" && elem.type === "button" || name === "button";
		},

		"text": function( elem ) {
			var attr;
			return elem.nodeName.toLowerCase() === "input" &&
				elem.type === "text" &&

				// Support: IE<8
				// New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
				( (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		"first": createPositionalPseudo(function() {
			return [ 0 ];
		}),

		"last": createPositionalPseudo(function( matchIndexes, length ) {
			return [ length - 1 ];
		}),

		"eq": createPositionalPseudo(function( matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		}),

		"even": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"odd": createPositionalPseudo(function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"lt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		}),

		"gt": createPositionalPseudo(function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		})
	}
};

Expr.pseudos["nth"] = Expr.pseudos["eq"];

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

tokenize = Sizzle.tokenize = function( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || (match = rcomma.exec( soFar )) ) {
			if ( match ) {
				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[0].length ) || soFar;
			}
			groups.push( (tokens = []) );
		}

		matched = false;

		// Combinators
		if ( (match = rcombinators.exec( soFar )) ) {
			matched = match.shift();
			tokens.push({
				value: matched,
				// Cast descendant combinators to space
				type: match[0].replace( rtrim, " " )
			});
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( (match = matchExpr[ type ].exec( soFar )) && (!preFilters[ type ] ||
				(match = preFilters[ type ]( match ))) ) {
				matched = match.shift();
				tokens.push({
					value: matched,
					type: type,
					matches: match
				});
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	return parseOnly ?
		soFar.length :
		soFar ?
			Sizzle.error( selector ) :
			// Cache the tokens
			tokenCache( selector, groups ).slice( 0 );
};

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[i].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		checkNonElements = base && dir === "parentNode",
		doneName = done++;

	return combinator.first ?
		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( (elem = elem[ dir ]) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, uniqueCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( (elem = elem[ dir ]) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || (elem[ expando ] = {});

						// Support: IE <9 only
						// Defend against cloned attroperties (jQuery gh-1709)
						uniqueCache = outerCache[ elem.uniqueID ] || (outerCache[ elem.uniqueID ] = {});

						if ( (oldCache = uniqueCache[ dir ]) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return (newCache[ 2 ] = oldCache[ 2 ]);
						} else {
							// Reuse newcache so results back-propagate to previous elements
							uniqueCache[ dir ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( (newCache[ 2 ] = matcher( elem, context, xml )) ) {
								return true;
							}
						}
					}
				}
			}
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[i]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[0];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		Sizzle( selector, contexts[i], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( (elem = unmatched[i]) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction(function( seed, results, context, xml ) {
		var temp, i, elem,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed || multipleContexts( selector || "*", context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems,

			matcherOut = matcher ?
				// If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
				postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

					// ...intermediate processing is necessary
					[] :

					// ...otherwise use results directly
					results :
				matcherIn;

		// Find primary matches
		if ( matcher ) {
			matcher( matcherIn, matcherOut, context, xml );
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( (elem = temp[i]) ) {
					matcherOut[ postMap[i] ] = !(matcherIn[ postMap[i] ] = elem);
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {
					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( (elem = matcherOut[i]) ) {
							// Restore matcherIn since elem is not yet a final match
							temp.push( (matcherIn[i] = elem) );
						}
					}
					postFinder( null, (matcherOut = []), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( (elem = matcherOut[i]) &&
						(temp = postFinder ? indexOf( seed, elem ) : preMap[i]) > -1 ) {

						seed[temp] = !(results[temp] = elem);
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	});
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[0].type ],
		implicitRelative = leadingRelative || Expr.relative[" "],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {
			var ret = ( !leadingRelative && ( xml || context !== outermostContext ) ) || (
				(checkContext = context).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );
			// Avoid hanging onto element (issue #299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( (matcher = Expr.relative[ tokens[i].type ]) ) {
			matchers = [ addCombinator(elementMatcher( matchers ), matcher) ];
		} else {
			matcher = Expr.filter[ tokens[i].type ].apply( null, tokens[i].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {
				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[j].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(
						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 ).concat({ value: tokens[ i - 2 ].type === " " ? "*" : "" })
					).replace( rtrim, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( (tokens = tokens.slice( j )) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,
				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find["TAG"]( "*", outermost ),
				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
				len = elems.length;

			if ( outermost ) {
				outermostContext = context === document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: IE<9, Safari
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
			for ( ; i !== len && (elem = elems[i]) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;
					if ( !context && elem.ownerDocument !== document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( (matcher = elementMatchers[j++]) ) {
						if ( matcher( elem, context || document, xml) ) {
							results.push( elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {
					// They will have gone through all possible matchers
					if ( (elem = !matcher && elem) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( (matcher = setMatchers[j++]) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {
					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !(unmatched[i] || setMatched[i]) ) {
								setMatched[i] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					Sizzle.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

compile = Sizzle.compile = function( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {
		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[i] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector, matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
};

/**
 * A low-level selection function that works with Sizzle's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with Sizzle.compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
select = Sizzle.select = function( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( (selector = compiled.selector || selector) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[0] = match[0].slice( 0 );
		if ( tokens.length > 2 && (token = tokens[0]).type === "ID" &&
				support.getById && context.nodeType === 9 && documentIsHTML &&
				Expr.relative[ tokens[1].type ] ) {

			context = ( Expr.find["ID"]( token.matches[0].replace(runescape, funescape), context ) || [] )[0];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr["needsContext"].test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[i];

			// Abort if we hit a combinator
			if ( Expr.relative[ (type = token.type) ] ) {
				break;
			}
			if ( (find = Expr.find[ type ]) ) {
				// Search, expanding context for leading sibling combinators
				if ( (seed = find(
					token.matches[0].replace( runescape, funescape ),
					rsibling.test( tokens[0].type ) && testContext( context.parentNode ) || context
				)) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
};

// One-time assignments

// Sort stability
support.sortStable = expando.split("").sort( sortOrder ).join("") === expando;

// Support: Chrome 14-35+
// Always assume duplicates if they aren't passed to the comparison function
support.detectDuplicates = !!hasDuplicate;

// Initialize against the default document
setDocument();

// Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert(function( div1 ) {
	// Should return 1, but returns 4 (following)
	return div1.compareDocumentPosition( document.createElement("div") ) & 1;
});

// Support: IE<8
// Prevent attribute/property "interpolation"
// http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
if ( !assert(function( div ) {
	div.innerHTML = "<a href='#'></a>";
	return div.firstChild.getAttribute("href") === "#" ;
}) ) {
	addHandle( "type|href|height|width", function( elem, name, isXML ) {
		if ( !isXML ) {
			return elem.getAttribute( name, name.toLowerCase() === "type" ? 1 : 2 );
		}
	});
}

// Support: IE<9
// Use defaultValue in place of getAttribute("value")
if ( !support.attributes || !assert(function( div ) {
	div.innerHTML = "<input/>";
	div.firstChild.setAttribute( "value", "" );
	return div.firstChild.getAttribute( "value" ) === "";
}) ) {
	addHandle( "value", function( elem, name, isXML ) {
		if ( !isXML && elem.nodeName.toLowerCase() === "input" ) {
			return elem.defaultValue;
		}
	});
}

// Support: IE<9
// Use getAttributeNode to fetch booleans when getAttribute lies
if ( !assert(function( div ) {
	return div.getAttribute("disabled") == null;
}) ) {
	addHandle( booleans, function( elem, name, isXML ) {
		var val;
		if ( !isXML ) {
			return elem[ name ] === true ? name.toLowerCase() :
					(val = elem.getAttributeNode( name )) && val.specified ?
					val.value :
				null;
		}
	});
}

return Sizzle;

})( window );



jQuery.find = Sizzle;
jQuery.expr = Sizzle.selectors;
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.uniqueSort = jQuery.unique = Sizzle.uniqueSort;
jQuery.text = Sizzle.getText;
jQuery.isXMLDoc = Sizzle.isXML;
jQuery.contains = Sizzle.contains;



var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = ( /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/ );



var risSimple = /^.[^:#\[\.,]*$/;

// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( jQuery.isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			/* jshint -W018 */
			return !!qualifier.call( elem, i, elem ) !== not;
		} );

	}

	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );

	}

	if ( typeof qualifier === "string" ) {
		if ( risSimple.test( qualifier ) ) {
			return jQuery.filter( qualifier, elements, not );
		}

		qualifier = jQuery.filter( qualifier, elements );
	}

	return jQuery.grep( elements, function( elem ) {
		return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
	} );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	return elems.length === 1 && elem.nodeType === 1 ?
		jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [] :
		jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
			return elem.nodeType === 1;
		} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i,
			len = this.length,
			ret = [],
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		// Needed because $( selector, context ) becomes $( context ).find( selector )
		ret = this.pushStack( len > 1 ? jQuery.unique( ret ) : ret );
		ret.selector = this.selector ? this.selector + " " + selector : selector;
		return ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (#9521)
	// Strict HTML recognition (#11290: must start with <)
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]*))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( jQuery.isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					// Support: Blackberry 4.6
					// gEBID returns nodes no longer in the document (#6963)
					if ( elem && elem.parentNode ) {

						// Inject the element directly into the jQuery object
						this.length = 1;
						this[ 0 ] = elem;
					}

					this.context = document;
					this.selector = selector;
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this.context = this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( jQuery.isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		if ( selector.selector !== undefined ) {
			this.selector = selector.selector;
			this.context = selector.context;
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			pos = rneedsContext.test( selectors ) || typeof selectors !== "string" ?
				jQuery( selectors, context || this.context ) :
				0;

		for ( ; i < l; i++ ) {
			for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

				// Always skip document fragments
				if ( cur.nodeType < 11 && ( pos ?
					pos.index( cur ) > -1 :

					// Don't pass non-elements to Sizzle
					cur.nodeType === 1 &&
						jQuery.find.matchesSelector( cur, selectors ) ) ) {

					matched.push( cur );
					break;
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		return elem.contentDocument || jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnotwhite = ( /\S+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnotwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( jQuery.isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && jQuery.type( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, listener list, final state
				[ "resolve", "done", jQuery.Callbacks( "once memory" ), "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ), "rejected" ],
				[ "notify", "progress", jQuery.Callbacks( "memory" ) ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				then: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;
					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( i, tuple ) {
							var fn = jQuery.isFunction( fns[ i ] ) && fns[ i ];

							// deferred[ done | fail | progress ] for forwarding actions to newDefer
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && jQuery.isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this === promise ? newDefer.promise() : this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Keep pipe for back-compat
		promise.pipe = promise.then;

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 3 ];

			// promise[ done | fail | progress ] = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add( function() {

					// state = [ resolved | rejected ]
					state = stateString;

				// [ reject_list | resolve_list ].disable; progress_list.lock
				}, tuples[ i ^ 1 ][ 2 ].disable, tuples[ 2 ][ 2 ].lock );
			}

			// deferred[ resolve | reject | notify ]
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? promise : this, arguments );
				return this;
			};
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( subordinate /* , ..., subordinateN */ ) {
		var i = 0,
			resolveValues = slice.call( arguments ),
			length = resolveValues.length,

			// the count of uncompleted subordinates
			remaining = length !== 1 ||
				( subordinate && jQuery.isFunction( subordinate.promise ) ) ? length : 0,

			// the master Deferred.
			// If resolveValues consist of only a single Deferred, just use that.
			deferred = remaining === 1 ? subordinate : jQuery.Deferred(),

			// Update function for both resolve and progress values
			updateFunc = function( i, contexts, values ) {
				return function( value ) {
					contexts[ i ] = this;
					values[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( values === progressValues ) {
						deferred.notifyWith( contexts, values );
					} else if ( !( --remaining ) ) {
						deferred.resolveWith( contexts, values );
					}
				};
			},

			progressValues, progressContexts, resolveContexts;

		// Add listeners to Deferred subordinates; treat others as resolved
		if ( length > 1 ) {
			progressValues = new Array( length );
			progressContexts = new Array( length );
			resolveContexts = new Array( length );
			for ( ; i < length; i++ ) {
				if ( resolveValues[ i ] && jQuery.isFunction( resolveValues[ i ].promise ) ) {
					resolveValues[ i ].promise()
						.progress( updateFunc( i, progressContexts, progressValues ) )
						.done( updateFunc( i, resolveContexts, resolveValues ) )
						.fail( deferred.reject );
				} else {
					--remaining;
				}
			}
		}

		// If we're not waiting on anything, resolve the master
		if ( !remaining ) {
			deferred.resolveWith( resolveContexts, resolveValues );
		}

		return deferred.promise();
	}
} );


// The deferred used on DOM ready
var readyList;

jQuery.fn.ready = function( fn ) {

	// Add the callback
	jQuery.ready.promise().done( fn );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See #6781
	readyWait: 1,

	// Hold (or release) the ready event
	holdReady: function( hold ) {
		if ( hold ) {
			jQuery.readyWait++;
		} else {
			jQuery.ready( true );
		}
	},

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );

		// Trigger any bound ready events
		if ( jQuery.fn.triggerHandler ) {
			jQuery( document ).triggerHandler( "ready" );
			jQuery( document ).off( "ready" );
		}
	}
} );

/**
 * The ready event handler and self cleanup method
 */
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

jQuery.ready.promise = function( obj ) {
	if ( !readyList ) {

		readyList = jQuery.Deferred();

		// Catch cases where $(document).ready() is called
		// after the browser event has already occurred.
		// Support: IE9-10 only
		// Older IE sometimes signals "interactive" too soon
		if ( document.readyState === "complete" ||
			( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

			// Handle it asynchronously to allow scripts the opportunity to delay ready
			window.setTimeout( jQuery.ready );

		} else {

			// Use the handy event callback
			document.addEventListener( "DOMContentLoaded", completed );

			// A fallback to window.onload, that will always work
			window.addEventListener( "load", completed );
		}
	}
	return readyList.promise( obj );
};

// Kick off the DOM ready check even if the user does not
jQuery.ready.promise();




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( jQuery.type( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !jQuery.isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
					value :
					value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	return chainable ?
		elems :

		// Gets
		bulk ?
			fn.call( elems ) :
			len ? fn( elems[ 0 ], key ) : emptyGet;
};
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	/* jshint -W018 */
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	register: function( owner, initial ) {
		var value = initial || {};

		// If it is a node unlikely to be stringify-ed or looped over
		// use plain assignment
		if ( owner.nodeType ) {
			owner[ this.expando ] = value;

		// Otherwise secure it in a non-enumerable, non-writable property
		// configurability must be true to allow the property to be
		// deleted with the delete operator
		} else {
			Object.defineProperty( owner, this.expando, {
				value: value,
				writable: true,
				configurable: true
			} );
		}
		return owner[ this.expando ];
	},
	cache: function( owner ) {

		// We can accept data for non-element nodes in modern browsers,
		// but we should not, see #8335.
		// Always return an empty object.
		if ( !acceptData( owner ) ) {
			return {};
		}

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see #8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		if ( typeof data === "string" ) {
			cache[ data ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ prop ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :
			owner[ this.expando ] && owner[ this.expando ][ key ];
	},
	access: function( owner, key, value ) {
		var stored;

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			stored = this.get( owner, key );

			return stored !== undefined ?
				stored : this.get( owner, jQuery.camelCase( key ) );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i, name, camel,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key === undefined ) {
			this.register( owner );

		} else {

			// Support array or space separated string of keys
			if ( jQuery.isArray( key ) ) {

				// If "name" is an array of keys...
				// When data is initially created, via ("key", "val") signature,
				// keys will be converted to camelCase.
				// Since there is no way to tell _how_ a key was added, remove
				// both plain key and camelCase key. #12786
				// This will only penalize the array argument path.
				name = key.concat( key.map( jQuery.camelCase ) );
			} else {
				camel = jQuery.camelCase( key );

				// Try the string as a key before any manipulation
				if ( key in cache ) {
					name = [ key, camel ];
				} else {

					// If a key with the spaces exists, use it.
					// Otherwise, create an array by matching non-whitespace
					name = camel;
					name = name in cache ?
						[ name ] : ( name.match( rnotwhite ) || [] );
				}
			}

			i = name.length;

			while ( i-- ) {
				delete cache[ name[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <= 35-45+
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://code.google.com/p/chromium/issues/detail?id=378607
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = data === "true" ? true :
					data === "false" ? false :
					data === "null" ? null :

					// Only convert to a number if it doesn't change the string
					+data + "" === data ? +data :
					rbrace.test( data ) ? jQuery.parseJSON( data ) :
					data;
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE11+
						// The attrs elements can be null (#14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = jQuery.camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data, camelKey;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// with the key as-is
				data = dataUser.get( elem, key ) ||

					// Try to find dashed key if it exists (gh-2779)
					// This is for 2.2.x only
					dataUser.get( elem, key.replace( rmultiDash, "-$&" ).toLowerCase() );

				if ( data !== undefined ) {
					return data;
				}

				camelKey = jQuery.camelCase( key );

				// Attempt to get data from the cache
				// with the key camelized
				data = dataUser.get( elem, camelKey );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, camelKey, undefined );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			camelKey = jQuery.camelCase( key );
			this.each( function() {

				// First, attempt to store a copy or reference of any
				// data that might've been store with a camelCased key.
				var data = dataUser.get( this, camelKey );

				// For HTML5 data-* attribute interop, we have to
				// store property names with dashes in a camelCase form.
				// This might not apply to all properties...*
				dataUser.set( this, camelKey, value );

				// *... In the case of properties that might _actually_
				// have dashes, we need to also store a copy of that
				// unchanged property.
				if ( key.indexOf( "-" ) > -1 && data !== undefined ) {
					dataUser.set( this, key, value );
				}
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || jQuery.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var isHidden = function( elem, el ) {

		// isHidden might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;
		return jQuery.css( elem, "display" ) === "none" ||
			!jQuery.contains( elem.ownerDocument, elem );
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted,
		scale = 1,
		maxIterations = 20,
		currentValue = tween ?
			function() { return tween.cur(); } :
			function() { return jQuery.css( elem, prop, "" ); },
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = ( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		do {

			// If previous iteration zeroed out, double until we get *something*.
			// Use string for doubling so we don't accidentally see scale as unchanged below
			scale = scale || ".5";

			// Adjust and apply
			initialInUnit = initialInUnit / scale;
			jQuery.style( elem, prop, initialInUnit + unit );

		// Update scale, tolerating zero or NaN from tween.cur()
		// Break the loop if scale is unchanged or perfect, or if we've just had enough.
		} while (
			scale !== ( scale = currentValue() / initial ) && scale !== 1 && --maxIterations
		);
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([\w:-]+)/ );

var rscriptType = ( /^$|\/(?:java|ecma)script/i );



// We have to close these tags to support XHTML (#13200)
var wrapMap = {

	// Support: IE9
	option: [ 1, "<select multiple='multiple'>", "</select>" ],

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

// Support: IE9
wrapMap.optgroup = wrapMap.option;

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;


function getAll( context, tag ) {

	// Support: IE9-11+
	// Use typeof to avoid zero-argument method invocation on host objects (#15151)
	var ret = typeof context.getElementsByTagName !== "undefined" ?
			context.getElementsByTagName( tag || "*" ) :
			typeof context.querySelectorAll !== "undefined" ?
				context.querySelectorAll( tag || "*" ) :
			[];

	return tag === undefined || tag && jQuery.nodeName( context, tag ) ?
		jQuery.merge( [ context ], ret ) :
		ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, contains, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( jQuery.type( elem ) === "object" ) {

				// Support: Android<4.1, PhantomJS<2
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android<4.1, PhantomJS<2
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (#12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		contains = jQuery.contains( elem.ownerDocument, elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( contains ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0-4.3, Safari<=5.1
	// Check state lost if the name is set (#11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (#14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Safari<=5.1, Android<4.2
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE<=11+
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;
} )();


var
	rkeyEvent = /^key/,
	rmouseEvent = /^(?:mouse|pointer|contextmenu|drag|drop)|click/,
	rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

// Support: IE9
// See #13393 for more info
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Don't attach events to noData or text/comment nodes (but allow plain objects)
		if ( !elemData ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = {};
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnotwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( event ) {

		// Make a writable jQuery.Event from the native event object
		event = jQuery.event.fix( event );

		var i, j, ret, matched, handleObj,
			handlerQueue = [],
			args = slice.call( arguments ),
			handlers = ( dataPriv.get( this, "events" ) || {} )[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;
		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// Triggered event must either 1) have no namespace, or 2) have namespace(s)
				// a subset or equal to those in the bound event (both can have no namespace).
				if ( !event.rnamespace || event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, matches, sel, handleObj,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Support (at least): Chrome, IE9
		// Find delegate handlers
		// Black-hole SVG <use> instance trees (#13180)
		//
		// Support: Firefox<=42+
		// Avoid non-left-click in FF but don't block IE radio events (#3861, gh-2343)
		if ( delegateCount && cur.nodeType &&
			( event.type !== "click" || isNaN( event.button ) || event.button < 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (#13208)
				// Don't process clicks on disabled elements (#6911, #8165, #11382, #11764)
				if ( cur.nodeType === 1 && ( cur.disabled !== true || event.type !== "click" ) ) {
					matches = [];
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (#13203)
						sel = handleObj.selector + " ";

						if ( matches[ sel ] === undefined ) {
							matches[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matches[ sel ] ) {
							matches.push( handleObj );
						}
					}
					if ( matches.length ) {
						handlerQueue.push( { elem: cur, handlers: matches } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: this, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	// Includes some event props shared by KeyEvent and MouseEvent
	props: ( "altKey bubbles cancelable ctrlKey currentTarget detail eventPhase " +
		"metaKey relatedTarget shiftKey target timeStamp view which" ).split( " " ),

	fixHooks: {},

	keyHooks: {
		props: "char charCode key keyCode".split( " " ),
		filter: function( event, original ) {

			// Add which for key events
			if ( event.which == null ) {
				event.which = original.charCode != null ? original.charCode : original.keyCode;
			}

			return event;
		}
	},

	mouseHooks: {
		props: ( "button buttons clientX clientY offsetX offsetY pageX pageY " +
			"screenX screenY toElement" ).split( " " ),
		filter: function( event, original ) {
			var eventDoc, doc, body,
				button = original.button;

			// Calculate pageX/Y if missing and clientX/Y available
			if ( event.pageX == null && original.clientX != null ) {
				eventDoc = event.target.ownerDocument || document;
				doc = eventDoc.documentElement;
				body = eventDoc.body;

				event.pageX = original.clientX +
					( doc && doc.scrollLeft || body && body.scrollLeft || 0 ) -
					( doc && doc.clientLeft || body && body.clientLeft || 0 );
				event.pageY = original.clientY +
					( doc && doc.scrollTop  || body && body.scrollTop  || 0 ) -
					( doc && doc.clientTop  || body && body.clientTop  || 0 );
			}

			// Add which for click: 1 === left; 2 === middle; 3 === right
			// Note: button is not normalized, so don't use it
			if ( !event.which && button !== undefined ) {
				event.which = ( button & 1 ? 1 : ( button & 2 ? 3 : ( button & 4 ? 2 : 0 ) ) );
			}

			return event;
		}
	},

	fix: function( event ) {
		if ( event[ jQuery.expando ] ) {
			return event;
		}

		// Create a writable copy of the event object and normalize some properties
		var i, prop, copy,
			type = event.type,
			originalEvent = event,
			fixHook = this.fixHooks[ type ];

		if ( !fixHook ) {
			this.fixHooks[ type ] = fixHook =
				rmouseEvent.test( type ) ? this.mouseHooks :
				rkeyEvent.test( type ) ? this.keyHooks :
				{};
		}
		copy = fixHook.props ? this.props.concat( fixHook.props ) : this.props;

		event = new jQuery.Event( originalEvent );

		i = copy.length;
		while ( i-- ) {
			prop = copy[ i ];
			event[ prop ] = originalEvent[ prop ];
		}

		// Support: Cordova 2.5 (WebKit) (#13255)
		// All events should have a target; Cordova deviceready doesn't
		if ( !event.target ) {
			event.target = document;
		}

		// Support: Safari 6.0+, Chrome<28
		// Target should not be a text node (#504, #13143)
		if ( event.target.nodeType === 3 ) {
			event.target = event.target.parentNode;
		}

		return fixHook.filter ? fixHook.filter( event, originalEvent ) : event;
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		focus: {

			// Fire native event if possible so blur/focus sequence is correct
			trigger: function() {
				if ( this !== safeActiveElement() && this.focus ) {
					this.focus();
					return false;
				}
			},
			delegateType: "focusin"
		},
		blur: {
			trigger: function() {
				if ( this === safeActiveElement() && this.blur ) {
					this.blur();
					return false;
				}
			},
			delegateType: "focusout"
		},
		click: {

			// For checkbox, fire native event so checked state will be right
			trigger: function() {
				if ( this.type === "checkbox" && this.click && jQuery.nodeName( this, "input" ) ) {
					this.click();
					return false;
				}
			},

			// For cross-browser consistency, don't fire native .click() on links
			_default: function( event ) {
				return jQuery.nodeName( event.target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android<4.0
				src.returnValue === false ?
			returnTrue :
			returnFalse;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || jQuery.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// http://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://code.google.com/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {
	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var
	rxhtmlTag = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi,

	// Support: IE 10-11, Edge 10240+
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
	rscriptTypeMasked = /^true\/(.*)/,
	rcleanScript = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;

// Manipulating tables requires a tbody
function manipulationTarget( elem, content ) {
	return jQuery.nodeName( elem, "table" ) &&
		jQuery.nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ?

		elem.getElementsByTagName( "tbody" )[ 0 ] ||
			elem.appendChild( elem.ownerDocument.createElement( "tbody" ) ) :
		elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	var match = rscriptTypeMasked.exec( elem.type );

	if ( match ) {
		elem.type = match[ 1 ];
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, pdataCur, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.access( src );
		pdataCur = dataPriv.set( dest, pdataOld );
		events = pdataOld.events;

		if ( events ) {
			delete pdataCur.handle;
			pdataCur.events = {};

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = concat.apply( [], args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		isFunction = jQuery.isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( isFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( isFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (#8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android<4.1, PhantomJS<2
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Reenable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl ) {
								jQuery._evalUrl( node.src );
							}
						} else {
							jQuery.globalEval( node.textContent.replace( rcleanScript, "" ) );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && jQuery.contains( node.ownerDocument, node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html.replace( rxhtmlTag, "<$1></$2>" );
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = jQuery.contains( elem.ownerDocument, elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew Sizzle here for performance reasons: http://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <= 35-45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <= 35-45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {

	// Keep domManip exposed until 3.0 (gh-2225)
	domManip: domManip,

	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: QtWebKit
			// .get() because push.apply(_, arraylike) throws
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );


var iframe,
	elemdisplay = {

		// Support: Firefox
		// We have to pre-define these values for FF (#10227)
		HTML: "block",
		BODY: "block"
	};

/**
 * Retrieve the actual display of a element
 * @param {String} name nodeName of the element
 * @param {Object} doc Document object
 */

// Called only from within defaultDisplay
function actualDisplay( name, doc ) {
	var elem = jQuery( doc.createElement( name ) ).appendTo( doc.body ),

		display = jQuery.css( elem[ 0 ], "display" );

	// We don't have any data stored on the element,
	// so use "detach" method as fast way to get rid of the element
	elem.detach();

	return display;
}

/**
 * Try to determine the default display value of an element
 * @param {String} nodeName
 */
function defaultDisplay( nodeName ) {
	var doc = document,
		display = elemdisplay[ nodeName ];

	if ( !display ) {
		display = actualDisplay( nodeName, doc );

		// If the simple way fails, read from inside an iframe
		if ( display === "none" || !display ) {

			// Use the already-created iframe if possible
			iframe = ( iframe || jQuery( "<iframe frameborder='0' width='0' height='0'/>" ) )
				.appendTo( doc.documentElement );

			// Always write a new HTML skeleton so Webkit and Firefox don't choke on reuse
			doc = iframe[ 0 ].contentDocument;

			// Support: IE
			doc.write();
			doc.close();

			display = actualDisplay( nodeName, doc );
			iframe.detach();
		}

		// Store the correct default display
		elemdisplay[ nodeName ] = display;
	}

	return display;
}
var rmargin = ( /^margin/ );

var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var getStyles = function( elem ) {

		// Support: IE<=11+, Firefox<=30+ (#15098, #14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback, args ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.apply( elem, args || [] );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var documentElement = document.documentElement;



( function() {
	var pixelPositionVal, boxSizingReliableVal, pixelMarginRightVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE9-11+
	// Style of cloned element affects source element cloned (#8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	container.style.cssText = "border:0;width:8px;height:0;top:0;left:-9999px;" +
		"padding:0;margin-top:1px;position:absolute";
	container.appendChild( div );

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {
		div.style.cssText =

			// Support: Firefox<29, Android 2.3
			// Vendor-prefix box-sizing
			"-webkit-box-sizing:border-box;-moz-box-sizing:border-box;box-sizing:border-box;" +
			"position:relative;display:block;" +
			"margin:auto;border:1px;padding:1px;" +
			"top:1%;width:50%";
		div.innerHTML = "";
		documentElement.appendChild( container );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";
		reliableMarginLeftVal = divStyle.marginLeft === "2px";
		boxSizingReliableVal = divStyle.width === "4px";

		// Support: Android 4.0 - 4.3 only
		// Some styles come back with percentage values, even though they shouldn't
		div.style.marginRight = "50%";
		pixelMarginRightVal = divStyle.marginRight === "4px";

		documentElement.removeChild( container );
	}

	jQuery.extend( support, {
		pixelPosition: function() {

			// This test is executed only once but we still do memoizing
			// since we can use the boxSizingReliable pre-computing.
			// No need to check if the test was already performed, though.
			computeStyleTests();
			return pixelPositionVal;
		},
		boxSizingReliable: function() {
			if ( boxSizingReliableVal == null ) {
				computeStyleTests();
			}
			return boxSizingReliableVal;
		},
		pixelMarginRight: function() {

			// Support: Android 4.0-4.3
			// We're checking for boxSizingReliableVal here instead of pixelMarginRightVal
			// since that compresses better and they're computed together anyway.
			if ( boxSizingReliableVal == null ) {
				computeStyleTests();
			}
			return pixelMarginRightVal;
		},
		reliableMarginLeft: function() {

			// Support: IE <=8 only, Android 4.0 - 4.3 only, Firefox <=3 - 37
			if ( boxSizingReliableVal == null ) {
				computeStyleTests();
			}
			return reliableMarginLeftVal;
		},
		reliableMarginRight: function() {

			// Support: Android 2.3
			// Check if div with explicit width and no margin-right incorrectly
			// gets computed margin-right based on width of container. (#3333)
			// WebKit Bug 13343 - getComputedStyle returns wrong value for margin-right
			// This support function is only executed once so no memoizing is needed.
			var ret,
				marginDiv = div.appendChild( document.createElement( "div" ) );

			// Reset CSS: box-sizing; display; margin; border; padding
			marginDiv.style.cssText = div.style.cssText =

				// Support: Android 2.3
				// Vendor-prefix box-sizing
				"-webkit-box-sizing:content-box;box-sizing:content-box;" +
				"display:block;margin:0;border:0;padding:0";
			marginDiv.style.marginRight = marginDiv.style.width = "0";
			div.style.width = "1px";
			documentElement.appendChild( container );

			ret = !parseFloat( window.getComputedStyle( marginDiv ).marginRight );

			documentElement.removeChild( container );
			div.removeChild( marginDiv );

			return ret;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		style = elem.style;

	computed = computed || getStyles( elem );
	ret = computed ? computed.getPropertyValue( name ) || computed[ name ] : undefined;

	// Support: Opera 12.1x only
	// Fall back to style even without computed
	// computed is undefined for elems on document fragments
	if ( ( ret === "" || ret === undefined ) && !jQuery.contains( elem.ownerDocument, elem ) ) {
		ret = jQuery.style( elem, name );
	}

	// Support: IE9
	// getPropertyValue is only needed for .css('filter') (#12537)
	if ( computed ) {

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// http://dev.w3.org/csswg/cssom/#resolved-values
		if ( !support.pixelMarginRight() && rnumnonpx.test( ret ) && rmargin.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE9-11+
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,

	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	},

	cssPrefixes = [ "Webkit", "O", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style;

// Return a css property mapped to a potentially vendor prefixed property
function vendorPropName( name ) {

	// Shortcut for names that are not vendor prefixed
	if ( name in emptyStyle ) {
		return name;
	}

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

function setPositiveNumber( elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function augmentWidthOrHeight( elem, name, extra, isBorderBox, styles ) {
	var i = extra === ( isBorderBox ? "border" : "content" ) ?

		// If we already have the right measurement, avoid augmentation
		4 :

		// Otherwise initialize for horizontal or vertical properties
		name === "width" ? 1 : 0,

		val = 0;

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin, so add it if we want it
		if ( extra === "margin" ) {
			val += jQuery.css( elem, extra + cssExpand[ i ], true, styles );
		}

		if ( isBorderBox ) {

			// border-box includes padding, so remove it if we want content
			if ( extra === "content" ) {
				val -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// At this point, extra isn't border nor margin, so remove border
			if ( extra !== "margin" ) {
				val -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		} else {

			// At this point, extra isn't content, so add padding
			val += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// At this point, extra isn't content nor padding, so add border
			if ( extra !== "padding" ) {
				val += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	return val;
}

function getWidthOrHeight( elem, name, extra ) {

	// Start with offset property, which is equivalent to the border-box value
	var valueIsBorderBox = true,
		val = name === "width" ? elem.offsetWidth : elem.offsetHeight,
		styles = getStyles( elem ),
		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

	// Some non-html elements return undefined for offsetWidth, so check for null/undefined
	// svg - https://bugzilla.mozilla.org/show_bug.cgi?id=649285
	// MathML - https://bugzilla.mozilla.org/show_bug.cgi?id=491668
	if ( val <= 0 || val == null ) {

		// Fall back to computed then uncomputed css if necessary
		val = curCSS( elem, name, styles );
		if ( val < 0 || val == null ) {
			val = elem.style[ name ];
		}

		// Computed unit is not pixels. Stop here and return.
		if ( rnumnonpx.test( val ) ) {
			return val;
		}

		// Check for style in case a browser which returns unreliable values
		// for getComputedStyle silently falls back to the reliable elem.style
		valueIsBorderBox = isBorderBox &&
			( support.boxSizingReliable() || val === elem.style[ name ] );

		// Normalize "", auto, and prepare for extra
		val = parseFloat( val ) || 0;
	}

	// Use the active box-sizing model to add/subtract irrelevant styles
	return ( val +
		augmentWidthOrHeight(
			elem,
			name,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles
		)
	) + "px";
}

function showHide( elements, show ) {
	var display, elem, hidden,
		values = [],
		index = 0,
		length = elements.length;

	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		values[ index ] = dataPriv.get( elem, "olddisplay" );
		display = elem.style.display;
		if ( show ) {

			// Reset the inline display of this element to learn if it is
			// being hidden by cascaded rules or not
			if ( !values[ index ] && display === "none" ) {
				elem.style.display = "";
			}

			// Set elements which have been overridden with display: none
			// in a stylesheet to whatever the default browser style is
			// for such an element
			if ( elem.style.display === "" && isHidden( elem ) ) {
				values[ index ] = dataPriv.access(
					elem,
					"olddisplay",
					defaultDisplay( elem.nodeName )
				);
			}
		} else {
			hidden = isHidden( elem );

			if ( display !== "none" || !hidden ) {
				dataPriv.set(
					elem,
					"olddisplay",
					hidden ? display : jQuery.css( elem, "display" )
				);
			}
		}
	}

	// Set the display of most of the elements in a second loop
	// to avoid the constant reflow
	for ( index = 0; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}
		if ( !show || elem.style.display === "none" || elem.style.display === "" ) {
			elem.style.display = show ? values[ index ] || "" : "none";
		}
	}

	return elements;
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		"animationIterationCount": true,
		"columnCount": true,
		"fillOpacity": true,
		"flexGrow": true,
		"flexShrink": true,
		"fontWeight": true,
		"lineHeight": true,
		"opacity": true,
		"order": true,
		"orphans": true,
		"widows": true,
		"zIndex": true,
		"zoom": true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {
		"float": "cssFloat"
	},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = jQuery.camelCase( name ),
			style = elem.style;

		name = jQuery.cssProps[ origName ] ||
			( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (#7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug #9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (#7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			if ( type === "number" ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// Support: IE9-11+
			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				style[ name ] = value;
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = jQuery.camelCase( name );

		// Make sure that we're working with the right name
		name = jQuery.cssProps[ origName ] ||
			( jQuery.cssProps[ origName ] = vendorPropName( origName ) || origName );

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}
		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( i, name ) {
	jQuery.cssHooks[ name ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&
					elem.offsetWidth === 0 ?
						swap( elem, cssShow, function() {
							return getWidthOrHeight( elem, name, extra );
						} ) :
						getWidthOrHeight( elem, name, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = extra && getStyles( elem ),
				subtract = extra && augmentWidthOrHeight(
					elem,
					name,
					extra,
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
					styles
				);

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ name ] = value;
				value = jQuery.css( elem, name );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
				) + "px";
		}
	}
);

// Support: Android 2.3
jQuery.cssHooks.marginRight = addGetHookIf( support.reliableMarginRight,
	function( elem, computed ) {
		if ( computed ) {
			return swap( elem, { "display": "inline-block" },
				curCSS, [ elem, "marginRight" ] );
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( !rmargin.test( prefix ) ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( jQuery.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	},
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHidden( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 &&
				( tween.elem.style[ jQuery.cssProps[ tween.prop ] ] != null ||
					jQuery.cssHooks[ tween.prop ] ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE9
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back Compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, timerId,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = jQuery.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4 ; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	/* jshint validthis: true */
	var prop, value, toggle, tween, hooks, oldfire, display, checkDisplay,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHidden( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Handle queue: false promises
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Height/width overflow pass
	if ( elem.nodeType === 1 && ( "height" in props || "width" in props ) ) {

		// Make sure that nothing sneaks out
		// Record all 3 overflow attributes because IE9-10 do not
		// change the overflow attribute when overflowX and
		// overflowY are set to the same value
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Set display property to inline-block for height/width
		// animations on inline elements that are having width/height animated
		display = jQuery.css( elem, "display" );

		// Test default display if display is currently "none"
		checkDisplay = display === "none" ?
			dataPriv.get( elem, "olddisplay" ) || defaultDisplay( elem.nodeName ) : display;

		if ( checkDisplay === "inline" && jQuery.css( elem, "float" ) === "none" ) {
			style.display = "inline-block";
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// show/hide pass
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.exec( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// If there is dataShow left over from a stopped hide or show
				// and we are going to proceed with show, we should pretend to be hidden
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );

		// Any non-fx value stops us from restoring the original display value
		} else {
			display = undefined;
		}
	}

	if ( !jQuery.isEmptyObject( orig ) ) {
		if ( dataShow ) {
			if ( "hidden" in dataShow ) {
				hidden = dataShow.hidden;
			}
		} else {
			dataShow = dataPriv.access( elem, "fxshow", {} );
		}

		// Store state if its toggle - enables .stop().toggle() to "reverse"
		if ( toggle ) {
			dataShow.hidden = !hidden;
		}
		if ( hidden ) {
			jQuery( elem ).show();
		} else {
			anim.done( function() {
				jQuery( elem ).hide();
			} );
		}
		anim.done( function() {
			var prop;

			dataPriv.remove( elem, "fxshow" );
			for ( prop in orig ) {
				jQuery.style( elem, prop, orig[ prop ] );
			}
		} );
		for ( prop in orig ) {
			tween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );

			if ( !( prop in dataShow ) ) {
				dataShow[ prop ] = tween.start;
				if ( hidden ) {
					tween.end = tween.start;
					tween.start = prop === "width" || prop === "height" ? 1 : 0;
				}
			}
		}

	// If this is a noop like .hide().hide(), restore an overwritten display value
	} else if ( ( display === "none" ? defaultDisplay( elem.nodeName ) : display ) === "inline" ) {
		style.display = display;
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = jQuery.camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( jQuery.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (#12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length ; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			if ( percent < 1 && length ) {
				return remaining;
			} else {
				deferred.resolveWith( elem, [ animation ] );
				return false;
			}
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
						animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length ; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length ; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( jQuery.isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					jQuery.proxy( result.stop, result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( jQuery.isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	// attach callbacks from options
	return animation.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );
}

jQuery.Animation = jQuery.extend( Animation, {
	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( jQuery.isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnotwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length ; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			jQuery.isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !jQuery.isFunction( easing ) && easing
	};

	opt.duration = jQuery.fx.off ? 0 : typeof opt.duration === "number" ?
		opt.duration : opt.duration in jQuery.fx.speeds ?
			jQuery.fx.speeds[ opt.duration ] : jQuery.fx.speeds._default;

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( jQuery.isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHidden ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};
			doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue && type !== false ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = jQuery.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Checks the timer has not already been removed
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	if ( timer() ) {
		jQuery.fx.start();
	} else {
		jQuery.timers.pop();
	}
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( !timerId ) {
		timerId = window.setInterval( jQuery.fx.tick, jQuery.fx.interval );
	}
};

jQuery.fx.stop = function() {
	window.clearInterval( timerId );

	timerId = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
// http://web.archive.org/web/20100324014747/http://blindsignals.com/index.php/2009/07/jquery-delay/
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: iOS<=5.1, Android<=4.2+
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE<=11+
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: Android<=2.3
	// Options inside disabled selects are incorrectly marked as disabled
	select.disabled = true;
	support.optDisabled = !opt.disabled;

	// Support: IE<=11+
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// All attributes are lowercase
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			name = name.toLowerCase();
			hooks = jQuery.attrHooks[ name ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					jQuery.nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name, propName,
			i = 0,
			attrNames = value && value.match( rnotwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				propName = jQuery.propFix[ name ] || name;

				// Boolean attributes get special treatment (#10870)
				if ( jQuery.expr.match.bool.test( name ) ) {

					// Set corresponding property to false
					elem[ propName ] = false;
				}

				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};
jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle;
		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ name ];
			attrHandle[ name ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				name.toLowerCase() :
				null;
			attrHandle[ name ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// http://fluidproject.org/blog/2008/01/09/getting-setting-and-removing-tabindex-values-with-javascript/
				// Use proper attribute retrieval(#12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				return tabindex ?
					parseInt( tabindex, 10 ) :
					rfocusable.test( elem.nodeName ) ||
						rclickable.test( elem.nodeName ) && elem.href ?
							0 :
							-1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {
			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {
			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




var rclass = /[\t\r\n\f]/g;

function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnotwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );
				cur = elem.nodeType === 1 &&
					( " " + curValue + " " ).replace( rclass, " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {
						if ( cur.indexOf( " " + clazz + " " ) < 0 ) {
							cur += clazz + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = jQuery.trim( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	removeClass: function( value ) {
		var classes, elem, cur, curValue, clazz, j, finalValue,
			i = 0;

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		if ( typeof value === "string" && value ) {
			classes = value.match( rnotwhite ) || [];

			while ( ( elem = this[ i++ ] ) ) {
				curValue = getClass( elem );

				// This expression is here for better compressibility (see addClass)
				cur = elem.nodeType === 1 &&
					( " " + curValue + " " ).replace( rclass, " " );

				if ( cur ) {
					j = 0;
					while ( ( clazz = classes[ j++ ] ) ) {

						// Remove *all* instances
						while ( cur.indexOf( " " + clazz + " " ) > -1 ) {
							cur = cur.replace( " " + clazz + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = jQuery.trim( cur );
					if ( curValue !== finalValue ) {
						elem.setAttribute( "class", finalValue );
					}
				}
			}
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var type = typeof value;

		if ( typeof stateVal === "boolean" && type === "string" ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		if ( jQuery.isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		return this.each( function() {
			var className, i, self, classNames;

			if ( type === "string" ) {

				// Toggle individual class names
				i = 0;
				self = jQuery( this );
				classNames = value.match( rnotwhite ) || [];

				while ( ( className = classNames[ i++ ] ) ) {

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
						"" :
						dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + getClass( elem ) + " " ).replace( rclass, " " )
					.indexOf( className ) > -1
			) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g,
	rspaces = /[\x20\t\r\n\f]+/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, isFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				return typeof ret === "string" ?

					// Handle most common string cases
					ret.replace( rreturn, "" ) :

					// Handle cases where value is null/undef or number
					ret == null ? "" : ret;
			}

			return;
		}

		isFunction = jQuery.isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( isFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( jQuery.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE10-11+
					// option.text throws exceptions (#14686, #14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					jQuery.trim( jQuery.text( elem ) ).replace( rspaces, " " );
			}
		},
		select: {
			get: function( elem ) {
				var value, option,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one" || index < 0,
					values = one ? null : [],
					max = one ? index + 1 : options.length,
					i = index < 0 ?
						max :
						one ? index : 0;

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// IE8-9 doesn't update selected after form reset (#2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							( support.optDisabled ?
								!option.disabled : option.getAttribute( "disabled" ) === null ) &&
							( !option.parentNode.disabled ||
								!jQuery.nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];
					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( jQuery.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/;

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (#9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (#9724)
		if ( !onlyHandlers && !special.noBubble && !jQuery.isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {

			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || {} )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name name as the event.
				// Don't do default actions on window, that's where global variables be (#6170)
				if ( ontype && jQuery.isFunction( elem[ type ] ) && !jQuery.isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;
					elem[ type ]();
					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


jQuery.each( ( "blur focus focusin focusout load resize scroll unload click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup error contextmenu" ).split( " " ),
	function( i, name ) {

	// Handle event binding
	jQuery.fn[ name ] = function( data, fn ) {
		return arguments.length > 0 ?
			this.on( name, null, data, fn ) :
			this.trigger( name );
	};
} );

jQuery.fn.extend( {
	hover: function( fnOver, fnOut ) {
		return this.mouseenter( fnOver ).mouseleave( fnOut || fnOver );
	}
} );




support.focusin = "onfocusin" in window;


// Support: Firefox
// Firefox doesn't have focus(in | out) events
// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
//
// Support: Chrome, Safari
// focus(in | out) events fire after focus & blur events,
// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
// Related ticket - https://code.google.com/p/chromium/issues/detail?id=449857
if ( !support.focusin ) {
	jQuery.each( { focus: "focusin", blur: "focusout" }, function( orig, fix ) {

		// Attach a single capturing handler on the document while someone wants focusin/focusout
		var handler = function( event ) {
			jQuery.event.simulate( fix, event.target, jQuery.event.fix( event ) );
		};

		jQuery.event.special[ fix ] = {
			setup: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix );

				if ( !attaches ) {
					doc.addEventListener( orig, handler, true );
				}
				dataPriv.access( doc, fix, ( attaches || 0 ) + 1 );
			},
			teardown: function() {
				var doc = this.ownerDocument || this,
					attaches = dataPriv.access( doc, fix ) - 1;

				if ( !attaches ) {
					doc.removeEventListener( orig, handler, true );
					dataPriv.remove( doc, fix );

				} else {
					dataPriv.access( doc, fix, attaches );
				}
			}
		};
	} );
}
var location = window.location;

var nonce = jQuery.now();

var rquery = ( /\?/ );



// Support: Android 2.3
// Workaround failure to string-cast null input
jQuery.parseJSON = function( data ) {
	return JSON.parse( data + "" );
};


// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE9
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {
		xml = undefined;
	}

	if ( !xml || xml.getElementsByTagName( "parsererror" ).length ) {
		jQuery.error( "Invalid XML: " + data );
	}
	return xml;
};


var
	rhash = /#.*$/,
	rts = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// #7653, #8125, #8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (#10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );
	originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnotwhite ) || [];

		if ( jQuery.isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes #9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

		// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",
		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": jQuery.parseJSON,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
					jQuery( callbackContext ) :
					jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// The jqXHR state
			state = 0,

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( state === 2 ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() ] = match[ 2 ];
							}
						}
						match = responseHeaders[ key.toLowerCase() ];
					}
					return match == null ? null : match;
				},

				// Raw string
				getAllResponseHeaders: function() {
					return state === 2 ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					var lname = name.toLowerCase();
					if ( !state ) {
						name = requestHeadersNames[ lname ] = requestHeadersNames[ lname ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( !state ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( state < 2 ) {
							for ( code in map ) {

								// Lazy-add the new callback in a way that preserves old ones
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						} else {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR ).complete = completeDeferred.add;
		jqXHR.success = jqXHR.done;
		jqXHR.error = jqXHR.fail;

		// Remove hash character (#7531: and string promotion)
		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (#10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" ).replace( rhash, "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket #12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = jQuery.trim( s.dataType || "*" ).toLowerCase().match( rnotwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE8-11+
			// IE throws exception if url is malformed, e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE8-11+
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( state === 2 ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (#15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		cacheURL = s.url;

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// If data is available, append data to url
			if ( s.data ) {
				cacheURL = ( s.url += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data );

				// #9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add anti-cache in url if needed
			if ( s.cache === false ) {
				s.url = rts.test( cacheURL ) ?

					// If there is already a '_' parameter, set its value
					cacheURL.replace( rts, "$1_=" + nonce++ ) :

					// Otherwise add one to the end
					cacheURL + ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + nonce++;
			}
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || state === 2 ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		for ( i in { success: 1, error: 1, complete: 1 } ) {
			jqXHR[ i ]( s[ i ] );
		}

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( state === 2 ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				state = 1;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Propagate exception as error if not done
				if ( state < 2 ) {
					done( -1, e );

				// Simply rethrow otherwise
				} else {
					throw e;
				}
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Called once
			if ( state === 2 ) {
				return;
			}

			// State is "done" now
			state = 2;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( jQuery.isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );


jQuery._evalUrl = function( url ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (#11264)
		type: "GET",
		dataType: "script",
		async: false,
		global: false,
		"throws": true
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapAll( html.call( this, i ) );
			} );
		}

		if ( this[ 0 ] ) {

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( jQuery.isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var isFunction = jQuery.isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( isFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function() {
		return this.parent().each( function() {
			if ( !jQuery.nodeName( this, "body" ) ) {
				jQuery( this ).replaceWith( this.childNodes );
			}
		} ).end();
	}
} );


jQuery.expr.filters.hidden = function( elem ) {
	return !jQuery.expr.filters.visible( elem );
};
jQuery.expr.filters.visible = function( elem ) {

	// Support: Opera <= 12.12
	// Opera reports offsetWidths and offsetHeights less than zero on some elements
	// Use OR instead of AND as the element is not visible if either is true
	// See tickets #10406 and #13132
	return elem.offsetWidth > 0 || elem.offsetHeight > 0 || elem.getClientRects().length > 0;
};




var r20 = /%20/g,
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( jQuery.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && jQuery.type( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, value ) {

			// If value is a function, invoke it and return its value
			value = jQuery.isFunction( value ) ? value() : ( value == null ? "" : value );
			s[ s.length ] = encodeURIComponent( key ) + "=" + encodeURIComponent( value );
		};

	// Set traditional to true for jQuery <= 1.3.2 behavior.
	if ( traditional === undefined ) {
		traditional = jQuery.ajaxSettings && jQuery.ajaxSettings.traditional;
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( jQuery.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" ).replace( r20, "+" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} )
		.filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} )
		.map( function( i, elem ) {
			var val = jQuery( this ).val();

			return val == null ?
				null :
				jQuery.isArray( val ) ?
					jQuery.map( val, function( val ) {
						return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
					} ) :
					{ name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE9
		// #1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE9
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see #8605, #14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = callback( "error" );

				// Support: IE9
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// #14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain requests
	if ( s.crossDomain ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" ).prop( {
					charset: s.scriptCharset,
					src: s.url
				} ).on(
					"load error",
					callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					}
				);

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = jQuery.isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && jQuery.isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( !data || typeof data !== "string" ) {
		return null;
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}
	context = context || document;

	var parsed = rsingleTag.exec( data ),
		scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


// Keep a copy of the old load method
var _load = jQuery.fn.load;

/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	if ( typeof url !== "string" && _load ) {
		return _load.apply( this, arguments );
	}

	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = jQuery.trim( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( jQuery.isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




// Attach a bunch of functions for handling common AJAX events
jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.expr.filters.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




/**
 * Gets a window from an element
 */
function getWindow( elem ) {
	return jQuery.isWindow( elem ) ? elem : elem.nodeType === 9 && elem.defaultView;
}

jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( jQuery.isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {
	offset: function( options ) {
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var docElem, win,
			elem = this[ 0 ],
			box = { top: 0, left: 0 },
			doc = elem && elem.ownerDocument;

		if ( !doc ) {
			return;
		}

		docElem = doc.documentElement;

		// Make sure it's not a disconnected DOM node
		if ( !jQuery.contains( docElem, elem ) ) {
			return box;
		}

		box = elem.getBoundingClientRect();
		win = getWindow( doc );
		return {
			top: box.top + win.pageYOffset - docElem.clientTop,
			left: box.left + win.pageXOffset - docElem.clientLeft
		};
	},

	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// Fixed elements are offset from window (parentOffset = {top:0, left: 0},
		// because it is its only offset parent
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume getBoundingClientRect is there when computed position is fixed
			offset = elem.getBoundingClientRect();

		} else {

			// Get *real* offsetParent
			offsetParent = this.offsetParent();

			// Get correct offsets
			offset = this.offset();
			if ( !jQuery.nodeName( offsetParent[ 0 ], "html" ) ) {
				parentOffset = offsetParent.offset();
			}

			// Add offsetParent borders
			parentOffset.top += jQuery.css( offsetParent[ 0 ], "borderTopWidth", true );
			parentOffset.left += jQuery.css( offsetParent[ 0 ], "borderLeftWidth", true );
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {
			var win = getWindow( elem );

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari<7-8+, Chrome<37-44+
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://code.google.com/p/chromium/issues/detail?id=229280
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( { padding: "inner" + name, content: type, "": "outer" + name },
		function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( jQuery.isWindow( elem ) ) {

					// As of 5/8/2012 this will yield incorrect results for Mobile Safari, but there
					// isn't a whole lot we can do. See pull request at this URL for discussion:
					// https://github.com/jquery/jquery/pull/764
					return elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable, null );
		};
	} );
} );


jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},
	size: function() {
		return this.length;
	}
} );

jQuery.fn.andSelf = jQuery.fn.addBack;




// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}



var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (#7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (#13566)
if ( !noGlobal ) {
	window.jQuery = window.$ = jQuery;
}

return jQuery;
}));


/***/ }),

/***/ 124:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return trackShare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return trackshareEmailButtonClick; });
/* global RdcTracking */

var trackShare = function trackShare(omtag) {
  var successShare = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var articlePageUrl = window.location.href;
  var pageType = MOVE_DATA.adobeDTM.pageType;
  var listingId = MOVE_DATA.adobeDTM.listingID;
  var eventName = omtag ? 'socialShare' : 'emailShare';
  var shareName = successShare ? 'web:share:email:success' : omtag ? 'web:' + pageType + ':shares:social:' + omtag : 'web:shares:social:eml';

  var props = {
    articlePageUrl: articlePageUrl,
    pageType: pageType,
    listingId: listingId,
    socialShare: shareName
  };
  if (omtag || successShare) {
    Object.assign(props, { linkName: shareName });
  }
  RdcTracking.trackEvent(eventName, props);
};

var trackshareEmailButtonClick = function trackshareEmailButtonClick() {
  var eventName = 'click';
  var linkName = 'eml';
  RdcTracking.trackEvent(eventName, { linkName: linkName });
};

/***/ }),

/***/ 1242:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setupSrpClickTracking; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_clicks__ = __webpack_require__(96);


// Bootstrap page specific clicks here if need be before passing off to main click file.

var setupSrpClickTracking = function setupSrpClickTracking(pageName) {
  if (!window.rdcTrackingInitialized) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_clicks__["a" /* setupClickTracking */])(pageName);
  }
};

/***/ }),

/***/ 1243:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fireMalLeadTracking; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__leads__ = __webpack_require__(162);


var fireMalLeadTracking = function fireMalLeadTracking(malLeads) {
  var opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  var leadGuids = {},
      malListings = opts.malListings,
      guidsForAdobeDtm = [];
  if (malLeads instanceof Array) {
    //create a hashmap of all checked mal properties
    malLeads.forEach(function (lead) {
      leadGuids[lead.listing_id] = lead.id;
      guidsForAdobeDtm.push(lead.id);
    });
    //compare the above map with all potential malListings and submit the ones that were selected.
    if (malListings) {
      trackMalLeads(malListings, leadGuids, opts);
    }
  }
  updateDtmObject(guidsForAdobeDtm);
};

var trackMalLeads = function trackMalLeads(malListings, leadGuids, opts) {
  malListings.forEach(function (property, index) {
    if (property.listing_id && leadGuids[property.listing_id.toString()]) {
      var trackingOptions = {
        leadGuid: leadGuids[property.listing_id.toString()],
        is_mal: true,
        placementData: 'pos_' + index,
        leadValue: opts.leadValue,
        initialLeadValue: opts.initialLeadValue,
        property_type: property.status,
        property_status: property.status,
        type: property.property_type
      };
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__leads__["b" /* trackLead */])(Object.assign({}, property, trackingOptions));
    }
  });
};

var updateDtmObject = function updateDtmObject(guidsForAdobeDtm) {
  MOVE.Helper.updateOmnitureLeadJson({ leadGuid: guidsForAdobeDtm, malCt: guidsForAdobeDtm.length });
};

/***/ }),

/***/ 1244:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return trackSearch; });
/* global RdcTracking */

var DEFAULT_VALUE = 'unknown';

var trackSearch = function trackSearch(searchBox, pageType) {
  var props = {
    linkName: pageType + ':searchBox:' + searchBox.name + '-search',
    searchType: searchBox.searchType,
    searchBox: getSearchBox(searchBox),
    searchQuery: searchBox.query,
    pageType: pageType,
    searchUserEnteredText: searchBox.userEnteredText,
    searchRank: getSearchRank(searchBox)
  };
  RdcTracking.trackEvent('search', props, null, true);
};

var getSearchBox = function getSearchBox(searchBox) {
  var searchFeature = searchBox.autoComplete || searchBox.feature;
  searchBox.name + ':' + searchFeature + ':' + searchBox.match;
};

var getSearchRank = function getSearchRank() {
  var searchBox = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var feature = searchBox.featureRank || DEFAULT_VALUE,
      overall = searchBox.overallRank || DEFAULT_VALUE;
  return 'feature:' + feature + '|overall:' + overall;
};

/***/ }),

/***/ 1276:
/***/ (function(module, exports) {

// https://gist.github.com/jonathantneal/3748027

!window.addEventListener && function (WindowPrototype, DocumentPrototype, ElementPrototype, addEventListener, removeEventListener, dispatchEvent, registry) {
    WindowPrototype[addEventListener] = DocumentPrototype[addEventListener] = ElementPrototype[addEventListener] = function (type, listener) {
        var target = this;

        registry.unshift([target, type, listener, function (event) {
            event.currentTarget = target;
            event.preventDefault = function () {
                event.returnValue = false;
            };
            event.stopPropagation = function () {
                event.cancelBubble = true;
            };
            event.target = event.srcElement || target;

            listener.call(target, event);
        }]);

        this.attachEvent("on" + type, registry[0][3]);
    };

    WindowPrototype[removeEventListener] = DocumentPrototype[removeEventListener] = ElementPrototype[removeEventListener] = function (type, listener) {
        for (var index = 0, register; register = registry[index]; ++index) {
            if (register[0] == this && register[1] == type && register[2] == listener) {
                return this.detachEvent("on" + type, registry.splice(index, 1)[0][3]);
            }
        }
    };

    WindowPrototype[dispatchEvent] = DocumentPrototype[dispatchEvent] = ElementPrototype[dispatchEvent] = function (eventObject) {
        return this.fireEvent("on" + eventObject.type, eventObject);
    };
}(Window.prototype, HTMLDocument.prototype, Element.prototype, "addEventListener", "removeEventListener", "dispatchEvent", []);

/***/ }),

/***/ 1277:
/***/ (function(module, exports) {

//https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Number/isInteger

Number.isInteger = Number.isInteger || function (value) {
  return typeof value === 'number' && isFinite(value) && Math.floor(value) === value;
};

/***/ }),

/***/ 1278:
/***/ (function(module, exports) {

// polyfill for the MouseEvent() constructor functionality
// in Internet Explorer 9 and higher
// from https://developer.mozilla.org/en-US/docs/Web/API/MouseEvent/MouseEvent

(function (window) {
  try {
    new MouseEvent('test');
    return false; // No need to polyfill
  } catch (e) {}
  // Need to polyfill - fall through
  // eslint-disable-line no-unused-vars


  // Polyfills DOM4 MouseEvent

  var MouseEvent = function MouseEvent(eventType) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    params.bubbles = params.bubbles || false;
    params.cancelable = params.cancelable || false;
    params.clientX = params.clientX || 0;
    params.clientY = params.clientY || 0;

    var mouseEvent = document.createEvent('MouseEvent');

    mouseEvent.initMouseEvent(eventType, params.bubbles, params.cancelable, window, // view
    0, // detail
    0, // screenX
    0, // screenY
    params.clientX, params.clientY, false, false, false, false, 0, null);

    return mouseEvent;
  };

  MouseEvent.prototype = Event.prototype;

  window.MouseEvent = MouseEvent;
})(window);

/***/ }),

/***/ 1279:
/***/ (function(module, exports) {

// polyfill for the Object.assign() functionality
// in Internet Explorer 9 and higher
// from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign

(function (window) {
  if (typeof Object.assign != 'function') {
    // Must be writable: true, enumerable: false, configurable: true
    Object.defineProperty(Object, "assign", {
      value: function assign(target, varArgs) {
        // .length of function is 2
        'use strict';

        if (target == null) {
          // TypeError if undefined or null
          throw new TypeError('Cannot convert undefined or null to object');
        }

        var to = Object(target);

        for (var index = 1; index < arguments.length; index++) {
          var nextSource = arguments[index];

          if (nextSource != null) {
            // Skip over if undefined or null
            for (var nextKey in nextSource) {
              // Avoid bugs when hasOwnProperty is shadowed
              if (Object.prototype.hasOwnProperty.call(nextSource, nextKey)) {
                to[nextKey] = nextSource[nextKey];
              }
            }
          }
        }
        return to;
      },
      writable: true,
      configurable: true
    });
  }
})(window);

/***/ }),

/***/ 1280:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill__ = __webpack_require__(1667);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_promise_polyfill__);


// set Promise only if not defined natively
if (!window.Promise) window.Promise = __WEBPACK_IMPORTED_MODULE_0_promise_polyfill___default.a;

/***/ }),

/***/ 1281:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_url_search_params__ = __webpack_require__(1691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_url_search_params___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_url_search_params__);


// set URLSearchParams only if not defined natively
if (!window.URLSearchParams) window.URLSearchParams = __WEBPACK_IMPORTED_MODULE_0_url_search_params___default.a;

/***/ }),

/***/ 1282:
/***/ (function(module, exports) {

// see https://raw.githubusercontent.com/webcomponents/URL/4758781bba9226795d094528c2b66dce42538a85/url.js
(function (scope) {
  "use strict";
  var hasWorkingUrl = false;if (!scope.forceJURL) {
    try {
      var u = new URL("b", "http://a");u.pathname = "c%20d";hasWorkingUrl = u.href === "http://a/c%20d";
    } catch (e) {}
  }if (hasWorkingUrl) return;var relative = Object.create(null);relative["ftp"] = 21;relative["file"] = 0;relative["gopher"] = 70;relative["http"] = 80;relative["https"] = 443;relative["ws"] = 80;relative["wss"] = 443;var relativePathDotMapping = Object.create(null);relativePathDotMapping["%2e"] = ".";relativePathDotMapping[".%2e"] = "..";relativePathDotMapping["%2e."] = "..";relativePathDotMapping["%2e%2e"] = "..";function isRelativeScheme(scheme) {
    return relative[scheme] !== undefined;
  }function invalid() {
    clear.call(this);this._isInvalid = true;
  }function IDNAToASCII(h) {
    if ("" == h) {
      invalid.call(this);
    }return h.toLowerCase();
  }function percentEscape(c) {
    var unicode = c.charCodeAt(0);if (unicode > 32 && unicode < 127 && [34, 35, 60, 62, 63, 96].indexOf(unicode) == -1) {
      return c;
    }return encodeURIComponent(c);
  }function percentEscapeQuery(c) {
    var unicode = c.charCodeAt(0);if (unicode > 32 && unicode < 127 && [34, 35, 60, 62, 96].indexOf(unicode) == -1) {
      return c;
    }return encodeURIComponent(c);
  }var EOF = undefined,
      ALPHA = /[a-zA-Z]/,
      ALPHANUMERIC = /[a-zA-Z0-9\+\-\.]/;function parse(input, stateOverride, base) {
    function err(message) {
      errors.push(message);
    }var state = stateOverride || "scheme start",
        cursor = 0,
        buffer = "",
        seenAt = false,
        seenBracket = false,
        errors = [];loop: while ((input[cursor - 1] != EOF || cursor == 0) && !this._isInvalid) {
      var c = input[cursor];switch (state) {case "scheme start":
          if (c && ALPHA.test(c)) {
            buffer += c.toLowerCase();state = "scheme";
          } else if (!stateOverride) {
            buffer = "";state = "no scheme";continue;
          } else {
            err("Invalid scheme.");break loop;
          }break;case "scheme":
          if (c && ALPHANUMERIC.test(c)) {
            buffer += c.toLowerCase();
          } else if (":" == c) {
            this._scheme = buffer;buffer = "";if (stateOverride) {
              break loop;
            }if (isRelativeScheme(this._scheme)) {
              this._isRelative = true;
            }if ("file" == this._scheme) {
              state = "relative";
            } else if (this._isRelative && base && base._scheme == this._scheme) {
              state = "relative or authority";
            } else if (this._isRelative) {
              state = "authority first slash";
            } else {
              state = "scheme data";
            }
          } else if (!stateOverride) {
            buffer = "";cursor = 0;state = "no scheme";continue;
          } else if (EOF == c) {
            break loop;
          } else {
            err("Code point not allowed in scheme: " + c);break loop;
          }break;case "scheme data":
          if ("?" == c) {
            this._query = "?";state = "query";
          } else if ("#" == c) {
            this._fragment = "#";state = "fragment";
          } else {
            if (EOF != c && "	" != c && "\n" != c && "\r" != c) {
              this._schemeData += percentEscape(c);
            }
          }break;case "no scheme":
          if (!base || !isRelativeScheme(base._scheme)) {
            err("Missing scheme.");invalid.call(this);
          } else {
            state = "relative";continue;
          }break;case "relative or authority":
          if ("/" == c && "/" == input[cursor + 1]) {
            state = "authority ignore slashes";
          } else {
            err("Expected /, got: " + c);state = "relative";continue;
          }break;case "relative":
          this._isRelative = true;if ("file" != this._scheme) this._scheme = base._scheme;if (EOF == c) {
            this._host = base._host;this._port = base._port;this._path = base._path.slice();this._query = base._query;this._username = base._username;this._password = base._password;break loop;
          } else if ("/" == c || "\\" == c) {
            if ("\\" == c) err("\\ is an invalid code point.");state = "relative slash";
          } else if ("?" == c) {
            this._host = base._host;this._port = base._port;this._path = base._path.slice();this._query = "?";this._username = base._username;this._password = base._password;state = "query";
          } else if ("#" == c) {
            this._host = base._host;this._port = base._port;this._path = base._path.slice();this._query = base._query;this._fragment = "#";this._username = base._username;this._password = base._password;state = "fragment";
          } else {
            var nextC = input[cursor + 1];var nextNextC = input[cursor + 2];if ("file" != this._scheme || !ALPHA.test(c) || nextC != ":" && nextC != "|" || EOF != nextNextC && "/" != nextNextC && "\\" != nextNextC && "?" != nextNextC && "#" != nextNextC) {
              this._host = base._host;this._port = base._port;this._username = base._username;this._password = base._password;this._path = base._path.slice();this._path.pop();
            }state = "relative path";continue;
          }break;case "relative slash":
          if ("/" == c || "\\" == c) {
            if ("\\" == c) {
              err("\\ is an invalid code point.");
            }if ("file" == this._scheme) {
              state = "file host";
            } else {
              state = "authority ignore slashes";
            }
          } else {
            if ("file" != this._scheme) {
              this._host = base._host;this._port = base._port;this._username = base._username;this._password = base._password;
            }state = "relative path";continue;
          }break;case "authority first slash":
          if ("/" == c) {
            state = "authority second slash";
          } else {
            err("Expected '/', got: " + c);state = "authority ignore slashes";continue;
          }break;case "authority second slash":
          state = "authority ignore slashes";if ("/" != c) {
            err("Expected '/', got: " + c);continue;
          }break;case "authority ignore slashes":
          if ("/" != c && "\\" != c) {
            state = "authority";continue;
          } else {
            err("Expected authority, got: " + c);
          }break;case "authority":
          if ("@" == c) {
            if (seenAt) {
              err("@ already seen.");buffer += "%40";
            }seenAt = true;for (var i = 0; i < buffer.length; i++) {
              var cp = buffer[i];if ("	" == cp || "\n" == cp || "\r" == cp) {
                err("Invalid whitespace in authority.");continue;
              }if (":" == cp && null === this._password) {
                this._password = "";continue;
              }var tempC = percentEscape(cp);null !== this._password ? this._password += tempC : this._username += tempC;
            }buffer = "";
          } else if (EOF == c || "/" == c || "\\" == c || "?" == c || "#" == c) {
            cursor -= buffer.length;buffer = "";state = "host";continue;
          } else {
            buffer += c;
          }break;case "file host":
          if (EOF == c || "/" == c || "\\" == c || "?" == c || "#" == c) {
            if (buffer.length == 2 && ALPHA.test(buffer[0]) && (buffer[1] == ":" || buffer[1] == "|")) {
              state = "relative path";
            } else if (buffer.length == 0) {
              state = "relative path start";
            } else {
              this._host = IDNAToASCII.call(this, buffer);buffer = "";state = "relative path start";
            }continue;
          } else if ("	" == c || "\n" == c || "\r" == c) {
            err("Invalid whitespace in file host.");
          } else {
            buffer += c;
          }break;case "host":case "hostname":
          if (":" == c && !seenBracket) {
            this._host = IDNAToASCII.call(this, buffer);buffer = "";state = "port";if ("hostname" == stateOverride) {
              break loop;
            }
          } else if (EOF == c || "/" == c || "\\" == c || "?" == c || "#" == c) {
            this._host = IDNAToASCII.call(this, buffer);buffer = "";state = "relative path start";if (stateOverride) {
              break loop;
            }continue;
          } else if ("	" != c && "\n" != c && "\r" != c) {
            if ("[" == c) {
              seenBracket = true;
            } else if ("]" == c) {
              seenBracket = false;
            }buffer += c;
          } else {
            err("Invalid code point in host/hostname: " + c);
          }break;case "port":
          if (/[0-9]/.test(c)) {
            buffer += c;
          } else if (EOF == c || "/" == c || "\\" == c || "?" == c || "#" == c || stateOverride) {
            if ("" != buffer) {
              var temp = parseInt(buffer, 10);if (temp != relative[this._scheme]) {
                this._port = temp + "";
              }buffer = "";
            }if (stateOverride) {
              break loop;
            }state = "relative path start";continue;
          } else if ("	" == c || "\n" == c || "\r" == c) {
            err("Invalid code point in port: " + c);
          } else {
            invalid.call(this);
          }break;case "relative path start":
          if ("\\" == c) err("'\\' not allowed in path.");state = "relative path";if ("/" != c && "\\" != c) {
            continue;
          }break;case "relative path":
          if (EOF == c || "/" == c || "\\" == c || !stateOverride && ("?" == c || "#" == c)) {
            if ("\\" == c) {
              err("\\ not allowed in relative path.");
            }var tmp;if (tmp = relativePathDotMapping[buffer.toLowerCase()]) {
              buffer = tmp;
            }if (".." == buffer) {
              this._path.pop();if ("/" != c && "\\" != c) {
                this._path.push("");
              }
            } else if ("." == buffer && "/" != c && "\\" != c) {
              this._path.push("");
            } else if ("." != buffer) {
              if ("file" == this._scheme && this._path.length == 0 && buffer.length == 2 && ALPHA.test(buffer[0]) && buffer[1] == "|") {
                buffer = buffer[0] + ":";
              }this._path.push(buffer);
            }buffer = "";if ("?" == c) {
              this._query = "?";state = "query";
            } else if ("#" == c) {
              this._fragment = "#";state = "fragment";
            }
          } else if ("	" != c && "\n" != c && "\r" != c) {
            buffer += percentEscape(c);
          }break;case "query":
          if (!stateOverride && "#" == c) {
            this._fragment = "#";state = "fragment";
          } else if (EOF != c && "	" != c && "\n" != c && "\r" != c) {
            this._query += percentEscapeQuery(c);
          }break;case "fragment":
          if (EOF != c && "	" != c && "\n" != c && "\r" != c) {
            this._fragment += c;
          }break;}cursor++;
    }
  }function clear() {
    this._scheme = "";this._schemeData = "";this._username = "";this._password = null;this._host = "";this._port = "";this._path = [];this._query = "";this._fragment = "";this._isInvalid = false;this._isRelative = false;
  }function jURL(url, base) {
    if (base !== undefined && !(base instanceof jURL)) base = new jURL(String(base));this._url = url;clear.call(this);var input = url.replace(/^[ \t\r\n\f]+|[ \t\r\n\f]+$/g, "");parse.call(this, input, null, base);
  }jURL.prototype = { toString: function toString() {
      return this.href;
    }, get href() {
      if (this._isInvalid) return this._url;var authority = "";if ("" != this._username || null != this._password) {
        authority = this._username + (null != this._password ? ":" + this._password : "") + "@";
      }return this.protocol + (this._isRelative ? "//" + authority + this.host : "") + this.pathname + this._query + this._fragment;
    }, set href(href) {
      clear.call(this);parse.call(this, href);
    }, get protocol() {
      return this._scheme + ":";
    }, set protocol(protocol) {
      if (this._isInvalid) return;parse.call(this, protocol + ":", "scheme start");
    }, get host() {
      return this._isInvalid ? "" : this._port ? this._host + ":" + this._port : this._host;
    }, set host(host) {
      if (this._isInvalid || !this._isRelative) return;parse.call(this, host, "host");
    }, get hostname() {
      return this._host;
    }, set hostname(hostname) {
      if (this._isInvalid || !this._isRelative) return;parse.call(this, hostname, "hostname");
    }, get port() {
      return this._port;
    }, set port(port) {
      if (this._isInvalid || !this._isRelative) return;parse.call(this, port, "port");
    }, get pathname() {
      return this._isInvalid ? "" : this._isRelative ? "/" + this._path.join("/") : this._schemeData;
    }, set pathname(pathname) {
      if (this._isInvalid || !this._isRelative) return;this._path = [];parse.call(this, pathname, "relative path start");
    }, get search() {
      return this._isInvalid || !this._query || "?" == this._query ? "" : this._query;
    }, set search(search) {
      if (this._isInvalid || !this._isRelative) return;this._query = "?";if ("?" == search[0]) search = search.slice(1);parse.call(this, search, "query");
    }, get hash() {
      return this._isInvalid || !this._fragment || "#" == this._fragment ? "" : this._fragment;
    }, set hash(hash) {
      if (this._isInvalid) return;this._fragment = "#";if ("#" == hash[0]) hash = hash.slice(1);parse.call(this, hash, "fragment");
    }, get origin() {
      var host;if (this._isInvalid || !this._scheme) {
        return "";
      }switch (this._scheme) {case "data":case "file":case "javascript":case "mailto":
          return "null";}host = this.host;if (!host) {
        return "";
      }return this._scheme + "://" + host;
    } };var OriginalURL = scope.URL;if (OriginalURL) {
    jURL.createObjectURL = function (blob) {
      return OriginalURL.createObjectURL.apply(OriginalURL, arguments);
    };jURL.revokeObjectURL = function (url) {
      OriginalURL.revokeObjectURL(url);
    };
  }scope.URL = jURL;
})(window);

/***/ }),

/***/ 1283:
/***/ (function(module, exports) {

/*global window*/

/**
 * if adobeDTM will get blocked will have a stub that will prevent exceptions
 */
(function (MOVE) {
    "use strict";

    var init = function init() {
        if (!window._satellite) {
            window._satellite = {
                track: function track() {}
            };
        }
    };

    MOVE.addWorkaround({
        init: init
    });
})(MOVE || {});

/***/ }),

/***/ 1284:
/***/ (function(module, exports) {

/*global window*/

/**
 * for some reason we're getting requests with email and password added to url as a query param or in a hash string
 * there's no known place nor flow in our application that would be doing that on our side,
 *
 * there were comments on email thread that this could have been happening in v6 but this version is not deployed anywhere anymore
 *
 * issue with that is that google ads are picking up url with that email password and are raising security issue, threatening to stop serving ads
 *
 *
 * examples or urls:
 * http://www.realtor.com/realestateandhomes-detail/19075-SE-Foster-Rd_Damascus_OR_97089_M20166-03451?email=redacted@example.com&psw=morgan201
 * http://www.realtor.com/realestateandhomes-detail/19075-SE-Foster-Rd_Damascus_OR_97089_M20166-03451#email=redacted@example.com&psw=morgan201
 *
 * urls with query param are handled by ruby middleware making a 301 redirect
 * urls with hash are handled by this workaround
 */

(function (MOVE) {
  "use strict";

  var containsBlacklistedStrings = function containsBlacklistedStrings(text) {
    var normalized_text = text.toLowerCase();
    var blacklistedStrings = ['@', 'pass', 'mail'];

    return _.some(blacklistedStrings, function (blacklistedString) {
      return normalized_text.indexOf(blacklistedString) !== -1;
    });
  };

  var removeHash = function removeHash() {
    var scrollV,
        scrollH,
        loc = window.location;
    if ("replaceState" in history) {
      history.replaceState("", document.title, loc.pathname + loc.search);
    } else {
      // Prevent scrolling by storing the page's current scroll offset
      scrollV = document.body.scrollTop;
      scrollH = document.body.scrollLeft;

      loc.hash = "";

      // Restore the scroll offset, should be flicker free
      document.body.scrollTop = scrollV;
      document.body.scrollLeft = scrollH;
    }
  };

  var init = function init() {
    if (containsBlacklistedStrings(window.location.hash)) {
      removeHash();
    }
  };

  MOVE.addWorkaround({
    init: init
  });
})(MOVE || {});

/***/ }),

/***/ 1285:
/***/ (function(module, exports) {

/**
 * overriding the google method of adding additional css.
 */
(function (MOVE) {
    "use strict";

    var init = function init() {
        var head = document.getElementsByTagName('head')[0];

        // Save the original method
        var insertBefore = head.insertBefore;

        // Replace it!
        head.insertBefore = function (newElement, referenceElement) {

            if (newElement.href && newElement.href.indexOf('https://fonts.googleapis.com/css?family=Roboto') === 0) {
                return;
            }

            insertBefore.call(head, newElement, referenceElement);
        };
    };

    MOVE.addWorkaround({
        init: init
    });
})(MOVE || {});

/***/ }),

/***/ 1286:
/***/ (function(module, exports) {

/*global window*/

/**
 * if adobeDTM will get blocked will have a stub that will prevent exceptions
 */
(function (MOVE) {
    "use strict";

    var init = function init() {
        //it will prevent the back-forward cache for the Safari browser.
        window.onpageshow = function (event) {
            if (event.persisted) {
                window.location.reload();
            }
        };
    };

    MOVE.addWorkaround({
        init: init
    });
})(MOVE || {});

/***/ }),

/***/ 1332:
/***/ (function(module, exports) {

MOVE.AmenitiesNearYouADS = function (MOVE) {

  var init,
      updateInsuranceCategory,
      updateSponsoredByLabel,
      updateSponsorImage,
      attachSponsorOmnitureTags,
      trackThirdParty,
      mapvertisingData,
      mapAmentiyCategoryToAds,
      setAdsData,
      getAdsData,
      renderAmenities,
      insuranceTile = $('li#insurances'),
      insuranceContainer = $('label#insurances');

  init = function init(mapvertisingDataFromAds) {
    if (mapvertisingDataFromAds) {
      var category = mapvertisingDataFromAds.category;
      // In Future there will be 5 more categories. So we can use Switches.
      if (category === 'Insurance') {
        updateInsuranceCategory(mapvertisingDataFromAds);
      }
    }
  };

  /*
  Updates the Insurance category with Insurance Ads. It
  */
  updateInsuranceCategory = function updateInsuranceCategory(mapvertisingDataFromAds) {
    if (MOVE.AmenitiesNearYou.allAmenitiesData()) {
      renderAmenities(mapvertisingDataFromAds);
    } else {
      $('#amenitiesMap').on('amenitiesDataReady', function () {
        renderAmenities(mapvertisingDataFromAds);
      });
    }
  };

  renderAmenities = function renderAmenities(mapvertisingDataFromAds) {
    var amenities = MOVE.AmenitiesNearYou.allAmenitiesData();

    mapAmentiyCategoryToAds(amenities, mapvertisingDataFromAds, 'insurances');
    insuranceContainer.addClass('label-sponsor');
    updateSponsorImage(insuranceContainer, mapvertisingDataFromAds.logo_image_26_26);
    updateSponsoredByLabel(insuranceContainer, mapvertisingDataFromAds.name);
    MOVE.AmenitiesNearYou.plotAmenities(amenities);
    attachSponsorOmnitureTags();
    trackThirdParty(mapvertisingDataFromAds.customer_imp_tracking);
  };

  updateSponsoredByLabel = function updateSponsoredByLabel(element, sponsorName) {
    return element.find('span.ldp-amenity-sponsor').text('Sponsored by ' + sponsorName);
  };

  updateSponsorImage = function updateSponsorImage(element, sponsorImage) {
    var insuranceImagePlaceholder = element.find('.ldp-amenity-sponsor-logo');
    insuranceImagePlaceholder.html('<img src="' + sponsorImage + '" />');
  };

  /*
   Remaps the Amenities response with the Ads JSON response
  */
  mapAmentiyCategoryToAds = function mapAmentiyCategoryToAds(amenities, mapvertisingDataFromAds) {
    if (amenities) {
      _.map(amenities.insurances, function (amenity) {
        if (amenity.name.indexOf(mapvertisingDataFromAds.name) > -1) {
          amenity.havingAdCampaign = amenity.name.indexOf(mapvertisingDataFromAds.name) > -1;
          amenity.logo = mapvertisingDataFromAds.tooltip_image;
          amenity.yelp_url = amenity.business_url;
        }
        return amenity;
      });
    }
  };

  /*
    Once the Ads are successful. We need to attach new omniture tags
    and send some custom tracking
  */
  attachSponsorOmnitureTags = function attachSponsorOmnitureTags() {
    var insuranceRadioButton = insuranceTile.find('input:radio');
    insuranceRadioButton.attr("data-omtag", "ldp:sponsor:amenities:insurances:card");
  };

  trackThirdParty = function trackThirdParty(trackingUrl) {
    if (trackingUrl) {
      var token = Math.random();
      var finalTrackingUrl = trackingUrl.replace('CACHEBUSTER', token).replace('=?', '=?token=' + token);
      var img = $('<img />', { src: finalTrackingUrl });
      img.addClass('hide');
      img.appendTo($('#qv-sections-wrapper'));
    }
  };

  setAdsData = function setAdsData(data) {
    mapvertisingData = data;
  };

  getAdsData = function getAdsData() {
    return mapvertisingData;
  };

  MOVE.AmenitiesNearYouADS = {
    init: init,
    setAdsData: setAdsData,
    getAdsData: getAdsData
  };
  return MOVE.AmenitiesNearYouADS;
}(MOVE || {});

/*
 setMapAds is a function set by the Ads server which powers the Ads targeting
  for Amenities Map.
*/
window.setMapAds = function (mapvertisingData) {
  MOVE.AmenitiesNearYouADS.setAdsData(mapvertisingData);
  $('#amenitiesMap').trigger('MapVertisingDataReady');

  if (mapvertisingData.adPosition == 'MAPEXP1') {
    $('.ldp-amenity-map-attribution #fullmapSponsorshipURL').attr("href", mapvertisingData.click_url);
  } else if (mapvertisingData.adPosition == 'MAPAD4') {
    $('.ldp-amenity-map-attribution #sponsorshipURL').attr("href", mapvertisingData.click_url);
    $('.ldp-amenity-map-attribution #ldpFullmapSponsorshipURL').attr("href", mapvertisingData.click_url);
  }
};

/***/ }),

/***/ 1379:
/***/ (function(module, exports) {

MOVE.FeedbackForABTests = function () {

  var init = function init() {
    displayForm();
  };

  var displayForm = function displayForm() {

    /* eslint-disable */

    var g = function g(e, h, f, _g) {
      this.get = function (a) {
        for (var a = a + "=", c = document.cookie.split(";"), b = 0, e = c.length; b < e; b++) {
          for (var d = c[b]; " " == d.charAt(0);) {
            d = d.substring(1, d.length);
          }if (0 == d.indexOf(a)) return d.substring(a.length, d.length);
        }return null;
      };
      this.set = function (a, c) {
        var b = "",
            b = new Date();b.setTime(b.getTime() + 6048E5);b = "; expires=" + b.toGMTString();document.cookie = a + "=" + c + b + "; path=/; ";
      };
      this.check = function () {
        var a = this.get(f);if (a) a = a.split(":");else if (100 != e) "v" == h && (e = Math.random() >= e / 100 ? 0 : 100), a = [h, e, 0], this.set(f, a.join(":"));else return !0;var c = a[1];if (100 == c) return !0;switch (a[0]) {case "v":
            return !1;case "r":
            return c = a[2] % Math.floor(100 / c), a[2]++, this.set(f, a.join(":")), !c;}return !0;
      };
      this.go = function () {
        if (this.check()) {
          var a = document.createElement("script");a.type = "text/javascript";a.src = _g + "&t=" + new Date().getTime();document.body && document.body.appendChild(a);
        }
      };
      this.start = function () {
        var a = this;window.addEventListener ? window.addEventListener("load", function () {
          a.go();
        }, !1) : window.attachEvent && window.attachEvent("onload", function () {
          a.go();
        });
      };
    };
    try {
      new g(100, "v", "QSI_S_ZN_0CKNREmxHYCPWS1", "//zn0cknremxhycpws1-move.siteintercept.qualtrics.com/WRSiteInterceptEngine/?Q_ZID=ZN_0CKNREmxHYCPWS1&Q_LOC=" + encodeURIComponent(window.location.href)).start();
    } catch (i) {}

    /* eslint-enable */

    if (document.body) {
      var qualtricsDiv = document.createElement('div');
      qualtricsDiv.id = 'ZN_0CKNREmxHYCPWS1';
      document.body.appendChild(qualtricsDiv);
    }
  };

  MOVE.FeedbackForABTests = {
    init: init
  };
  return MOVE.FeedbackForABTests;
}();

/***/ }),

/***/ 1384:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_critical_tracking_shared_special_events__ = __webpack_require__(49);


// Configure the adblock detector
(function () {
  function adBlockDetected() {
    if (!window.sessionStorage.getItem('adBlockDetected')) {
      window.sessionStorage.setItem('adBlockDetected', true);
      MOVE_DATA.adobeDTM.adBlocker = 'true';
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_critical_tracking_shared_special_events__["g" /* trackAdblock */])('true');
    }
  }

  if (typeof window.adblockDetector === 'undefined') {
    adBlockDetected();
  } else {
    window.adblockDetector.init({
      debug: false,
      found: function found() {
        adBlockDetected();
      }
    });
  }
})();

/***/ }),

/***/ 1385:
/***/ (function(module, exports) {

MOVE.AutoComplete = function (MOVE) {
  "use strict";

  // Disables the native HTML form handling and allows the custom form handling
  // to take over instead.

  var disableHtmlForm = function disableHtmlForm($selector) {
    $selector.closest('form.inline-form').contents().unwrap();
    $selector.parent().find('button[type=submit]').attr('type', 'button');
  };

  var init = function init($selector, latLongInfo, isSRP, options) {
    disableHtmlForm($selector);
    var combinedOptions = $.extend({ isSRP: isSRP, latLongInfo: latLongInfo }, options);
    $selector.autocomplete(combinedOptions);
  };

  MOVE.AutoComplete = {
    init: init
  };
  return MOVE.AutoComplete;
}(MOVE || {});

/***/ }),

/***/ 1386:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_critical_tracking_shared_special_events__ = __webpack_require__(49);
var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };



MOVE.Branch = function (MOVE) {

  var pageType = MOVE_DATA.pageType;

  var init = function init() {
    if ((typeof branch === "undefined" ? "undefined" : _typeof(branch)) === "object") {
      var options = { disable_entry_animation: true, disable_exit_animation: true };
      window.branch.init(MOVE_DATA.branch_key, options, function (err, data) {
        MOVE_DATA.branch_has_app = data.has_app;
        setupEventTracking();
        setupBranchViewData();
        listenForDtm();
      });
    }
  };

  //Data to send to branch on banner link click
  var setupBranchViewData = function setupBranchViewData() {
    var ldpPhoto = getLdpPhoto();
    window.branch.setBranchViewData({
      data: {
        "referrer_id": "int-dsp_smart-banner_" + pageType,
        "rdcUrl": branchDeeplink(),
        "sub1": $.cookie("__vst"),
        ldpPhoto: ldpPhoto
      }
    });
  };

  var getLdpPhoto = function getLdpPhoto() {
    if (MOVE_DATA.propertyDetails && MOVE_DATA.propertyDetails.photos && MOVE_DATA.propertyDetails.photos[0].url) {
      return MOVE_DATA.propertyDetails.photos[0].url;
    }
  };

  var setupEventTracking = function setupEventTracking() {
    trackPageViews();
    trackLogin();
  };

  var branchDeeplink = function branchDeeplink() {
    if (pageType === "ldp" || pageType === "srp") {
      return location.protocol + "//" + location.host + location.pathname;
    } else {
      return location.protocol + "//" + location.host;
    }
  };

  //Tracking flags to send to branch for banner targeting
  var trackPageViews = function trackPageViews() {
    if (pageType === 'srp') {
      window.branch.track('srpView');
    } else if (pageType === 'ldp') {
      window.branch.track('ldpView');
    }
  };

  var trackLogin = function trackLogin() {
    if ($.cookie('REMEMBER_ME')) {
      window.branch.track('loggedIn');
    }
  };

  var trackBannerClose = function trackBannerClose() {
    MOVE_DATA.adobeDTM.linkName = 'email:branch:close';
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_critical_tracking_shared_special_events__["h" /* trackBranchBannerClose */])();
    window.branch.track('journeyClose');
  };

  var listenForDtm = function listenForDtm() {
    window.branch.addListener('didClickJourneyClose', trackBannerClose);
  };

  MOVE.Branch = {
    init: init
  };

  return MOVE.Branch;
}(MOVE || {});

/***/ }),

/***/ 1387:
/***/ (function(module, exports) {

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/*global _ newrelic */
MOVE.CalculatePageLoadTime = function (MOVE) {

  var interval,
      previousEntries = 0;

  var init = function init() {
    // Safari browser does not support performance object.
    if (window.performance && window.performance.getEntries !== "undefined" && typeof window.performance.getEntries === "function") {
      // We assume that the page load (along with third party JS) is completed if there are no calls for
      // 2 seconds.
      interval = window.setInterval(getRdcEntries, 2000);
    }
  };

  var getRdcEntries = function getRdcEntries() {
    if (window.performance.getEntries().length === previousEntries) {
      window.clearInterval(interval);
      var lastEntry = _.last(window.performance.getEntries());
      // Sometimes, performance.getEntries just has the startTime and no responseEnd
      var fullPageLoadTimeInSeconds = Math.round(lastEntry.responseEnd || lastEntry.startTime);

      var t = window.performance.timing;

      var tmp = {
        'deviceLag': t.requestStart - t.navigationStart,
        'responseEnd': t.responseEnd - t.requestStart,
        'loadEventEnd': t.loadEventEnd - t.requestStart,
        "fullPageLoadTime": fullPageLoadTimeInSeconds,

        'pageType': window.MOVE_DATA.pageType,
        'isMobile': !!window.MOVE_DATA.isPhone
      };

      if ((typeof newrelic === "undefined" ? "undefined" : _typeof(newrelic)) === 'object') {
        newrelic.addPageAction("Full Page Load", tmp);
      }
    } else {
      previousEntries = window.performance.getEntries().length;
    }
  };

  MOVE.CalculatePageLoadTime = {
    init: init
  };

  return MOVE.CalculatePageLoadTime;
}(MOVE || {});

/***/ }),

/***/ 1388:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_critical_tracking_shared_search__ = __webpack_require__(1244);

/*global window, MOVE_DATA, _satellite*/



(function ($) {
  "use strict";

  var propertyStatus,
      removingKey,
      enableSchoolFlag = {
    '#searchBox': false,
    '#mortgageSearchBox': false,
    '#localSearchBox': false
  },
      validateGeoUrl;

  var AB_SRP_LAYOUT_COOKIE_LIST = 'ab-list-view';

  var formatType = {
    postal_code: ['postal_code', 'city', 'state_code'],
    city: ['city', 'state_code'],
    county: ['county', 'state_code'],
    address: ['line', 'city', 'state_code', 'postal_code'],
    neighborhood: ['neighborhood', 'city', 'state_code'],
    street: ['street', 'city', 'state_code'],
    recent: ['neighborhood', 'postal_code', 'street', 'city', 'state_code', 'mlslid'],
    recent_address: ['address', 'neighborhood', 'city', 'state_code', 'postal_code'],
    school: ['school', 'city', 'state_code'],
    building: ['building', 'city', 'state_code'],
    school_district: ['school_district', 'city', 'state_code'],
    university: ['university', 'city', 'state_code'],
    park: ['park', 'city', 'state_code']
  };

  var schoolDistrictFeatureSwitch = function schoolDistrictFeatureSwitch() {
    return MOVE.DataStore.getData('schoolDistrictEnabled');
  };

  var isAddressSearch = function isAddressSearch(query) {
    return query.address !== undefined;
  };

  var isSchoolSearch = function isSchoolSearch(query) {
    return query.school !== undefined;
  };

  var isSchoolDistrictSearch = function isSchoolDistrictSearch(query) {
    return query.school_district !== undefined && schoolDistrictFeatureSwitch();
  };

  var parseSearch = function parseSearch(search, searchFormat) {
    return _.chain(search).pick(searchFormat).reject(function (str) {
      return !str || str.match(/^\s+$/);
    }).value().join(', ');
  };

  var getRecentSearchFormat = function getRecentSearchFormat(formatType, search, schoolShowFlag) {
    if (isSchoolSearch(search.query) && Boolean(schoolShowFlag)) {
      return formatType.school;
    } else if (isSchoolDistrictSearch(search.query) && Boolean(schoolShowFlag)) {
      return formatType.school_district;
    } else if (search.query.university) {
      return formatType.university;
    } else if (search.query.park) {
      return formatType.park;
    } else if (isAddressSearch(search.query)) {
      return formatType.recent_address;
    } else {
      return formatType.recent;
    }
  };

  var formatRecentSearches = function formatRecentSearches(searches, schoolShowFlag) {
    return _.map(searches, function (search) {
      var recentSearchFormat = getRecentSearchFormat(formatType, search, schoolShowFlag);

      return {
        location: parseSearch(search.query, recentSearchFormat),
        areaType: search.search_type
      };
    });
  };

  var formatPlaces = function formatPlaces(searches) {
    return _.map(searches, function (search) {
      var areaType = search.area_type;
      return {
        location: parseSearch(search, formatType[areaType] || []),
        areaType: areaType
      };
    });
  };

  var getPropertyStatus = function getPropertyStatus() {
    return propertyStatus;
  };

  var setPropertyStatus = function setPropertyStatus(newStatus) {
    newStatus = newStatus || "for_sale";
    propertyStatus = newStatus;
  };

  var updateSearchBox = function updateSearchBox(widgetType) {
    var searchBoxValue = MOVE.UserActivity.getSortedRecentSearches().splice(0, 1);
    var schoolEnable = widgetType === "#searchBox" && _.contains(MOVE.CONSTANTS.ALLOWED_SCHOOL_PAGETYPE, MOVE.DataStore.getData('pageType')) ? true : false;
    // Handling LDP in controllers/property_details.js to prepopulate sooner
    if (searchBoxValue && MOVE.DataStore.getData('pageType') !== 'ldp') {
      // Override schoolenable flag for widgetType #searchBox and page is for_sale::SRP
      if (MOVE.DataStore.getData('propertyStatus') === 'for_sale' && MOVE.DataStore.getData('pageType') === 'srp') {
        schoolEnable = true;
      }
      var recentSearch = widgetType === "#mortgageSearchBox" ? MOVE.SearchHelper.getMortgageFormattedRecentSearch() : formatRecentSearches(searchBoxValue, schoolEnable);
      var formattedLocation = MOVE.SearchHelper.getVitalityFormattedRecentSearch();

      if (!_.isEmpty(recentSearch)) {
        $(widgetType).val(recentSearch[0].location);
      }
      if (widgetType === '#searchBox') {
        $('.js-vitality-location').html(formattedLocation);
      }
    }
  };

  var $searchBoxMultiGeo = $('#add-geos-searchbox'); // AB testing ;

  $.fn.autocomplete = function (options) {
    var searchBox,
        searchBoxId,
        confidenceSuggestBox,
        confidenceSuggestBoxFlag,
        searchButton,
        searchAutoComplete,
        defaultSearchResults,
        foundSearchResults,
        invalidSearch,
        geoListPos,
        isFromSRP,
        includeZip,
        pd,
        slugPrefix,
        validateSearchCriteriaCallback,
        placeholderText = "Please Enter a Location or #MLS",
        homepageHeaderBound = false,
        usingAutoComplete = false,
        usingRecentSearch = false,
        usingHighConfidenceSearch = false,
        keyPressed = false,
        userEnteredText = "",
        performGeoValidation,
        getMatchedRecentSearches,
        showHighConfidenceSuggestion,
        setCursorOnFocus,
        retainSecondaryFacets,
        isContentKeyCode;

    var getSearchBoxOmnitureName = function getSearchBoxOmnitureName() {
      if (_.isEmpty(searchBox[0])) {
        return 'property';
      }
      switch (searchBox[0].id) {
        case 'mortgageSearchBox':
          return 'mortgage';
        case 'localSearchBox':
          return 'local';
        default:
          return 'property';
      }
    };

    options = options || {};
    searchBox = $(this);
    searchBoxId = searchBox[0] && searchBox[0].id ? "#" + searchBox[0].id : null;
    confidenceSuggestBoxFlag = false;
    if ($(this).parent().find('.pre-populate-box').length !== 0) {
      confidenceSuggestBox = $(this).parent().find('.pre-populate-box');
      confidenceSuggestBoxFlag = true;
    }

    if (options.validateSearchCriteriaCallback !== undefined) {
      validateSearchCriteriaCallback = options.validateSearchCriteriaCallback;
    }

    if (options.placeholderText !== undefined) {
      placeholderText = options.placeholderText;
    }

    var showSearchSuggestions = function showSearchSuggestions() {
      if (searchBox.is(":focus") || searchBox.is(":active")) {
        searchAutoComplete.slideDown("fast", function () {
          $(this).removeClass('no-show');
        });
      }
    };

    var getLastThreeMatchedRecentSearches = function getLastThreeMatchedRecentSearches(allRecentSearches, searchValue) {
      var lastThreeMatchedRecentSearches = [];
      $.each(allRecentSearches, function (index, recentSearch) {
        if (lastThreeMatchedRecentSearches.length >= 3) {
          return false;
        }
        var recentLocations = _.pluck(lastThreeMatchedRecentSearches, 'location');
        if (!_.isUndefined(searchValue) && recentSearch.location && recentSearch.location.toLowerCase().startsWith(searchValue.toLowerCase()) && recentLocations.indexOf(recentSearch.location) < 0) {
          lastThreeMatchedRecentSearches.push(recentSearch);
        }
      });
      return lastThreeMatchedRecentSearches;
    };

    var convert_case = function convert_case(str) {
      var lower = str.toLowerCase();
      return lower.replace(/(^| )(\w)/g, function (x) {
        return x.toUpperCase();
      });
    };

    var makeRecentSuggestionHTML = function makeRecentSuggestionHTML(matchedRecentSearches) {
      var elements = $(),
          searchBoxValue = searchBox.val(),
          regEx = new RegExp(searchBoxValue, "i"),
          replaceValue = '<span class="font-semibold">' + convert_case(searchBoxValue) + '</span>';
      elements = elements.add('<div class="hidden-xxs hidden-xs"><i class="ra ra-clock-o icon-space-right"></i>Recent Searches</div>');
      var ranking = 1;
      //For recent searched overall ranking and category ranking are the same as recent searches are top of the list.
      matchedRecentSearches.forEach(function (object) {
        elements = elements.add('<li class="recent-search" data-overall-rank=' + ranking + ' data-area-type=' + object.areaType + ' data-feature-rank=' + ranking + '><a href="#">' + object.location.replace(regEx, replaceValue) + '</a></li>');
        ranking++;
      });
      return elements;
    };

    var setEnableSchoolFlag = function setEnableSchoolFlag(widgetType) {
      if ((_.contains(MOVE.CONSTANTS.ALLOWED_SCHOOL_PAGETYPE, MOVE.DataStore.getData('pageType')) || MOVE.DataStore.getData('propertyStatus') === 'for_sale') && _.contains(['#searchBox'], widgetType)) {
        enableSchoolFlag[widgetType] = true;
      }
    };

    var getEnableSchoolFlag = function getEnableSchoolFlag(widgetType) {
      return enableSchoolFlag[widgetType];
    };

    var elementDropDown = function elementDropDown(autoComplete, oRank, cRank, areaType, eleText) {
      return '<li class="' + autoComplete + '" data-overall-rank=' + oRank + ' data-feature-rank=' + cRank + ' data-area-type=' + areaType + '><a href="#">' + eleText + '</a></li>';
    };

    var populateDropDown = function populateDropDown(autoCompleteResponses, matchedRecentSearches) {
      var elements = $(),
          searchBoxValue = searchBox.val();

      if (matchedRecentSearches.length > 0) {
        elements = elements.add(makeRecentSuggestionHTML(matchedRecentSearches));
        elements = elements.add('<hr class="divider">');
      }
      var remainingSearches = _.reject(autoCompleteResponses, function (a) {
        return _.find(matchedRecentSearches, function (m) {
          return m.location === a.location;
        });
      });
      // The total number of searches which is Recent Searches + Auto Suggest is always equal to length of Auto Suggest (which is 10)
      var numberOfAutoCompleteSearchesToBeAppended = autoCompleteResponses.length - matchedRecentSearches.length;
      if (remainingSearches.length > 0) {
        var grouping = {
          total: 0,
          order: ['places', 'school', 'school_district', 'university'],
          places: {
            cls: 'autocomplete-place',
            groupText: 'Places',
            groupIcon: 'map-marker',
            buildings: [],
            items: []
          },
          school: {
            cls: 'autocomplete-school',
            groupText: 'Schools',
            groupIcon: 'graduation-cap',
            items: []
          },
          school_district: {
            cls: 'autocomplete-schooldistricts',
            groupText: 'School Districts',
            groupIcon: 'district-solid',
            items: []
          },
          university: {
            cls: 'autocomplete-university',
            groupText: 'Universities',
            groupIcon: 'graduation-cap',
            items: []
          }
        };
        var overallRank = matchedRecentSearches.length + 1,
            categoryRank = 1;
        for (var index = 0; index < numberOfAutoCompleteSearchesToBeAppended; index++) {
          var areaType = remainingSearches[index].areaType,
              location = remainingSearches[index].location,
              regEx = new RegExp(searchBoxValue, "i"),
              // use "ig" for case insensitive and global match (if-required)
          replaceValue = '<span class="font-semibold">' + convert_case(searchBoxValue) + '</span>',

          //conditions for New York Experience building search
          //if there is an address search that meets the below conditions for New York, then this search mimics a building search and ranks the search as a top suggestion
          nyExpConditions = location.indexOf("Apt") < 0 && location.indexOf("Unit") < 0 && location.indexOf("Ph") < 0 && (location.indexOf("New York") >= 0 || location.indexOf("NY") >= 0);

          var group = grouping[areaType] || grouping.places,
              li = elementDropDown(group.cls, overallRank, categoryRank, areaType, location.replace(regEx, replaceValue));

          group.items.push(li);
          if (group !== grouping.places) {
            grouping.total++;
          }
          if (nyExpConditions && !grouping[areaType]) {
            // New York Building Search
            grouping.places.buildings.push(li);
          }
          categoryRank++;
          overallRank++;
        }
        //List of dropdown objects
        elements = elements.add(composeAutoCompleteDropdown(grouping));
      }
      return _.uniq(elements, false, "textContent");
    };

    var composeAutoCompleteDropdown = function composeAutoCompleteDropdown(grouping) {
      var elements = [];

      if (!schoolDistrictFeatureSwitch()) {
        grouping.total -= grouping.school_district.items.length;
        grouping.school_district.items = [];
      }
      grouping.order.forEach(function (areaType) {
        var group = grouping[areaType];
        var items = [].concat(group.items);
        if (areaType === 'places') {
          if (grouping.total) {
            items = _.first(items, 3);
          }
          if (group.buildings.length) {
            items.unshift(group.buildings[0]);
          }
        }
        if (items.length) {
          elements = elements.concat('<div class="hidden-xxs hidden-xs"><i class="ra ra-' + group.groupIcon + ' icon-space-right"></i>' + group.groupText + '</div>').concat(items);
        }
      });

      return $(elements.map(function (x) {
        return $(x)[0];
      }));
    };

    var setRanks = function setRanks(objWithRank) {
      var featureRank = objWithRank.data("feature-rank") || '';
      var overallRank = objWithRank.data("overall-rank") || '';
      searchBox.data('feature-rank', featureRank);
      searchBox.data('overall-rank', overallRank);
    };

    var setAreaType = function setAreaType(objWithAreaType) {
      var areaType = objWithAreaType.data("area-type") || '';
      areaType = areaType == 'zip_code' || areaType == 'postal_code' ? 'zip' : areaType;
      searchBox.data('area-type', areaType);
    };

    var hideSearchSuggestions = function hideSearchSuggestions(ShouldloadSRPPage) {
      if (!$(this).hasClass('no-show')) {
        searchAutoComplete.slideUp("slow", function () {
          if (ShouldloadSRPPage) {
            performGeoValidation();
          }
        });
      }
    };

    var clickOnSearchSuggestionLink = function clickOnSearchSuggestionLink() {
      foundSearchResults.find('.list-unstyled li').on('click', function (e) {
        e.preventDefault();
        e.stopPropagation();
        usingAutoComplete = true;
        if ($(this).hasClass('recent-search')) {
          usingRecentSearch = true;
        }
        searchBox.val($(this).text());
        if (confidenceSuggestBoxFlag) {
          confidenceSuggestBox.val('');
        }
        setRanks($(this));
        setAreaType($(this));
        smoothAutocompleteScroll();
        hideSearchSuggestions(true);
      });
    };

    var showResultsContent = function showResultsContent(recentSearches, resultResponse) {
      var structuredResponse = formatPlaces(resultResponse);
      var dropDown = populateDropDown(structuredResponse, recentSearches);
      foundSearchResults.find('.list-unstyled').html(dropDown);
      clickOnSearchSuggestionLink();
      defaultSearchResults.addClass('no-show');
      foundSearchResults.removeClass('no-show');
      invalidSearch.addClass('no-show');
      geoListPos = 0;
    };

    var showRecentSearchSuggestions = function showRecentSearchSuggestions(searchValue, isRemoveKey) {
      if (isSellSearchBox()) {
        return [];
      }
      var enableSchool = getEnableSchoolFlag(searchBoxId);
      var matchedRecentSearches = getMatchedRecentSearches(searchValue, enableSchool);
      if (matchedRecentSearches.length > 0) {
        showSearchSuggestions();
        var recentSearchHTML = makeRecentSuggestionHTML(matchedRecentSearches);
        foundSearchResults.find('.list-unstyled').html(recentSearchHTML);
        if (confidenceSuggestBoxFlag && searchBox.val().length > 0 && !isRemoveKey) {
          showHighConfidenceSuggestion(matchedRecentSearches);
        }
        clickOnSearchSuggestionLink();
        defaultSearchResults.addClass('no-show');
        foundSearchResults.removeClass('no-show');
        invalidSearch.addClass('no-show');
        geoListPos = 0;
      } else {
        searchAutoComplete.css('display', 'none');
        $('#autocomplete').val('');
      }
    };

    getMatchedRecentSearches = function getMatchedRecentSearches(searchValue, enableSchool) {
      if (MOVE.UserActivity === undefined) {
        return [];
      }
      var recentSearches = MOVE.UserActivity.getSortedNonAjaxRecentSearches().splice(0, 10);
      var formattedRecentSearches = formatRecentSearches(recentSearches, enableSchool);
      var matchedRecentSearches = getLastThreeMatchedRecentSearches(formattedRecentSearches, searchValue);
      var autocomplete_suggest = options.autocomplete_suggest;
      if (autocomplete_suggest && autocomplete_suggest.filter_recent_searches) {
        matchedRecentSearches = matchedRecentSearches.filter(function (item) {
          return autocomplete_suggest.area_types.includes(item.areaType);
        });
      }
      return _.uniq(matchedRecentSearches, 'location');
    };

    var getSearchController = function getSearchController() {
      if (isFromSRP && !_.isUndefined(MOVE.SRP)) {
        var searchCriteria = MOVE.SRP.SearchFacet.getSearchCriteria();
        return searchCriteria.search_controller;
      } else {
        var propertyTypes = MOVE.CONSTANTS.PROPERTY_STATUS,
            controllerTypes = MOVE.CONSTANTS.SEARCH_CONTROLLER_TYPE;

        // For Home page, we have to decide the controller type based on property status
        // selected
        switch (getPropertyStatus()) {
          case propertyTypes.forSale:
            return controllerTypes.forSale;
          case propertyTypes.forRent:
            return controllerTypes.forRent;
          case propertyTypes.recentlySold:
            return controllerTypes.recentlySold;
          case propertyTypes.propertyRecords:
            return controllerTypes.propertyRecords;
          case propertyTypes.newCommunity:
            return controllerTypes.newCommunity;
          case propertyTypes.newPlan:
            return controllerTypes.newPlan;
          case propertyTypes.foreclosure:
            return controllerTypes.foreclosure;
        }
      }
    };

    var setNoResultsFound = function setNoResultsFound(noSuggestion) {
      if (noSuggestion) {
        showSearchSuggestions();
        defaultSearchResults.addClass('no-show');
        foundSearchResults.addClass('no-show');
      }
    };

    // Check if the user has moved to suggestion box using keyboard up/down
    var interactWithSuggestion = function interactWithSuggestion() {
      return $('.js-found-search-results .list-unstyled .highlight').length !== 0;
    };

    // Check if the user has moved to recent search box using keyboard up/down
    var interactWithRecentSearchSuggestion = function interactWithRecentSearchSuggestion() {
      return $('.js-found-search-results .list-unstyled  .highlight').hasClass('recent-search');
    };

    var getFeatureType = function getFeatureType() {
      var featureType = 'pre-populated-default';
      if (interactWithRecentSearchSuggestion() || usingRecentSearch) {
        featureType = 'recent-search';
      } else if (interactWithSuggestion() || usingAutoComplete) {
        featureType = 'auto-suggest';
      } else if (usingHighConfidenceSearch === true) {
        featureType = 'high-confidence';
      } else if (keyPressed === true) {
        featureType = 'typed-in';
      }
      return featureType;
    };

    // To get secondary facets for already searched scenarios from below landers pages
    retainSecondaryFacets = function retainSecondaryFacets() {
      return isFromSRP || $.inArray(MOVE.DOMHelper.detectPageType(), ["hp", "landers_sale", "landers_rental"]) != -1;
    };

    // Add custom logic for SRP here
    performGeoValidation = function performGeoValidation(params) {
      if (isSellSearchBox()) {
        return MOVE.SellSearch.performGeoValidation();
      }
      var locationName = params && params.location ? params.location : searchBox.val();
      var requestArgs = {
        location: locationName,
        prop_status: getPropertyStatus(),
        retain_secondary_facets: retainSecondaryFacets(),
        include_zip: includeZip,
        search_controller: getSearchController()
      };

      if (params && params.radius) {
        requestArgs.radius = params.radius;
      }

      if (slugPrefix !== undefined) {
        requestArgs.slug_prefix = "/" + slugPrefix;
        requestArgs.strip_all_facets = true;
      }

      if (requestArgs.location[0] === '#') {
        // $.cookie('srp.viewType', 'list', { path: '/' });
        //AB:BASE-103
        $.cookie('ab_srp_viewtype', AB_SRP_LAYOUT_COOKIE_LIST, { path: '/' });
      }

      $.ajax({
        url: validateGeoUrl || '/validate_geo',
        method: 'GET',
        dataType: 'JSON',
        data: requestArgs,
        success: function success(response) {
          var callbackOptions = {},
              redirectCallback,
              searchBoxOmnitureName = getSearchBoxOmnitureName();
          if (response && response.url && response.url !== "no_match_found") {
            redirectCallback = function redirectCallback(newAddress, is_geo_search_box_search) {
              if (response.slug && (response.slug === 'New-York_NY' || response.slug === 'New-York-City_NY')) {
                $.cookie("manhattanRedirect", true, { path: '/' });
                newAddress = newAddress.replace(response.slug, 'Manhattan_NY');
              }
              if (newAddress !== undefined && newAddress.indexOf('/realestateandhomes-detail') >= 0 && MOVE.Helper.hasSessionStorage()) {
                window.sessionStorage.setItem("isLDPSearch", "true");
              }
              if (is_geo_search_box_search) {
                var match = "exact-match";
                if (_.isObject(response) && _.isObject(requestArgs) && _.isObject(response.validatedLocation)) {
                  var isSchoolOrDistrict = _.isNull(response.school) || _.isNull(response.school_district),
                      isValidatedLocation = !_.isNull(response.validatedLocation) && !_.isNull(requestArgs.location) && response.validatedLocation.toUpperCase() !== requestArgs.location.toUpperCase();
                  if (isValidatedLocation && isSchoolOrDistrict) {
                    match = "partial-match";
                  }
                }
                MOVE_DATA.adobeDTM.searchBox = {
                  "name": searchBoxOmnitureName,
                  "query": requestArgs.location,
                  "searchType": _.isUndefined(searchBox.data("area-type")) ? '' : searchBox.data("area-type"),
                  "userEnteredText": userEnteredText,
                  "overallRank": _.isUndefined(searchBox.data("overall-rank")) ? '' : searchBox.data("overall-rank"),
                  "featureRank": _.isUndefined(searchBox.data("feature-rank")) ? '' : searchBox.data("feature-rank"),
                  "feature": getFeatureType(),
                  "match": match
                };
                __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_critical_tracking_shared_search__["a" /* trackSearch */])(MOVE_DATA.adobeDTM.searchBox, MOVE_DATA.adobeDTM.pageType);
              }
              // move this method to end of redirect callback
              // as behavior of scripts after redirecting
              // is undefined
              window.location.href = newAddress;
            };
            if (options.validateSuccessCallback) {
              callbackOptions.url = response.url;
              callbackOptions.slugPrefix = slugPrefix;
              callbackOptions.slug = response.slug;
              callbackOptions.location = response.location;
              callbackOptions.zip = response.zip;
              callbackOptions.city = response.city;
              callbackOptions.state = response.state_id;
              callbackOptions.school = response.school;
              callbackOptions.school_district = response.school_district;
              callbackOptions.redirectCallback = redirectCallback;
              options.validateSuccessCallback(callbackOptions);
            } else {
              redirectCallback(response.url, true);
            }
          } else {
            var noSuggestion = true;
            setNoResultsFound(noSuggestion);
            searchAutoComplete.slideDown("fast", function () {
              $(this).removeAttr('style');
              $(this).removeClass('no-show');
              $(this).find('.not-found-text').text(searchBox.val());
              var autoCompleteErrorMessage = $('#auto-complete-error-message');
              if (autoCompleteErrorMessage.length > 0) {
                $(this).children('.js-no-found-results').html(autoCompleteErrorMessage.html());
              } else {
                $(this).children('.js-no-found-results').html('<p class="h5 autocomplete-title font-normal">We did not find listings</p>');
              }
              $(this).children('.js-no-found-results').removeClass('no-show');
            });
            searchBox.css('color', '#d92228');
            MOVE_DATA.adobeDTM.searchBox = {
              "name": searchBoxOmnitureName,
              "query": requestArgs.location,
              "searchType": searchBox.data('area-type'),
              "userEnteredText": userEnteredText,
              "overallRank": searchBox.data("overall-rank"),
              "featureRank": searchBox.data("feature-rank"),
              "feature": getFeatureType(),
              "match": "failure"
            };
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_critical_tracking_shared_search__["a" /* trackSearch */])(MOVE_DATA.adobeDTM.searchBox, MOVE_DATA.adobeDTM.pageType);
          }

          if (confidenceSuggestBox) {
            confidenceSuggestBox.val('');
          }

          usingAutoComplete = false;
          usingRecentSearch = false;
          usingHighConfidenceSearch = false;
          userEnteredText = '';
        }
      });
    };

    var listingDetailsOnError = function listingDetailsOnError(requestArgs) {
      var supportedFields = ['status'];
      var additionalData = { requestArgs: requestArgs, apiUrl: MOVE_DATA.suggestApiEndPoint };
      var transform = function transform(response) {
        return _.chain(response).pick(supportedFields).extend({ serviceResponse: response }).extend(additionalData).value();
      };
      return function (response) {
        MOVE.Common.addNewRelicLog('suggestApiError', transform(response));
      };
    };

    var getListingDetails = function getListingDetails(searchValue, isRemoveKey) {
      if (isSellSearchBox()) {
        return getSellListingDetails(searchValue, isRemoveKey);
      }
      var suggestUrl = MOVE_DATA.suggestApiEndPoint;
      var searchText = searchBox.val(),
          requestArgs = {
        'input': searchText,
        'limit': 10,
        'lat': pd.latitude,
        'long': pd.longitude,
        'client_id': 'rdcV8'
      },
          enableSchool = getEnableSchoolFlag(searchBoxId),
          area_types = ['neighborhood', 'city', 'county', 'postal_code', 'address', 'building', 'street', 'university', 'park'];

      if (enableSchool) {
        area_types.push('school');
      }
      if (schoolDistrictFeatureSwitch()) {
        area_types.push('school_district');
      }

      requestArgs.area_types = area_types.join(',');

      if (options.autocomplete_suggest && options.autocomplete_suggest.area_types) {
        requestArgs.area_types = options.autocomplete_suggest.area_types;
      }
      var matchedRecentSearches = getMatchedRecentSearches(searchValue, enableSchool);

      $.ajax({
        url: suggestUrl,
        method: 'GET',
        dataType: 'JSON',
        // strip falsy values, such as BLANK
        data: _.pick(requestArgs, _.identity),
        matchedRecentSearches: matchedRecentSearches,
        error: listingDetailsOnError(requestArgs),
        success: function success(response) {
          if (response && response.autocomplete) {
            var autocompleteResponse = response.autocomplete;
            if (autocompleteResponse.length > 0) {
              showSearchSuggestions();
              showResultsContent(matchedRecentSearches, autocompleteResponse);
              if (confidenceSuggestBoxFlag && !isRemoveKey) {
                showHighConfidenceSuggestion(matchedRecentSearches, autocompleteResponse);
              }
              if (removingKey || isRemoveKey) {
                // Clean up confidenceSuggestBox when clicking on backspace and delete. removingKey is global variable to record if removing key is pressed.
                // The reason of this line is to avoid issue of sequence of ajax success and key press.
                if (confidenceSuggestBox) {
                  confidenceSuggestBox.val('');
                }
              }
            } else {
              hideSearchSuggestions(false);
              if (confidenceSuggestBoxFlag) {
                confidenceSuggestBox.val('');
              }
            }
          }
        }
      });
    };

    var isSellSearchBox = function isSellSearchBox() {
      return searchBoxId == "#sell-search-address";
    };

    var getSellListingDetails = function getSellListingDetails(searchValue, isRemoveKey) {
      var suggestUrl = MOVE_DATA.suggestApiEndPoint;
      var searchText = searchBox.val(),
          requestArgs = {
        'input': searchText,
        'limit': 10,
        'lat': pd.latitude,
        'long': pd.longitude,
        'client_id': 'rdcV8',
        'debug': false,
        'include': 'summary'
      };
      requestArgs.area_types = 'address';
      var matchedRecentSearches = [];

      $.ajax({
        url: suggestUrl,
        method: 'GET',
        dataType: 'JSON',
        // strip falsy values, such as BLANK
        data: _.pick(requestArgs, _.identity),
        error: listingDetailsOnError(requestArgs),
        success: function success(response) {
          getSellAutoCompleteData(response, matchedRecentSearches, isRemoveKey);
        }
      });
    };

    var getSellAutoCompleteData = function getSellAutoCompleteData(response, matchedRecentSearches, isRemoveKey) {
      if (response && response.autocomplete) {
        var autocompleteResponse = response.autocomplete;
        if (autocompleteResponse.length > 0) {
          $('.js-sell-address-error').addClass("hide");
          showSearchSuggestions();
          showResultsContent(matchedRecentSearches, autocompleteResponse);
          if (confidenceSuggestBoxFlag && !isRemoveKey) {
            showHighConfidenceSuggestion(matchedRecentSearches, autocompleteResponse);
          }
          if (removingKey || isRemoveKey) {
            if (confidenceSuggestBox) {
              confidenceSuggestBox.val('');
            }
          }
        } else {
          $('.js-sell-address-error').removeClass("hide");
          hideSearchSuggestions(false);
          if (confidenceSuggestBoxFlag) {
            confidenceSuggestBox.val('');
          }
        }
      }
    };

    var onFocusInSearchBox = function onFocusInSearchBox() {
      searchBox.focus(function () {
        $searchBoxMultiGeo.addClass('hide');
        setCursorOnFocus();
        var searchBoxValue = searchBox.val();
        if (searchBoxValue === placeholderText) {
          searchBox.val('').css('color', '');
        } else if (searchBoxValue === '') {
          showRecentSearchSuggestions(searchBoxValue);
        } else {
          searchBox.css('color', '');
        }
      });
    };

    var smoothAutocompleteScroll = function smoothAutocompleteScroll() {
      $('.js-autocomplete-dropdow').off('click.preventClose').on('click.preventClose', function (e) {
        e.stopPropagation();
      });
    };

    var getPrePopulateItem = function getPrePopulateItem(recentsearch, suggestion) {
      if (recentsearch.length !== 0) {
        return recentsearch[0];
      } else if (suggestion.length !== 0) {
        return formatPlaces(suggestion)[0];
      } else {
        return '';
      }
    };

    showHighConfidenceSuggestion = function showHighConfidenceSuggestion(recentsearch, suggestion) {
      suggestion = suggestion || {};
      var suggest_keyword = getPrePopulateItem(recentsearch, suggestion);
      var highlight_word = '';
      var input_word = searchBox.val();

      if (confidenceSuggestBox) {
        if (suggest_keyword.location && suggest_keyword.location.toLowerCase().startsWith(input_word.toLowerCase()) && suggest_keyword.location.length > input_word.length) {
          highlight_word = suggest_keyword.location.slice(input_word.length);
          confidenceSuggestBox.val(input_word + highlight_word);
          confidenceSuggestBox.data('area-type', suggest_keyword.areaType);
        } else {
          confidenceSuggestBox.val('');
        }
      }
    };

    setCursorOnFocus = function setCursorOnFocus() {
      if (navigator.geolocation && $.Device.isMobile(navigator.userAgent)) {
        // Select searchbox text in mobile device
        searchBox.select();
      } else {
        // Move cursor to the end of searchbox
        searchBox.val(searchBox.val());
      }
    };

    // Currently, when the search box is empty and we click on search button, the error pop up
    // opens quickly , then closes and then opens again. This happens everytime we click on search box
    // with error message and then click on search button. The below logic checks for
    // such scenarios and closes all the suggestions/errors only when required.
    var checkIfCloseSuggestions = function checkIfCloseSuggestions(event) {
      var closeSuggestions = true;
      if (event.relatedTarget !== undefined && event.relatedTarget !== null) {
        var $target = $(event.relatedTarget);
        var isSearchLink = $target.is('a');
        var isSearchButton = $target.hasClass('js-searchButton');
        var isTargetSearchButton = isSearchButton || event.relatedTarget.id === 'searchBox';
        var isErrorDisplayed = !invalidSearch.hasClass('no-show');
        if (isTargetSearchButton) {
          if (isErrorDisplayed) {
            closeSuggestions = false;
          }
        } else if (isSearchLink) {
          closeSuggestions = false;
        }
      }
      return closeSuggestions;
    };

    var onFocusOutSearchBox = function onFocusOutSearchBox() {
      searchBox.blur(function (event) {
        if (checkIfCloseSuggestions(event)) {
          hideSearchSuggestions(false);
        }
        if ($searchBoxMultiGeo.length) {
          // for ab test
          $searchBoxMultiGeo.removeClass('hide');
          $('#clearInput').removeClass('hide');
        }
      });
    };

    var onFocusOutSearchButton = function onFocusOutSearchButton() {
      searchButton.blur(function (event) {
        if (checkIfCloseSuggestions(event)) {
          hideSearchSuggestions(false);
        }
      });
    };

    var onClickBody = function onClickBody() {
      var body = $('body');
      body.on('click', function (event) {
        if (event.target == searchBox[0]) {
          return;
        }
        if (checkIfCloseSuggestions(event)) {
          hideSearchSuggestions(false);
        }
      });
    };

    var highlightSelectGeo = function highlightSelectGeo(inc) {
      if (!foundSearchResults.hasClass("no-show")) {
        var geos = foundSearchResults.find('li');
        if (geos.length > 0) {
          geos.removeClass("highlight");
          geoListPos += inc;
          if (geoListPos < 0) {
            geoListPos = 0;
          } else if (geoListPos > geos.length) {
            geoListPos = geoListPos - 1;
          }
          var selectedGeo = $(geos[geoListPos - 1]);
          selectedGeo.addClass("highlight");
          searchBox.val(selectedGeo.find("a").text());
          setRanks(selectedGeo);
          setAreaType(selectedGeo);
        }
      }
    };

    var updateGeoEndpoint = function updateGeoEndpoint(callback) {
      // this method updates the endpoint
      // as the endpoint is searchbox-specific
      validateGeoUrl = searchButton.attr("path");
      callback();
      validateGeoUrl = undefined;
    };

    var performSearch = function performSearch() {
      updateGeoEndpoint(function () {
        var searchBoxLength = searchBox.val().length;
        if (confidenceSuggestBoxFlag && confidenceSuggestBox) {
          var confidenceSuggestBoxLength = confidenceSuggestBox.val().length;
          if (confidenceSuggestBoxLength > 0) {
            searchBox.val(confidenceSuggestBox.val());
            usingHighConfidenceSearch = true;
          }
          setAreaType(confidenceSuggestBox);
        }

        if (searchBoxLength < 1) {
          if (options.emptySearchCallback) {
            options.emptySearchCallback();
          } else {
            searchBox.attr("placeholder", placeholderText);
            searchBox.addClass("input-error");
            setNoResultsFound();
          }
        } else {
          searchBox.blur();
          if (validateSearchCriteriaCallback === undefined || validateSearchCriteriaCallback()) {
            hideSearchSuggestions(false);
            performGeoValidation();
          } else {
            setNoResultsFound();
            searchBox.css('color', '#d92228');
          }
        }
      });
    };

    var listenForNoOfKeyStrokes = function listenForNoOfKeyStrokes() {
      searchBox.keydown(function (e) {
        if (keyPressed === false) {
          keyPressed = true;
          userEnteredText = searchBox.val();
        }
        removingKey = isRemovingKey(e.which);
        if (confidenceSuggestBoxFlag && confidenceSuggestBox && confidenceSuggestBox.val().length !== 0) {
          var searchTextLength = searchBox.val().length;
          var prePopText = confidenceSuggestBox.val();
          var nextCharCode = prePopText.charCodeAt(searchTextLength);
          if (e.which === 39 || e.which === 9) {
            // `TAB` and arrow right button
            if (confidenceSuggestBox.val() !== '') {
              e.preventDefault();
              searchBox.val(confidenceSuggestBox.val());
              usingHighConfidenceSearch = true;
            }
          } else if (e.which === 16) {
            // Disable `Shift`
            e.stopPropagation();
          } else if (e.which === 8 || e.which === 46) {
            // Backspace and delete keydown
            if (confidenceSuggestBoxFlag) {
              confidenceSuggestBox.val('');
            }
            if (searchTextLength.length == 0) {
              searchBox.val('');
            }
          } else if (e.which === nextCharCode) {
            // case-insensitive match
            // Input box is not scrolling
            e.preventDefault();
            searchBox.val(searchBox.val() + String.fromCharCode(nextCharCode));
          } else if (e.which === 188 && nextCharCode === 44 || e.which === 13 || e.which === nextCharCode - 32) {
            // Handle char-match, ',' or 'enter', do nothing
            return;
          } else {
            // Handle `, ` issue
            if (prePopText.charCodeAt(searchTextLength - 1) === 44 && nextCharCode === 32 && e.which === prePopText.charCodeAt(searchTextLength + 1)) {
              e.preventDefault();
              searchBox.val(searchBox.val() + ' ' + prePopText.charAt(searchTextLength + 1));
            }
            // Typing in letters, numbers, comma, etc. But typing didn't match prepopulate content
            else if (isContentKeyCode(e.which) && e.which !== nextCharCode && e.which !== nextCharCode - 32) {
                confidenceSuggestBox.val('');
              }
          }
        }
      });
      searchBox.keyup(function (e) {
        searchBox.removeClass("input-error");
        if (e.which === 38) {
          //up
          highlightSelectGeo(-1);
          usingAutoComplete = true;
          if (confidenceSuggestBoxFlag && confidenceSuggestBox) {
            confidenceSuggestBox.val('');
          }
        } else if (e.which === 40) {
          //down
          highlightSelectGeo(1);
          usingAutoComplete = true;
          if (confidenceSuggestBoxFlag && confidenceSuggestBox) {
            confidenceSuggestBox.val('');
          }
        } else if (e.which === 13) {
          //enter
          e.preventDefault();
          performSearch();
          return;
        } else if (e.which === 27) {
          //ESC
          if (confidenceSuggestBoxFlag && confidenceSuggestBox) {
            confidenceSuggestBox.val('');
          }
        } else {
          var searchValue = searchBox.val();
          userEnteredText = searchValue;
          var totalCount = searchValue.length;
          var isRemoveKey = false;
          if (isRemovingKey(e.which)) {
            //backspace and delete
            searchBox.css('color', '');
            isRemoveKey = true;
            if (searchValue.indexOf("Please Enter") !== -1) {
              searchBox.val('');
            }
          }
          if (totalCount >= 0 && totalCount < 3 || searchValue.indexOf('#') === 0) {
            showRecentSearchSuggestions(searchValue, isRemoveKey);
          } else {
            if (searchBox[0].clientWidth == searchBox[0].scrollWidth || searchBox[0].scrollWidth == searchBox.width()) {
              getListingDetails(searchValue, isRemoveKey);
            } else {
              getListingDetails(searchValue, true);
            }
          }
        }
      });
    };

    isContentKeyCode = function isContentKeyCode(keycode) {
      var valid = keycode > 47 && keycode < 58 || // number keys
      keycode === 32 || keycode === 13 || // spacebar & return key(s) (if you want to allow carriage returns)
      keycode > 64 && keycode < 91 || // letter keys
      keycode > 95 && keycode < 112 || // numpad keys
      keycode > 185 && keycode < 193 || // ;=,-./` (in order)
      keycode > 218 && keycode < 223; // [\]' (in order)
      return valid;
    };

    var isRemovingKey = function isRemovingKey(keycode) {
      return keycode == 8 || keycode == 46;
    };

    var clickSearchButton = function clickSearchButton() {
      searchButton.click(performSearch);
    };

    var detectClickOnAnywhere = function detectClickOnAnywhere() {
      if (homepageHeaderBound === true) {
        return;
      }
      // This functionality is only for home page.
      var touchStartPos = 0;
      $('#homepage-header').on('touchstart', function () {
        touchStartPos = $(window).scrollTop();
      }).on('touchend', function (event) {
        var distance = touchStartPos - $(window).scrollTop();
        var isSearchButton = $(event.target).hasClass('js-searchButton');
        if (!(distance > 20 || distance < -20) && !isSearchButton) {
          var insideClick = $("#" + event.target.id).parents(".home-search-wrapper").length === 1;
          if (!insideClick) {
            hideSearchSuggestions(false);
          }
        }
      });
      homepageHeaderBound = true; // flag to bind touch events once
    };

    var detectIsIpad = function detectIsIpad() {
      if (MOVE.CONSTANTS.IS_IPAD) {
        detectClickOnAnywhere();
      }
    };

    var clearableInput = function clearableInput() {
      var $searchBox = $('#searchBox');
      var $clearInput = $('#clearInput');
      // Show/hide "x" button on input change event
      $searchBox.on('input', function () {
        if ($searchBox.val()) {
          $clearInput.removeClass('hide');
        } else {
          $clearInput.addClass('hide');
        }
      }).trigger('input'); // trigger on page load to show "x" if $searchBox.val()
      // Clear input value on "x" click and hide "x" button
      $clearInput.on('click', function () {
        $('#autocomplete').val('');
        $searchBox.val('').focus();
        $clearInput.addClass('hide');
        if (!foundSearchResults.hasClass("no-show")) {
          showSearchSuggestions();
        }
      });
    };

    var init = function init() {
      // For SRP, pd will be null and we need to get the value from gon variable.
      pd = options.latLongInfo || MOVE.DataStore.getData('searchLatLong') || {};
      searchButton = searchBox.parent().find(".js-searchButton");
      searchAutoComplete = searchBox.parent().next(".js-autocomplete-dropdow");
      foundSearchResults = searchAutoComplete.children(".js-found-search-results");
      defaultSearchResults = searchAutoComplete.children('.js-default-search-results');
      invalidSearch = searchAutoComplete.children('.js-no-found-results');
      isFromSRP = options.isSRP;
      includeZip = options.includeZip || false;
      if (options.validate_geo && options.validate_geo.slug_prefix) {
        slugPrefix = options.validate_geo.slug_prefix;
      }
      // Solve 'back' button
      if (confidenceSuggestBoxFlag && confidenceSuggestBox) {
        confidenceSuggestBox.val('');
      }

      if (_.isObject(MOVE.HOMEPAGE) && (searchBoxId === "#mortgageSearchBox" || searchBoxId === "#localSearchBox") || !_.isObject(MOVE.HOMEPAGE)) {
        updateSearchBox(searchBoxId);
      }

      onFocusInSearchBox();
      onFocusOutSearchBox();
      onFocusOutSearchButton();
      onClickBody();
      listenForNoOfKeyStrokes();
      clickSearchButton();
      detectIsIpad();
      clearableInput();
      setEnableSchoolFlag(searchBoxId);
      smoothAutocompleteScroll();
    };

    $.fn.autocomplete.newSearch = performGeoValidation;

    init();
  };

  $.fn.autocomplete.getPropertyStatus = getPropertyStatus;
  $.fn.autocomplete.setPropertyStatus = setPropertyStatus;
  $.fn.autocomplete.formatRecentSearches = formatRecentSearches;
  $.fn.autocomplete.enableSchoolFlag = enableSchoolFlag;

  $(document).ready(function () {
    if (_.isObject(MOVE.HOMEPAGE)) {
      updateSearchBox('#searchBox');
    }
  });
})($);

/***/ }),

/***/ 1389:
/***/ (function(module, exports) {

MOVE.CustomSmartbanner = function (MOVE) {

  var init = function init() {
    closeCustomBanner();
    keepBannerClosed();
    toggleCustomBannerOnMapView();
  };

  var closeCustomBanner = function closeCustomBanner() {
    $('#store-smartbanner').on('click', '.sb-close', function () {
      setDismissalExpiry();
      hideCustomBanner();
    });
  };

  // If user has dismissed the banner and is still active in session, keep cookie active.
  var keepBannerClosed = function keepBannerClosed() {
    if ($.cookie('bannerDismissed')) {
      setDismissalExpiry();
    }
  };

  var setDismissalExpiry = function setDismissalExpiry() {
    var date = MOVE.Helper.setCookieExpiry(30);
    $.cookie('bannerDismissed', true, { path: '/', expires: date });
  };

  var toggleCustomBannerOnMapView = function toggleCustomBannerOnMapView() {
    $('.srp-view-list-toggle').on('click', function () {
      showCustomBanner();
    });
    $('.srp-view-map-toggle').on('click', function () {
      hideCustomBanner();
    });
  };

  var hideCustomBanner = function hideCustomBanner() {
    $('#store-smartbanner').addClass('hide');
  };

  var showCustomBanner = function showCustomBanner() {
    if (!$.cookie('bannerDismissed')) {
      $('#store-smartbanner').removeClass('hide');
    }
  };

  MOVE.CustomSmartbanner = {
    init: init
  };

  return MOVE.CustomSmartbanner;
}(MOVE || {});

/***/ }),

/***/ 1390:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_non_critical_lead_open_keyboard_js__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__quick_view_optimization_ab_hlt_open_house__ = __webpack_require__(583);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__quick_view_optimization_ab_only_text_cta_lead__ = __webpack_require__(584);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__quick_view_optimization_ab_open_keyboard_txt_lead__ = __webpack_require__(1537);
/*global window, _, MOVE_DATA, localStorage, JST, swap_login_header_text:true, raasSWAP */
/* exported swap_login_header_text */
/** AB TESTS **/





(function (MOVE) {

  var removeErrorModal = function removeErrorModal() {
    if ($('#shareUnavailable').length) {
      // Make sure error modal is closed (if any)
      if ($('#shareUnavailable').is(':visible')) {
        $('#shareUnavailable').modal('hide');
      }

      //Make sure the error modal gets removed
      $('#shareUnavailable, .modal-backdrop').remove();
    }
  };

  var showErrorTryAgainModal = function showErrorTryAgainModal(target, modelData) {
    // Append the new error modal
    $('#modal-container').append(JST['templates/modal_error']({
      hasTarget: true,
      target: target,
      property: JSON.stringify(modelData)
    }));

    // Open the error modal
    $('#shareUnavailable').modal();
  };

  var showErrorModal = function showErrorModal() {
    // Append the new error modal
    $('#modal-container').append(JST['templates/modal_error']({
      hasTarget: false
    }));

    // Open the error modal
    $('#shareUnavailable').modal();
  };

  var initModalData = function initModalData(target, modelData, additionalData, source) {
    if (target === '#ldpBottomLeadModal') {
      var $sellDateSelect = $(target).find('.selectpicker');
      if ($sellDateSelect) {
        $sellDateSelect.selectpicker();
      }
      MOVE.LDP.LeadForm.init('gallery_request_more_details', modelData, MOVE.LDP.PhotoGallery.hideLeadForm);
      MOVE.LDP.SellerLead.init();
    } else if (target === '#request-private-showing') {
      MOVE.LDP.LeadForm.init('request-private-showing', modelData);
    } else if (target.includes('#homes-around-card')) {
      MOVE.LDP.LeadForm.init(target.replace(/#/, ''), modelData);
    } else if (target === '#shareEmailModal') {
      MOVE.ShareEmailModal.init();
    } else if (target === '#mobileShareOptionsModal') {
      MOVE.ShareEmailModal.init();
    } else if (target === '#rental-lead-free-moving-quotes-modal') {
      MOVE.LDP.RentalLeadFreeMovingQuotesModal.init();
    } else if (target === '#rental-lead-moving-modal') {
      MOVE.LDP.RentalLeadMovingModal.init(additionalData.position, additionalData.placement);
    } else if (target === '#modal-rental-floorplan') {
      MOVE.LDP.RentalsFloorplanModal.init(additionalData);
      MOVE.LDP.LeadForm.init("modal-rental-floorplan", modelData);
    } else if (target === '#mortgagePaymentModal') {
      MOVE.LDP.MortgagePayment.init();
    } else if (target === '#moving-calculator-modal') {
      MOVE.MovingEstimateModal.init(additionalData.calculation);
    } else if (target === '#leadSimpleThankYouVeterans' || target === '#leadSimpleThankYouShared') {
      MOVE.LDP.LeadSimpleThankyouModal.init(target, additionalData.isVeteran, additionalData.creditScore, additionalData.isNearbyHomeCard);
    } else if (/^#srp-lead-modal/.test(target)) {
      // does target start with #srp-lead-modal ?
      MOVE.SRP.CardLead.init(target, additionalData);
    } else if (target === '#pdp-contact-local-agent-modal') {
      var propertyData;
      if (modelData.is_nearby_home_card) {
        propertyData = Object.assign(modelData, {
          lead_placement: 'ldp:homes-near-street:contact-neighborhood-expert'
        });
      }
      MOVE.LDP.ContactLocalAgentModal.init(propertyData);
    } else if (target === '#fs-matterport-modal') {
      MOVE.MatterportModal.init(target, additionalData);
    } else if (target === '#note-input-modal') {
      MOVE.LDP.NoteComponent.initModal();
    } else if (target === '#off-market-edit-facts-modal') {
      MOVE.DOMHelper.initPopOver($(".edited-facts-header"));
      hideAdditionalOffmarketEditedData(source);
    } else if (target === '#textInputModal') {
      /* LGWEB-160 */
      if (MOVE_DATA.ab_only_txt_mweb === "V1" && !MOVE_DATA.is_flipped_market) {
        $('#srp-lead-modal').modal('hide');
        var abOnlyTxtCtaTextMe = additionalData.target.attributes['data-ab-only-text-cta-text-me'] ? true : false;
        var abLeadSubmitted = additionalData.target.attributes['data-ab-lead-submitted'];
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__quick_view_optimization_ab_only_text_cta_lead__["d" /* toggleOrEmailMeBtn */])(target, abOnlyTxtCtaTextMe, abLeadSubmitted);
      }
      /* END LGWEB-160 */

      /* LGWEB-162 */
      if (MOVE_DATA.ab_open_keyboard_txt === "V1") {
        __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_3__quick_view_optimization_ab_open_keyboard_txt_lead__["a" /* focusTextLead */])();
      }
      /* END LGWEB-162 */

      var omtag = additionalData.target && additionalData.target.attributes['data-omtag'] ? additionalData.target.attributes['data-omtag'].value : '';
      MOVE.LEAD.TextInputModal.init(omtag);
    } else if (target === '#scheduleTourModal') {
      MOVE.LEAD.ScheduleTourModal.init();
    }

    // focus and open keyboard
    if (MOVE_DATA.isPhone && MOVE_DATA.adobeDTM.propertyStatus === 'for_sale') {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_non_critical_lead_open_keyboard_js__["a" /* focusRequestLead */])();
    }
    //LGWEB-14 AB Test
    if (MOVE_DATA.ab_schedule_tour === 'V2' && !MOVE_DATA.is_flipped_market) {
      var $modalContainer = $('#modal-container');
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__quick_view_optimization_ab_hlt_open_house__["b" /* abOpenHouseTimePicker */])();
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__quick_view_optimization_ab_hlt_open_house__["c" /* abOpenHouseDatePicker */])();
      MOVE.DOMHelper.initPopOverHover($('.lead_form_tcpa_text'));
      Promise.resolve().then(function () {
        $modalContainer.on('shown.bs.modal', function () {
          if ($modalContainer.hasClass('oh-request-modal')) {
            $(this).find('.op-datetimepicker').removeClass('hide');
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__quick_view_optimization_ab_hlt_open_house__["a" /* abSetDateTime */])();
            __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__quick_view_optimization_ab_hlt_open_house__["d" /* abPopulateForm */])();
          }
        });
      });
      $modalContainer.on('hidden.bs.modal', function () {
        $modalContainer.removeClass('oh-request-modal');
        $(this).find('.op-datetimepicker').addClass('hide');
      });
    } else {
      MOVE.DOMHelper.initPopOverHover($('.lead_form_tcpa_text'));
    }
  };

  var removeSaveInThankYouModal = function removeSaveInThankYouModal() {
    if (MOVE_DATA.propertyDetails) {
      if (MOVE_DATA.propertyDetails.saved_resource_id) {
        $("#save-content-wrapper").hide();
      } else {
        $("#save-content-wrapper").show();
      }
    }
  };

  var fetchModal = function fetchModal(target) {
    var modelData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var additionalData = arguments[2];
    var source = arguments[3];

    if (!window.modals) window.modals = [];

    // keep track of target modals
    if (window.modals.indexOf(target) >= 0) {
      return;
    } else {
      window.modals.push(target);
    }

    var propertyInstance = modelData.is_nearby_home_card ? modelData.property_id : null;
    var targetForModalFetch = target.includes('#homes-around-card') ? 'homes_around_card' : target.replace(/#/, '');

    var moddify_property = additionalData.property || modelData;
    if (!moddify_property.saved_resource_id) {
      moddify_property.saved_resource_id = MOVE_DATA.subResId;
    }
    var data = $.extend(MOVE.DOMHelper.getUrlParams(), {
      target: targetForModalFetch,
      property_slug: window.location.pathname.split('/').pop(),
      // on srp additionalData will store property info in additionalData
      // on ldp we rely on model.getData
      property: JSON.stringify(moddify_property),
      propertyInstance: propertyInstance
    });

    removeErrorModal();

    // add explicit return to access promise
    return $.post('/properties/modals', data).done(function (data) {
      // Append the modal HTML
      $('#modal-container').append(data.html);

      // Trigger a custom event after DOM injection
      $(document).trigger('modalInserted');

      // Initialize modal data
      initModalData(target, modelData, additionalData);

      // Open Modal
      $(target).modal();

      // Binds action buttons to close modal
      if ($(target).find('.modal-actions > a.btn').length) {
        $(target).find('.modal-actions > a.btn').on('click', function () {
          $(target).modal('hide');
        });
      }
      if (target === '#shareEmailThankYou') {
        removeSaveInThankYouModal();
      }
      if (target === '#off-market-edit-facts-modal') {
        hideAdditionalOffmarketEditedData(source);
      }
    }).fail(function () {
      showErrorTryAgainModal(target);
    });
  };

  var hideAdditionalOffmarketEditedData = function hideAdditionalOffmarketEditedData(data_source) {
    if (data_source === 'info-icon') {
      $('.show-additional-data').hide();
    } else {
      $('.show-additional-data').show();
    }
  };

  var raasSwap = function raasSwap(data, opts) {
    var swap_login_header_text = void 0;
    if (opts.source) {
      switch (opts.source) {
        case 'save_home':
          swap_login_header_text = "Save all the homes you love in one place";
          break;
        case 'save_search':
          swap_login_header_text = "Save this search and get new home notifications fast";
          break;
        case 'save_note':
          swap_login_header_text = "Save notes and homes you love in one place";
          break;
        default:
          swap_login_header_text;
          break;
      }
    }
    raasSWAP(data, null, opts.triggerLocation);
  };

  MOVE.ModalHelper = {
    fetchModal: fetchModal,
    initModalData: initModalData,
    removeErrorModal: removeErrorModal,
    showErrorModal: showErrorModal,
    removeSaveInThankYouModal: removeSaveInThankYouModal,
    raasSwap: raasSwap
  };
})(MOVE);

/***/ }),

/***/ 1391:
/***/ (function(module, exports) {

MOVE.SearchHelper = function (MOVE) {
  "use strict";

  var getVitalityFormattedRecentSearch = function getVitalityFormattedRecentSearch() {
    var recentSearches = MOVE.UserActivity.getSortedRecentSearches().splice(0, 1);
    if (recentSearches.length > 0) {
      var lastSearched = recentSearches[0];
      // we are reusing the autocomplete formatRecentSearches Method.
      // So to avoid the address framed with address we are deleting the nodes from query
      if (lastSearched.query.hasOwnProperty('address')) {
        delete lastSearched.query.address;
        delete lastSearched.query.postal_code;
      } else if (lastSearched.query.hasOwnProperty('city') && lastSearched.query.hasOwnProperty('postal_code')) {
        delete lastSearched.query.city;
        delete lastSearched.query.state_code;
      }
      return $.fn.autocomplete.formatRecentSearches(recentSearches)[0].location;
    }
    return null;
  };

  var getMortgageFormattedRecentSearch = function getMortgageFormattedRecentSearch() {
    var recentSearches = MOVE.UserActivity.getSortedRecentSearches().splice(0, 1);
    if (recentSearches.length > 0) {
      var lastSearched = recentSearches[0];
      // we are reusing the autocomplete formatRecentSearches Method.
      // So to avoid the address framed with address we are deleting the nodes from query
      // Mortgage only supports city, zip & state_code.
      if (lastSearched.query.hasOwnProperty('county') && lastSearched.query.hasOwnProperty('city') && lastSearched.query.city.toLowerCase().indexOf("county") !== -1) {
        lastSearched.query = {};
      } else {
        $.each(lastSearched.query, function (k) {
          if (k !== 'city' && k !== 'state_code' && k !== 'postal_code') {
            delete lastSearched.query[k];
          }
        });
      }
      return $.fn.autocomplete.formatRecentSearches(recentSearches);
    }
    return null;
  };

  // The deaultLocation for vitality will be undefined.
  // Already there is code avilable in vitality js to use  ip sniff if recent search return null.
  // The deaultLocation for landerpages in cookie location or san fransico.
  var getRecentSearchedLocation = function getRecentSearchedLocation(defaultLocation) {
    return MOVE.SearchHelper.getVitalityFormattedRecentSearch() || defaultLocation;
  };

  MOVE.SearchHelper = {
    getVitalityFormattedRecentSearch: getVitalityFormattedRecentSearch,
    getRecentSearchedLocation: getRecentSearchedLocation,
    getMortgageFormattedRecentSearch: getMortgageFormattedRecentSearch
  };

  return MOVE.SearchHelper;
}(MOVE || {});

/***/ }),

/***/ 1392:
/***/ (function(module, exports) {

////////////////////////////////////////////////////////////////
// Description:
// Speed RUM Monitoting Framework
// to caclulate RUM metrics and report back to our servers.
// Through this script we calculate Speed Index for real users
// (rupex) and report it for analysis.
//
// Author:
// Sembian Mani (smani@move.com)
//
// Usage:
// 1. Include the script file in your HTML
// 2. Add ATF and meaningful paint markers
// 3. Run SpeedRUMModule.init()
///////////////////////////////////////////////////////////////

/* global newrelic */

window.SpeedRUMModule = function () {
  //PRIVATE VARIABLES
  //Speed Gauge to collect all the metrics to monitor
  var speedGaugeObj = {};
  //Custom metrics defined by application team
  var customSelectors = ["first-meaningful-paint", "above-the-fold"];
  //Performance API
  var perfAPI = window.performance;
  //If performance API is not present return right away
  if (!perfAPI) {
    return;
  }
  var perfData = window.performance.timing;

  //PRIVATE FUNCTIONS
  //Gathering perf data from the following channels:
  //1. Navigation Timing API
  //2. Paint Timing API
  //3. User Timing API
  //4. Resource Timing API

  //Gathering user centric nav timing data
  function gatherNavTimingMetrics() {
    //Time to first byte
    speedGaugeObj.ttfb = perfData.responseStart - perfData.navigationStart;
    //Page Load Time Measured until load start (to acomodate data sent to beacon)
    speedGaugeObj.plt = perfData.loadEventStart - perfData.navigationStart;
  }
  //Gathering user centric paint timing data
  function gatherPaintTimingMetrics() {
    var paintMetrics = perfAPI.getEntriesByType("paint");
    if (paintMetrics !== undefined && paintMetrics.length > 0) {
      paintMetrics.forEach(function (paintMetric) {
        if (paintMetric.name == "first-paint") {
          //Time to first paint
          speedGaugeObj.ttfp = Math.round(paintMetric.startTime);
        }
        if (paintMetric.name == "first-contentful-paint") {
          //Time to first contentful paint
          speedGaugeObj.ttfcp = Math.round(paintMetric.startTime);
        }
      });
    }
  }
  //Gathering user centric nav timing data
  function gatherSecondaryNavTimingMetrics() {
    //DNS Lookup Time
    speedGaugeObj.dns = perfData.domainLookupEnd - perfData.domainLookupStart;
    //TCP Connect Time
    speedGaugeObj.tcpconnect = perfData.connectEnd - perfData.connectStart;
    //SSL Time
    speedGaugeObj.ssl = perfData.secureConnectionStart ? perfData.connectEnd - perfData.secureConnectionStart : 0;
    //Cache lookmup time
    speedGaugeObj.cachelookup = perfData.domainLookupStart - perfData.fetchStart;
    //Redirect lookup time
    speedGaugeObj.redirectlookup = perfData.fetchStart - perfData.navigationStart;
    //Unload time
    speedGaugeObj.unload = perfData.unloadEventEnd - perfData.unloadEventStart;
  }
  //Gathering user centric custom (User) timing data
  function gatherCustomTimingData() {
    var marks = performance.getEntriesByType("mark");
    marks.forEach(function (mark) {
      if (mark.name == customSelectors[0]) {
        speedGaugeObj.ttfmp = Math.round(mark.startTime);
      }
      if (mark.name == customSelectors[1]) {
        speedGaugeObj.atf = Math.round(mark.startTime);
      }
    });
  }
  //RUPEX:  *R*eal *U*ser *P*erformance Ind*ex*
  //5 key metrics that are included and their Visual Completion values:
  //1. TTFB: Time to first byte: 20%
  //2. TTFCP: Time to first contentful paint: 40%
  //3. TTFMP: Time to first meaningful paint: 60%
  //4. ATF:Above The Fold: 80%
  //5. PLT: Page Load Time: 100%
  //Refer: https://docs.google.com/presentation/d/1N1iOw511vuuaGGdVYe897mWcyRNTbdSBggQzRgKtdJM/edit#slide=id.g4071ba6792_0_6
  function calculateRUPEX() {
    //Calculated with equal constant Visual Completion percentage
    speedGaugeObj.rupex = Math.round(speedGaugeObj.ttfb + 0.8 * (speedGaugeObj.ttfp - speedGaugeObj.ttfb) + 0.6 * (speedGaugeObj.ttfmp - speedGaugeObj.ttfp) + 0.4 * (speedGaugeObj.atf - speedGaugeObj.ttfmp) + 0.2 * (speedGaugeObj.plt - speedGaugeObj.atf));
  }

  //Setup SPA Tracking for RUPEX
  function initSPATracking() {
    //Setting up Event Publisher
    window.publishEvent = function (e_name) {
      var event;
      if (typeof Event === "function") {
        event = new Event(e_name);
      } else {
        event = document.createEvent("Event");
        event.initEvent(e_name, true, true);
      }
      window.dispatchEvent(event);
    };
    //Whenever there is a SPA navigation, initialise timers and attach listener for spa dom ready.
    window.addEventListener('spa-navstart', function () {
      _clearMetrics();
      speedGaugeObj.isSPAData = 1;
      speedGaugeObj.spaNavStart = new Date().getTime();
      window.addEventListener('spa-domready', handleSPADOMReady);
    });
  }
  //After SPA Navigation when the DOM is ready (Component updated) add ATF image handlers,
  function handleSPADOMReady() {
    var atfImages = document.querySelectorAll('[data-atf="true"]');
    var atfLength = atfImages.length;
    //If ATF data attribute is not yet set return back
    if (atfLength == 0) {
      return;
    }
    var atfLoadedCount = 0;
    //Remove event listener so that it is invoked only once per SPA navigation
    window.removeEventListener('spa-domready', handleSPADOMReady);
    //Record DOM Ready timestamp
    speedGaugeObj.spaDomReady = new Date().getTime();
    //Gather ATF images
    var incCount = function incCount() {
      atfLoadedCount++;
      if (atfLoadedCount == atfLength) {
        gatherSPAMetrics();
      }
    };
    //Iterate to check if already loaded. If not attach handler.
    for (var i = 0; i < atfLength; i++) {
      if (atfImages[i].complete) {
        incCount();
      } else {
        atfImages[i].addEventListener('load', incCount);
      }
    }
  }
  //Collect and send all SPA metrics after ATF images are loaded.
  function gatherSPAMetrics() {
    speedGaugeObj.ttfb = 0;
    speedGaugeObj.ttfp = 0;
    speedGaugeObj.ttfcp = 0;
    gatherCustomTimingData();
    speedGaugeObj.ttfmp = speedGaugeObj.ttfmp - (speedGaugeObj.spaNavStart - perfData.navigationStart);
    //If meaningful paint marker is negative, it means the image was already load complete and no new mark was created.
    //In that case we assign spa dom ready to ttfmp.
    if (speedGaugeObj.ttfmp < 0) {
      speedGaugeObj.ttfmp = speedGaugeObj.spaDomReady - speedGaugeObj.spaNavStart;
    }
    //Assign SPA ATF whenever the current function is called.
    speedGaugeObj.atf = new Date().getTime() - speedGaugeObj.spaNavStart;
    speedGaugeObj.plt = speedGaugeObj.atf;
    calculateRUPEX();
    _setMetrics();
    if (typeof newrelic !== 'undefined') {
      newrelic.addPageAction('SPA Page Load');
    }
  }

  //Main method to gather data
  function main() {
    gatherNavTimingMetrics();
    gatherPaintTimingMetrics();
    gatherCustomTimingData();
    calculateRUPEX();
    gatherSecondaryNavTimingMetrics();
    _setMetrics();
    initSPATracking();
  }
  //Send collected metrics to 3rd party tracking (NewRelic)
  function _setMetrics() {
    if (typeof newrelic !== 'undefined') {
      newrelic.setCustomAttribute("rdc-appname", "BASECAMP");
      newrelic.setCustomAttribute("rdc-ttfb", speedGaugeObj.ttfb);
      newrelic.setCustomAttribute("rdc-ttfp", speedGaugeObj.ttfp);
      newrelic.setCustomAttribute("rdc-ttfcp", speedGaugeObj.ttfcp);
      newrelic.setCustomAttribute("rdc-ttfmp", speedGaugeObj.ttfmp);
      newrelic.setCustomAttribute("rdc-atf", speedGaugeObj.atf);
      newrelic.setCustomAttribute("rdc-plt", speedGaugeObj.plt);
      newrelic.setCustomAttribute("rdc-rupex", speedGaugeObj.rupex);
      newrelic.setCustomAttribute("rdc-dns", speedGaugeObj.dns);
      newrelic.setCustomAttribute("rdc-tcpconnect", speedGaugeObj.tcpconnect);
      newrelic.setCustomAttribute("rdc-ssl", speedGaugeObj.ssl);
      newrelic.setCustomAttribute("rdc-cachelookup", speedGaugeObj.cachelookup);
      newrelic.setCustomAttribute("rdc-redirectlookup", speedGaugeObj.redirectlookup);
      newrelic.setCustomAttribute("rdc-unload", speedGaugeObj.unload);
    }
  }
  //Clear NewRelic Gauge after API call is made.
  function _clearMetrics() {
    if (typeof newrelic !== 'undefined') {
      newrelic.setCustomAttribute("rdc-ttfb", null);
      newrelic.setCustomAttribute("rdc-ttfp", null);
      newrelic.setCustomAttribute("rdc-ttfcp", null);
      newrelic.setCustomAttribute("rdc-ttfmp", null);
      newrelic.setCustomAttribute("rdc-atf", null);
      newrelic.setCustomAttribute("rdc-plt", null);
      newrelic.setCustomAttribute("rdc-rupex", null);
      newrelic.setCustomAttribute("rdc-dns", null);
      newrelic.setCustomAttribute("rdc-tcpconnect", null);
      newrelic.setCustomAttribute("rdc-ssl", null);
      newrelic.setCustomAttribute("rdc-cachelookup", null);
      newrelic.setCustomAttribute("rdc-redirectlookup", null);
      newrelic.setCustomAttribute("rdc-unload", null);
    }
  }
  //Exposed functions to access the SpeedGauge.
  return {
    getMetric: function getMetric(metric_name) {
      //Access collected data from outside the module.
      return speedGaugeObj[metric_name];
    },
    setMetric: function setMetric(metric_name, value) {
      //Modify Gauge data from outside the module.
      speedGaugeObj[metric_name] = value;
    },
    markAs: function markAs() {
      if (perfAPI) {
        for (var i = 0; i < arguments.length; i++) {
          perfAPI.mark(arguments[i]);
        }
      }
      gatherCustomTimingData();
      calculateRUPEX();
      _setMetrics();
    },
    clearMetrics: function clearMetrics() {
      _clearMetrics();
    },
    setMetrics: function setMetrics() {
      _setMetrics();
    },
    init: function init() {
      main();
    }
  };
}();
window.addEventListener('load', function () {
  SpeedRUMModule.init();window.markAs = SpeedRUMModule.markAs;
});

/***/ }),

/***/ 1393:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__pages_ldp_ldp_clicks__ = __webpack_require__(1009);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages_ldp_ldp_page_load__ = __webpack_require__(585);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pages_srp_srp_clicks__ = __webpack_require__(1242);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__pages_srp_srp_page_load__ = __webpack_require__(95);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__pages_srp_srp_tracking_helper__ = __webpack_require__(180);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__shared_clicks__ = __webpack_require__(96);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__shared_common_leads__ = __webpack_require__(102);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__shared_leads__ = __webpack_require__(162);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__shared_mal_leads__ = __webpack_require__(1243);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__shared_modal_impression__ = __webpack_require__(18);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__shared_phone_leads__ = __webpack_require__(626);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__shared_saves__ = __webpack_require__(81);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__shared_search__ = __webpack_require__(1244);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__shared_shares__ = __webpack_require__(124);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__shared_special_events__ = __webpack_require__(49);
/* unused harmony reexport namespace */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__shared_tracking_helper__ = __webpack_require__(1010);
/* unused harmony reexport namespace */



















/***/ }),

/***/ 1394:
/***/ (function(module, exports) {

MOVE.UserProfileLeadInputs = function (MOVE) {

  var setLeadInputs = function setLeadInputs() {
    if ($.cookie('REMEMBER_ME') && !MOVE.DataStore.getData(MOVE.CONSTANTS.CACHED_USER_PROFILE_LEAD_INPUTS)) {
      var account_host = window.location.hostname.includes('sandbox-qa') ? 'myaccount-qa' : 'myaccount';
      $.ajax({
        url: 'https://' + account_host + '.realtor.com/my_profile/index.json',
        headers: { "REMEMBER_ME": $.cookie('REMEMBER_ME') },
        success: function success(data) {
          var inputs = {};
          inputs['fullName'] = [data.nsi_profile.first_name, data.nsi_profile.last_name].join(" ").trim();
          inputs['email'] = data.nsi_profile.email_address;
          inputs['phone'] = data.nsi_profile.phone;
          MOVE.DataStore.setData(MOVE.CONSTANTS.CACHED_USER_PROFILE_LEAD_INPUTS, JSON.stringify(inputs));
        }
      });
    }
  };

  MOVE.UserProfileLeadInputs = {
    setLeadInputs: setLeadInputs
  };
  return MOVE.UserProfileLeadInputs;
}(MOVE || {});

/***/ }),

/***/ 1427:
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: affix.js v3.3.2
 * http://getbootstrap.com/javascript/#affix
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // AFFIX CLASS DEFINITION
  // ======================

  var Affix = function (element, options) {
    this.options = $.extend({}, Affix.DEFAULTS, options)

    this.$target = $(this.options.target)
      .on('scroll.bs.affix.data-api', $.proxy(this.checkPosition, this))
      .on('click.bs.affix.data-api',  $.proxy(this.checkPositionWithEventLoop, this))

    this.$element     = $(element)
    this.affixed      =
    this.unpin        =
    this.pinnedOffset = null

    this.checkPosition()
  }

  Affix.VERSION  = '3.3.2'

  Affix.RESET    = 'affix affix-top affix-bottom'

  Affix.DEFAULTS = {
    offset: 0,
    target: window
  }

  Affix.prototype.getState = function (scrollHeight, height, offsetTop, offsetBottom) {
    var scrollTop    = this.$target.scrollTop()
    var position     = this.$element.offset()
    var targetHeight = this.$target.height()

    if (offsetTop != null && this.affixed == 'top') return scrollTop < offsetTop ? 'top' : false

    if (this.affixed == 'bottom') {
      if (offsetTop != null) return (scrollTop + this.unpin <= position.top) ? false : 'bottom'
      return (scrollTop + targetHeight <= scrollHeight - offsetBottom) ? false : 'bottom'
    }

    var initializing   = this.affixed == null
    var colliderTop    = initializing ? scrollTop : position.top
    var colliderHeight = initializing ? targetHeight : height

    if (offsetTop != null && scrollTop <= offsetTop) return 'top'
    if (offsetBottom != null && (colliderTop + colliderHeight >= scrollHeight - offsetBottom)) return 'bottom'

    return false
  }

  Affix.prototype.getPinnedOffset = function () {
    if (this.pinnedOffset) return this.pinnedOffset
    this.$element.removeClass(Affix.RESET).addClass('affix')
    var scrollTop = this.$target.scrollTop()
    var position  = this.$element.offset()
    return (this.pinnedOffset = position.top - scrollTop)
  }

  Affix.prototype.checkPositionWithEventLoop = function () {
    setTimeout($.proxy(this.checkPosition, this), 1)
  }

  Affix.prototype.checkPosition = function () {
    if (!this.$element.is(':visible')) return

    var height       = this.$element.height()
    var offset       = this.options.offset
    var offsetTop    = offset.top
    var offsetBottom = offset.bottom
    var scrollHeight = $('body').height()

    if (typeof offset != 'object')         offsetBottom = offsetTop = offset
    if (typeof offsetTop == 'function')    offsetTop    = offset.top(this.$element)
    if (typeof offsetBottom == 'function') offsetBottom = offset.bottom(this.$element)

    var affix = this.getState(scrollHeight, height, offsetTop, offsetBottom)

    if (this.affixed != affix) {
      if (this.unpin != null) this.$element.css('top', '')

      var affixType = 'affix' + (affix ? '-' + affix : '')
      var e         = $.Event(affixType + '.bs.affix')

      this.$element.trigger(e)

      if (e.isDefaultPrevented()) return

      this.affixed = affix
      this.unpin = affix == 'bottom' ? this.getPinnedOffset() : null

      this.$element
        .removeClass(Affix.RESET)
        .addClass(affixType)
        .trigger(affixType.replace('affix', 'affixed') + '.bs.affix')
    }

    if (affix == 'bottom') {
      this.$element.offset({
        top: scrollHeight - height - offsetBottom
      })
    }
  }


  // AFFIX PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.affix')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.affix', (data = new Affix(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.affix

  $.fn.affix             = Plugin
  $.fn.affix.Constructor = Affix


  // AFFIX NO CONFLICT
  // =================

  $.fn.affix.noConflict = function () {
    $.fn.affix = old
    return this
  }


  // AFFIX DATA-API
  // ==============

  $(window).on('load', function () {
    $('[data-spy="affix"]').each(function () {
      var $spy = $(this)
      var data = $spy.data()

      data.offset = data.offset || {}

      if (data.offsetBottom != null) data.offset.bottom = data.offsetBottom
      if (data.offsetTop    != null) data.offset.top    = data.offsetTop

      Plugin.call($spy, data)
    })
  })

}(jQuery);


/***/ }),

/***/ 1428:
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: alert.js v3.3.2
 * http://getbootstrap.com/javascript/#alerts
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // ALERT CLASS DEFINITION
  // ======================

  var dismiss = '[data-dismiss="alert"]'
  var Alert   = function (el) {
    $(el).on('click', dismiss, this.close)
  }

  Alert.VERSION = '3.3.2'

  Alert.TRANSITION_DURATION = 150

  Alert.prototype.close = function (e) {
    var $this    = $(this)
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = $(selector)

    if (e) e.preventDefault()

    if (!$parent.length) {
      $parent = $this.closest('.alert')
    }

    $parent.trigger(e = $.Event('close.bs.alert'))

    if (e.isDefaultPrevented()) return

    $parent.removeClass('in')

    function removeElement() {
      // detach from parent, fire event then clean up data
      $parent.detach().trigger('closed.bs.alert').remove()
    }

    $.support.transition && $parent.hasClass('fade') ?
      $parent
        .one('bsTransitionEnd', removeElement)
        .emulateTransitionEnd(Alert.TRANSITION_DURATION) :
      removeElement()
  }


  // ALERT PLUGIN DEFINITION
  // =======================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.alert')

      if (!data) $this.data('bs.alert', (data = new Alert(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.alert

  $.fn.alert             = Plugin
  $.fn.alert.Constructor = Alert


  // ALERT NO CONFLICT
  // =================

  $.fn.alert.noConflict = function () {
    $.fn.alert = old
    return this
  }


  // ALERT DATA-API
  // ==============

  $(document).on('click.bs.alert.data-api', dismiss, Alert.prototype.close)

}(jQuery);


/***/ }),

/***/ 1431:
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: scrollspy.js v3.3.2
 * http://getbootstrap.com/javascript/#scrollspy
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // SCROLLSPY CLASS DEFINITION
  // ==========================

  function ScrollSpy(element, options) {
    var process  = $.proxy(this.process, this)

    this.$body          = $('body')
    this.$scrollElement = $(element).is('body') ? $(window) : $(element)
    this.options        = $.extend({}, ScrollSpy.DEFAULTS, options)
    this.selector       = (this.options.target || '') + ' .nav li > a'
    this.offsets        = []
    this.targets        = []
    this.activeTarget   = null
    this.scrollHeight   = 0

    this.$scrollElement.on('scroll.bs.scrollspy', process)
    this.refresh()
    this.process()
  }

  ScrollSpy.VERSION  = '3.3.2'

  ScrollSpy.DEFAULTS = {
    offset: 10
  }

  ScrollSpy.prototype.getScrollHeight = function () {
    return this.$scrollElement[0].scrollHeight || Math.max(this.$body[0].scrollHeight, document.documentElement.scrollHeight)
  }

  ScrollSpy.prototype.refresh = function () {
    var offsetMethod = 'offset'
    var offsetBase   = 0

    if (!$.isWindow(this.$scrollElement[0])) {
      offsetMethod = 'position'
      offsetBase   = this.$scrollElement.scrollTop()
    }

    this.offsets = []
    this.targets = []
    this.scrollHeight = this.getScrollHeight()

    var self     = this

    this.$body
      .find(this.selector)
      .map(function () {
        var $el   = $(this)
        var href  = $el.data('target') || $el.attr('href')
        var $href = /^#./.test(href) && $(href)

        return ($href
          && $href.length
          && $href.is(':visible')
          && [[$href[offsetMethod]().top + offsetBase, href]]) || null
      })
      .sort(function (a, b) { return a[0] - b[0] })
      .each(function () {
        self.offsets.push(this[0])
        self.targets.push(this[1])
      })
  }

  ScrollSpy.prototype.process = function () {
    var scrollTop    = this.$scrollElement.scrollTop() + this.options.offset
    var scrollHeight = this.getScrollHeight()
    var maxScroll    = this.options.offset + scrollHeight - this.$scrollElement.height()
    var offsets      = this.offsets
    var targets      = this.targets
    var activeTarget = this.activeTarget
    var i

    if (this.scrollHeight != scrollHeight) {
      this.refresh()
    }

    if (scrollTop >= maxScroll) {
      return activeTarget != (i = targets[targets.length - 1]) && this.activate(i)
    }

    if (activeTarget && scrollTop < offsets[0]) {
      this.activeTarget = null
      return this.clear()
    }

    for (i = offsets.length; i--;) {
      activeTarget != targets[i]
        && scrollTop >= offsets[i]
        && (!offsets[i + 1] || scrollTop <= offsets[i + 1])
        && this.activate(targets[i])
    }
  }

  ScrollSpy.prototype.activate = function (target) {
    this.activeTarget = target

    this.clear()

    var selector = this.selector +
        '[data-target="' + target + '"],' +
        this.selector + '[href="' + target + '"]'

    var active = $(selector)
      .parents('li')
      .addClass('active')

    if (active.parent('.dropdown-menu').length) {
      active = active
        .closest('li.dropdown')
        .addClass('active')
    }

    active.trigger('activate.bs.scrollspy')
  }

  ScrollSpy.prototype.clear = function () {
    $(this.selector)
      .parentsUntil(this.options.target, '.active')
      .removeClass('active')
  }


  // SCROLLSPY PLUGIN DEFINITION
  // ===========================

  function Plugin(option) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.scrollspy')
      var options = typeof option == 'object' && option

      if (!data) $this.data('bs.scrollspy', (data = new ScrollSpy(this, options)))
      if (typeof option == 'string') data[option]()
    })
  }

  var old = $.fn.scrollspy

  $.fn.scrollspy             = Plugin
  $.fn.scrollspy.Constructor = ScrollSpy


  // SCROLLSPY NO CONFLICT
  // =====================

  $.fn.scrollspy.noConflict = function () {
    $.fn.scrollspy = old
    return this
  }


  // SCROLLSPY DATA-API
  // ==================

  $(window).on('load.bs.scrollspy.data-api', function () {
    $('[data-spy="scroll"]').each(function () {
      var $spy = $(this)
      Plugin.call($spy, $spy.data())
    })
  })

}(jQuery);


/***/ }),

/***/ 1515:
/***/ (function(module, exports) {

try {
	// test for scope support
	document.createElement('a').querySelector(':scope *');
} catch (error) {
	(function () {
		// scope regex
		var scope = /:scope\b/gi;

		// polyfilled <Element>.querySelector
		var querySelectorWithScope = polyfill(Element.prototype.querySelector);

		Element.prototype.querySelector = function querySelector(selectors) {
			return querySelectorWithScope.apply(this, arguments);
		};

		// polyfilled <Element>.querySelectorAll
		var querySelectorAllWithScope = polyfill(Element.prototype.querySelectorAll);

		Element.prototype.querySelectorAll = function querySelectorAll(selectors) {
			return querySelectorAllWithScope.apply(this, arguments);
		};

		function polyfill(originalQuerySelector) {
			return function (selectors) {
				// whether selectors contain :scope
				var hasScope = selectors && scope.test(selectors);

				if (hasScope) {
					// element id
					var id = this.getAttribute('id');

					if (!id) {
						// update id if falsey or missing
						this.id = 'q' + Math.floor(Math.random() * 9000000) + 1000000;
					}

					// modify arguments
					arguments[0] = selectors.replace(scope, '#' + this.id);

					// result of the original query selector
					var elementOrNodeList = originalQuerySelector.apply(this, arguments);

					if (id === null) {
						// remove id if missing
						this.removeAttribute('id');
					} else if (!id) {
						// restore id if falsey
						this.id = id;
					}

					return elementOrNodeList;
				} else {
					// result of the original query sleector
					return originalQuerySelector.apply(this, arguments);
				}
			};
		}
	})();
}


/***/ }),

/***/ 1517:
/***/ (function(module, exports) {

(function($, undefined) {

/**
 * Unobtrusive scripting adapter for jQuery
 * https://github.com/rails/jquery-ujs
 *
 * Requires jQuery 1.8.0 or later.
 *
 * Released under the MIT license
 *
 */

  // Cut down on the number of issues from people inadvertently including jquery_ujs twice
  // by detecting and raising an error when it happens.
  'use strict';

  if ( $.rails !== undefined ) {
    $.error('jquery-ujs has already been loaded!');
  }

  // Shorthand to make it a little easier to call public rails functions from within rails.js
  var rails;
  var $document = $(document);

  $.rails = rails = {
    // Link elements bound by jquery-ujs
    linkClickSelector: 'a[data-confirm], a[data-method], a[data-remote]:not([disabled]), a[data-disable-with], a[data-disable]',

    // Button elements bound by jquery-ujs
    buttonClickSelector: 'button[data-remote]:not([form]):not(form button), button[data-confirm]:not([form]):not(form button)',

    // Select elements bound by jquery-ujs
    inputChangeSelector: 'select[data-remote], input[data-remote], textarea[data-remote]',

    // Form elements bound by jquery-ujs
    formSubmitSelector: 'form',

    // Form input elements bound by jquery-ujs
    formInputClickSelector: 'form input[type=submit], form input[type=image], form button[type=submit], form button:not([type]), input[type=submit][form], input[type=image][form], button[type=submit][form], button[form]:not([type])',

    // Form input elements disabled during form submission
    disableSelector: 'input[data-disable-with]:enabled, button[data-disable-with]:enabled, textarea[data-disable-with]:enabled, input[data-disable]:enabled, button[data-disable]:enabled, textarea[data-disable]:enabled',

    // Form input elements re-enabled after form submission
    enableSelector: 'input[data-disable-with]:disabled, button[data-disable-with]:disabled, textarea[data-disable-with]:disabled, input[data-disable]:disabled, button[data-disable]:disabled, textarea[data-disable]:disabled',

    // Form required input elements
    requiredInputSelector: 'input[name][required]:not([disabled]), textarea[name][required]:not([disabled])',

    // Form file input elements
    fileInputSelector: 'input[name][type=file]:not([disabled])',

    // Link onClick disable selector with possible reenable after remote submission
    linkDisableSelector: 'a[data-disable-with], a[data-disable]',

    // Button onClick disable selector with possible reenable after remote submission
    buttonDisableSelector: 'button[data-remote][data-disable-with], button[data-remote][data-disable]',

    // Up-to-date Cross-Site Request Forgery token
    csrfToken: function() {
     return $('meta[name=csrf-token]').attr('content');
    },

    // URL param that must contain the CSRF token
    csrfParam: function() {
     return $('meta[name=csrf-param]').attr('content');
    },

    // Make sure that every Ajax request sends the CSRF token
    CSRFProtection: function(xhr) {
      var token = rails.csrfToken();
      if (token) xhr.setRequestHeader('X-CSRF-Token', token);
    },

    // Make sure that all forms have actual up-to-date tokens (cached forms contain old ones)
    refreshCSRFTokens: function(){
      $('form input[name="' + rails.csrfParam() + '"]').val(rails.csrfToken());
    },

    // Triggers an event on an element and returns false if the event result is false
    fire: function(obj, name, data) {
      var event = $.Event(name);
      obj.trigger(event, data);
      return event.result !== false;
    },

    // Default confirm dialog, may be overridden with custom confirm dialog in $.rails.confirm
    confirm: function(message) {
      return confirm(message);
    },

    // Default ajax function, may be overridden with custom function in $.rails.ajax
    ajax: function(options) {
      return $.ajax(options);
    },

    // Default way to get an element's href. May be overridden at $.rails.href.
    href: function(element) {
      return element[0].href;
    },

    // Checks "data-remote" if true to handle the request through a XHR request.
    isRemote: function(element) {
      return element.data('remote') !== undefined && element.data('remote') !== false;
    },

    // Submits "remote" forms and links with ajax
    handleRemote: function(element) {
      var method, url, data, withCredentials, dataType, options;

      if (rails.fire(element, 'ajax:before')) {
        withCredentials = element.data('with-credentials') || null;
        dataType = element.data('type') || ($.ajaxSettings && $.ajaxSettings.dataType);

        if (element.is('form')) {
          method = element.data('ujs:submit-button-formmethod') || element.attr('method');
          url = element.data('ujs:submit-button-formaction') || element.attr('action');
          data = $(element[0]).serializeArray();
          // memoized value from clicked submit button
          var button = element.data('ujs:submit-button');
          if (button) {
            data.push(button);
            element.data('ujs:submit-button', null);
          }
          element.data('ujs:submit-button-formmethod', null);
          element.data('ujs:submit-button-formaction', null);
        } else if (element.is(rails.inputChangeSelector)) {
          method = element.data('method');
          url = element.data('url');
          data = element.serialize();
          if (element.data('params')) data = data + '&' + element.data('params');
        } else if (element.is(rails.buttonClickSelector)) {
          method = element.data('method') || 'get';
          url = element.data('url');
          data = element.serialize();
          if (element.data('params')) data = data + '&' + element.data('params');
        } else {
          method = element.data('method');
          url = rails.href(element);
          data = element.data('params') || null;
        }

        options = {
          type: method || 'GET', data: data, dataType: dataType,
          // stopping the "ajax:beforeSend" event will cancel the ajax request
          beforeSend: function(xhr, settings) {
            if (settings.dataType === undefined) {
              xhr.setRequestHeader('accept', '*/*;q=0.5, ' + settings.accepts.script);
            }
            if (rails.fire(element, 'ajax:beforeSend', [xhr, settings])) {
              element.trigger('ajax:send', xhr);
            } else {
              return false;
            }
          },
          success: function(data, status, xhr) {
            element.trigger('ajax:success', [data, status, xhr]);
          },
          complete: function(xhr, status) {
            element.trigger('ajax:complete', [xhr, status]);
          },
          error: function(xhr, status, error) {
            element.trigger('ajax:error', [xhr, status, error]);
          },
          crossDomain: rails.isCrossDomain(url)
        };

        // There is no withCredentials for IE6-8 when
        // "Enable native XMLHTTP support" is disabled
        if (withCredentials) {
          options.xhrFields = {
            withCredentials: withCredentials
          };
        }

        // Only pass url to `ajax` options if not blank
        if (url) { options.url = url; }

        return rails.ajax(options);
      } else {
        return false;
      }
    },

    // Determines if the request is a cross domain request.
    isCrossDomain: function(url) {
      var originAnchor = document.createElement('a');
      originAnchor.href = location.href;
      var urlAnchor = document.createElement('a');

      try {
        urlAnchor.href = url;
        // This is a workaround to a IE bug.
        urlAnchor.href = urlAnchor.href;

        // If URL protocol is false or is a string containing a single colon
        // *and* host are false, assume it is not a cross-domain request
        // (should only be the case for IE7 and IE compatibility mode).
        // Otherwise, evaluate protocol and host of the URL against the origin
        // protocol and host.
        return !(((!urlAnchor.protocol || urlAnchor.protocol === ':') && !urlAnchor.host) ||
          (originAnchor.protocol + '//' + originAnchor.host ===
            urlAnchor.protocol + '//' + urlAnchor.host));
      } catch (e) {
        // If there is an error parsing the URL, assume it is crossDomain.
        return true;
      }
    },

    // Handles "data-method" on links such as:
    // <a href="/users/5" data-method="delete" rel="nofollow" data-confirm="Are you sure?">Delete</a>
    handleMethod: function(link) {
      var href = rails.href(link),
        method = link.data('method'),
        target = link.attr('target'),
        csrfToken = rails.csrfToken(),
        csrfParam = rails.csrfParam(),
        form = $('<form method="post" action="' + href + '"></form>'),
        metadataInput = '<input name="_method" value="' + method + '" type="hidden" />';

      if (csrfParam !== undefined && csrfToken !== undefined && !rails.isCrossDomain(href)) {
        metadataInput += '<input name="' + csrfParam + '" value="' + csrfToken + '" type="hidden" />';
      }

      if (target) { form.attr('target', target); }

      form.hide().append(metadataInput).appendTo('body');
      form.submit();
    },

    // Helper function that returns form elements that match the specified CSS selector
    // If form is actually a "form" element this will return associated elements outside the from that have
    // the html form attribute set
    formElements: function(form, selector) {
      return form.is('form') ? $(form[0].elements).filter(selector) : form.find(selector);
    },

    /* Disables form elements:
      - Caches element value in 'ujs:enable-with' data store
      - Replaces element text with value of 'data-disable-with' attribute
      - Sets disabled property to true
    */
    disableFormElements: function(form) {
      rails.formElements(form, rails.disableSelector).each(function() {
        rails.disableFormElement($(this));
      });
    },

    disableFormElement: function(element) {
      var method, replacement;

      method = element.is('button') ? 'html' : 'val';
      replacement = element.data('disable-with');

      if (replacement !== undefined) {
        element.data('ujs:enable-with', element[method]());
        element[method](replacement);
      }

      element.prop('disabled', true);
      element.data('ujs:disabled', true);
    },

    /* Re-enables disabled form elements:
      - Replaces element text with cached value from 'ujs:enable-with' data store (created in `disableFormElements`)
      - Sets disabled property to false
    */
    enableFormElements: function(form) {
      rails.formElements(form, rails.enableSelector).each(function() {
        rails.enableFormElement($(this));
      });
    },

    enableFormElement: function(element) {
      var method = element.is('button') ? 'html' : 'val';
      if (element.data('ujs:enable-with') !== undefined) {
        element[method](element.data('ujs:enable-with'));
        element.removeData('ujs:enable-with'); // clean up cache
      }
      element.prop('disabled', false);
      element.removeData('ujs:disabled');
    },

   /* For 'data-confirm' attribute:
      - Fires `confirm` event
      - Shows the confirmation dialog
      - Fires the `confirm:complete` event

      Returns `true` if no function stops the chain and user chose yes; `false` otherwise.
      Attaching a handler to the element's `confirm` event that returns a `falsy` value cancels the confirmation dialog.
      Attaching a handler to the element's `confirm:complete` event that returns a `falsy` value makes this function
      return false. The `confirm:complete` event is fired whether or not the user answered true or false to the dialog.
   */
    allowAction: function(element) {
      var message = element.data('confirm'),
          answer = false, callback;
      if (!message) { return true; }

      if (rails.fire(element, 'confirm')) {
        try {
          answer = rails.confirm(message);
        } catch (e) {
          (console.error || console.log).call(console, e.stack || e);
        }
        callback = rails.fire(element, 'confirm:complete', [answer]);
      }
      return answer && callback;
    },

    // Helper function which checks for blank inputs in a form that match the specified CSS selector
    blankInputs: function(form, specifiedSelector, nonBlank) {
      var foundInputs = $(),
        input,
        valueToCheck,
        radiosForNameWithNoneSelected,
        radioName,
        selector = specifiedSelector || 'input,textarea',
        requiredInputs = form.find(selector),
        checkedRadioButtonNames = {};

      requiredInputs.each(function() {
        input = $(this);
        if (input.is('input[type=radio]')) {

          // Don't count unchecked required radio as blank if other radio with same name is checked,
          // regardless of whether same-name radio input has required attribute or not. The spec
          // states https://www.w3.org/TR/html5/forms.html#the-required-attribute
          radioName = input.attr('name');

          // Skip if we've already seen the radio with this name.
          if (!checkedRadioButtonNames[radioName]) {

            // If none checked
            if (form.find('input[type=radio]:checked[name="' + radioName + '"]').length === 0) {
              radiosForNameWithNoneSelected = form.find(
                'input[type=radio][name="' + radioName + '"]');
              foundInputs = foundInputs.add(radiosForNameWithNoneSelected);
            }

            // We only need to check each name once.
            checkedRadioButtonNames[radioName] = radioName;
          }
        } else {
          valueToCheck = input.is('input[type=checkbox],input[type=radio]') ? input.is(':checked') : !!input.val();
          if (valueToCheck === nonBlank) {
            foundInputs = foundInputs.add(input);
          }
        }
      });
      return foundInputs.length ? foundInputs : false;
    },

    // Helper function which checks for non-blank inputs in a form that match the specified CSS selector
    nonBlankInputs: function(form, specifiedSelector) {
      return rails.blankInputs(form, specifiedSelector, true); // true specifies nonBlank
    },

    // Helper function, needed to provide consistent behavior in IE
    stopEverything: function(e) {
      $(e.target).trigger('ujs:everythingStopped');
      e.stopImmediatePropagation();
      return false;
    },

    //  Replace element's html with the 'data-disable-with' after storing original html
    //  and prevent clicking on it
    disableElement: function(element) {
      var replacement = element.data('disable-with');

      if (replacement !== undefined) {
        element.data('ujs:enable-with', element.html()); // store enabled state
        element.html(replacement);
      }

      element.bind('click.railsDisable', function(e) { // prevent further clicking
        return rails.stopEverything(e);
      });
      element.data('ujs:disabled', true);
    },

    // Restore element to its original state which was disabled by 'disableElement' above
    enableElement: function(element) {
      if (element.data('ujs:enable-with') !== undefined) {
        element.html(element.data('ujs:enable-with')); // set to old enabled state
        element.removeData('ujs:enable-with'); // clean up cache
      }
      element.unbind('click.railsDisable'); // enable element
      element.removeData('ujs:disabled');
    }
  };

  if (rails.fire($document, 'rails:attachBindings')) {

    $.ajaxPrefilter(function(options, originalOptions, xhr){ if ( !options.crossDomain ) { rails.CSRFProtection(xhr); }});

    // This event works the same as the load event, except that it fires every
    // time the page is loaded.
    //
    // See https://github.com/rails/jquery-ujs/issues/357
    // See https://developer.mozilla.org/en-US/docs/Using_Firefox_1.5_caching
    $(window).on('pageshow.rails', function () {
      $($.rails.enableSelector).each(function () {
        var element = $(this);

        if (element.data('ujs:disabled')) {
          $.rails.enableFormElement(element);
        }
      });

      $($.rails.linkDisableSelector).each(function () {
        var element = $(this);

        if (element.data('ujs:disabled')) {
          $.rails.enableElement(element);
        }
      });
    });

    $document.on('ajax:complete', rails.linkDisableSelector, function() {
        rails.enableElement($(this));
    });

    $document.on('ajax:complete', rails.buttonDisableSelector, function() {
        rails.enableFormElement($(this));
    });

    $document.on('click.rails', rails.linkClickSelector, function(e) {
      var link = $(this), method = link.data('method'), data = link.data('params'), metaClick = e.metaKey || e.ctrlKey;
      if (!rails.allowAction(link)) return rails.stopEverything(e);

      if (!metaClick && link.is(rails.linkDisableSelector)) rails.disableElement(link);

      if (rails.isRemote(link)) {
        if (metaClick && (!method || method === 'GET') && !data) { return true; }

        var handleRemote = rails.handleRemote(link);
        // Response from rails.handleRemote() will either be false or a deferred object promise.
        if (handleRemote === false) {
          rails.enableElement(link);
        } else {
          handleRemote.fail( function() { rails.enableElement(link); } );
        }
        return false;

      } else if (method) {
        rails.handleMethod(link);
        return false;
      }
    });

    $document.on('click.rails', rails.buttonClickSelector, function(e) {
      var button = $(this);

      if (!rails.allowAction(button) || !rails.isRemote(button)) return rails.stopEverything(e);

      if (button.is(rails.buttonDisableSelector)) rails.disableFormElement(button);

      var handleRemote = rails.handleRemote(button);
      // Response from rails.handleRemote() will either be false or a deferred object promise.
      if (handleRemote === false) {
        rails.enableFormElement(button);
      } else {
        handleRemote.fail( function() { rails.enableFormElement(button); } );
      }
      return false;
    });

    $document.on('change.rails', rails.inputChangeSelector, function(e) {
      var link = $(this);
      if (!rails.allowAction(link) || !rails.isRemote(link)) return rails.stopEverything(e);

      rails.handleRemote(link);
      return false;
    });

    $document.on('submit.rails', rails.formSubmitSelector, function(e) {
      var form = $(this),
        remote = rails.isRemote(form),
        blankRequiredInputs,
        nonBlankFileInputs;

      if (!rails.allowAction(form)) return rails.stopEverything(e);

      // Skip other logic when required values are missing or file upload is present
      if (form.attr('novalidate') === undefined) {
        if (form.data('ujs:formnovalidate-button') === undefined) {
          blankRequiredInputs = rails.blankInputs(form, rails.requiredInputSelector, false);
          if (blankRequiredInputs && rails.fire(form, 'ajax:aborted:required', [blankRequiredInputs])) {
            return rails.stopEverything(e);
          }
        } else {
          // Clear the formnovalidate in case the next button click is not on a formnovalidate button
          // Not strictly necessary to do here, since it is also reset on each button click, but just to be certain
          form.data('ujs:formnovalidate-button', undefined);
        }
      }

      if (remote) {
        nonBlankFileInputs = rails.nonBlankInputs(form, rails.fileInputSelector);
        if (nonBlankFileInputs) {
          // Slight timeout so that the submit button gets properly serialized
          // (make it easy for event handler to serialize form without disabled values)
          setTimeout(function(){ rails.disableFormElements(form); }, 13);
          var aborted = rails.fire(form, 'ajax:aborted:file', [nonBlankFileInputs]);

          // Re-enable form elements if event bindings return false (canceling normal form submission)
          if (!aborted) { setTimeout(function(){ rails.enableFormElements(form); }, 13); }

          return aborted;
        }

        rails.handleRemote(form);
        return false;

      } else {
        // Slight timeout so that the submit button gets properly serialized
        setTimeout(function(){ rails.disableFormElements(form); }, 13);
      }
    });

    $document.on('click.rails', rails.formInputClickSelector, function(event) {
      var button = $(this);

      if (!rails.allowAction(button)) return rails.stopEverything(event);

      // Register the pressed submit button
      var name = button.attr('name'),
        data = name ? {name:name, value:button.val()} : null;

      var form = button.closest('form');
      if (form.length === 0) {
        form = $('#' + button.attr('form'));
      }
      form.data('ujs:submit-button', data);

      // Save attributes from button
      form.data('ujs:formnovalidate-button', button.attr('formnovalidate'));
      form.data('ujs:submit-button-formaction', button.attr('formaction'));
      form.data('ujs:submit-button-formmethod', button.attr('formmethod'));
    });

    $document.on('ajax:send.rails', rails.formSubmitSelector, function(event) {
      if (this === event.target) rails.disableFormElements($(this));
    });

    $document.on('ajax:complete.rails', rails.formSubmitSelector, function(event) {
      if (this === event.target) rails.enableFormElements($(this));
    });

    $(function(){
      rails.refreshCSRFTokens();
    });
  }

})( jQuery );


/***/ }),

/***/ 1518:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// ===============================================
// AdBlock detector
//
// Attempts to detect the presence of Ad Blocker software and notify listener of its existence.
// Copyright (c) 2017 IAB
//
// The BSD-3 License
// Redistribution and use in source and binary forms, with or without modification, are permitted provided that the following conditions are met:
// 1. Redistributions of source code must retain the above copyright notice, this list of conditions and the following disclaimer.
// 2. Redistributions in binary form must reproduce the above copyright notice, this list of conditions and the following disclaimer in the documentation and/or other materials provided with the distribution.
// 3. Neither the name of the copyright holder nor the names of its contributors may be used to endorse or promote products derived from this software without specific prior written permission.
// THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
// ===============================================

/**
* @name window.adblockDetector
*
* IAB Adblock detector.
* Usage: window.adblockDetector.init(options);
*
* Options object settings
*
*	@prop debug:  boolean
*         Flag to indicate additional debug output should be printed to console
*
*	@prop found: @function
*         Callback function to fire if adblock is detected
*
*	@prop notfound: @function
*         Callback function to fire if adblock is not detected.
*         NOTE: this function may fire multiple times and give false negative
*         responses during a test until adblock is successfully detected.
*
*	@prop complete: @function
*         Callback function to fire once a round of testing is complete.
*         The test result (boolean) is included as a parameter to callback
*
* example: 	window.adblockDetector.init(
				{
					found: function(){ ...},
 					notFound: function(){...}
				}
			);
*
*
*/


(function(win) {

	var version = '1.0';

	var ofs = 'offset', cl = 'client';
	var noop = function(){};

	var testedOnce = false;
	var testExecuting = false;

	var isOldIEevents = (win.addEventListener === undefined);

	/**
	* Options set with default options initialized
	*
	*/
	var _options = {
		loopDelay: 50,
		maxLoop: 5,
		debug: true,
		found: noop, 					// function to fire when adblock detected
		notfound: noop, 				// function to fire if adblock not detected after testing
		complete: noop  				// function to fire after testing completes, passing result as parameter
	}

	function parseAsJson(data){
		var result, fnData;
		try{
			result = JSON.parse(data);
		}
		catch(ex){
			try{
				fnData = new Function("return " + data);
				result = fnData();
			}
			catch(ex){
				log('Failed secondary JSON parse', true);
			}
		}

		return result;
	}

	/**
	* Ajax helper object to download external scripts.
	* Initialize object with an options object
	* Ex:
	  {
		  url : 'http://example.org/url_to_download',
		  method: 'POST|GET',
		  success: callback_function,
		  fail:  callback_function
	  }
	*/
	var AjaxHelper = function(opts){
		var xhr = new XMLHttpRequest();

		this.success = opts.success || noop;
		this.fail = opts.fail || noop;
		var me = this;

		var method = opts.method || 'get';

		/**
		* Abort the request
		*/
		this.abort = function(){
			try{
				xhr.abort();
			}
			catch(ex){
			}
		}

		function stateChange(vals){
			if(xhr.readyState == 4){
				if(xhr.status == 200){
					me.success(xhr.response);
				}
				else{
					// failed
					me.fail(xhr.status);
				}
			}
		}

		xhr.onreadystatechange = stateChange;

		function start(){
			xhr.open(method, opts.url, true);
			xhr.send();
		}

		start();
	}

	/**
	* Object tracking the various block lists
	*/
	var BlockListTracker = function(){
		var me = this;
		var externalBlocklistData = {};

		/**
		* Add a new external URL to track
		*/
		this.addUrl = function(url){
			externalBlocklistData[url] = {
				url: url,
				state: 'pending',
				format: null,
				data: null,
				result: null
			}

			return externalBlocklistData[url];
		}

		/**
		* Loads a block list definition
		*/
		this.setResult = function(urlKey, state, data){
			var obj = externalBlocklistData[urlKey];
			if(obj == null){
				obj = this.addUrl(urlKey);
			}

			obj.state = state;
			if(data == null){
				obj.result = null;
				return;
			}

			if(typeof data === 'string'){
				try{
					data = parseAsJson(data);
					obj.format = 'json';
				}
				catch(ex){
					obj.format = 'easylist';
					// parseEasyList(data);
				}
			}
			obj.data = data;

			return obj;
		}

	}

	var listeners = []; // event response listeners
	var baitNode = null;
	var quickBait = {
		cssClass: 'pub_300x250 pub_300x250m pub_728x90 text-ad textAd text_ad text_ads text-ads text-ad-links'
	};
	var baitTriggers = {
		nullProps: [ofs + 'Parent'],
		zeroProps: []
	};

	baitTriggers.zeroProps = [
		ofs +'Height', ofs +'Left', ofs +'Top', ofs +'Width', ofs +'Height',
		cl + 'Height', cl + 'Width'
	];

	// result object
	var exeResult = {
		quick: null,
		remote: null
	};

	var findResult = null; // result of test for ad blocker

	var timerIds = {
		test: 0,
		download: 0
	};

	function isFunc(fn){
		return typeof(fn) == 'function';
	}

	/**
	* Make a DOM element
	*/
	function makeEl(tag, attributes){
		var k, v, el, attr = attributes;
		var d = document;

		el = d.createElement(tag);

		if(attr){
			for(k in attr){
				if(attr.hasOwnProperty(k)){
					el.setAttribute(k, attr[k]);
				}
			}
		}

		return el;
	}

	function attachEventListener(dom, eventName, handler){
		if(isOldIEevents){
			dom.attachEvent('on' + eventName, handler);
		}
		else{
			dom.addEventListener(eventName, handler, false);
		}
	}

	function log(message, isError){
		if(!_options.debug && !isError){
			return;
		}
		if(win.console && win.console.log){
			if(isError){
				console.error('[ABD] ' + message);
			}
			else{
				console.log('[ABD] ' + message);
			}
		}
	}

	var ajaxDownloads = [];

	/**
	* Load and execute the URL inside a closure function
	*/
	function loadExecuteUrl(url){
		var ajax, result;

		blockLists.addUrl(url);
		// setup call for remote list
		ajax = new AjaxHelper(
			{
				url: url,
				success: function(data){
					log('downloaded file ' + url); // todo - parse and store until use
					result = blockLists.setResult(url, 'success', data);
					try{
						var intervalId = 0,
							retryCount = 0;

						var tryExecuteTest = function(listData){
							if(!testExecuting){
								beginTest(listData, true);
								return true;
							}
							return false;
						}

						if(findResult == true){
							return;
						}

						if(tryExecuteTest(result.data)){
							return;
						}
						else{
							log('Pause before test execution');
							intervalId = setInterval(function(){
								if(tryExecuteTest(result.data) || retryCount++ > 5){
									clearInterval(intervalId);
								}
							}, 250);
						}
					}
					catch(ex){
						log(ex.message + ' url: ' + url, true);
					}
				},
				fail: function(status){
					log(status, true);
					blockLists.setResult(url, 'error', null);
				}
			});

		ajaxDownloads.push(ajax);
	}


	/**
	* Fetch the external lists and initiate the tests
	*/
	function fetchRemoteLists(){
		var i, url;
		var opts = _options;

		for(i=0;i<opts.blockLists.length;i++){
			url = opts.blockLists[i];
			loadExecuteUrl(url);
		}
	}

	function cancelRemoteDownloads(){
		var i, aj;

		for(i=ajaxDownloads.length-1;i >= 0;i--){
			aj = ajaxDownloads.pop();
			aj.abort();
		}
	}


	// =============================================================================
	/**
	* Begin execution of the test
	*/
	function beginTest(bait){
		log('start beginTest');
		if(findResult == true){
			return; // we found it. don't continue executing
		}
		testExecuting = true;
		castBait(bait);

		exeResult.quick = 'testing';

		timerIds.test = setTimeout(
			function(){ reelIn(bait, 1); },
			5);
	}

	/**
	* Create the bait node to see how the browser page reacts
	*/
	function castBait(bait){
		var i, d = document, b = d.body;
		var t;
		var baitStyle = 'width: 1px !important; height: 1px !important; position: absolute !important; left: -10000px !important; top: -1000px !important;'

		if(bait == null || typeof(bait) == 'string'){
			log('invalid bait being cast');
			return;
		}

		if(bait.style != null){
			baitStyle += bait.style;
		}

		baitNode = makeEl('div', {
			'class': bait.cssClass,
			'style': baitStyle
		});

		log('adding bait node to DOM');

		b.appendChild(baitNode);

		// touch these properties
		for(i=0;i<baitTriggers.nullProps.length;i++){
			t = baitNode[baitTriggers.nullProps[i]];
		}
		for(i=0;i<baitTriggers.zeroProps.length;i++){
			t = baitNode[baitTriggers.zeroProps[i]];
		}
	}

	/**
	* Run tests to see if browser has taken the bait and blocked the bait element
	*/
	function reelIn(bait, attemptNum){
		var i, k, v;
		var body = document.body;
		var found = false;

		if(baitNode == null){
			log('recast bait');
			castBait(bait || quickBait);
		}

		if(typeof(bait) == 'string'){
			log('invalid bait used', true);
			if(clearBaitNode()){
				setTimeout(function(){
					testExecuting = false;
				}, 5);
			}

			return;
		}

		if(timerIds.test > 0){
			clearTimeout(timerIds.test);
			timerIds.test = 0;
		}

		// test for issues

		if(body.getAttribute('abp') !== null){
			log('found adblock body attribute');
			found = true;
		}

		for(i=0;i<baitTriggers.nullProps.length;i++){
			if(baitNode[baitTriggers.nullProps[i]] == null){
				if(attemptNum>4)
				found = true;
				log('found adblock null attr: ' + baitTriggers.nullProps[i]);
				break;
			}
			if(found == true){
				break;
			}
		}

		for(i=0;i<baitTriggers.zeroProps.length;i++){
			if(found == true){
				break;
			}
			if(baitNode[baitTriggers.zeroProps[i]] == 0){
				if(attemptNum>4)
				found = true;
				log('found adblock zero attr: ' + baitTriggers.zeroProps[i]);
			}
		}

		if(window.getComputedStyle !== undefined) {
			var baitTemp = window.getComputedStyle(baitNode, null);
			if(baitTemp.getPropertyValue('display') == 'none'
			|| baitTemp.getPropertyValue('visibility') == 'hidden') {
				if(attemptNum>4)
				found = true;
				log('found adblock computedStyle indicator');
			}
		}

		testedOnce = true;

		if(found || attemptNum++ >= _options.maxLoop){
			findResult = found;
			log('exiting test loop - value: ' + findResult);
			notifyListeners();
			if(clearBaitNode()){
				setTimeout(function(){
					testExecuting = false;
				}, 5);
			}
		}
		else{
			timerIds.test = setTimeout(function(){
				reelIn(bait, attemptNum);
			}, _options.loopDelay);
		}
	}

	function clearBaitNode(){
		if(baitNode === null){
			return true;
		}

		try{
			if(isFunc(baitNode.remove)){
				baitNode.remove();
			}
			document.body.removeChild(baitNode);
		}
		catch(ex){
		}
		baitNode = null;

		return true;
	}

	/**
	* Halt the test and any pending timeouts
	*/
	function stopFishing(){
		if(timerIds.test > 0){
			clearTimeout(timerIds.test);
		}
		if(timerIds.download > 0){
			clearTimeout(timerIds.download);
		}

		cancelRemoteDownloads();

		clearBaitNode();
	}

	/**
	* Fire all registered listeners
	*/
	function notifyListeners(){
		var i, funcs;
		if(findResult === null){
			return;
		}
		for(i=0;i<listeners.length;i++){
			funcs = listeners[i];
			try{
				if(funcs != null){
					if(isFunc(funcs['complete'])){
						funcs['complete'](findResult);
					}

					if(findResult && isFunc(funcs['found'])){
						funcs['found']();
					}
					else if(findResult === false && isFunc(funcs['notfound'])){
						funcs['notfound']();
					}
				}
			}
			catch(ex){
				log('Failure in notify listeners ' + ex.Message, true);
			}
		}
	}

	/**
	* Attaches event listener or fires if events have already passed.
	*/
	function attachOrFire(){
		var fireNow = false;
		var fn;

		if(document.readyState){
			if(document.readyState == 'complete'){
				fireNow = true;
			}
		}

		fn = function(){
			beginTest(quickBait, false);
		}

		if(fireNow){
			fn();
		}
		else{
			attachEventListener(win, 'load', fn);
		}
	}


	var blockLists; // tracks external block lists

	/**
	* Public interface of adblock detector
	*/
	var impl = {
		/**
		* Version of the adblock detector package
		*/
		version: version,

		/**
		* Initialization function. See comments at top for options object
		*/
		init: function(options){
			var k, v, funcs;

			if(!options){
				return;
			}

			funcs = {
				complete: noop,
				found: noop,
				notfound: noop
			};

			for(k in options){
				if(options.hasOwnProperty(k)){
					if(k == 'complete' || k == 'found' || k == 'notFound'){
						funcs[k.toLowerCase()] = options[k];
					}
					else{
						_options[k] = options[k];
					}
				}
			}

			listeners.push(funcs);

			blockLists = new BlockListTracker();

			attachOrFire();
		}
	}

	win['adblockDetector'] = impl;

})(window)


/***/ }),

/***/ 1519:
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: dropdown.js v3.3.6
 * http://getbootstrap.com/javascript/#dropdowns
 * ========================================================================
 * Copyright 2011-2016 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */

/* namespaced version for RDC */

+function ($) {
  'use strict';

  // DROPDOWN CLASS DEFINITION
  // =========================

  var backdrop = '.dropdown-backdrop'
  var toggle   = '[data-toggle="rdc-dropdown"]'
  var Dropdown = function (element) {
    $(element).on('click.bs.dropdown', this.toggle)
  }

  Dropdown.VERSION = '3.3.6'

  function getParent($this) {
    var selector = $this.attr('data-target')

    if (!selector) {
      selector = $this.attr('href')
      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
    }

    var $parent = selector && $(selector)

    return $parent && $parent.length ? $parent : $this.parent()
  }

  function clearMenus(e) {
    if (e && e.which === 3) return
    $(backdrop).remove()
    $(toggle).each(function () {
      var $this         = $(this)
      var $parent       = getParent($this)
      var relatedTarget = { relatedTarget: this }

      if (!$parent.hasClass('open')) return

      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return

      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this.attr('aria-expanded', 'false')
      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
    })
  }

  Dropdown.prototype.toggle = function (e) {
    var $this = $(this)

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    clearMenus()

    if (!isActive) {
      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
        // if mobile we use a backdrop because click events don't delegate
        $(document.createElement('div'))
          .addClass('dropdown-backdrop')
          .insertAfter($(this))
          .on('click', clearMenus)
      }

      var relatedTarget = { relatedTarget: this }
      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))

      if (e.isDefaultPrevented()) return

      $this
        .trigger('focus')
        .attr('aria-expanded', 'true')

      $parent
        .toggleClass('open')
        .trigger($.Event('shown.bs.dropdown', relatedTarget))
    }

    return false
  }

  Dropdown.prototype.keydown = function (e) {
    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return

    var $this = $(this)

    e.preventDefault()
    e.stopPropagation()

    if ($this.is('.disabled, :disabled')) return

    var $parent  = getParent($this)
    var isActive = $parent.hasClass('open')

    if (!isActive && e.which != 27 || isActive && e.which == 27) {
      if (e.which == 27) $parent.find(toggle).trigger('focus')
      return $this.trigger('click')
    }

    var desc = ' li:not(.disabled):visible a'
    var $items = $parent.find('.dropdown-menu' + desc)

    if (!$items.length) return

    var index = $items.index(e.target)

    if (e.which == 38 && index > 0)                 index--         // up
    if (e.which == 40 && index < $items.length - 1) index++         // down
    if (!~index)                                    index = 0

    $items.eq(index).trigger('focus')
  }


  // DROPDOWN PLUGIN DEFINITION
  // ==========================

  function Plugin(option) {
    return this.each(function () {
      var $this = $(this)
      var data  = $this.data('bs.dropdown')

      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
      if (typeof option == 'string') data[option].call($this)
    })
  }

  var old = $.fn.dropdown

  $.fn.dropdown             = Plugin
  $.fn.dropdown.Constructor = Dropdown


  // DROPDOWN NO CONFLICT
  // ====================

  $.fn.dropdown.noConflict = function () {
    $.fn.dropdown = old
    return this
  }


  // APPLY TO STANDARD DROPDOWN ELEMENTS
  // ===================================

  $(document)
    .on('click.bs.dropdown.data-api', clearMenus)
    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)

}(jQuery);


/***/ }),

/***/ 1520:
/***/ (function(module, exports) {

/* ========================================================================
 * Bootstrap: modal.js v3.3.4
 * http://getbootstrap.com/javascript/#modals
 * ========================================================================
 * Copyright 2011-2015 Twitter, Inc.
 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
 * ======================================================================== */


+function ($) {
  'use strict';

  // MODAL CLASS DEFINITION
  // ======================

  var Modal = function (element, options) {
    this.options             = options
    this.$body               = $(document.body)
    this.$element            = $(element)
    this.$dialog             = this.$element.find('.modal-dialog')
    this.$backdrop           = null
    this.isShown             = null
    this.originalBodyPad     = null
    this.scrollbarWidth      = 0
    this.ignoreBackdropClick = false

    if (this.options.remote) {
      this.$element
        .find('.modal-content')
        .load(this.options.remote, $.proxy(function () {
          this.$element.trigger('loaded.bs.modal')
        }, this))
    }
  }

  Modal.VERSION  = '3.3.4'

  Modal.TRANSITION_DURATION = 300
  Modal.BACKDROP_TRANSITION_DURATION = 150

  Modal.DEFAULTS = {
    backdrop: true,
    keyboard: true,
    show: true
  }

  Modal.prototype.toggle = function (_relatedTarget) {
    return this.isShown ? this.hide() : this.show(_relatedTarget)
  }

  Modal.prototype.show = function (_relatedTarget) {
    var that = this
    var e    = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })

    this.$element.trigger(e)

    if (this.isShown || e.isDefaultPrevented()) return

    this.isShown = true

    this.checkScrollbar()
    this.setScrollbar()
    ipadFormModal(true);
    this.$body.addClass('modal-open')

    this.escape()
    this.resize()

    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))

    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
      })
    })

    this.backdrop(function () {
      var transition = $.support.transition && that.$element.hasClass('fade')

      if (!that.$element.parent().length) {
        that.$element.appendTo(that.$body) // don't move modals dom position
      }

      that.$element
        .show()
        .scrollTop(0)

      that.adjustDialog()

      if (transition) {
        that.$element[0].offsetWidth // force reflow
      }

      that.$element
        .addClass('in')
        .attr('aria-hidden', false)

      that.enforceFocus()

      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })

      transition ?
        that.$dialog // wait for modal to slide in
          .one('bsTransitionEnd', function () {
            that.$element.trigger('focus').trigger(e)
          })
          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
        that.$element.trigger('focus').trigger(e)
    })
  }

  Modal.prototype.hide = function (e) {
    if (e) e.preventDefault()

    e = $.Event('hide.bs.modal')

    this.$element.trigger(e)

    if (!this.isShown || e.isDefaultPrevented()) return

    this.isShown = false

    this.escape()
    this.resize()

    $(document).off('focusin.bs.modal')

    this.$element
      .removeClass('in')
      .attr('aria-hidden', true)
      .off('click.dismiss.bs.modal')
      .off('mouseup.dismiss.bs.modal')

    this.$dialog.off('mousedown.dismiss.bs.modal')

    $.support.transition && this.$element.hasClass('fade') ?
      this.$element
        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
      this.hideModal()
  }


  function ipadFormModal(isModalOpen) {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;
    if (/iPad|iPod/.test(userAgent) && !window.MSStream) {
      var scrollTopPos = Math.abs(parseInt($("body").css("margin-top"), 10)) || $(window).scrollTop();
      var thankYouModalMarginTop = '';
      if ($(".modal").is(':visible')) {
        thankYouModalMarginTop = "-" + scrollTopPos + "px";
      }
      if(isModalOpen){
        $("body").css({"position" : "fixed", "margin-top": "-" + scrollTopPos + "px",  right: 0, left: 0, top: 0, bottom: 0, "padding-right": 0});
      }
      else{
        $("body").css({"position": '', "margin-top": thankYouModalMarginTop,  right: '', left: '', top: '', bottom: '', "padding-right": ''});
        if (thankYouModalMarginTop === ''){
          $(window).scrollTop(scrollTopPos);
        }
      }
    }
  }


  Modal.prototype.enforceFocus = function () {
    $(document)
      .off('focusin.bs.modal') // guard against infinite focus loop
      .on('focusin.bs.modal', $.proxy(function (e) {
        if (this.$element[0] !== e.target && !this.$element.has(e.target).length) {
          this.$element.trigger('focus')
        }
      }, this))
  }

  Modal.prototype.escape = function () {
    if (this.isShown && this.options.keyboard) {
      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
        e.which == 27 && this.hide()
      }, this))
    } else if (!this.isShown) {
      this.$element.off('keydown.dismiss.bs.modal')
    }
  }

  Modal.prototype.resize = function () {
    if (this.isShown) {
      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
    } else {
      $(window).off('resize.bs.modal')
    }
  }

  Modal.prototype.hideModal = function () {
    var that = this
    this.$element.hide()
    this.backdrop(function () {
      ipadFormModal(false)
      that.$body.removeClass('modal-open')
      that.resetAdjustments()
      that.resetScrollbar()
      that.$element.trigger('hidden.bs.modal')
    })
  }

  Modal.prototype.removeBackdrop = function () {
    this.$backdrop && this.$backdrop.remove()
    this.$backdrop = null
  }

  Modal.prototype.backdrop = function (callback) {
    var that = this
    var animate = this.$element.hasClass('fade') ? 'fade' : ''

    if (this.isShown && this.options.backdrop) {
      var doAnimate = $.support.transition && animate

      this.$backdrop = $('<div class="modal-backdrop ' + animate + '" />')
        .appendTo(this.$body)

      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
        if (this.ignoreBackdropClick) {
          this.ignoreBackdropClick = false
          return
        }
        if (e.target !== e.currentTarget) return
        this.options.backdrop == 'static'
          ? this.$element[0].focus()
          : this.hide()
      }, this))

      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow

      this.$backdrop.addClass('in')

      if (!callback) return

      doAnimate ?
        this.$backdrop
          .one('bsTransitionEnd', callback)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callback()

    } else if (!this.isShown && this.$backdrop) {
      this.$backdrop.removeClass('in')

      var callbackRemove = function () {
        that.removeBackdrop()
        callback && callback()
      }
      $.support.transition && this.$element.hasClass('fade') ?
        this.$backdrop
          .one('bsTransitionEnd', callbackRemove)
          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
        callbackRemove()

    } else if (callback) {
      callback()
    }
  }

  // these following methods are used to handle overflowing modals

  Modal.prototype.handleUpdate = function () {
    this.adjustDialog()
  }

  Modal.prototype.adjustDialog = function () {
    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight

    this.$element.css({
      paddingLeft:  !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
    })
  }

  Modal.prototype.resetAdjustments = function () {
    this.$element.css({
      paddingLeft: '',
      paddingRight: ''
    })
  }

  Modal.prototype.checkScrollbar = function () {
    var fullWindowWidth = window.innerWidth
    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
      var documentElementRect = document.documentElement.getBoundingClientRect()
      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
    }
    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
    this.scrollbarWidth = this.measureScrollbar()
  }

  Modal.prototype.setScrollbar = function () {
    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
    this.originalBodyPad = document.body.style.paddingRight || ''
    if (this.bodyIsOverflowing) this.$body.css('padding-right', bodyPad + this.scrollbarWidth)
  }

  Modal.prototype.resetScrollbar = function () {
    this.$body.css('padding-right', this.originalBodyPad)
  }

  Modal.prototype.measureScrollbar = function () { // thx walsh
    var scrollDiv = document.createElement('div')
    scrollDiv.className = 'modal-scrollbar-measure'
    this.$body.append(scrollDiv)
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
    this.$body[0].removeChild(scrollDiv)
    return scrollbarWidth
  }


  // MODAL PLUGIN DEFINITION
  // =======================

  function Plugin(option, _relatedTarget) {
    return this.each(function () {
      var $this   = $(this)
      var data    = $this.data('bs.modal')
      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)

      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
      if (typeof option == 'string') data[option](_relatedTarget)
      else if (options.show) data.show(_relatedTarget)
    })
  }

  var old = $.fn.modal

  $.fn.modal             = Plugin
  $.fn.modal.Constructor = Modal


  // MODAL NO CONFLICT
  // =================

  $.fn.modal.noConflict = function () {
    $.fn.modal = old
    return this
  }


  // MODAL DATA-API
  // ==============

  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
    var $this   = $(this)
    var href    = $this.attr('href')
    var $target = $($this.attr('data-target') || (href && href.replace(/.*(?=#[^\s]+$)/, ''))) // strip for ie7
    var option  = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())

    if ($this.is('a')) e.preventDefault()

    $target.one('show.bs.modal', function (showEvent) {
      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
      $target.one('hidden.bs.modal', function () {
        $this.is(':visible') && $this.trigger('focus')
      })
    })
    Plugin.call($target, option, this)
  })

}(jQuery);


/***/ }),

/***/ 1521:
/***/ (function(module, exports) {


(function ($) {
  'use strict';

  //<editor-fold desc="Shims">
  if (!String.prototype.includes) {
    (function () {
      'use strict'; // needed to support `apply`/`call` with `undefined`/`null`
      var toString = {}.toString;
      var defineProperty = (function () {
        // IE 8 only supports `Object.defineProperty` on DOM elements
        try {
          var object = {};
          var $defineProperty = Object.defineProperty;
          var result = $defineProperty(object, object, object) && $defineProperty;
        } catch (error) {
        }
        return result;
      }());
      var indexOf = ''.indexOf;
      var includes = function (search) {
        if (this == null) {
          throw TypeError();
        }
        var string = String(this);
        if (search && toString.call(search) == '[object RegExp]') {
          throw TypeError();
        }
        var stringLength = string.length;
        var searchString = String(search);
        var searchLength = searchString.length;
        var position = arguments.length > 1 ? arguments[1] : undefined;
        // `ToInteger`
        var pos = position ? Number(position) : 0;
        if (pos != pos) { // better `isNaN`
          pos = 0;
        }
        var start = Math.min(Math.max(pos, 0), stringLength);
        // Avoid the `indexOf` call if no match is possible
        if (searchLength + start > stringLength) {
          return false;
        }
        return indexOf.call(string, searchString, pos) != -1;
      };
      if (defineProperty) {
        defineProperty(String.prototype, 'includes', {
          'value': includes,
          'configurable': true,
          'writable': true
        });
      } else {
        String.prototype.includes = includes;
      }
    }());
  }

  if (!String.prototype.startsWith) {
    (function () {
      'use strict'; // needed to support `apply`/`call` with `undefined`/`null`
      var defineProperty = (function () {
        // IE 8 only supports `Object.defineProperty` on DOM elements
        try {
          var object = {};
          var $defineProperty = Object.defineProperty;
          var result = $defineProperty(object, object, object) && $defineProperty;
        } catch (error) {
        }
        return result;
      }());
      var toString = {}.toString;
      var startsWith = function (search) {
        if (this == null) {
          throw TypeError();
        }
        var string = String(this);
        if (search && toString.call(search) == '[object RegExp]') {
          throw TypeError();
        }
        var stringLength = string.length;
        var searchString = String(search);
        var searchLength = searchString.length;
        var position = arguments.length > 1 ? arguments[1] : undefined;
        // `ToInteger`
        var pos = position ? Number(position) : 0;
        if (pos != pos) { // better `isNaN`
          pos = 0;
        }
        var start = Math.min(Math.max(pos, 0), stringLength);
        // Avoid the `indexOf` call if no match is possible
        if (searchLength + start > stringLength) {
          return false;
        }
        var index = -1;
        while (++index < searchLength) {
          if (string.charCodeAt(start + index) != searchString.charCodeAt(index)) {
            return false;
          }
        }
        return true;
      };
      if (defineProperty) {
        defineProperty(String.prototype, 'startsWith', {
          'value': startsWith,
          'configurable': true,
          'writable': true
        });
      } else {
        String.prototype.startsWith = startsWith;
      }
    }());
  }
  //</editor-fold>

  // Case insensitive contains search
  $.expr[':'].icontains = function (obj, index, meta) {
    var $obj = $(obj);
    var haystack = ($obj.data('tokens') || $obj.text()).toUpperCase();
    return haystack.includes(meta[3].toUpperCase());
  };

  // Case insensitive begins search
  $.expr[':'].ibegins = function (obj, index, meta) {
    var $obj = $(obj);
    var haystack = ($obj.data('tokens') || $obj.text()).toUpperCase();
    return haystack.startsWith(meta[3].toUpperCase());
  };

  // Case and accent insensitive contains search
  $.expr[':'].aicontains = function (obj, index, meta) {
    var $obj = $(obj);
    var haystack = ($obj.data('tokens') || $obj.data('normalizedText') || $obj.text()).toUpperCase();
    return haystack.includes(haystack, meta[3]);
  };

  // Case and accent insensitive begins search
  $.expr[':'].aibegins = function (obj, index, meta) {
    var $obj = $(obj);
    var haystack = ($obj.data('tokens') || $obj.data('normalizedText') || $obj.text()).toUpperCase();
    return haystack.startsWith(meta[3].toUpperCase());
  };

  /**
   * Remove all diatrics from the given text.
   * @access private
   * @param {String} text
   * @returns {String}
   */
  function normalizeToBase(text) {
    var rExps = [
      {re: /[\xC0-\xC6]/g, ch: "A"},
      {re: /[\xE0-\xE6]/g, ch: "a"},
      {re: /[\xC8-\xCB]/g, ch: "E"},
      {re: /[\xE8-\xEB]/g, ch: "e"},
      {re: /[\xCC-\xCF]/g, ch: "I"},
      {re: /[\xEC-\xEF]/g, ch: "i"},
      {re: /[\xD2-\xD6]/g, ch: "O"},
      {re: /[\xF2-\xF6]/g, ch: "o"},
      {re: /[\xD9-\xDC]/g, ch: "U"},
      {re: /[\xF9-\xFC]/g, ch: "u"},
      {re: /[\xC7-\xE7]/g, ch: "c"},
      {re: /[\xD1]/g, ch: "N"},
      {re: /[\xF1]/g, ch: "n"}
    ];
    $.each(rExps, function () {
      text = text.replace(this.re, this.ch);
    });
    return text;
  }


  function htmlEscape(html) {
    var escapeMap = {
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#x27;',
      '`': '&#x60;'
    };
    var source = '(?:' + Object.keys(escapeMap).join('|') + ')',
        testRegexp = new RegExp(source),
        replaceRegexp = new RegExp(source, 'g'),
        string = html == null ? '' : '' + html;
    return testRegexp.test(string) ? string.replace(replaceRegexp, function (match) {
      return escapeMap[match];
    }) : string;
  }

  var Selectpicker = function (element, options, e) {
    if (e) {
      e.stopPropagation();
      e.preventDefault();
    }

    this.$element = $(element);
    this.$newElement = null;
    this.$button = null;
    this.$menu = null;
    this.$lis = null;
    this.options = options;

    // If we have no title yet, try to pull it from the html title attribute (jQuery doesnt' pick it up as it's not a
    // data-attribute)
    if (this.options.title === null) {
      this.options.title = this.$element.attr('title');
    }

    //Expose public methods
    this.val = Selectpicker.prototype.val;
    this.render = Selectpicker.prototype.render;
    this.refresh = Selectpicker.prototype.refresh;
    this.setStyle = Selectpicker.prototype.setStyle;
    this.selectAll = Selectpicker.prototype.selectAll;
    this.deselectAll = Selectpicker.prototype.deselectAll;
    this.destroy = Selectpicker.prototype.remove;
    this.remove = Selectpicker.prototype.remove;
    this.show = Selectpicker.prototype.show;
    this.hide = Selectpicker.prototype.hide;

    this.init();
  };

  Selectpicker.VERSION = '1.6.4';

  // part of this is duplicated in i18n/defaults-en_US.js. Make sure to update both.
  Selectpicker.DEFAULTS = {
    noneSelectedText: 'Nothing selected',
    noneResultsText: 'No results matched {0}',
    countSelectedText: function (numSelected, numTotal) {
      return (numSelected == 1) ? "{0} item selected" : "{0} items selected";
    },
    maxOptionsText: function (numAll, numGroup) {
      return [
        (numAll == 1) ? 'Limit reached ({n} item max)' : 'Limit reached ({n} items max)',
        (numGroup == 1) ? 'Group limit reached ({n} item max)' : 'Group limit reached ({n} items max)'
      ];
    },
    selectAllText: 'Select All',
    deselectAllText: 'Deselect All',
    doneButton: false,
    doneButtonText: 'Close',
    multipleSeparator: ', ',
    style: 'btn-default',
    size: 'auto',
    title: null,
    selectedTextFormat: 'values',
    width: false,
    container: false,
    hideDisabled: false,
    showSubtext: false,
    showIcon: true,
    showContent: true,
    dropupAuto: true,
    header: false,
    liveSearch: false,
    liveSearchPlaceholder: null,
    liveSearchNormalize: false,
    liveSearchStyle: 'contains',
    actionsBox: false,
    iconBase: 'glyphicon',
    tickIcon: 'glyphicon-ok',
    maxOptions: false,
    mobile: false,
    selectOnTab: false,
    dropdownAlignRight: false
  };

  Selectpicker.prototype = {

    constructor: Selectpicker,

    init: function () {
      var that = this,
          id = this.$element.attr('id');

      this.$element.hide();
      this.multiple = this.$element.prop('multiple');
      this.autofocus = this.$element.prop('autofocus');
      this.$newElement = this.createView();
      this.$element.after(this.$newElement);
      this.$button = this.$newElement.children('button');
      this.$menu = this.$newElement.children('.dropdown-menu');
      this.$searchbox = this.$menu.find('input');

      if (this.options.dropdownAlignRight)
        this.$menu.addClass('dropdown-menu-right');

      if (typeof id !== 'undefined') {
        this.$button.attr('data-id', id);
        $('label[for="' + id + '"]').click(function (e) {
          e.preventDefault();
          that.$button.focus();
        });
      }

      this.checkDisabled();
      this.clickListener();
      if (this.options.liveSearch) this.liveSearchListener();
      this.render();
      this.liHeight();
      this.setStyle();
      this.setWidth();
      if (this.options.container) this.selectPosition();
      this.$menu.data('this', this);
      this.$newElement.data('this', this);
      if (this.options.mobile) this.mobile();
    },

    createDropdown: function () {
      // Options
      // If we are multiple, then add the show-tick class by default
      var multiple = this.multiple ? ' show-tick' : '',
          inputGroup = this.$element.parent().hasClass('input-group') ? ' input-group-btn' : '',
          autofocus = this.autofocus ? ' autofocus' : '';
      // Elements
      var header = this.options.header ? '<div class="popover-title"><button type="button" class="close" aria-hidden="true">&times;</button>' + this.options.header + '</div>' : '';
      var searchbox = this.options.liveSearch ?
      '<div class="bs-searchbox">' +
      '<input type="text" class="form-control" autocomplete="off"' +
      (null === this.options.liveSearchPlaceholder ? '' : ' placeholder="' + htmlEscape(this.options.liveSearchPlaceholder) + '"') + '>' +
      '</div>'
          : '';
      var actionsbox = this.multiple && this.options.actionsBox ?
      '<div class="bs-actionsbox">' +
      '<div class="btn-group btn-group-sm btn-block">' +
      '<button class="actions-btn bs-select-all btn btn-default">' +
      this.options.selectAllText +
      '</button>' +
      '<button class="actions-btn bs-deselect-all btn btn-default">' +
      this.options.deselectAllText +
      '</button>' +
      '</div>' +
      '</div>'
          : '';
      var donebutton = this.multiple && this.options.doneButton ?
      '<div class="bs-donebutton">' +
      '<div class="btn-group btn-block">' +
      '<button class="btn btn-sm btn-default">' +
      this.options.doneButtonText +
      '</button>' +
      '</div>' +
      '</div>'
          : '';
      var drop =
          '<div class="btn-group bootstrap-select' + multiple + inputGroup + '">' +
          '<button type="button" class="btn dropdown-toggle" data-toggle="dropdown"' + autofocus + '>' +
          '<span class="filter-option pull-left"></span>&nbsp;' +
          '<span class="caret"></span>' +
          '</button>' +
          '<div class="dropdown-menu open">' +
          header +
          searchbox +
          actionsbox +
          '<ul class="dropdown-menu inner" role="menu">' +
          '</ul>' +
          donebutton +
          '</div>' +
          '</div>';

      return $(drop);
    },

    createView: function () {
      var $drop = this.createDropdown();
      var $li = this.createLi();
      $drop.find('ul').append($li);
      return $drop;
    },

    reloadLi: function () {
      //Remove all children.
      this.destroyLi();
      //Re build
      var $li = this.createLi();
      this.$menu.find('ul').append($li);
    },

    destroyLi: function () {
      this.$menu.find('li').remove();
    },

    createLi: function () {
      var that = this,
          _li = [],
          optID = 0;

      // Helper functions
      /**
       * @param content
       * @param [index]
       * @param [classes]
       * @param [optgroup]
       * @returns {string}
       */
      var generateLI = function (content, index, classes, optgroup) {
        return '<li' +
            ((typeof classes !== 'undefined' & '' !== classes) ? ' class="' + classes + '"' : '') +
            ((typeof index !== 'undefined' & null !== index) ? ' data-original-index="' + index + '"' : '') +
            ((typeof optgroup !== 'undefined' & null !== optgroup) ? 'data-optgroup="' + optgroup + '"' : '') +
            '>' + content + '</li>';
      };

      /**
       * @param text
       * @param [classes]
       * @param [inline]
       * @param [tokens]
       * @returns {string}
       */
      var generateA = function (text, classes, inline, tokens) {
        return '<a tabindex="0"' +
            (typeof classes !== 'undefined' ? ' class="' + classes + '"' : '') +
            (typeof inline !== 'undefined' ? ' style="' + inline + '"' : '') +
            ' data-normalized-text="' + normalizeToBase(htmlEscape(text)) + '"' +
            (typeof tokens !== 'undefined' || tokens !== null ? ' data-tokens="' + tokens + '"' : '') +
            '>' + text +
            '<span class="' + that.options.iconBase + ' ' + that.options.tickIcon + ' check-mark"></span>' +
            '</a>';
      };

      this.$element.find('option').each(function (index) {
        var $this = $(this);

        // Get the class and text for the option
        var optionClass = $this.attr('class') || '',
            inline = $this.attr('style'),
            text = $this.data('content') ? $this.data('content') : $this.html(),
            tokens = $this.data('tokens') ? $this.data('tokens') : null,
            subtext = typeof $this.data('subtext') !== 'undefined' ? '<small class="text-muted">' + $this.data('subtext') + '</small>' : '',
            icon = typeof $this.data('icon') !== 'undefined' ? '<span class="' + that.options.iconBase + ' ' + $this.data('icon') + '"></span> ' : '',
            isDisabled = $this.is(':disabled') || $this.parent().is(':disabled');
        if (icon !== '' && isDisabled) {
          icon = '<span>' + icon + '</span>';
        }

        if (!$this.data('content')) {
          // Prepend any icon and append any subtext to the main text.
          text = icon + '<span class="text">' + text + subtext + '</span>';
        }

        if (that.options.hideDisabled && isDisabled) {
          return;
        }

        if ($this.parent().is('optgroup') && $this.data('divider') !== true) {
          if ($this.index() === 0) { // Is it the first option of the optgroup?
            optID += 1;

            // Get the opt group label
            var label = $this.parent().attr('label');
            var labelSubtext = typeof $this.parent().data('subtext') !== 'undefined' ? '<small class="text-muted">' + $this.parent().data('subtext') + '</small>' : '';
            var labelIcon = $this.parent().data('icon') ? '<span class="' + that.options.iconBase + ' ' + $this.parent().data('icon') + '"></span> ' : '';
            label = labelIcon + '<span class="text">' + label + labelSubtext + '</span>';

            if (index !== 0 && _li.length > 0) { // Is it NOT the first option of the select && are there elements in the dropdown?
              _li.push(generateLI('', null, 'divider', optID + 'div'));
            }

            _li.push(generateLI(label, null, 'dropdown-header', optID));
          }

          _li.push(generateLI(generateA(text, 'opt ' + optionClass, inline, tokens), index, '', optID));
        } else if ($this.data('divider') === true) {
          _li.push(generateLI('', index, 'divider'));
        } else if ($this.data('hidden') === true) {
          _li.push(generateLI(generateA(text, optionClass, inline, tokens), index, 'hidden is-hidden'));
        } else {
          if ($this.prev().is('optgroup')) _li.push(generateLI('', null, 'divider', optID + 'div'));
          _li.push(generateLI(generateA(text, optionClass, inline, tokens), index));
        }
      });

      //If we are not multiple, we don't have a selected item, and we don't have a title, select the first element so something is set in the button
      if (!this.multiple && this.$element.find('option:selected').length === 0 && !this.options.title) {
        this.$element.find('option').eq(0).prop('selected', true).attr('selected', 'selected');
      }

      return $(_li.join(''));
    },

    findLis: function () {
      if (this.$lis == null) this.$lis = this.$menu.find('li');
      return this.$lis;
    },

    /**
     * @param [updateLi] defaults to true
     */
    render: function (updateLi) {
      var that = this;

      //Update the LI to match the SELECT
      if (updateLi !== false) {
        this.$element.find('option').each(function (index) {
          that.setDisabled(index, $(this).is(':disabled') || $(this).parent().is(':disabled'));
          that.setSelected(index, $(this).is(':selected'));
        });
      }

      this.tabIndex();
      var notDisabled = this.options.hideDisabled ? ':enabled' : '';
      var selectedItems = this.$element.find('option:selected' + notDisabled).map(function () {
        var $this = $(this);
        var icon = $this.data('icon') && that.options.showIcon ? '<i class="' + that.options.iconBase + ' ' + $this.data('icon') + '"></i> ' : '';
        var subtext;
        if (that.options.showSubtext && $this.data('subtext') && !that.multiple) {
          subtext = ' <small class="text-muted">' + $this.data('subtext') + '</small>';
        } else {
          subtext = '';
        }
        if (typeof $this.attr('title') !== 'undefined') {
          return $this.attr('title');
        } else if ($this.data('content') && that.options.showContent) {
          return $this.data('content');
        } else {
          return icon + $this.html() + subtext;
        }
      }).toArray();

      //Fixes issue in IE10 occurring when no default option is selected and at least one option is disabled
      //Convert all the values into a comma delimited string
      var title = !this.multiple ? selectedItems[0] : selectedItems.join(this.options.multipleSeparator);

      //If this is multi select, and the selectText type is count, the show 1 of 2 selected etc..
      if (this.multiple && this.options.selectedTextFormat.indexOf('count') > -1) {
        var max = this.options.selectedTextFormat.split('>');
        if ((max.length > 1 && selectedItems.length > max[1]) || (max.length == 1 && selectedItems.length >= 2)) {
          notDisabled = this.options.hideDisabled ? ', [disabled]' : '';
          var totalCount = this.$element.find('option').not('[data-divider="true"], [data-hidden="true"]' + notDisabled).length,
              tr8nText = (typeof this.options.countSelectedText === 'function') ? this.options.countSelectedText(selectedItems.length, totalCount) : this.options.countSelectedText;
          title = tr8nText.replace('{0}', selectedItems.length.toString()).replace('{1}', totalCount.toString());
        }
      }

      if (this.options.title == undefined) {
        this.options.title = this.$element.attr('title');
      }

      if (this.options.selectedTextFormat == 'static') {
        title = this.options.title;
      }

      //If we dont have a title, then use the default, or if nothing is set at all, use the not selected text
      if (!title) {
        title = typeof this.options.title !== 'undefined' ? this.options.title : this.options.noneSelectedText;
      }

      //strip all html-tags and trim the result
      this.$button.attr('title', $.trim(title.replace(/<[^>]*>?/g, '')));
      this.$button.children('.filter-option').html(title);
    },

    /**
     * @param [style]
     * @param [status]
     */
    setStyle: function (style, status) {
      if (this.$element.attr('class')) {
        this.$newElement.addClass(this.$element.attr('class').replace(/selectpicker|mobile-device|validate\[.*\]/gi, ''));
      }

      var buttonClass = style ? style : this.options.style;

      if (status == 'add') {
        this.$button.addClass(buttonClass);
      } else if (status == 'remove') {
        this.$button.removeClass(buttonClass);
      } else {
        this.$button.removeClass(this.options.style);
        this.$button.addClass(buttonClass);
      }
    },

    liHeight: function () {
      if (this.options.size === false) return;

      var $selectClone = this.$menu.parent().clone().children('.dropdown-toggle').prop('autofocus', false).end().appendTo('body'),
          $menuClone = $selectClone.addClass('open').children('.dropdown-menu'),
          liHeight = $menuClone.find('li').not('.divider, .dropdown-header').filter(':visible').children('a').outerHeight(),
          headerHeight = this.options.header ? $menuClone.find('.popover-title').outerHeight() : 0,
          searchHeight = this.options.liveSearch ? $menuClone.find('.bs-searchbox').outerHeight() : 0,
          actionsHeight = this.options.actionsBox ? $menuClone.find('.bs-actionsbox').outerHeight() : 0,
          doneButtonHeight = this.multiple ? $menuClone.find('.bs-donebutton').outerHeight() : 0;

      $selectClone.remove();

      this.$newElement
          .data('liHeight', liHeight)
          .data('headerHeight', headerHeight)
          .data('searchHeight', searchHeight)
          .data('actionsHeight', actionsHeight)
          .data('doneButtonHeight', doneButtonHeight);
    },

    setSize: function () {
      this.findLis();
      var that = this,
          $menu = this.$menu,
          $menuInner = $menu.children('.inner'),
          selectHeight = this.$newElement.outerHeight(),
          liHeight = this.$newElement.data('liHeight'),
          headerHeight = this.$newElement.data('headerHeight'),
          searchHeight = this.$newElement.data('searchHeight'),
          actionsHeight = this.$newElement.data('actionsHeight'),
          doneButtonHeight = this.$newElement.data('doneButtonHeight'),
          divHeight = this.$lis.filter('.divider').outerHeight(true),
          menuPadding = parseInt($menu.css('padding-top')) +
              parseInt($menu.css('padding-bottom')) +
              parseInt($menu.css('border-top-width')) +
              parseInt($menu.css('border-bottom-width')),
          notDisabled = this.options.hideDisabled ? '.disabled' : '',
          $window = $(window),
          menuExtras = menuPadding + parseInt($menu.css('margin-top')) + parseInt($menu.css('margin-bottom')) + 2,
          menuHeight,
          selectOffsetTop,
          selectOffsetBot,
          posVert = function () {
            // JQuery defines a scrollTop function, but in pure JS it's a property
            //noinspection JSValidateTypes
            selectOffsetTop = that.$newElement.offset().top - $window.scrollTop();
            selectOffsetBot = $window.height() - selectOffsetTop - selectHeight;
          };
      posVert();
      if (this.options.header) $menu.css('padding-top', 0);

      if (this.options.size == 'auto') {
        var getSize = function () {
          var minHeight,
              lisVis = that.$lis.not('.hidden');

          posVert();
          menuHeight = selectOffsetBot - menuExtras;

          if (that.options.dropupAuto) {
            that.$newElement.toggleClass('dropup', selectOffsetTop > selectOffsetBot && (menuHeight - menuExtras) < $menu.height());
          }
          if (that.$newElement.hasClass('dropup')) {
            menuHeight = selectOffsetTop - menuExtras;
          }

          if ((lisVis.length + lisVis.filter('.dropdown-header').length) > 3) {
            minHeight = liHeight * 3 + menuExtras - 2;
          } else {
            minHeight = 0;
          }

          $menu.css({
            'max-height': menuHeight + 'px',
            'overflow': 'hidden',
            'min-height': minHeight + headerHeight + searchHeight + actionsHeight + doneButtonHeight + 'px'
          });
          $menuInner.css({
            'max-height': menuHeight - headerHeight - searchHeight - actionsHeight - doneButtonHeight - menuPadding + 'px',
            'overflow-y': 'auto',
            'min-height': Math.max(minHeight - menuPadding, 0) + 'px'
          });
        };
        getSize();
        this.$searchbox.off('input.getSize propertychange.getSize').on('input.getSize propertychange.getSize', getSize);
        $window.off('resize.getSize scroll.getSize').on('resize.getSize scroll.getSize', getSize);
      } else if (this.options.size && this.options.size != 'auto' && $menu.find('li').not(notDisabled).length > this.options.size) {
        var optIndex = this.$lis.not('.divider').not(notDisabled).children().slice(0, this.options.size).last().parent().index();
        var divLength = this.$lis.slice(0, optIndex + 1).filter('.divider').length;
        menuHeight = liHeight * this.options.size + divLength * divHeight + menuPadding;
        if (that.options.dropupAuto) {
          //noinspection JSUnusedAssignment
          this.$newElement.toggleClass('dropup', selectOffsetTop > selectOffsetBot && menuHeight < $menu.height());
        }
        $menu.css({
          'max-height': menuHeight + headerHeight + searchHeight + actionsHeight + doneButtonHeight + 'px',
          'overflow': 'hidden'
        });
        $menuInner.css({
          'max-height': menuHeight - menuPadding + 'px',
          'overflow-y': 'auto'
        });
      }
    },

    setWidth: function () {
      if (this.options.width == 'auto') {
        this.$menu.css('min-width', '0');

        // Get correct width if element hidden
        var selectClone = this.$newElement.clone().appendTo('body');
        var ulWidth = selectClone.children('.dropdown-menu').css('width');
        var btnWidth = selectClone.css('width', 'auto').children('button').css('width');
        selectClone.remove();

        // Set width to whatever's larger, button title or longest option
        this.$newElement.css('width', Math.max(parseInt(ulWidth), parseInt(btnWidth)) + 'px');
      } else if (this.options.width == 'fit') {
        // Remove inline min-width so width can be changed from 'auto'
        this.$menu.css('min-width', '');
        this.$newElement.css('width', '').addClass('fit-width');
      } else if (this.options.width) {
        // Remove inline min-width so width can be changed from 'auto'
        this.$menu.css('min-width', '');
        this.$newElement.css('width', this.options.width);
      } else {
        // Remove inline min-width/width so width can be changed
        this.$menu.css('min-width', '');
        this.$newElement.css('width', '');
      }
      // Remove fit-width class if width is changed programmatically
      if (this.$newElement.hasClass('fit-width') && this.options.width !== 'fit') {
        this.$newElement.removeClass('fit-width');
      }
    },

    selectPosition: function () {
      var that = this,
          drop = '<div />',
          $drop = $(drop),
          pos,
          actualHeight,
          getPlacement = function ($element) {
            $drop.addClass($element.attr('class').replace(/form-control/gi, '')).toggleClass('dropup', $element.hasClass('dropup'));
            pos = $element.offset();
            actualHeight = $element.hasClass('dropup') ? 0 : $element[0].offsetHeight;
            $drop.css({
              'top': pos.top + actualHeight,
              'left': pos.left,
              'width': $element[0].offsetWidth,
              'position': 'absolute'
            });
          };
      this.$newElement.on('click', function () {
        if (that.isDisabled()) {
          return;
        }
        getPlacement($(this));
        $drop.appendTo(that.options.container);
        $drop.toggleClass('open', !$(this).hasClass('open'));
        $drop.append(that.$menu);
      });
      $(window).on('resize scroll', function () {
        getPlacement(that.$newElement);
      });
      $('html').on('click', function (e) {
        if ($(e.target).closest(that.$newElement).length < 1) {
          $drop.removeClass('open');
        }
      });
    },

    setSelected: function (index, selected) {
      this.findLis();
      this.$lis.filter('[data-original-index="' + index + '"]').toggleClass('selected', selected);
    },

    setDisabled: function (index, disabled) {
      this.findLis();
      if (disabled) {
        this.$lis.filter('[data-original-index="' + index + '"]').addClass('disabled').children('a').attr('href', '#').attr('tabindex', -1);
      } else {
        this.$lis.filter('[data-original-index="' + index + '"]').removeClass('disabled').children('a').removeAttr('href').attr('tabindex', 0);
      }
    },

    isDisabled: function () {
      return this.$element.is(':disabled');
    },

    checkDisabled: function () {
      var that = this;

      if (this.isDisabled()) {
        this.$button.addClass('disabled').attr('tabindex', -1);
      } else {
        if (this.$button.hasClass('disabled')) {
          this.$button.removeClass('disabled');
        }

        if (this.$button.attr('tabindex') == -1 && !this.$element.data('tabindex')) {
          this.$button.removeAttr('tabindex');
        }
      }

      this.$button.click(function () {
        return !that.isDisabled();
      });
    },

    tabIndex: function () {
      if (this.$element.is('[tabindex]')) {
        this.$element.data('tabindex', this.$element.attr('tabindex'));
        this.$button.attr('tabindex', this.$element.data('tabindex'));
      }
    },

    clickListener: function () {
      var that = this;

      this.$newElement.on('touchstart.dropdown', '.dropdown-menu', function (e) {
        e.stopPropagation();
      });

      this.$newElement.on('click', function () {
        that.setSize();
        if (!that.options.liveSearch && !that.multiple) {
          setTimeout(function () {
            that.$menu.find('.selected a').focus();
          }, 10);
        }
      });

      this.$menu.on('click', 'li a', function (e) {
        var $this = $(this),
            clickedIndex = $this.parent().data('originalIndex'),
            prevValue = that.$element.val(),
            prevIndex = that.$element.prop('selectedIndex');

        // Don't close on multi choice menu
        if (that.multiple) {
          e.stopPropagation();
        }

        e.preventDefault();

        //Don't run if we have been disabled
        if (!that.isDisabled() && !$this.parent().hasClass('disabled')) {
          var $options = that.$element.find('option'),
              $option = $options.eq(clickedIndex),
              state = $option.prop('selected'),
              $optgroup = $option.parent('optgroup'),
              maxOptions = that.options.maxOptions,
              maxOptionsGrp = $optgroup.data('maxOptions') || false;

          if (!that.multiple) { // Deselect all others if not multi select box
            $options.prop('selected', false);
            $option.prop('selected', true);
            that.$menu.find('.selected').removeClass('selected');
            that.setSelected(clickedIndex, true);
          } else { // Toggle the one we have chosen if we are multi select.
            $option.prop('selected', !state);
            that.setSelected(clickedIndex, !state);
            $this.blur();

            if (maxOptions !== false || maxOptionsGrp !== false) {
              var maxReached = maxOptions < $options.filter(':selected').length,
                  maxReachedGrp = maxOptionsGrp < $optgroup.find('option:selected').length;

              if ((maxOptions && maxReached) || (maxOptionsGrp && maxReachedGrp)) {
                if (maxOptions && maxOptions == 1) {
                  $options.prop('selected', false);
                  $option.prop('selected', true);
                  that.$menu.find('.selected').removeClass('selected');
                  that.setSelected(clickedIndex, true);
                } else if (maxOptionsGrp && maxOptionsGrp == 1) {
                  $optgroup.find('option:selected').prop('selected', false);
                  $option.prop('selected', true);
                  var optgroupID = $this.data('optgroup');

                  that.$menu.find('.selected').has('a[data-optgroup="' + optgroupID + '"]').removeClass('selected');

                  that.setSelected(clickedIndex, true);
                } else {
                  var maxOptionsArr = (typeof that.options.maxOptionsText === 'function') ?
                          that.options.maxOptionsText(maxOptions, maxOptionsGrp) : that.options.maxOptionsText,
                      maxTxt = maxOptionsArr[0].replace('{n}', maxOptions),
                      maxTxtGrp = maxOptionsArr[1].replace('{n}', maxOptionsGrp),
                      $notify = $('<div class="notify"></div>');
                  // If {var} is set in array, replace it
                  /** @deprecated */
                  if (maxOptionsArr[2]) {
                    maxTxt = maxTxt.replace('{var}', maxOptionsArr[2][maxOptions > 1 ? 0 : 1]);
                    maxTxtGrp = maxTxtGrp.replace('{var}', maxOptionsArr[2][maxOptionsGrp > 1 ? 0 : 1]);
                  }

                  $option.prop('selected', false);

                  that.$menu.append($notify);

                  if (maxOptions && maxReached) {
                    $notify.append($('<div>' + maxTxt + '</div>'));
                    that.$element.trigger('maxReached.bs.select');
                  }

                  if (maxOptionsGrp && maxReachedGrp) {
                    $notify.append($('<div>' + maxTxtGrp + '</div>'));
                    that.$element.trigger('maxReachedGrp.bs.select');
                  }

                  setTimeout(function () {
                    that.setSelected(clickedIndex, false);
                  }, 10);

                  $notify.delay(750).fadeOut(300, function () {
                    $(this).remove();
                  });
                }
              }
            }
          }

          if (!that.multiple) {
            that.$button.focus();
          } else if (that.options.liveSearch) {
            that.$searchbox.focus();
          }

          // Trigger select 'change'
          if ((prevValue != that.$element.val() && that.multiple) || (prevIndex != that.$element.prop('selectedIndex') && !that.multiple)) {
            that.$element.change();
          }
        }
      });

      this.$menu.on('click', 'li.disabled a, .popover-title, .popover-title :not(.close)', function (e) {
        if (e.currentTarget == this) {
          e.preventDefault();
          e.stopPropagation();
          if (that.options.liveSearch) {
            that.$searchbox.focus();
          } else {
            that.$button.focus();
          }
        }
      });

      this.$menu.on('click', 'li.divider, li.dropdown-header', function (e) {
        e.preventDefault();
        e.stopPropagation();
        if (that.options.liveSearch) {
          that.$searchbox.focus();
        } else {
          that.$button.focus();
        }
      });

      this.$menu.on('click', '.popover-title .close', function () {
        that.$button.focus();
      });

      this.$searchbox.on('click', function (e) {
        e.stopPropagation();
      });

      this.$menu.on('click', '.actions-btn', function (e) {
        if (that.options.liveSearch) {
          that.$searchbox.focus();
        } else {
          that.$button.focus();
        }

        e.preventDefault();
        e.stopPropagation();

        if ($(this).hasClass('bs-select-all')) {
          that.selectAll();
        } else {
          that.deselectAll();
        }
        that.$element.change();
      });

      this.$element.change(function () {
        that.render(false);
      });
    },

    liveSearchListener: function () {
      var that = this,
          $no_results = $('<li class="no-results"></li>');

      this.$newElement.on('click.dropdown.data-api touchstart.dropdown.data-api', function () {
        that.$menu.find('.active').removeClass('active');
        if (!!that.$searchbox.val()) {
          that.$searchbox.val('');
          that.$lis.not('.is-hidden').removeClass('hidden');
          if (!!$no_results.parent().length) $no_results.remove();
        }
        if (!that.multiple) that.$menu.find('.selected').addClass('active');
        setTimeout(function () {
          that.$searchbox.focus();
        }, 10);
      });

      this.$searchbox.on('click.dropdown.data-api focus.dropdown.data-api touchend.dropdown.data-api', function (e) {
        e.stopPropagation();
      });

      this.$searchbox.on('input propertychange', function () {
        if (that.$searchbox.val()) {
          var $searchBase = that.$lis.not('.is-hidden').removeClass('hidden').children('a');
          if (that.options.liveSearchNormalize) {
            $searchBase = $searchBase.not(':a' + that._searchStyle() + '(' + normalizeToBase(that.$searchbox.val()) + ')');
          } else {
            $searchBase = $searchBase.not(':' + that._searchStyle() + '(' + that.$searchbox.val() + ')');
          }
          $searchBase.parent().addClass('hidden');

          that.$lis.filter('.dropdown-header').each(function () {
            var $this = $(this),
                optgroup = $this.data('optgroup');

            if (that.$lis.filter('[data-optgroup=' + optgroup + ']').not($this).not('.hidden').length === 0) {
              $this.addClass('hidden');
              that.$lis.filter('[data-optgroup=' + optgroup + 'div]').addClass('hidden');
            }
          });

          var $lisVisible = that.$lis.not('.hidden');

          // hide divider if first or last visible, or if followed by another divider
          $lisVisible.each(function(index) {
            var $this = $(this);

            if ($this.hasClass('divider') && (
              $this.index() === $lisVisible.eq(0).index() ||
              $this.index() === $lisVisible.last().index() ||
              $lisVisible.eq(index + 1).hasClass('divider'))) {
              $this.addClass('hidden');
            }
          });

          if (!that.$lis.not('.hidden, .no-results').length) {
            if (!!$no_results.parent().length) {
              $no_results.remove();
            }
            $no_results.html(that.options.noneResultsText.replace('{0}', '"' + htmlEscape(that.$searchbox.val()) + '"')).show();
            that.$menu.append($no_results);
          } else if (!!$no_results.parent().length) {
            $no_results.remove();
          }

        } else {
          that.$lis.not('.is-hidden').removeClass('hidden');
          if (!!$no_results.parent().length) {
            $no_results.remove();
          }
        }

        that.$lis.filter('.active').removeClass('active');
        that.$lis.not('.hidden, .divider, .dropdown-header').eq(0).addClass('active').children('a').focus();
        $(this).focus();
      });
    },

    _searchStyle: function () {
      var style = 'icontains';
      switch (this.options.liveSearchStyle) {
        case 'begins':
        case 'startsWith':
          style = 'ibegins';
          break;
        case 'contains':
        default:
          break; //no need to change the default
      }

      return style;
    },

    val: function (value) {
      if (typeof value !== 'undefined') {
        this.$element.val(value);
        this.render();

        return this.$element;
      } else {
        return this.$element.val();
      }
    },

    selectAll: function () {
      this.findLis();
      this.$element.find('option:enabled').not('[data-divider], [data-hidden]').prop('selected', true);
      this.$lis.not('.divider, .dropdown-header, .disabled, .hidden').addClass('selected');
      this.render(false);
    },

    deselectAll: function () {
      this.findLis();
      this.$element.find('option:enabled').not('[data-divider], [data-hidden]').prop('selected', false);
      this.$lis.not('.divider, .dropdown-header, .disabled, .hidden').removeClass('selected');
      this.render(false);
    },

    keydown: function (e) {
      var $this = $(this),
          $parent = $this.is('input') ? $this.parent().parent() : $this.parent(),
          $items,
          that = $parent.data('this'),
          index,
          next,
          first,
          last,
          prev,
          nextPrev,
          prevIndex,
          isActive,
          keyCodeMap = {
            32: ' ',
            48: '0',
            49: '1',
            50: '2',
            51: '3',
            52: '4',
            53: '5',
            54: '6',
            55: '7',
            56: '8',
            57: '9',
            59: ';',
            65: 'a',
            66: 'b',
            67: 'c',
            68: 'd',
            69: 'e',
            70: 'f',
            71: 'g',
            72: 'h',
            73: 'i',
            74: 'j',
            75: 'k',
            76: 'l',
            77: 'm',
            78: 'n',
            79: 'o',
            80: 'p',
            81: 'q',
            82: 'r',
            83: 's',
            84: 't',
            85: 'u',
            86: 'v',
            87: 'w',
            88: 'x',
            89: 'y',
            90: 'z',
            96: '0',
            97: '1',
            98: '2',
            99: '3',
            100: '4',
            101: '5',
            102: '6',
            103: '7',
            104: '8',
            105: '9'
          };

      if (that.options.liveSearch) $parent = $this.parent().parent();

      if (that.options.container) $parent = that.$menu;

      $items = $('[role=menu] li a', $parent);

      isActive = that.$menu.parent().hasClass('open');

      if (!isActive && /([0-9]|[A-z])/.test(String.fromCharCode(e.keyCode))) {
        if (!that.options.container) {
          that.setSize();
          that.$menu.parent().addClass('open');
          isActive = true;
        } else {
          that.$newElement.trigger('click');
        }
        that.$searchbox.focus();
      }

      if (that.options.liveSearch) {
        if (/(^9$|27)/.test(e.keyCode.toString(10)) && isActive && that.$menu.find('.active').length === 0) {
          e.preventDefault();
          that.$menu.parent().removeClass('open');
          that.$button.focus();
        }
        $items = $('[role=menu] li:not(.divider):not(.dropdown-header):visible a', $parent);
        if (!$this.val() && !/(38|40)/.test(e.keyCode.toString(10))) {
          if ($items.filter('.active').length === 0) {
            $items = that.$newElement.find('li a');
            if (that.options.liveSearchNormalize) {
              $items = $items.filter(':a' + that._searchStyle() + '(' + normalizeToBase(keyCodeMap[e.keyCode]) + ')');
            } else {
              $items = $items.filter(':' + that._searchStyle() + '(' + keyCodeMap[e.keyCode] + ')');
            }
          }
        }
      }

      if (!$items.length) return;

      if (/(38|40)/.test(e.keyCode.toString(10))) {
        index = $items.index($items.filter(':focus'));
        first = $items.parent(':not(.disabled):visible').first().index();
        last = $items.parent(':not(.disabled):visible').last().index();
        next = $items.eq(index).parent().nextAll(':not(.disabled):visible').eq(0).index();
        prev = $items.eq(index).parent().prevAll(':not(.disabled):visible').eq(0).index();
        nextPrev = $items.eq(next).parent().prevAll(':not(.disabled):visible').eq(0).index();

        if (that.options.liveSearch) {
          $items.each(function (i) {
            if (!$(this).hasClass('disabled')) {
              $(this).data('index', i);
            }
          });
          index = $items.index($items.filter('.active'));
          first = $items.filter(':not(.disabled):visible').first().data('index');
          last = $items.filter(':not(.disabled):visible').last().data('index');
          next = $items.eq(index).nextAll(':not(.disabled):visible').eq(0).data('index');
          prev = $items.eq(index).prevAll(':not(.disabled):visible').eq(0).data('index');
          nextPrev = $items.eq(next).prevAll(':not(.disabled):visible').eq(0).data('index');
        }

        prevIndex = $this.data('prevIndex');

        if (e.keyCode == 38) {
          if (that.options.liveSearch) index -= 1;
          if (index != nextPrev && index > prev) index = prev;
          if (index < first) index = first;
          if (index == prevIndex) index = last;
        } else if (e.keyCode == 40) {
          if (that.options.liveSearch) index += 1;
          if (index == -1) index = 0;
          if (index != nextPrev && index < next) index = next;
          if (index > last) index = last;
          if (index == prevIndex) index = first;
        }

        $this.data('prevIndex', index);

        if (!that.options.liveSearch) {
          $items.eq(index).focus();
        } else {
          e.preventDefault();
          if (!$this.hasClass('dropdown-toggle')) {
            $items.removeClass('active');
            $items.eq(index).addClass('active').children('a').focus();
            $this.focus();
          }
        }

      } else if (!$this.is('input')) {
        var keyIndex = [],
            count,
            prevKey;

        $items.each(function () {
          if (!$(this).parent().hasClass('disabled')) {
            if ($.trim($(this).text().toLowerCase()).substring(0, 1) == keyCodeMap[e.keyCode]) {
              keyIndex.push($(this).parent().index());
            }
          }
        });

        count = $(document).data('keycount');
        count++;
        $(document).data('keycount', count);

        prevKey = $.trim($(':focus').text().toLowerCase()).substring(0, 1);

        if (prevKey != keyCodeMap[e.keyCode]) {
          count = 1;
          $(document).data('keycount', count);
        } else if (count >= keyIndex.length) {
          $(document).data('keycount', 0);
          if (count > keyIndex.length) count = 1;
        }

        $items.eq(keyIndex[count - 1]).focus();
      }

      // Select focused option if "Enter", "Spacebar" or "Tab" (when selectOnTab is true) are pressed inside the menu.
      if ((/(13|32)/.test(e.keyCode.toString(10)) || (/(^9$)/.test(e.keyCode.toString(10)) && that.options.selectOnTab)) && isActive) {
        if (!/(32)/.test(e.keyCode.toString(10))) e.preventDefault();
        if (!that.options.liveSearch) {
          var elem = $(':focus');
          elem.click();
          // Bring back focus for multiselects
          elem.focus();
          // Prevent screen from scrolling if the user hit the spacebar
          e.preventDefault();
        } else if (!/(32)/.test(e.keyCode.toString(10))) {
          that.$menu.find('.active a').click();
          $this.focus();
        }
        $(document).data('keycount', 0);
      }

      if ((/(^9$|27)/.test(e.keyCode.toString(10)) && isActive && (that.multiple || that.options.liveSearch)) || (/(27)/.test(e.keyCode.toString(10)) && !isActive)) {
        that.$menu.parent().removeClass('open');
        that.$button.focus();
      }
    },

    mobile: function () {
      this.$element.addClass('mobile-device').appendTo(this.$newElement);
      if (this.options.container) this.$menu.hide();
    },

    refresh: function () {
      this.$lis = null;
      this.reloadLi();
      this.render();
      this.setWidth();
      this.setStyle();
      this.checkDisabled();
      this.liHeight();
    },

    hide: function () {
      this.$newElement.hide();
    },

    show: function () {
      this.$newElement.show();
    },

    remove: function () {
      this.$newElement.remove();
      this.$element.remove();
    }
  };

  // SELECTPICKER PLUGIN DEFINITION
  // ==============================
  function Plugin(option, event) {
    // get the args of the outer function..
    var args = arguments;
    // The arguments of the function are explicitly re-defined from the argument list, because the shift causes them
    // to get lost/corrupted in android 2.3 and IE9 #715 #775
    var _option = option,
        _event = event;
    [].shift.apply(args);

    var value;
    var chain = this.each(function () {
      var $this = $(this);
      if ($this.is('select')) {
        var data = $this.data('selectpicker'),
            options = typeof _option == 'object' && _option;

        if (!data) {
          var config = $.extend({}, Selectpicker.DEFAULTS, $.fn.selectpicker.defaults || {}, $this.data(), options);
          $this.data('selectpicker', (data = new Selectpicker(this, config, _event)));
        } else if (options) {
          for (var i in options) {
            if (options.hasOwnProperty(i)) {
              data.options[i] = options[i];
            }
          }
        }

        if (typeof _option == 'string') {
          if (data[_option] instanceof Function) {
            value = data[_option].apply(data, args);
          } else {
            value = data.options[_option];
          }
        }
      }
    });

    if (typeof value !== 'undefined') {
      //noinspection JSUnusedAssignment
      return value;
    } else {
      return chain;
    }
  }

  var old = $.fn.selectpicker;
  $.fn.selectpicker = Plugin;
  $.fn.selectpicker.Constructor = Selectpicker;

  // SELECTPICKER NO CONFLICT
  // ========================
  $.fn.selectpicker.noConflict = function () {
    $.fn.selectpicker = old;
    return this;
  };

  $(document)
      .data('keycount', 0)
      .on('keydown', '.bootstrap-select [data-toggle=dropdown], .bootstrap-select [role=menu], .bs-searchbox input', Selectpicker.prototype.keydown)
      .on('focusin.modal', '.bootstrap-select [data-toggle=dropdown], .bootstrap-select [role=menu], .bs-searchbox input', function (e) {
        e.stopPropagation();
      });

  // SELECTPICKER DATA-API
  // =====================
  $(window).on('load.bs.select.data-api', function () {
    $('.selectpicker').each(function () {
      var $selectpicker = $(this);
      Plugin.call($selectpicker, $selectpicker.data());
    })
  });
})(jQuery);


/***/ }),

/***/ 1522:
/***/ (function(module, exports) {

/*!
 * jquery.customSelect() - v0.5.1
 * http://adam.co/lab/jquery/customselect/
 * 2014-04-19
 *
 * Copyright 2013 Adam Coulombe
 * @license http://www.opensource.org/licenses/mit-license.html MIT License
 * @license http://www.gnu.org/licenses/gpl.html GPL2 License
 */
(function(a){a.fn.extend({customSelect:function(c){if(typeof document.body.style.maxHeight==="undefined"){return this}var e={customClass:"customSelect",mapClass:true,mapStyle:true},c=a.extend(e,c),d=c.customClass,f=function(h,k){var g=h.find(":selected"),j=k.children(":first"),i=g.html()||"&nbsp;";j.html(i);if(g.attr("disabled")){k.addClass(b("DisabledOption"))}else{k.removeClass(b("DisabledOption"))}setTimeout(function(){k.removeClass(b("Open"));a(document).off("mouseup.customSelect")},60)},b=function(g){return d+g};return this.each(function(){var g=a(this),i=a("<span />").addClass(b("Inner")),h=a("<span />");g.after(h.append(i));h.addClass(d);if(c.mapClass){h.addClass(g.attr("class"))}if(c.mapStyle){h.attr("style",g.attr("style"))}g.addClass("hasCustomSelect").on("render.customSelect",function(){f(g,h);g.css("width","");var k=parseInt(g.outerWidth(),10)-(parseInt(h.outerWidth(),10)-parseInt(h.width(),10));h.css({display:"inline-block"});var j=h.outerHeight();if(g.attr("disabled")){h.addClass(b("Disabled"))}else{h.removeClass(b("Disabled"))}i.css({width:k,display:"inline-block"});g.css({"-webkit-appearance":"menulist-button",width:h.outerWidth(),position:"absolute",opacity:0,height:j,fontSize:h.css("font-size")})}).on("change.customSelect",function(){h.addClass(b("Changed"));f(g,h)}).on("keyup.customSelect",function(j){if(!h.hasClass(b("Open"))){g.trigger("blur.customSelect");g.trigger("focus.customSelect")}else{if(j.which==13||j.which==27){f(g,h)}}}).on("mousedown.customSelect",function(){h.removeClass(b("Changed"))}).on("mouseup.customSelect",function(j){if(!h.hasClass(b("Open"))){if(a("."+b("Open")).not(h).length>0&&typeof InstallTrigger!=="undefined"){g.trigger("focus.customSelect")}else{h.addClass(b("Open"));j.stopPropagation();a(document).one("mouseup.customSelect",function(k){if(k.target!=g.get(0)&&a.inArray(k.target,g.find("*").get())<0){g.trigger("blur.customSelect")}else{f(g,h)}})}}}).on("focus.customSelect",function(){h.removeClass(b("Changed")).addClass(b("Focus"))}).on("blur.customSelect",function(){h.removeClass(b("Focus")+" "+b("Open"))}).on("mouseenter.customSelect",function(){h.addClass(b("Hover"))}).on("mouseleave.customSelect",function(){h.removeClass(b("Hover"))}).trigger("render.customSelect")})}})})(jQuery);


/***/ }),

/***/ 1523:
/***/ (function(module, exports) {

/* jQuery appear plugin - Copyright (c) 2012 Andrey Sidorov - licensed under MIT license. https://github.com/morr/jquery.appear/ - Version: 0.3.3 */
(function(e){function u(){r=false;for(var n=0,i=t.length;n<i;n++){var s=e(t[n]).filter(function(){return e(this).is(":appeared")});s.trigger("appear",[s]);if(o){var u=o.not(s);u.trigger("disappear",[u])}o=s}}var t=[];var n=false;var r=false;var i={interval:250,force_process:false};var s=e(window);var o;e.expr[":"]["appeared"]=function(t){var n=e(t);if(!n.is(":visible")){return false}var r=s.scrollLeft();var i=s.scrollTop();var o=n.offset();var u=o.left;var a=o.top;if(a+n.height()>=i&&a-(n.data("appear-top-offset")||0)<=i+s.height()&&u+n.width()>=r&&u-(n.data("appear-left-offset")||0)<=r+s.width()){return true}else{return false}};e.fn.extend({appear:function(s){var o=e.extend({},i,s||{});var a=this.selector||this;if(!n){var f=function(){if(r){return}r=true;setTimeout(u,o.interval)};e(window).scroll(f).resize(f);n=true}if(o.force_process){setTimeout(u,o.interval)}t.push(a);return e(a)}});e.extend({force_appear:function(){if(n){u();return true}return false}})})(jQuery)


/***/ }),

/***/ 1524:
/***/ (function(module, exports) {

/*!
 * jCarouselLite - v1.1 - 2014-09-28
 * http://www.gmarwaha.com/jquery/jcarousellite/
 * Copyright (c) 2014 Ganeshji Marwaha
 * Licensed MIT (https://github.com/ganeshmax/jcarousellite/blob/master/LICENSE)
*/

!function(a){a.jCarouselLite={version:"1.1"},a.fn.jCarouselLite=function(b){return b=a.extend({},a.fn.jCarouselLite.options,b||{}),this.each(function(){function c(a){return n||(clearTimeout(A),z=a,b.beforeStart&&b.beforeStart.call(this,i()),b.circular?j(a):k(a),m({start:function(){n=!0},done:function(){b.afterEnd&&b.afterEnd.call(this,i()),b.auto&&h(),n=!1}}),b.circular||l()),!1}function d(){if(n=!1,o=b.vertical?"top":"left",p=b.vertical?"height":"width",q=B.find(">ul"),r=q.find(">li"),x=r.size(),w=x<b.visible?x:b.visible,b.circular){var c=r.slice(x-w).clone(),d=r.slice(0,w).clone();q.prepend(c).append(d),b.start+=w}s=a("li",q),y=s.size(),z=b.start}function e(){B.css("visibility","visible"),s.css({overflow:"hidden","float":b.vertical?"none":"left"}),q.css({margin:"0",padding:"0",position:"relative","list-style":"none","z-index":"1"}),B.css({overflow:"hidden",position:"relative","z-index":"2",left:"0px"}),!b.circular&&b.btnPrev&&0==b.start&&a(b.btnPrev).addClass("disabled")}function f(){t=b.vertical?s.outerHeight(!0):s.outerWidth(!0),u=t*y,v=t*w,s.css({width:s.width(),height:s.height()}),q.css(p,u+"px").css(o,-(z*t)),B.css(p,v+"px")}function g(){b.btnPrev&&a(b.btnPrev).click(function(){return c(z-b.scroll)}),b.btnNext&&a(b.btnNext).click(function(){return c(z+b.scroll)}),b.btnGo&&a.each(b.btnGo,function(d,e){a(e).click(function(){return c(b.circular?w+d:d)})}),b.mouseWheel&&B.mousewheel&&B.mousewheel(function(a,d){return c(d>0?z-b.scroll:z+b.scroll)}),b.auto&&h()}function h(){A=setTimeout(function(){c(z+b.scroll)},b.auto)}function i(){return s.slice(z).slice(0,w)}function j(a){var c;a<=b.start-w-1?(c=a+x+b.scroll,q.css(o,-(c*t)+"px"),z=c-b.scroll):a>=y-w+1&&(c=a-x-b.scroll,q.css(o,-(c*t)+"px"),z=c+b.scroll)}function k(a){0>a?z=0:a>y-w&&(z=y-w)}function l(){a(b.btnPrev+","+b.btnNext).removeClass("disabled"),a(z-b.scroll<0&&b.btnPrev||z+b.scroll>y-w&&b.btnNext||[]).addClass("disabled")}function m(c){n=!0,q.animate("left"==o?{left:-(z*t)}:{top:-(z*t)},a.extend({duration:b.speed,easing:b.easing},c))}var n,o,p,q,r,s,t,u,v,w,x,y,z,A,B=a(this);d(),e(),f(),g()})},a.fn.jCarouselLite.options={btnPrev:null,btnNext:null,btnGo:null,mouseWheel:!1,auto:null,speed:200,easing:null,vertical:!1,circular:!0,visible:3,start:0,scroll:1,beforeStart:null,afterEnd:null}}(jQuery);


/***/ }),

/***/ 1525:
/***/ (function(module, exports) {

/**
 * jQuery Unveil
 * A very lightweight jQuery plugin to lazy load images
 * http://luis-almeida.github.com/unveil
 *
 * Licensed under the MIT license.
 * Copyright 2013 Luís Almeida
 * https://github.com/luis-almeida
 */

;(function($) {

  $.fn.unveil = function(threshold, container, callback) {

    var $w = $(window),
        th = threshold || 0,
        retina = window.devicePixelRatio > 1,
        attrib = retina? "data-src-retina" : "data-src",
        images = this,
        loaded;

    this.one("unveil", function() {
      var source = this.getAttribute(attrib);
      source = source || this.getAttribute("data-src");
      if (source) {
        this.setAttribute("src", source);
        if (typeof callback === "function") callback.call(this);
      }
    });

    function unveil() {
      var inview = images.filter(function() {
        var $e = $(this);
        if ($e.is(":hidden")) return;
        var wt = $w.scrollTop(),
            wb = wt + $w.height(),
            et = $e.offset().top,
            eb = et + $e.height();

        return eb >= wt - th && et <= wb + th;
      });
      loaded = inview.trigger("unveil");
      images = images.not(loaded);
    }

    $w.on("scroll.unveil resize.unveil lookup.unveil", unveil);
    $(container).on("scroll.unveil resize.unveil lookup.unveil", unveil);

    unveil();

    return this;

  };

})(window.jQuery || window.Zepto);


/***/ }),

/***/ 1526:
/***/ (function(module, exports) {

/**
 * Owl Carousel v2.2.1
 * Copyright 2013-2017 David Deutsch
 * Licensed under  ()
 */
!function(a,b,c,d){function e(b,c){this.settings=null,this.options=a.extend({},e.Defaults,c),this.$element=a(b),this._handlers={},this._plugins={},this._supress={},this._current=null,this._speed=null,this._coordinates=[],this._breakpoint=null,this._width=null,this._items=[],this._clones=[],this._mergers=[],this._widths=[],this._invalidated={},this._pipe=[],this._drag={time:null,target:null,pointer:null,stage:{start:null,current:null},direction:null},this._states={current:{},tags:{initializing:["busy"],animating:["busy"],dragging:["interacting"]}},a.each(["onResize","onThrottledResize"],a.proxy(function(b,c){this._handlers[c]=a.proxy(this[c],this)},this)),a.each(e.Plugins,a.proxy(function(a,b){this._plugins[a.charAt(0).toLowerCase()+a.slice(1)]=new b(this)},this)),a.each(e.Workers,a.proxy(function(b,c){this._pipe.push({filter:c.filter,run:a.proxy(c.run,this)})},this)),this.setup(),this.initialize()}e.Defaults={items:3,loop:!1,center:!1,rewind:!1,mouseDrag:!0,touchDrag:!0,pullDrag:!0,freeDrag:!1,margin:0,stagePadding:0,merge:!1,mergeFit:!0,autoWidth:!1,startPosition:0,rtl:!1,smartSpeed:250,fluidSpeed:!1,dragEndSpeed:!1,responsive:{},responsiveRefreshRate:200,responsiveBaseElement:b,fallbackEasing:"swing",info:!1,nestedItemSelector:!1,itemElement:"div",stageElement:"div",refreshClass:"owl-refresh",loadedClass:"owl-loaded",loadingClass:"owl-loading",rtlClass:"owl-rtl",responsiveClass:"owl-responsive",dragClass:"owl-drag",itemClass:"owl-item",stageClass:"owl-stage",stageOuterClass:"owl-stage-outer",grabClass:"owl-grab"},e.Width={Default:"default",Inner:"inner",Outer:"outer"},e.Type={Event:"event",State:"state"},e.Plugins={},e.Workers=[{filter:["width","settings"],run:function(){this._width=this.$element.width()}},{filter:["width","items","settings"],run:function(a){a.current=this._items&&this._items[this.relative(this._current)]}},{filter:["items","settings"],run:function(){this.$stage.children(".cloned").remove()}},{filter:["width","items","settings"],run:function(a){var b=this.settings.margin||"",c=!this.settings.autoWidth,d=this.settings.rtl,e={width:"auto","margin-left":d?b:"","margin-right":d?"":b};!c&&this.$stage.children().css(e),a.css=e}},{filter:["width","items","settings"],run:function(a){var b=(this.width()/this.settings.items).toFixed(3)-this.settings.margin,c=null,d=this._items.length,e=!this.settings.autoWidth,f=[];for(a.items={merge:!1,width:b};d--;)c=this._mergers[d],c=this.settings.mergeFit&&Math.min(c,this.settings.items)||c,a.items.merge=c>1||a.items.merge,f[d]=e?b*c:this._items[d].width();this._widths=f}},{filter:["items","settings"],run:function(){var b=[],c=this._items,d=this.settings,e=Math.max(2*d.items,4),f=2*Math.ceil(c.length/2),g=d.loop&&c.length?d.rewind?e:Math.max(e,f):0,h="",i="";for(g/=2;g--;)b.push(this.normalize(b.length/2,!0)),h+=c[b[b.length-1]][0].outerHTML,b.push(this.normalize(c.length-1-(b.length-1)/2,!0)),i=c[b[b.length-1]][0].outerHTML+i;this._clones=b,a(h).addClass("cloned").appendTo(this.$stage),a(i).addClass("cloned").prependTo(this.$stage)}},{filter:["width","items","settings"],run:function(){for(var a=this.settings.rtl?1:-1,b=this._clones.length+this._items.length,c=-1,d=0,e=0,f=[];++c<b;)d=f[c-1]||0,e=this._widths[this.relative(c)]+this.settings.margin,f.push(d+e*a);this._coordinates=f}},{filter:["width","items","settings"],run:function(){var a=this.settings.stagePadding,b=this._coordinates,c={width:Math.ceil(Math.abs(b[b.length-1]))+2*a,"padding-left":a||"","padding-right":a||""};this.$stage.css(c)}},{filter:["width","items","settings"],run:function(a){var b=this._coordinates.length,c=!this.settings.autoWidth,d=this.$stage.children();if(c&&a.items.merge)for(;b--;)a.css.width=this._widths[this.relative(b)],d.eq(b).css(a.css);else c&&(a.css.width=a.items.width,d.css(a.css))}},{filter:["items"],run:function(){this._coordinates.length<1&&this.$stage.removeAttr("style")}},{filter:["width","items","settings"],run:function(a){a.current=a.current?this.$stage.children().index(a.current):0,a.current=Math.max(this.minimum(),Math.min(this.maximum(),a.current)),this.reset(a.current)}},{filter:["position"],run:function(){this.animate(this.coordinates(this._current))}},{filter:["width","position","items","settings"],run:function(){var a,b,c,d,e=this.settings.rtl?1:-1,f=2*this.settings.stagePadding,g=this.coordinates(this.current())+f,h=g+this.width()*e,i=[];for(c=0,d=this._coordinates.length;c<d;c++)a=this._coordinates[c-1]||0,b=Math.abs(this._coordinates[c])+f*e,(this.op(a,"<=",g)&&this.op(a,">",h)||this.op(b,"<",g)&&this.op(b,">",h))&&i.push(c);this.$stage.children(".active").removeClass("active"),this.$stage.children(":eq("+i.join("), :eq(")+")").addClass("active"),this.settings.center&&(this.$stage.children(".center").removeClass("center"),this.$stage.children().eq(this.current()).addClass("center"))}}],e.prototype.initialize=function(){if(this.enter("initializing"),this.trigger("initialize"),this.$element.toggleClass(this.settings.rtlClass,this.settings.rtl),this.settings.autoWidth&&!this.is("pre-loading")){var b,c,e;b=this.$element.find("img"),c=this.settings.nestedItemSelector?"."+this.settings.nestedItemSelector:d,e=this.$element.children(c).width(),b.length&&e<=0&&this.preloadAutoWidthImages(b)}this.$element.addClass(this.options.loadingClass),this.$stage=a("<"+this.settings.stageElement+' class="'+this.settings.stageClass+'"/>').wrap('<div class="'+this.settings.stageOuterClass+'"/>'),this.$element.append(this.$stage.parent()),this.replace(this.$element.children().not(this.$stage.parent())),this.$element.is(":visible")?this.refresh():this.invalidate("width"),this.$element.removeClass(this.options.loadingClass).addClass(this.options.loadedClass),this.registerEventHandlers(),this.leave("initializing"),this.trigger("initialized")},e.prototype.setup=function(){var b=this.viewport(),c=this.options.responsive,d=-1,e=null;c?(a.each(c,function(a){a<=b&&a>d&&(d=Number(a))}),e=a.extend({},this.options,c[d]),"function"==typeof e.stagePadding&&(e.stagePadding=e.stagePadding()),delete e.responsive,e.responsiveClass&&this.$element.attr("class",this.$element.attr("class").replace(new RegExp("("+this.options.responsiveClass+"-)\\S+\\s","g"),"$1"+d))):e=a.extend({},this.options),this.trigger("change",{property:{name:"settings",value:e}}),this._breakpoint=d,this.settings=e,this.invalidate("settings"),this.trigger("changed",{property:{name:"settings",value:this.settings}})},e.prototype.optionsLogic=function(){this.settings.autoWidth&&(this.settings.stagePadding=!1,this.settings.merge=!1)},e.prototype.prepare=function(b){var c=this.trigger("prepare",{content:b});return c.data||(c.data=a("<"+this.settings.itemElement+"/>").addClass(this.options.itemClass).append(b)),this.trigger("prepared",{content:c.data}),c.data},e.prototype.update=function(){for(var b=0,c=this._pipe.length,d=a.proxy(function(a){return this[a]},this._invalidated),e={};b<c;)(this._invalidated.all||a.grep(this._pipe[b].filter,d).length>0)&&this._pipe[b].run(e),b++;this._invalidated={},!this.is("valid")&&this.enter("valid")},e.prototype.width=function(a){switch(a=a||e.Width.Default){case e.Width.Inner:case e.Width.Outer:return this._width;default:return this._width-2*this.settings.stagePadding+this.settings.margin}},e.prototype.refresh=function(){this.enter("refreshing"),this.trigger("refresh"),this.setup(),this.optionsLogic(),this.$element.addClass(this.options.refreshClass),this.update(),this.$element.removeClass(this.options.refreshClass),this.leave("refreshing"),this.trigger("refreshed")},e.prototype.onThrottledResize=function(){b.clearTimeout(this.resizeTimer),this.resizeTimer=b.setTimeout(this._handlers.onResize,this.settings.responsiveRefreshRate)},e.prototype.onResize=function(){return!!this._items.length&&(this._width!==this.$element.width()&&(!!this.$element.is(":visible")&&(this.enter("resizing"),this.trigger("resize").isDefaultPrevented()?(this.leave("resizing"),!1):(this.invalidate("width"),this.refresh(),this.leave("resizing"),void this.trigger("resized")))))},e.prototype.registerEventHandlers=function(){a.support.transition&&this.$stage.on(a.support.transition.end+".owl.core",a.proxy(this.onTransitionEnd,this)),this.settings.responsive!==!1&&this.on(b,"resize",this._handlers.onThrottledResize),this.settings.mouseDrag&&(this.$element.addClass(this.options.dragClass),this.$stage.on("mousedown.owl.core",a.proxy(this.onDragStart,this)),this.$stage.on("dragstart.owl.core selectstart.owl.core",function(){return!1})),this.settings.touchDrag&&(this.$stage.on("touchstart.owl.core",a.proxy(this.onDragStart,this)),this.$stage.on("touchcancel.owl.core",a.proxy(this.onDragEnd,this)))},e.prototype.onDragStart=function(b){var d=null;3!==b.which&&(a.support.transform?(d=this.$stage.css("transform").replace(/.*\(|\)| /g,"").split(","),d={x:d[16===d.length?12:4],y:d[16===d.length?13:5]}):(d=this.$stage.position(),d={x:this.settings.rtl?d.left+this.$stage.width()-this.width()+this.settings.margin:d.left,y:d.top}),this.is("animating")&&(a.support.transform?this.animate(d.x):this.$stage.stop(),this.invalidate("position")),this.$element.toggleClass(this.options.grabClass,"mousedown"===b.type),this.speed(0),this._drag.time=(new Date).getTime(),this._drag.target=a(b.target),this._drag.stage.start=d,this._drag.stage.current=d,this._drag.pointer=this.pointer(b),a(c).on("mouseup.owl.core touchend.owl.core",a.proxy(this.onDragEnd,this)),a(c).one("mousemove.owl.core touchmove.owl.core",a.proxy(function(b){var d=this.difference(this._drag.pointer,this.pointer(b));a(c).on("mousemove.owl.core touchmove.owl.core",a.proxy(this.onDragMove,this)),Math.abs(d.x)<Math.abs(d.y)&&this.is("valid")||(b.preventDefault(),this.enter("dragging"),this.trigger("drag"))},this)))},e.prototype.onDragMove=function(a){var b=null,c=null,d=null,e=this.difference(this._drag.pointer,this.pointer(a)),f=this.difference(this._drag.stage.start,e);this.is("dragging")&&(a.preventDefault(),this.settings.loop?(b=this.coordinates(this.minimum()),c=this.coordinates(this.maximum()+1)-b,f.x=((f.x-b)%c+c)%c+b):(b=this.settings.rtl?this.coordinates(this.maximum()):this.coordinates(this.minimum()),c=this.settings.rtl?this.coordinates(this.minimum()):this.coordinates(this.maximum()),d=this.settings.pullDrag?-1*e.x/5:0,f.x=Math.max(Math.min(f.x,b+d),c+d)),this._drag.stage.current=f,this.animate(f.x))},e.prototype.onDragEnd=function(b){var d=this.difference(this._drag.pointer,this.pointer(b)),e=this._drag.stage.current,f=d.x>0^this.settings.rtl?"left":"right";a(c).off(".owl.core"),this.$element.removeClass(this.options.grabClass),(0!==d.x&&this.is("dragging")||!this.is("valid"))&&(this.speed(this.settings.dragEndSpeed||this.settings.smartSpeed),this.current(this.closest(e.x,0!==d.x?f:this._drag.direction)),this.invalidate("position"),this.update(),this._drag.direction=f,(Math.abs(d.x)>3||(new Date).getTime()-this._drag.time>300)&&this._drag.target.one("click.owl.core",function(){return!1})),this.is("dragging")&&(this.leave("dragging"),this.trigger("dragged"))},e.prototype.closest=function(b,c){var d=-1,e=30,f=this.width(),g=this.coordinates();return this.settings.freeDrag||a.each(g,a.proxy(function(a,h){return"left"===c&&b>h-e&&b<h+e?d=a:"right"===c&&b>h-f-e&&b<h-f+e?d=a+1:this.op(b,"<",h)&&this.op(b,">",g[a+1]||h-f)&&(d="left"===c?a+1:a),d===-1},this)),this.settings.loop||(this.op(b,">",g[this.minimum()])?d=b=this.minimum():this.op(b,"<",g[this.maximum()])&&(d=b=this.maximum())),d},e.prototype.animate=function(b){var c=this.speed()>0;this.is("animating")&&this.onTransitionEnd(),c&&(this.enter("animating"),this.trigger("translate")),a.support.transform3d&&a.support.transition?this.$stage.css({transform:"translate3d("+b+"px,0px,0px)",transition:this.speed()/1e3+"s"}):c?this.$stage.animate({left:b+"px"},this.speed(),this.settings.fallbackEasing,a.proxy(this.onTransitionEnd,this)):this.$stage.css({left:b+"px"})},e.prototype.is=function(a){return this._states.current[a]&&this._states.current[a]>0},e.prototype.current=function(a){if(a===d)return this._current;if(0===this._items.length)return d;if(a=this.normalize(a),this._current!==a){var b=this.trigger("change",{property:{name:"position",value:a}});b.data!==d&&(a=this.normalize(b.data)),this._current=a,this.invalidate("position"),this.trigger("changed",{property:{name:"position",value:this._current}})}return this._current},e.prototype.invalidate=function(b){return"string"===a.type(b)&&(this._invalidated[b]=!0,this.is("valid")&&this.leave("valid")),a.map(this._invalidated,function(a,b){return b})},e.prototype.reset=function(a){a=this.normalize(a),a!==d&&(this._speed=0,this._current=a,this.suppress(["translate","translated"]),this.animate(this.coordinates(a)),this.release(["translate","translated"]))},e.prototype.normalize=function(a,b){var c=this._items.length,e=b?0:this._clones.length;return!this.isNumeric(a)||c<1?a=d:(a<0||a>=c+e)&&(a=((a-e/2)%c+c)%c+e/2),a},e.prototype.relative=function(a){return a-=this._clones.length/2,this.normalize(a,!0)},e.prototype.maximum=function(a){var b,c,d,e=this.settings,f=this._coordinates.length;if(e.loop)f=this._clones.length/2+this._items.length-1;else if(e.autoWidth||e.merge){for(b=this._items.length,c=this._items[--b].width(),d=this.$element.width();b--&&(c+=this._items[b].width()+this.settings.margin,!(c>d)););f=b+1}else f=e.center?this._items.length-1:this._items.length-e.items;return a&&(f-=this._clones.length/2),Math.max(f,0)},e.prototype.minimum=function(a){return a?0:this._clones.length/2},e.prototype.items=function(a){return a===d?this._items.slice():(a=this.normalize(a,!0),this._items[a])},e.prototype.mergers=function(a){return a===d?this._mergers.slice():(a=this.normalize(a,!0),this._mergers[a])},e.prototype.clones=function(b){var c=this._clones.length/2,e=c+this._items.length,f=function(a){return a%2===0?e+a/2:c-(a+1)/2};return b===d?a.map(this._clones,function(a,b){return f(b)}):a.map(this._clones,function(a,c){return a===b?f(c):null})},e.prototype.speed=function(a){return a!==d&&(this._speed=a),this._speed},e.prototype.coordinates=function(b){var c,e=1,f=b-1;return b===d?a.map(this._coordinates,a.proxy(function(a,b){return this.coordinates(b)},this)):(this.settings.center?(this.settings.rtl&&(e=-1,f=b+1),c=this._coordinates[b],c+=(this.width()-c+(this._coordinates[f]||0))/2*e):c=this._coordinates[f]||0,c=Math.ceil(c))},e.prototype.duration=function(a,b,c){return 0===c?0:Math.min(Math.max(Math.abs(b-a),1),6)*Math.abs(c||this.settings.smartSpeed)},e.prototype.to=function(a,b){var c=this.current(),d=null,e=a-this.relative(c),f=(e>0)-(e<0),g=this._items.length,h=this.minimum(),i=this.maximum();this.settings.loop?(!this.settings.rewind&&Math.abs(e)>g/2&&(e+=f*-1*g),a=c+e,d=((a-h)%g+g)%g+h,d!==a&&d-e<=i&&d-e>0&&(c=d-e,a=d,this.reset(c))):this.settings.rewind?(i+=1,a=(a%i+i)%i):a=Math.max(h,Math.min(i,a)),this.speed(this.duration(c,a,b)),this.current(a),this.$element.is(":visible")&&this.update()},e.prototype.next=function(a){a=a||!1,this.to(this.relative(this.current())+1,a)},e.prototype.prev=function(a){a=a||!1,this.to(this.relative(this.current())-1,a)},e.prototype.onTransitionEnd=function(a){if(a!==d&&(a.stopPropagation(),(a.target||a.srcElement||a.originalTarget)!==this.$stage.get(0)))return!1;this.leave("animating"),this.trigger("translated")},e.prototype.viewport=function(){var d;return this.options.responsiveBaseElement!==b?d=a(this.options.responsiveBaseElement).width():b.innerWidth?d=b.innerWidth:c.documentElement&&c.documentElement.clientWidth?d=c.documentElement.clientWidth:console.warn("Can not detect viewport width."),d},e.prototype.replace=function(b){this.$stage.empty(),this._items=[],b&&(b=b instanceof jQuery?b:a(b)),this.settings.nestedItemSelector&&(b=b.find("."+this.settings.nestedItemSelector)),b.filter(function(){return 1===this.nodeType}).each(a.proxy(function(a,b){b=this.prepare(b),this.$stage.append(b),this._items.push(b),this._mergers.push(1*b.find("[data-merge]").addBack("[data-merge]").attr("data-merge")||1)},this)),this.reset(this.isNumeric(this.settings.startPosition)?this.settings.startPosition:0),this.invalidate("items")},e.prototype.add=function(b,c){var e=this.relative(this._current);c=c===d?this._items.length:this.normalize(c,!0),b=b instanceof jQuery?b:a(b),this.trigger("add",{content:b,position:c}),b=this.prepare(b),0===this._items.length||c===this._items.length?(0===this._items.length&&this.$stage.append(b),0!==this._items.length&&this._items[c-1].after(b),this._items.push(b),this._mergers.push(1*b.find("[data-merge]").addBack("[data-merge]").attr("data-merge")||1)):(this._items[c].before(b),this._items.splice(c,0,b),this._mergers.splice(c,0,1*b.find("[data-merge]").addBack("[data-merge]").attr("data-merge")||1)),this._items[e]&&this.reset(this._items[e].index()),this.invalidate("items"),this.trigger("added",{content:b,position:c})},e.prototype.remove=function(a){a=this.normalize(a,!0),a!==d&&(this.trigger("remove",{content:this._items[a],position:a}),this._items[a].remove(),this._items.splice(a,1),this._mergers.splice(a,1),this.invalidate("items"),this.trigger("removed",{content:null,position:a}))},e.prototype.preloadAutoWidthImages=function(b){b.each(a.proxy(function(b,c){this.enter("pre-loading"),c=a(c),a(new Image).one("load",a.proxy(function(a){c.attr("src",a.target.src),c.css("opacity",1),this.leave("pre-loading"),!this.is("pre-loading")&&!this.is("initializing")&&this.refresh()},this)).attr("src",c.attr("src")||c.attr("data-src")||c.attr("data-src-retina"))},this))},e.prototype.destroy=function(){this.$element.off(".owl.core"),this.$stage.off(".owl.core"),a(c).off(".owl.core"),this.settings.responsive!==!1&&(b.clearTimeout(this.resizeTimer),this.off(b,"resize",this._handlers.onThrottledResize));for(var d in this._plugins)this._plugins[d].destroy();this.$stage.children(".cloned").remove(),this.$stage.unwrap(),this.$stage.children().contents().unwrap(),this.$stage.children().unwrap(),this.$element.removeClass(this.options.refreshClass).removeClass(this.options.loadingClass).removeClass(this.options.loadedClass).removeClass(this.options.rtlClass).removeClass(this.options.dragClass).removeClass(this.options.grabClass).attr("class",this.$element.attr("class").replace(new RegExp(this.options.responsiveClass+"-\\S+\\s","g"),"")).removeData("owl.carousel")},e.prototype.op=function(a,b,c){var d=this.settings.rtl;switch(b){case"<":return d?a>c:a<c;case">":return d?a<c:a>c;case">=":return d?a<=c:a>=c;case"<=":return d?a>=c:a<=c}},e.prototype.on=function(a,b,c,d){a.addEventListener?a.addEventListener(b,c,d):a.attachEvent&&a.attachEvent("on"+b,c)},e.prototype.off=function(a,b,c,d){a.removeEventListener?a.removeEventListener(b,c,d):a.detachEvent&&a.detachEvent("on"+b,c)},e.prototype.trigger=function(b,c,d,f,g){var h={item:{count:this._items.length,index:this.current()}},i=a.camelCase(a.grep(["on",b,d],function(a){return a}).join("-").toLowerCase()),j=a.Event([b,"owl",d||"carousel"].join(".").toLowerCase(),a.extend({relatedTarget:this},h,c));return this._supress[b]||(a.each(this._plugins,function(a,b){b.onTrigger&&b.onTrigger(j)}),this.register({type:e.Type.Event,name:b}),this.$element.trigger(j),this.settings&&"function"==typeof this.settings[i]&&this.settings[i].call(this,j)),j},e.prototype.enter=function(b){a.each([b].concat(this._states.tags[b]||[]),a.proxy(function(a,b){this._states.current[b]===d&&(this._states.current[b]=0),this._states.current[b]++},this))},e.prototype.leave=function(b){a.each([b].concat(this._states.tags[b]||[]),a.proxy(function(a,b){this._states.current[b]--},this))},e.prototype.register=function(b){if(b.type===e.Type.Event){if(a.event.special[b.name]||(a.event.special[b.name]={}),!a.event.special[b.name].owl){var c=a.event.special[b.name]._default;a.event.special[b.name]._default=function(a){return!c||!c.apply||a.namespace&&a.namespace.indexOf("owl")!==-1?a.namespace&&a.namespace.indexOf("owl")>-1:c.apply(this,arguments)},a.event.special[b.name].owl=!0}}else b.type===e.Type.State&&(this._states.tags[b.name]?this._states.tags[b.name]=this._states.tags[b.name].concat(b.tags):this._states.tags[b.name]=b.tags,this._states.tags[b.name]=a.grep(this._states.tags[b.name],a.proxy(function(c,d){return a.inArray(c,this._states.tags[b.name])===d},this)))},e.prototype.suppress=function(b){a.each(b,a.proxy(function(a,b){this._supress[b]=!0},this))},e.prototype.release=function(b){a.each(b,a.proxy(function(a,b){delete this._supress[b]},this))},e.prototype.pointer=function(a){var c={x:null,y:null};return a=a.originalEvent||a||b.event,a=a.touches&&a.touches.length?a.touches[0]:a.changedTouches&&a.changedTouches.length?a.changedTouches[0]:a,a.pageX?(c.x=a.pageX,c.y=a.pageY):(c.x=a.clientX,c.y=a.clientY),c},e.prototype.isNumeric=function(a){return!isNaN(parseFloat(a))},e.prototype.difference=function(a,b){return{x:a.x-b.x,y:a.y-b.y}},a.fn.owlCarousel=function(b){var c=Array.prototype.slice.call(arguments,1);return this.each(function(){var d=a(this),f=d.data("owl.carousel");f||(f=new e(this,"object"==typeof b&&b),d.data("owl.carousel",f),a.each(["next","prev","to","destroy","refresh","replace","add","remove"],function(b,c){f.register({type:e.Type.Event,name:c}),f.$element.on(c+".owl.carousel.core",a.proxy(function(a){a.namespace&&a.relatedTarget!==this&&(this.suppress([c]),f[c].apply(this,[].slice.call(arguments,1)),this.release([c]))},f))})),"string"==typeof b&&"_"!==b.charAt(0)&&f[b].apply(f,c)})},a.fn.owlCarousel.Constructor=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this._core=b,this._interval=null,this._visible=null,this._handlers={"initialized.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.autoRefresh&&this.watch()},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this._core.$element.on(this._handlers)};e.Defaults={autoRefresh:!0,autoRefreshInterval:500},e.prototype.watch=function(){this._interval||(this._visible=this._core.$element.is(":visible"),this._interval=b.setInterval(a.proxy(this.refresh,this),this._core.settings.autoRefreshInterval))},e.prototype.refresh=function(){this._core.$element.is(":visible")!==this._visible&&(this._visible=!this._visible,this._core.$element.toggleClass("owl-hidden",!this._visible),this._visible&&this._core.invalidate("width")&&this._core.refresh())},e.prototype.destroy=function(){var a,c;b.clearInterval(this._interval);for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(c in Object.getOwnPropertyNames(this))"function"!=typeof this[c]&&(this[c]=null)},a.fn.owlCarousel.Constructor.Plugins.AutoRefresh=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this._core=b,this._loaded=[],this._handlers={"initialized.owl.carousel change.owl.carousel resized.owl.carousel":a.proxy(function(b){if(b.namespace&&this._core.settings&&this._core.settings.lazyLoad&&(b.property&&"position"==b.property.name||"initialized"==b.type))for(var c=this._core.settings,e=c.center&&Math.ceil(c.items/2)||c.items,f=c.center&&e*-1||0,g=(b.property&&b.property.value!==d?b.property.value:this._core.current())+f,h=this._core.clones().length,i=a.proxy(function(a,b){this.load(b)},this);f++<e;)this.load(h/2+this._core.relative(g)),h&&a.each(this._core.clones(this._core.relative(g)),i),g++},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this._core.$element.on(this._handlers)};e.Defaults={lazyLoad:!1},e.prototype.load=function(c){var d=this._core.$stage.children().eq(c),e=d&&d.find(".owl-lazy");!e||a.inArray(d.get(0),this._loaded)>-1||(e.each(a.proxy(function(c,d){var e,f=a(d),g=b.devicePixelRatio>1&&f.attr("data-src-retina")||f.attr("data-src");this._core.trigger("load",{element:f,url:g},"lazy"),f.is("img")?f.one("load.owl.lazy",a.proxy(function(){f.css("opacity",1),this._core.trigger("loaded",{element:f,url:g},"lazy")},this)).attr("src",g):(e=new Image,e.onload=a.proxy(function(){f.css({"background-image":'url("'+g+'")',opacity:"1"}),this._core.trigger("loaded",{element:f,url:g},"lazy")},this),e.src=g)},this)),this._loaded.push(d.get(0)))},e.prototype.destroy=function(){var a,b;for(a in this.handlers)this._core.$element.off(a,this.handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.Lazy=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this._core=b,this._handlers={"initialized.owl.carousel refreshed.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.autoHeight&&this.update()},this),"changed.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.autoHeight&&"position"==a.property.name&&this.update()},this),"loaded.owl.lazy":a.proxy(function(a){a.namespace&&this._core.settings.autoHeight&&a.element.closest("."+this._core.settings.itemClass).index()===this._core.current()&&this.update()},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this._core.$element.on(this._handlers)};e.Defaults={autoHeight:!1,autoHeightClass:"owl-height"},e.prototype.update=function(){var b=this._core._current,c=b+this._core.settings.items,d=this._core.$stage.children().toArray().slice(b,c),e=[],f=0;a.each(d,function(b,c){e.push(a(c).height())}),f=Math.max.apply(null,e),this._core.$stage.parent().height(f).addClass(this._core.settings.autoHeightClass)},e.prototype.destroy=function(){var a,b;for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.AutoHeight=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this._core=b,this._videos={},this._playing=null,this._handlers={"initialized.owl.carousel":a.proxy(function(a){a.namespace&&this._core.register({type:"state",name:"playing",tags:["interacting"]})},this),"resize.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.video&&this.isInFullScreen()&&a.preventDefault()},this),"refreshed.owl.carousel":a.proxy(function(a){a.namespace&&this._core.is("resizing")&&this._core.$stage.find(".cloned .owl-video-frame").remove()},this),"changed.owl.carousel":a.proxy(function(a){a.namespace&&"position"===a.property.name&&this._playing&&this.stop()},this),"prepared.owl.carousel":a.proxy(function(b){if(b.namespace){var c=a(b.content).find(".owl-video");c.length&&(c.css("display","none"),this.fetch(c,a(b.content)))}},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this._core.$element.on(this._handlers),this._core.$element.on("click.owl.video",".owl-video-play-icon",a.proxy(function(a){this.play(a)},this))};e.Defaults={video:!1,videoHeight:!1,videoWidth:!1},e.prototype.fetch=function(a,b){var c=function(){return a.attr("data-vimeo-id")?"vimeo":a.attr("data-vzaar-id")?"vzaar":"youtube"}(),d=a.attr("data-vimeo-id")||a.attr("data-youtube-id")||a.attr("data-vzaar-id"),e=a.attr("data-width")||this._core.settings.videoWidth,f=a.attr("data-height")||this._core.settings.videoHeight,g=a.attr("href");if(!g)throw new Error("Missing video URL.");if(d=g.match(/(http:|https:|)\/\/(player.|www.|app.)?(vimeo\.com|youtu(be\.com|\.be|be\.googleapis\.com)|vzaar\.com)\/(video\/|videos\/|embed\/|channels\/.+\/|groups\/.+\/|watch\?v=|v\/)?([A-Za-z0-9._%-]*)(\&\S+)?/),d[3].indexOf("youtu")>-1)c="youtube";else if(d[3].indexOf("vimeo")>-1)c="vimeo";else{if(!(d[3].indexOf("vzaar")>-1))throw new Error("Video URL not supported.");c="vzaar"}d=d[6],this._videos[g]={type:c,id:d,width:e,height:f},b.attr("data-video",g),this.thumbnail(a,this._videos[g])},e.prototype.thumbnail=function(b,c){var d,e,f,g=c.width&&c.height?'style="width:'+c.width+"px;height:"+c.height+'px;"':"",h=b.find("img"),i="src",j="",k=this._core.settings,l=function(a){e='<div class="owl-video-play-icon"></div>',d=k.lazyLoad?'<div class="owl-video-tn '+j+'" '+i+'="'+a+'"></div>':'<div class="owl-video-tn" style="opacity:1;background-image:url('+a+')"></div>',b.after(d),b.after(e)};if(b.wrap('<div class="owl-video-wrapper"'+g+"></div>"),this._core.settings.lazyLoad&&(i="data-src",j="owl-lazy"),h.length)return l(h.attr(i)),h.remove(),!1;"youtube"===c.type?(f="//img.youtube.com/vi/"+c.id+"/hqdefault.jpg",l(f)):"vimeo"===c.type?a.ajax({type:"GET",url:"//vimeo.com/api/v2/video/"+c.id+".json",jsonp:"callback",dataType:"jsonp",success:function(a){f=a[0].thumbnail_large,l(f)}}):"vzaar"===c.type&&a.ajax({type:"GET",url:"//vzaar.com/api/videos/"+c.id+".json",jsonp:"callback",dataType:"jsonp",success:function(a){f=a.framegrab_url,l(f)}})},e.prototype.stop=function(){this._core.trigger("stop",null,"video"),this._playing.find(".owl-video-frame").remove(),this._playing.removeClass("owl-video-playing"),this._playing=null,this._core.leave("playing"),this._core.trigger("stopped",null,"video")},e.prototype.play=function(b){var c,d=a(b.target),e=d.closest("."+this._core.settings.itemClass),f=this._videos[e.attr("data-video")],g=f.width||"100%",h=f.height||this._core.$stage.height();this._playing||(this._core.enter("playing"),this._core.trigger("play",null,"video"),e=this._core.items(this._core.relative(e.index())),this._core.reset(e.index()),"youtube"===f.type?c='<iframe width="'+g+'" height="'+h+'" src="//www.youtube.com/embed/'+f.id+"?autoplay=1&rel=0&v="+f.id+'" frameborder="0" allowfullscreen></iframe>':"vimeo"===f.type?c='<iframe src="//player.vimeo.com/video/'+f.id+'?autoplay=1" width="'+g+'" height="'+h+'" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen></iframe>':"vzaar"===f.type&&(c='<iframe frameborder="0"height="'+h+'"width="'+g+'" allowfullscreen mozallowfullscreen webkitAllowFullScreen src="//view.vzaar.com/'+f.id+'/player?autoplay=true"></iframe>'),a('<div class="owl-video-frame">'+c+"</div>").insertAfter(e.find(".owl-video")),this._playing=e.addClass("owl-video-playing"))},e.prototype.isInFullScreen=function(){var b=c.fullscreenElement||c.mozFullScreenElement||c.webkitFullscreenElement;return b&&a(b).parent().hasClass("owl-video-frame")},e.prototype.destroy=function(){var a,b;this._core.$element.off("click.owl.video");for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.Video=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this.core=b,this.core.options=a.extend({},e.Defaults,this.core.options),this.swapping=!0,this.previous=d,this.next=d,this.handlers={"change.owl.carousel":a.proxy(function(a){a.namespace&&"position"==a.property.name&&(this.previous=this.core.current(),this.next=a.property.value)},this),"drag.owl.carousel dragged.owl.carousel translated.owl.carousel":a.proxy(function(a){a.namespace&&(this.swapping="translated"==a.type)},this),"translate.owl.carousel":a.proxy(function(a){a.namespace&&this.swapping&&(this.core.options.animateOut||this.core.options.animateIn)&&this.swap()},this)},this.core.$element.on(this.handlers)};e.Defaults={animateOut:!1,animateIn:!1},e.prototype.swap=function(){if(1===this.core.settings.items&&a.support.animation&&a.support.transition){this.core.speed(0);var b,c=a.proxy(this.clear,this),d=this.core.$stage.children().eq(this.previous),e=this.core.$stage.children().eq(this.next),f=this.core.settings.animateIn,g=this.core.settings.animateOut;this.core.current()!==this.previous&&(g&&(b=this.core.coordinates(this.previous)-this.core.coordinates(this.next),d.one(a.support.animation.end,c).css({left:b+"px"}).addClass("animated owl-animated-out").addClass(g)),f&&e.one(a.support.animation.end,c).addClass("animated owl-animated-in").addClass(f))}},e.prototype.clear=function(b){a(b.target).css({left:""}).removeClass("animated owl-animated-out owl-animated-in").removeClass(this.core.settings.animateIn).removeClass(this.core.settings.animateOut),this.core.onTransitionEnd()},e.prototype.destroy=function(){var a,b;for(a in this.handlers)this.core.$element.off(a,this.handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},
a.fn.owlCarousel.Constructor.Plugins.Animate=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){var e=function(b){this._core=b,this._timeout=null,this._paused=!1,this._handlers={"changed.owl.carousel":a.proxy(function(a){a.namespace&&"settings"===a.property.name?this._core.settings.autoplay?this.play():this.stop():a.namespace&&"position"===a.property.name&&this._core.settings.autoplay&&this._setAutoPlayInterval()},this),"initialized.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.autoplay&&this.play()},this),"play.owl.autoplay":a.proxy(function(a,b,c){a.namespace&&this.play(b,c)},this),"stop.owl.autoplay":a.proxy(function(a){a.namespace&&this.stop()},this),"mouseover.owl.autoplay":a.proxy(function(){this._core.settings.autoplayHoverPause&&this._core.is("rotating")&&this.pause()},this),"mouseleave.owl.autoplay":a.proxy(function(){this._core.settings.autoplayHoverPause&&this._core.is("rotating")&&this.play()},this),"touchstart.owl.core":a.proxy(function(){this._core.settings.autoplayHoverPause&&this._core.is("rotating")&&this.pause()},this),"touchend.owl.core":a.proxy(function(){this._core.settings.autoplayHoverPause&&this.play()},this)},this._core.$element.on(this._handlers),this._core.options=a.extend({},e.Defaults,this._core.options)};e.Defaults={autoplay:!1,autoplayTimeout:5e3,autoplayHoverPause:!1,autoplaySpeed:!1},e.prototype.play=function(a,b){this._paused=!1,this._core.is("rotating")||(this._core.enter("rotating"),this._setAutoPlayInterval())},e.prototype._getNextTimeout=function(d,e){return this._timeout&&b.clearTimeout(this._timeout),b.setTimeout(a.proxy(function(){this._paused||this._core.is("busy")||this._core.is("interacting")||c.hidden||this._core.next(e||this._core.settings.autoplaySpeed)},this),d||this._core.settings.autoplayTimeout)},e.prototype._setAutoPlayInterval=function(){this._timeout=this._getNextTimeout()},e.prototype.stop=function(){this._core.is("rotating")&&(b.clearTimeout(this._timeout),this._core.leave("rotating"))},e.prototype.pause=function(){this._core.is("rotating")&&(this._paused=!0)},e.prototype.destroy=function(){var a,b;this.stop();for(a in this._handlers)this._core.$element.off(a,this._handlers[a]);for(b in Object.getOwnPropertyNames(this))"function"!=typeof this[b]&&(this[b]=null)},a.fn.owlCarousel.Constructor.Plugins.autoplay=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){"use strict";var e=function(b){this._core=b,this._initialized=!1,this._pages=[],this._controls={},this._templates=[],this.$element=this._core.$element,this._overrides={next:this._core.next,prev:this._core.prev,to:this._core.to},this._handlers={"prepared.owl.carousel":a.proxy(function(b){b.namespace&&this._core.settings.dotsData&&this._templates.push('<div class="'+this._core.settings.dotClass+'">'+a(b.content).find("[data-dot]").addBack("[data-dot]").attr("data-dot")+"</div>")},this),"added.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.dotsData&&this._templates.splice(a.position,0,this._templates.pop())},this),"remove.owl.carousel":a.proxy(function(a){a.namespace&&this._core.settings.dotsData&&this._templates.splice(a.position,1)},this),"changed.owl.carousel":a.proxy(function(a){a.namespace&&"position"==a.property.name&&this.draw()},this),"initialized.owl.carousel":a.proxy(function(a){a.namespace&&!this._initialized&&(this._core.trigger("initialize",null,"navigation"),this.initialize(),this.update(),this.draw(),this._initialized=!0,this._core.trigger("initialized",null,"navigation"))},this),"refreshed.owl.carousel":a.proxy(function(a){a.namespace&&this._initialized&&(this._core.trigger("refresh",null,"navigation"),this.update(),this.draw(),this._core.trigger("refreshed",null,"navigation"))},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this.$element.on(this._handlers)};e.Defaults={nav:!1,navText:["prev","next"],navSpeed:!1,navElement:"div",navContainer:!1,navContainerClass:"owl-nav",navClass:["owl-prev","owl-next"],slideBy:1,dotClass:"owl-dot",dotsClass:"owl-dots",dots:!0,dotsEach:!1,dotsData:!1,dotsSpeed:!1,dotsContainer:!1},e.prototype.initialize=function(){var b,c=this._core.settings;this._controls.$relative=(c.navContainer?a(c.navContainer):a("<div>").addClass(c.navContainerClass).appendTo(this.$element)).addClass("disabled"),this._controls.$previous=a("<"+c.navElement+">").addClass(c.navClass[0]).html(c.navText[0]).prependTo(this._controls.$relative).on("click",a.proxy(function(a){this.prev(c.navSpeed)},this)),this._controls.$next=a("<"+c.navElement+">").addClass(c.navClass[1]).html(c.navText[1]).appendTo(this._controls.$relative).on("click",a.proxy(function(a){this.next(c.navSpeed)},this)),c.dotsData||(this._templates=[a("<div>").addClass(c.dotClass).append(a("<span>")).prop("outerHTML")]),this._controls.$absolute=(c.dotsContainer?a(c.dotsContainer):a("<div>").addClass(c.dotsClass).appendTo(this.$element)).addClass("disabled"),this._controls.$absolute.on("click","div",a.proxy(function(b){var d=a(b.target).parent().is(this._controls.$absolute)?a(b.target).index():a(b.target).parent().index();b.preventDefault(),this.to(d,c.dotsSpeed)},this));for(b in this._overrides)this._core[b]=a.proxy(this[b],this)},e.prototype.destroy=function(){var a,b,c,d;for(a in this._handlers)this.$element.off(a,this._handlers[a]);for(b in this._controls)this._controls[b].remove();for(d in this.overides)this._core[d]=this._overrides[d];for(c in Object.getOwnPropertyNames(this))"function"!=typeof this[c]&&(this[c]=null)},e.prototype.update=function(){var a,b,c,d=this._core.clones().length/2,e=d+this._core.items().length,f=this._core.maximum(!0),g=this._core.settings,h=g.center||g.autoWidth||g.dotsData?1:g.dotsEach||g.items;if("page"!==g.slideBy&&(g.slideBy=Math.min(g.slideBy,g.items)),g.dots||"page"==g.slideBy)for(this._pages=[],a=d,b=0,c=0;a<e;a++){if(b>=h||0===b){if(this._pages.push({start:Math.min(f,a-d),end:a-d+h-1}),Math.min(f,a-d)===f)break;b=0,++c}b+=this._core.mergers(this._core.relative(a))}},e.prototype.draw=function(){var b,c=this._core.settings,d=this._core.items().length<=c.items,e=this._core.relative(this._core.current()),f=c.loop||c.rewind;this._controls.$relative.toggleClass("disabled",!c.nav||d),c.nav&&(this._controls.$previous.toggleClass("disabled",!f&&e<=this._core.minimum(!0)),this._controls.$next.toggleClass("disabled",!f&&e>=this._core.maximum(!0))),this._controls.$absolute.toggleClass("disabled",!c.dots||d),c.dots&&(b=this._pages.length-this._controls.$absolute.children().length,c.dotsData&&0!==b?this._controls.$absolute.html(this._templates.join("")):b>0?this._controls.$absolute.append(new Array(b+1).join(this._templates[0])):b<0&&this._controls.$absolute.children().slice(b).remove(),this._controls.$absolute.find(".active").removeClass("active"),this._controls.$absolute.children().eq(a.inArray(this.current(),this._pages)).addClass("active"))},e.prototype.onTrigger=function(b){var c=this._core.settings;b.page={index:a.inArray(this.current(),this._pages),count:this._pages.length,size:c&&(c.center||c.autoWidth||c.dotsData?1:c.dotsEach||c.items)}},e.prototype.current=function(){var b=this._core.relative(this._core.current());return a.grep(this._pages,a.proxy(function(a,c){return a.start<=b&&a.end>=b},this)).pop()},e.prototype.getPosition=function(b){var c,d,e=this._core.settings;return"page"==e.slideBy?(c=a.inArray(this.current(),this._pages),d=this._pages.length,b?++c:--c,c=this._pages[(c%d+d)%d].start):(c=this._core.relative(this._core.current()),d=this._core.items().length,b?c+=e.slideBy:c-=e.slideBy),c},e.prototype.next=function(b){a.proxy(this._overrides.to,this._core)(this.getPosition(!0),b)},e.prototype.prev=function(b){a.proxy(this._overrides.to,this._core)(this.getPosition(!1),b)},e.prototype.to=function(b,c,d){var e;!d&&this._pages.length?(e=this._pages.length,a.proxy(this._overrides.to,this._core)(this._pages[(b%e+e)%e].start,c)):a.proxy(this._overrides.to,this._core)(b,c)},a.fn.owlCarousel.Constructor.Plugins.Navigation=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){"use strict";var e=function(c){this._core=c,this._hashes={},this.$element=this._core.$element,this._handlers={"initialized.owl.carousel":a.proxy(function(c){c.namespace&&"URLHash"===this._core.settings.startPosition&&a(b).trigger("hashchange.owl.navigation")},this),"prepared.owl.carousel":a.proxy(function(b){if(b.namespace){var c=a(b.content).find("[data-hash]").addBack("[data-hash]").attr("data-hash");if(!c)return;this._hashes[c]=b.content}},this),"changed.owl.carousel":a.proxy(function(c){if(c.namespace&&"position"===c.property.name){var d=this._core.items(this._core.relative(this._core.current())),e=a.map(this._hashes,function(a,b){return a===d?b:null}).join();if(!e||b.location.hash.slice(1)===e)return;b.location.hash=e}},this)},this._core.options=a.extend({},e.Defaults,this._core.options),this.$element.on(this._handlers),a(b).on("hashchange.owl.navigation",a.proxy(function(a){var c=b.location.hash.substring(1),e=this._core.$stage.children(),f=this._hashes[c]&&e.index(this._hashes[c]);f!==d&&f!==this._core.current()&&this._core.to(this._core.relative(f),!1,!0)},this))};e.Defaults={URLhashListener:!1},e.prototype.destroy=function(){var c,d;a(b).off("hashchange.owl.navigation");for(c in this._handlers)this._core.$element.off(c,this._handlers[c]);for(d in Object.getOwnPropertyNames(this))"function"!=typeof this[d]&&(this[d]=null)},a.fn.owlCarousel.Constructor.Plugins.Hash=e}(window.Zepto||window.jQuery,window,document),function(a,b,c,d){function e(b,c){var e=!1,f=b.charAt(0).toUpperCase()+b.slice(1);return a.each((b+" "+h.join(f+" ")+f).split(" "),function(a,b){if(g[b]!==d)return e=!c||b,!1}),e}function f(a){return e(a,!0)}var g=a("<support>").get(0).style,h="Webkit Moz O ms".split(" "),i={transition:{end:{WebkitTransition:"webkitTransitionEnd",MozTransition:"transitionend",OTransition:"oTransitionEnd",transition:"transitionend"}},animation:{end:{WebkitAnimation:"webkitAnimationEnd",MozAnimation:"animationend",OAnimation:"oAnimationEnd",animation:"animationend"}}},j={csstransforms:function(){return!!e("transform")},csstransforms3d:function(){return!!e("perspective")},csstransitions:function(){return!!e("transition")},cssanimations:function(){return!!e("animation")}};j.csstransitions()&&(a.support.transition=new String(f("transition")),a.support.transition.end=i.transition.end[a.support.transition]),j.cssanimations()&&(a.support.animation=new String(f("animation")),a.support.animation.end=i.animation.end[a.support.animation]),j.csstransforms()&&(a.support.transform=new String(f("transform")),a.support.transform3d=j.csstransforms3d())}(window.Zepto||window.jQuery,window,document);

/***/ }),

/***/ 1532:
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
    // https://tools.ietf.org/html/rfc7230#section-3.2
    var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
    preProcessedHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = options.status === undefined ? 200 : options.status
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      } else if (request.credentials === 'omit') {
        xhr.withCredentials = false
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),

/***/ 1537:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return focusTextLead; });
var focusTextLead = function focusTextLead() {
  $('#textInputModal').on('shown.bs.modal', function () {
    var requestLeadPhone = $(this).find('#text-number');
    var modalContent = $(this).find('.modal-content');
    requestLeadPhone.on('focus', function () {
      modalContent.animate({
        scrollTop: 325
      });
    });
    if (!requestLeadPhone.val()) {
      modalContent.addClass("ab-open-keyboard-txt-modal");
      requestLeadPhone.trigger("focus");
    }
  });
};

/***/ }),

/***/ 1539:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Message; });
/*global jQuery, window */

/**
 * Message
 *
 * @class Message
 * @constructor
 * @param {object} options
 * @param {function} callback
 */

var Message = function Message(options, callback) {
  "use strict";

  var self = this,
      _events = {
    visibleChanged: [],
    closeClicked: []
  },
      _visible,
      initialize;

  self.options = options;
  self.options.events = self.options.events || {};

  /*******************************************************************************************************************/
  /* Local Methods and Event handlers */

  /* Prepares the side list */
  initialize = function initialize() {
    if (!self.options.container) {
      self.options.mapContainer = $(self.options.mapContainer);
      var $parent = self.options.mapContainer.parent();
      // Create container for all sources
      self.options.container = $parent.find(".js-map-message-container");
      if (self.options.container.length === 0) {
        $parent.append('<div class="notification-container js-map-message-container absolute-centering"></div>');
        self.options.container = $parent.find(".js-map-message-container");
      }
    }

    if (self.options.events.closeClicked) {
      self.onCloseClicked(self.options.events.closeClicked);
    }

    // Call function at the end
    if (callback) {
      callback();
    }
  };

  /*******************************************************************************************************************/
  /* Public Properties and Methods */

  /**
   * Visible flag
   * Boolean flag to show/hide side list.
   *
   * @method setVisible
   * @type {boolean}
   */
  self.setVisible = function (flag) {
    if (_visible !== flag) {
      _visible = flag;
      if (_visible === true) {
        self.options.container.removeClass('hide').show(); // Put animations here
      } else {
        if (!self.options.container.hasClass('hide')) {
          // Remove click event from button and empty content
          jQuery(self.container).find(".close").unbind("click").end().find(".action").unbind("click");
          self.options.container.addClass('hide').empty();
        }
        self.options.container.hide(); // Put animations here
      }

      // Change event
      jQuery.each(_events.visibleChanged, function (x, callback) {
        callback(_visible);
      });
    }
  };

  /**
   * Visible flag
   * Boolean flag to show/hide side list.
   *
   * @method getVisible
   * @type {boolean}
   */
  self.getVisible = function () {
    return _visible;
  };

  /**
   * Hides Side List from display
   *
   * @method hide
   * @return {undefined}
   */
  self.hide = function () {
    self.setVisible(false);
  };

  /**
   * Shows Message on Display
   *
   * @method show
   * @param {object} params
   * @param {number} params.count Number of properties delivered to the map
   * @param {number} params.total Total number of properties available for the area
   * @param {string} params.message Text/HTML message
   * @param {bool} params.showAdvanced Show Advanced Button with event
   * @return {undefined}
   */
  self.show = function (params) {
    if (params) {
      var html = '<section class="overlay-message notification"><div class="ra ra-close close-overlay"></div><p>' + params.message + '</p></section>';

      // Hide existing notification
      self.setVisible(false);

      self.options.container.append(html);
      // Calculate position
      if (params.pos === undefined) {

        /*if ((params.total === 0 && params.count === 0) || params.message !== undefined) {
        // map centre
        params.pos = self.options.mapContainer.position();
        params.pos.top = params.pos.top + ((self.options.mapContainer.height() / 2) - (self.options.container.height() / 2));
        params.pos.left = params.pos.left + ((self.options.mapContainer.width() /2 ) - (self.options.container.width() / 2));
        self.options.container.removeClass('shadow');
        } else { // sidelist
        self.resize();
        params.pos = {};
        self.options.container.addClass('shadow');
        }
         // Set notification position
        if (params.pos.top >= 0) {
        pos.top = params.pos.top.toString() + "px";
        }
        if (params.pos.left > 0) {
        pos.left = params.pos.left.toString() + "px";
        }
        self.options.container.css(pos);*/

        // Wire up events
        // Close
        jQuery(self.options.container).find(".close-overlay").click(function (e) {
          jQuery.each(_events.closeClicked, function (x, callback) {
            if (callback) {
              callback({
                message: html
              });
            }
          });
          self.hide();
          e.stopPropagation();
        }).end();
        self.setVisible(true);
      }
    }
  };

  /*******************************************************************************************************************/
  /* Events */

  /**
   * Event occurs when extension visible flag is changed
   *
   * @method onVisibleChanged
   */
  self.onVisibleChanged = function (callback) {
    self.options.utils.addToEvents(callback, _events.visibleChanged);
  };

  /**
   * Event occurs when notification close button is clicked
   *
   * @method onCloseClicked
   */
  self.onCloseClicked = function (callback) {
    self.options.utils.addToEvents(callback, _events.closeClicked);
  };

  /* Initializes this extension */
  initialize();
};

/***/ }),

/***/ 1540:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__string__ = __webpack_require__(123);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__string__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__keys__ = __webpack_require__(24);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_1__keys__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pins__ = __webpack_require__(1541);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__pins__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__pins__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__pins__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__pins__["d"]; });




/***/ }),

/***/ 1541:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return DEFAULT_PIN_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DEFAULT_CLUSTER_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return PIN_SIZE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return CLUSTER_SIZE; });
var DEFAULT_PIN_COUNT = 200;
var DEFAULT_CLUSTER_COUNT = 30;

var PIN_SIZE = 44 * 44;
var CLUSTER_SIZE = 100 * 100;

/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Logger; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_critical_store__ = __webpack_require__(8);
/*global window*/


(function (MOVE) {
  "use strict";

  var logger = function logger() {

    var levels = ['error', 'warn', 'info', 'debug'];

    var level = '';

    // Android native WebView doesnt support localStorage by defualt
    if (__WEBPACK_IMPORTED_MODULE_0__shared_critical_store__["b" /* LocalStorage */].isAvailable) {
      level = window.localStorage.getItem('loglevel') || '';
    }
    var level_id = levels.indexOf(level);

    function noop() {}

    function consoleLog(type) {
      if (level_id < levels.indexOf(type)) {
        return noop;
      }

      var console = window.console || {},
          logFn = console[type] || console.log || noop,
          hasApply = false;

      // Note: reading logFn.apply throws an error in IE11 in IE8 document mode.
      // The reason behind this is that console.log has type "object" in IE8...
      try {
        hasApply = !!logFn.apply;
      } catch (e) {/* empty */
      }

      if (hasApply) {
        return function () {
          return logFn.apply(console, arguments);
        };
      }

      // we are IE which either doesn't have window.console => this is noop and we do nothing,
      // or we are IE where console.log doesn't have apply so we log at least first 2 args
      return function (arg1, arg2) {
        logFn(arg1, arg2 === null ? '' : arg2);
      };
    }

    return {
      error: consoleLog('error'),
      warn: consoleLog('warn'),
      info: consoleLog('info'),
      debug: consoleLog('debug')
    };
  }();

  MOVE.logger = logger;
})(MOVE);

var Logger = MOVE.logger;

/***/ }),

/***/ 162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return trackLead; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return trackLeadText; });
/* global RdcTracking */

var DEFAULT_VALUE = 'unknown';

var trackLead = function trackLead(pd) {
  var lead_attributes = pd.lead_attributes || {};
  var commonProps = commonPropsForLead(pd);
  var isBdp = pd.is_building;

  var opts = {
    propertyStatus: pd.property_type,
    source: pd.source,
    flags: pd.flags,
    leadType: getLeadType(lead_attributes.lead_type, isBdp),
    showContactALender: lead_attributes.show_contact_a_lender,
    isLcmEnabled: lead_attributes.is_lcm_enabled,
    leadFlow: pd.is_mal ? 'mal' : null,
    placementData: pd.placementData, //object that takes: pageType, pageSection, and pageAction, OR the entire constructed placement string
    leadAdditions: pd.leadAdditions,
    isBdp: isBdp
  };
  RdcTracking.trackLead(commonProps, opts);
};

var commonPropsForLead = function commonPropsForLead(pd) {
  return {
    propertyStatus: pd.property_status || pd.property_type || DEFAULT_VALUE,
    productType: pd.product_type || pd.productType || pd.producttype || DEFAULT_VALUE, // comes from adobeDTM, not propertyDetails, assigned from the function call
    state: pd.state_code || DEFAULT_VALUE,
    zip: pd.postal_code || DEFAULT_VALUE,
    city: pd.city || DEFAULT_VALUE,
    listingPrice: pd.price || DEFAULT_VALUE,
    creditScore: getCreditScore(pd.leadCreditScore) || DEFAULT_VALUE,
    leadGuid: pd.leadGuid,
    listingId: pd.listing_id || DEFAULT_VALUE,
    moveInDate: pd.moveInDate,
    leadAgentSelectionCount: pd.leadAgentSelectionCount,
    roleType: pd.roleType,
    dsProducts: getDataScienceProducts(pd.property_status, pd.quick_to_sell_days),
    actlv: pd.leadValue,
    adjv: pd.initialLeadValue,
    lcmOptIn: pd.lcmOptIn,
    listingActivity: pd.statusTags ? pd.statusTags : DEFAULT_VALUE,
    listingBeds: pd.beds,
    listingBaths: pd.baths,
    listingSqFt: pd.sqft,
    propertyType: pd.type || pd.prop_type || DEFAULT_VALUE,
    rentalDataSource: pd.rentalDataSource
  };
};

var getDataScienceProducts = function getDataScienceProducts(prop_status, qts) {
  if (prop_status === 'for_sale' && typeof qts !== 'undefined') {
    return 'hot-buy';
  }
};

var getLeadType = function getLeadType(leadType, isBdp) {
  return isBdp ? 'co_broke' : leadType;
};

var getCreditScore = function getCreditScore(creditScore) {
  if (creditScore && creditScore.length) {
    return creditScore;
  }
};

var trackLeadText = function trackLeadText(_ref) {
  var property = _ref.property,
      leadPlacement = _ref.leadPlacement;
  var propertyStatus = property.propertyStatus,
      listing = property.listing;
  var leadDelivery = listing.leadDelivery;

  var opts = {
    textLeads: 'web:leads:text:' + propertyStatus + ':' + leadDelivery,
    linkName: 'web:leads:text:' + propertyStatus + ':' + leadDelivery,
    leadPlacement: '' + leadPlacement
  };
  RdcTracking.trackEvent('forSaleCobrokeTextLead', opts);
};

/***/ }),

/***/ 1667:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(setImmediate) {(function (root) {

  // Store setTimeout reference so promise-polyfill will be unaffected by
  // other code modifying setTimeout (like sinon.useFakeTimers())
  var setTimeoutFunc = setTimeout;

  function noop() {}
  
  // Polyfill for Function.prototype.bind
  function bind(fn, thisArg) {
    return function () {
      fn.apply(thisArg, arguments);
    };
  }

  function Promise(fn) {
    if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
    if (typeof fn !== 'function') throw new TypeError('not a function');
    this._state = 0;
    this._handled = false;
    this._value = undefined;
    this._deferreds = [];

    doResolve(fn, this);
  }

  function handle(self, deferred) {
    while (self._state === 3) {
      self = self._value;
    }
    if (self._state === 0) {
      self._deferreds.push(deferred);
      return;
    }
    self._handled = true;
    Promise._immediateFn(function () {
      var cb = self._state === 1 ? deferred.onFulfilled : deferred.onRejected;
      if (cb === null) {
        (self._state === 1 ? resolve : reject)(deferred.promise, self._value);
        return;
      }
      var ret;
      try {
        ret = cb(self._value);
      } catch (e) {
        reject(deferred.promise, e);
        return;
      }
      resolve(deferred.promise, ret);
    });
  }

  function resolve(self, newValue) {
    try {
      // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
      if (newValue === self) throw new TypeError('A promise cannot be resolved with itself.');
      if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
        var then = newValue.then;
        if (newValue instanceof Promise) {
          self._state = 3;
          self._value = newValue;
          finale(self);
          return;
        } else if (typeof then === 'function') {
          doResolve(bind(then, newValue), self);
          return;
        }
      }
      self._state = 1;
      self._value = newValue;
      finale(self);
    } catch (e) {
      reject(self, e);
    }
  }

  function reject(self, newValue) {
    self._state = 2;
    self._value = newValue;
    finale(self);
  }

  function finale(self) {
    if (self._state === 2 && self._deferreds.length === 0) {
      Promise._immediateFn(function() {
        if (!self._handled) {
          Promise._unhandledRejectionFn(self._value);
        }
      });
    }

    for (var i = 0, len = self._deferreds.length; i < len; i++) {
      handle(self, self._deferreds[i]);
    }
    self._deferreds = null;
  }

  function Handler(onFulfilled, onRejected, promise) {
    this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
    this.onRejected = typeof onRejected === 'function' ? onRejected : null;
    this.promise = promise;
  }

  /**
   * Take a potentially misbehaving resolver function and make sure
   * onFulfilled and onRejected are only called once.
   *
   * Makes no guarantees about asynchrony.
   */
  function doResolve(fn, self) {
    var done = false;
    try {
      fn(function (value) {
        if (done) return;
        done = true;
        resolve(self, value);
      }, function (reason) {
        if (done) return;
        done = true;
        reject(self, reason);
      });
    } catch (ex) {
      if (done) return;
      done = true;
      reject(self, ex);
    }
  }

  Promise.prototype['catch'] = function (onRejected) {
    return this.then(null, onRejected);
  };

  Promise.prototype.then = function (onFulfilled, onRejected) {
    var prom = new (this.constructor)(noop);

    handle(this, new Handler(onFulfilled, onRejected, prom));
    return prom;
  };

  Promise.all = function (arr) {
    var args = Array.prototype.slice.call(arr);

    return new Promise(function (resolve, reject) {
      if (args.length === 0) return resolve([]);
      var remaining = args.length;

      function res(i, val) {
        try {
          if (val && (typeof val === 'object' || typeof val === 'function')) {
            var then = val.then;
            if (typeof then === 'function') {
              then.call(val, function (val) {
                res(i, val);
              }, reject);
              return;
            }
          }
          args[i] = val;
          if (--remaining === 0) {
            resolve(args);
          }
        } catch (ex) {
          reject(ex);
        }
      }

      for (var i = 0; i < args.length; i++) {
        res(i, args[i]);
      }
    });
  };

  Promise.resolve = function (value) {
    if (value && typeof value === 'object' && value.constructor === Promise) {
      return value;
    }

    return new Promise(function (resolve) {
      resolve(value);
    });
  };

  Promise.reject = function (value) {
    return new Promise(function (resolve, reject) {
      reject(value);
    });
  };

  Promise.race = function (values) {
    return new Promise(function (resolve, reject) {
      for (var i = 0, len = values.length; i < len; i++) {
        values[i].then(resolve, reject);
      }
    });
  };

  // Use polyfill for setImmediate for performance gains
  Promise._immediateFn = (typeof setImmediate === 'function' && function (fn) { setImmediate(fn); }) ||
    function (fn) {
      setTimeoutFunc(fn, 0);
    };

  Promise._unhandledRejectionFn = function _unhandledRejectionFn(err) {
    if (typeof console !== 'undefined' && console) {
      console.warn('Possible Unhandled Promise Rejection:', err); // eslint-disable-line no-console
    }
  };

  /**
   * Set the immediate function to execute callbacks
   * @param fn {function} Function to execute
   * @deprecated
   */
  Promise._setImmediateFn = function _setImmediateFn(fn) {
    Promise._immediateFn = fn;
  };

  /**
   * Change the function to execute on unhandled rejection
   * @param {function} fn Function to execute on unhandled rejection
   * @deprecated
   */
  Promise._setUnhandledRejectionFn = function _setUnhandledRejectionFn(fn) {
    Promise._unhandledRejectionFn = fn;
  };
  
  if (typeof module !== 'undefined' && module.exports) {
    module.exports = Promise;
  } else if (!root.Promise) {
    root.Promise = Promise;
  }

})(this);

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1690).setImmediate))

/***/ }),

/***/ 1684:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
    "use strict";

    if (global.setImmediate) {
        return;
    }

    var nextHandle = 1; // Spec says greater than zero
    var tasksByHandle = {};
    var currentlyRunningATask = false;
    var doc = global.document;
    var registerImmediate;

    function setImmediate(callback) {
      // Callback can either be a function or a string
      if (typeof callback !== "function") {
        callback = new Function("" + callback);
      }
      // Copy function arguments
      var args = new Array(arguments.length - 1);
      for (var i = 0; i < args.length; i++) {
          args[i] = arguments[i + 1];
      }
      // Store and register the task
      var task = { callback: callback, args: args };
      tasksByHandle[nextHandle] = task;
      registerImmediate(nextHandle);
      return nextHandle++;
    }

    function clearImmediate(handle) {
        delete tasksByHandle[handle];
    }

    function run(task) {
        var callback = task.callback;
        var args = task.args;
        switch (args.length) {
        case 0:
            callback();
            break;
        case 1:
            callback(args[0]);
            break;
        case 2:
            callback(args[0], args[1]);
            break;
        case 3:
            callback(args[0], args[1], args[2]);
            break;
        default:
            callback.apply(undefined, args);
            break;
        }
    }

    function runIfPresent(handle) {
        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
        // So if we're currently running a task, we'll need to delay this invocation.
        if (currentlyRunningATask) {
            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
            // "too much recursion" error.
            setTimeout(runIfPresent, 0, handle);
        } else {
            var task = tasksByHandle[handle];
            if (task) {
                currentlyRunningATask = true;
                try {
                    run(task);
                } finally {
                    clearImmediate(handle);
                    currentlyRunningATask = false;
                }
            }
        }
    }

    function installNextTickImplementation() {
        registerImmediate = function(handle) {
            process.nextTick(function () { runIfPresent(handle); });
        };
    }

    function canUsePostMessage() {
        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
        // where `global.postMessage` means something completely different and can't be used for this purpose.
        if (global.postMessage && !global.importScripts) {
            var postMessageIsAsynchronous = true;
            var oldOnMessage = global.onmessage;
            global.onmessage = function() {
                postMessageIsAsynchronous = false;
            };
            global.postMessage("", "*");
            global.onmessage = oldOnMessage;
            return postMessageIsAsynchronous;
        }
    }

    function installPostMessageImplementation() {
        // Installs an event handler on `global` for the `message` event: see
        // * https://developer.mozilla.org/en/DOM/window.postMessage
        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

        var messagePrefix = "setImmediate$" + Math.random() + "$";
        var onGlobalMessage = function(event) {
            if (event.source === global &&
                typeof event.data === "string" &&
                event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
            }
        };

        if (global.addEventListener) {
            global.addEventListener("message", onGlobalMessage, false);
        } else {
            global.attachEvent("onmessage", onGlobalMessage);
        }

        registerImmediate = function(handle) {
            global.postMessage(messagePrefix + handle, "*");
        };
    }

    function installMessageChannelImplementation() {
        var channel = new MessageChannel();
        channel.port1.onmessage = function(event) {
            var handle = event.data;
            runIfPresent(handle);
        };

        registerImmediate = function(handle) {
            channel.port2.postMessage(handle);
        };
    }

    function installReadyStateChangeImplementation() {
        var html = doc.documentElement;
        registerImmediate = function(handle) {
            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
            var script = doc.createElement("script");
            script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
            };
            html.appendChild(script);
        };
    }

    function installSetTimeoutImplementation() {
        registerImmediate = function(handle) {
            setTimeout(runIfPresent, 0, handle);
        };
    }

    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

    // Don't get fooled by e.g. browserify environments.
    if ({}.toString.call(global.process) === "[object process]") {
        // For Node.js before 0.9
        installNextTickImplementation();

    } else if (canUsePostMessage()) {
        // For non-IE10 modern browsers
        installPostMessageImplementation();

    } else if (global.MessageChannel) {
        // For web workers, where supported
        installMessageChannelImplementation();

    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
        // For IE 6–8
        installReadyStateChangeImplementation();

    } else {
        // For older browsers
        installSetTimeoutImplementation();
    }

    attachTo.setImmediate = setImmediate;
    attachTo.clearImmediate = clearImmediate;
}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21), __webpack_require__(650)))

/***/ }),

/***/ 1690:
/***/ (function(module, exports, __webpack_require__) {

var apply = Function.prototype.apply;

// DOM APIs, for completeness

exports.setTimeout = function() {
  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
};
exports.setInterval = function() {
  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
};
exports.clearTimeout =
exports.clearInterval = function(timeout) {
  if (timeout) {
    timeout.close();
  }
};

function Timeout(id, clearFn) {
  this._id = id;
  this._clearFn = clearFn;
}
Timeout.prototype.unref = Timeout.prototype.ref = function() {};
Timeout.prototype.close = function() {
  this._clearFn.call(window, this._id);
};

// Does not start the time, just sets up the members needed.
exports.enroll = function(item, msecs) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = msecs;
};

exports.unenroll = function(item) {
  clearTimeout(item._idleTimeoutId);
  item._idleTimeout = -1;
};

exports._unrefActive = exports.active = function(item) {
  clearTimeout(item._idleTimeoutId);

  var msecs = item._idleTimeout;
  if (msecs >= 0) {
    item._idleTimeoutId = setTimeout(function onTimeout() {
      if (item._onTimeout)
        item._onTimeout();
    }, msecs);
  }
};

// setimmediate attaches itself to the global object
__webpack_require__(1684);
exports.setImmediate = setImmediate;
exports.clearImmediate = clearImmediate;


/***/ }),

/***/ 1691:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/*!
Copyright (C) 2015-2017 Andrea Giammarchi - @WebReflection

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
THE SOFTWARE.

*/


function URLSearchParams(query) {
  var
    index, key, value,
    pairs, i, length,
    dict = Object.create(null)
  ;
  this[secret] = dict;
  if (!query) return;
  if (typeof query === 'string') {
    if (query.charAt(0) === '?') {
      query = query.slice(1);
    }
    for (
      pairs = query.split('&'),
      i = 0,
      length = pairs.length; i < length; i++
    ) {
      value = pairs[i];
      index = value.indexOf('=');
      if (-1 < index) {
        appendTo(
          dict,
          decode(value.slice(0, index)),
          decode(value.slice(index + 1))
        );
      } else if (value.length){
        appendTo(
          dict,
          decode(value),
          ''
        );
      }
    }
  } else {
    if (isArray(query)) {
      for (
        i = 0,
        length = query.length; i < length; i++
      ) {
        value = query[i];
        appendTo(dict, value[0], value[1]);
      }
    } else {
      for (key in query) {
         appendTo(dict, key, query[key]);
      }
    }
  }
}

var
  isArray = Array.isArray,
  URLSearchParamsProto = URLSearchParams.prototype,
  find = /[!'\(\)~]|%20|%00/g,
  plus = /\+/g,
  replace = {
    '!': '%21',
    "'": '%27',
    '(': '%28',
    ')': '%29',
    '~': '%7E',
    '%20': '+',
    '%00': '\x00'
  },
  replacer = function (match) {
    return replace[match];
  },
  secret = '__URLSearchParams__:' + Math.random()
;

function appendTo(dict, name, value) {
  if (name in dict) {
    dict[name].push('' + value);
  } else {
    dict[name] = isArray(value) ? value : ['' + value];
  }
}

function decode(str) {
  return decodeURIComponent(str.replace(plus, ' '));
}

function encode(str) {
  return encodeURIComponent(str).replace(find, replacer);
}

URLSearchParamsProto.append = function append(name, value) {
  appendTo(this[secret], name, value);
};

URLSearchParamsProto.delete = function del(name) {
  delete this[secret][name];
};

URLSearchParamsProto.get = function get(name) {
  var dict = this[secret];
  return name in dict ? dict[name][0] : null;
};

URLSearchParamsProto.getAll = function getAll(name) {
  var dict = this[secret];
  return name in dict ? dict[name].slice(0) : [];
};

URLSearchParamsProto.has = function has(name) {
  return name in this[secret];
};

URLSearchParamsProto.set = function set(name, value) {
  this[secret][name] = ['' + value];
};

URLSearchParamsProto.forEach = function forEach(callback, thisArg) {
  var dict = this[secret];
  Object.getOwnPropertyNames(dict).forEach(function(name) {
    dict[name].forEach(function(value) {
      callback.call(thisArg, value, name, this);
    }, this);
  }, this);
};

/*
URLSearchParamsProto.toBody = function() {
  return new Blob(
    [this.toString()],
    {type: 'application/x-www-form-urlencoded'}
  );
};
*/

URLSearchParamsProto.toJSON = function toJSON() {
  return {};
};

URLSearchParamsProto.toString = function toString() {
  var dict = this[secret], query = [], i, key, name, value;
  for (key in dict) {
    name = encode(key);
    for (
      i = 0,
      value = dict[key];
      i < value.length; i++
    ) {
      query.push(name + '=' + encode(value[i]));
    }
  }
  return query.join('&');
};

URLSearchParams = (module.exports = global.URLSearchParams || URLSearchParams);

(function (URLSearchParamsProto) {

  var iterable = (function () {
    try {
      return !!Symbol.iterator;
    } catch(error) {
      return false;
    }
  }());

  // mostly related to issue #24
  if (!('forEach' in URLSearchParamsProto)) {
    URLSearchParamsProto.forEach = function forEach(callback, thisArg) {
      var names = Object.create(null);
      this.toString()
          .replace(/=[\s\S]*?(?:&|$)/g, '=')
          .split('=')
          .forEach(function (name) {
            if (!name.length || name in names) return;
            (names[name] = this.getAll(name)).forEach(function(value) {
              callback.call(thisArg, value, name, this);
            }, this);
          }, this);
    };
  }

  if (!('keys' in URLSearchParamsProto)) {
    URLSearchParamsProto.keys = function keys() {
      var items = [];
      this.forEach(function(value, name) { items.push(name); });
      var iterator = {
        next: function() {
          var value = items.shift();
          return {done: value === undefined, value: value};
        }
      };

      if (iterable) {
        iterator[Symbol.iterator] = function() {
          return iterator;
        };
      }

      return iterator;
    };
  }

  if (!('values' in URLSearchParamsProto)) {
    URLSearchParamsProto.values = function values() {
      var items = [];
      this.forEach(function(value) { items.push(value); });
      var iterator = {
        next: function() {
          var value = items.shift();
          return {done: value === undefined, value: value};
        }
      };

      if (iterable) {
        iterator[Symbol.iterator] = function() {
          return iterator;
        };
      }

      return iterator;
    };
  }

  if (!('entries' in URLSearchParamsProto)) {
    URLSearchParamsProto.entries = function entries() {
      var items = [];
      this.forEach(function(value, name) { items.push([name, value]); });
      var iterator = {
        next: function() {
          var value = items.shift();
          return {done: value === undefined, value: value};
        }
      };

      if (iterable) {
        iterator[Symbol.iterator] = function() {
          return iterator;
        };
      }

      return iterator;
    };
  }

  if (iterable && !(Symbol.iterator in URLSearchParamsProto)) {
    URLSearchParamsProto[Symbol.iterator] = URLSearchParamsProto.entries;
  }

  if (!('sort' in URLSearchParamsProto)) {
    URLSearchParamsProto.sort = function sort() {
      var
        entries = this.entries(),
        entry = entries.next(),
        done = entry.done,
        keys = [],
        values = Object.create(null),
        i, key, value
      ;
      while (!done) {
        value = entry.value;
        key = value[0];
        keys.push(key);
        if (!(key in values)) {
          values[key] = [];
        }
        values[key].push(value[1]);
        entry = entries.next();
        done = entry.done;
      }
      // not the champion in efficiency
      // but these two bits just do the job
      keys.sort();
      for (i = 0; i < keys.length; i++) {
        this.delete(keys[i]);
      }
      for (i = 0; i < keys.length; i++) {
        key = keys[i];
        this.append(key, values[key].shift());
      }
    };
  }

}(URLSearchParams.prototype));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),

/***/ 18:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return trackModalImpression; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return trackRmdModalImpression; });
/* global RdcTracking */

var trackModalImpression = function trackModalImpression(modalName, modalTrigger) {
  if (modalName && modalTrigger) {
    RdcTracking.trackEvent('modalImpression', { modalName: modalName, modalTrigger: modalTrigger });
  }
};

//Simple helper function since this specific code is in a couple locations
var trackRmdModalImpression = function trackRmdModalImpression(e) {
  var omtag = e.target.attributes['data-omtag'] ? e.target.attributes['data-omtag'].value : '';
  trackModalImpression('homes:modal:rmd', omtag);
};

/***/ }),

/***/ 180:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getPageName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return getPropStatus; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getViewType; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getSiteSection; });
var NOT_FOR_SALE_STATUSES = ['for_rent', 'not_for_sale'];

var getPageName = function getPageName() {
  var propStatus = getPropStatus();
  var viewType = getViewType();
  if (!viewType) {
    return viewType;
  }
  return propStatus + ':' + viewType;
};

var getPropStatus = function getPropStatus() {
  var propStatus = MOVE_DATA.adobeDTM.propertyStatus;
  return NOT_FOR_SALE_STATUSES.indexOf(propStatus) >= 0 ? propStatus : 'for_sale';
};

var getViewType = function getViewType() {
  var pageType = MOVE_DATA.adobeDTM.pageType;
  var viewType = pageType === 'srp-list' ? 'list' : pageType === 'srp-map' ? 'map' : '';
  if (!viewType) {
    return viewType;
  }
  return 'srp_' + viewType;
};

var getSiteSection = function getSiteSection(propertyStatus) {
  return NOT_FOR_SALE_STATUSES.indexOf(propertyStatus) >= 0 ? propertyStatus : 'for_sale';
};

/***/ }),

/***/ 21:
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),

/***/ 212:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["RdcTracking"] = __webpack_require__(938);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),

/***/ 24:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return BACKSPACE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return DELETE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return TAB_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return UP_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return LEFT_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return RIGHT_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return DOWN_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return ZERO_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return NINE_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ENTER_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ESC_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return P_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return Q_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return A_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return Z_KEY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return SPACE_KEY; });
var BACKSPACE_KEY = 8;
var DELETE_KEY = 46;
var TAB_KEY = 9;
var UP_KEY = 38;
var LEFT_KEY = 37;
var RIGHT_KEY = 39;
var DOWN_KEY = 40;
var ZERO_KEY = 48;
var NINE_KEY = 57;
var ENTER_KEY = 13;
var ESC_KEY = 27;
var P_KEY = 80;
var Q_KEY = 81;
var A_KEY = 65;
var Z_KEY = 90;
var SPACE_KEY = 32;

/***/ }),

/***/ 25:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export formatPrice */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return formatPercent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return commaDelimit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return formatPriceToNumber; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return truncateAgentDescription; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return abbreviateCurrency; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return formatMortgagePercent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return constantize; });
/* unused harmony export getPriceFactor */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return roundOffPrice; });
/* unused harmony export arrayEqual */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return formatLoanTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return homeEquityLoanTypes; });
/*global window, _, MOVE_DATA, localStorage, JST */

var isEmpty = void 0;

// warning -- formatPrice("7510.07") === "7510.7"
var formatPrice = function formatPrice(value) {
  if (!value) {
    return 0;
  }
  return value.replace(/^.*\$(0)0*$|.*\$0*|,/gm, "$1").replace(/0*([1-9][0-9]*|0)/gm, "$1");
};

var formatPercent = function formatPercent(value) {
  if (!value) {
    return 0;
  }
  return value.replace(/[\.]+/g, '.').replace(/\%/g, '');
};

var commaDelimit = function commaDelimit(value) {
  if (!value) {
    return "0";
  }
  return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
};

var formatPriceToNumber = function formatPriceToNumber(value) {
  return value.replace(/^.*\$(0)0*$|.*\$0*|,/gm, "$1");
};

var truncateAgentDescription = function truncateAgentDescription(text) {
  if (text && text.length > 205) {
    return text.substr(0, text.lastIndexOf(' ', 202)) + ' ...';
  } else {
    return text;
  }
};

/**
 * Abbreviates large numbers to short thousands/million format 10k.. 1.2M etc.
 *
 * @method abbreviateCurrency
 * @param {number} value
 * @return {string} short version of number
 */
var abbreviateCurrency = function abbreviateCurrency(value) {
  value = !isEmpty(value) && value !== "" ? value : 0;
  var result = value.toString(),
      // coerce to string
  mode = "";
  value = parseInt(value, 10);
  // Calculate abbreviation
  if (value >= 1000 && value < 1000000) {
    value = Math.floor(value / 1000);
    if (value < 1000) {
      mode = "k";
    } else {
      value = Math.floor(value / 1000);
      mode = "M";
    }
  } else if (value >= 1000000) {
    value = Math.floor(value / 1000);
    value = Math.floor(value / 10);
    value = (value / 100).toFixed(2);
    mode = "M";
  }
  // Convert result
  result = value.toString();
  // Suppress last zero digits
  if (result.indexOf(".00") > -1) {
    result = result.substr(0, result.indexOf(".00"));
  }
  // Suppress last empty digit (zero)
  if (result.indexOf('.') > -1 && result.substr(result.length - 1, 1) === "0") {
    result = result.substr(0, result.length - 1);
  }
  result += mode;
  return '$' + result;
};

var formatMortgagePercent = function formatMortgagePercent(value) {
  var i = 0;
  return value.replace(/[\.\%]/g, function () {
    return i++ === 0 ? '.' : '';
  });
};

/**
 *
 * @param OBJ => Any object with property and values which is to be made constant.
 * @returns {*} => returns object whose properties values cant be modified.
 */
var constantize = function constantize(OBJ) {
  var C = null;
  for (C in OBJ) {
    Object.defineProperty(OBJ, C, { value: OBJ[C], writable: false });
  }
  return OBJ;
};

//For checking if a string is blank, null or undefined
isEmpty = function isEmpty(str) {
  return !str || /^\s*$/.test(str);
};

var getPriceFactor = function getPriceFactor(v) {
  if (v < 100) {
    return 10;
  } else if (v < 1000) {
    return 100;
  } else if (v < 10000) {
    return 1000;
  } else if (v < 100000) {
    return 10000;
  } else if (v < 150000) {
    return 20000;
  } else if (v < 200000) {
    return 30000;
  } else if (v < 500000) {
    return 50000;
  } else if (v < 1000000) {
    return 100000;
  } else if (v < 5000000) {
    return 200000;
  } else if (v < 10000000) {
    return 300000;
  } else if (v < 100000000) {
    return 10000000;
  } else if (v < 1000000000) {
    return 100000000;
  } else if (v < 10000000000) {
    return 1000000000;
  }
};

var roundOffPrice = function roundOffPrice(value) {
  var factor = getPriceFactor(value);
  return Math.round(value / factor) * factor;
};

var arrayEqual = function arrayEqual(arr1, arr2) {
  if (arr1.length !== arr2.length) {
    return false;
  }
  arr1 = arr1.sort();
  arr2 = arr2.sort();
  for (var i = 0; i < arr1.length; i++) {
    if (arr1[i] !== arr2[i]) {
      return false;
    }
  }
  return true;
};

var formatLoanTypes = function formatLoanTypes() {
  return [{ '30YrFixed': '30yr fixed' }, { '30YrFixed_FHA': '30yr fixed FHA' }, { '30YrFixed_VA': '30yr fixed VA' }, { '20YrFixed': '20yr fixed' }, { '15YrFixed': '15yr fixed' }, { '10YrFixed': '10yr fixed' }, { '5Arm': '5/1 ARM' }, { '7Arm': '7/1 ARM' }];
};

var homeEquityLoanTypes = [{ value: 'HELOC,HELOAN_FIXED_5YEARS,HELOAN_FIXED_10YEARS,HELOAN_FIXED_15YEARS,HELOAN_FIXED_20YEARS,HELOAN_FIXED_30YEARS', label: 'All Equity Products' }, { value: 'HELOC', label: 'Home Equity Line of Credit' }, { value: 'HELOAN_FIXED_5YEARS', label: 'Home Equity Loan - 5 Years' }, { value: 'HELOAN_FIXED_10YEARS', label: 'Home Equity Loan - 10 Years' }, { value: 'HELOAN_FIXED_15YEARS', label: 'Home Equity Loan - 15 Years' }, { value: 'HELOAN_FIXED_20YEARS', label: 'Home Equity Loan - 20 Years' }, { value: 'HELOAN_FIXED_30YEARS', label: 'Home Equity Loan - 30 Years' }];

(function (MOVE) {
  MOVE.FormatHelper = {
    abbreviateCurrency: abbreviateCurrency,
    formatPrice: formatPrice,
    formatPercent: formatPercent,
    commaDelimit: commaDelimit,
    formatPriceToNumber: formatPriceToNumber,
    formatMortgagePercent: formatMortgagePercent,
    formatLoanTypes: formatLoanTypes,
    isEmpty: isEmpty,
    constantize: constantize,
    roundOffPrice: roundOffPrice,
    arrayEqual: arrayEqual,
    truncateAgentDescription: truncateAgentDescription,
    _TEST_getPriceFactor: getPriceFactor
  };
})(MOVE);

/***/ }),

/***/ 26:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__set_public_path__ = __webpack_require__(1024);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__set_public_path___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__set_public_path__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__polyfill_eventListener_polyfill_js__ = __webpack_require__(1276);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__polyfill_eventListener_polyfill_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__polyfill_eventListener_polyfill_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__polyfill_url_min_js__ = __webpack_require__(1282);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__polyfill_url_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__polyfill_url_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__polyfill_mouse_event_js__ = __webpack_require__(1278);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__polyfill_mouse_event_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__polyfill_mouse_event_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__polyfill_url_search_params__ = __webpack_require__(1281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__polyfill_promise__ = __webpack_require__(1280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__polyfill_objectAssign_polyfill_js__ = __webpack_require__(1279);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__polyfill_objectAssign_polyfill_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__polyfill_objectAssign_polyfill_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__polyfill_isNumber_polyfill_js__ = __webpack_require__(1277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__polyfill_isNumber_polyfill_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__polyfill_isNumber_polyfill_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_qsa_scope__ = __webpack_require__(1515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_element_qsa_scope___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_element_qsa_scope__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_whatwg_fetch__ = __webpack_require__(1532);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_whatwg_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_whatwg_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery_ujs__ = __webpack_require__(1517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_jquery_ujs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_jquery_ujs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_bootstrap_js_scrollspy__ = __webpack_require__(1431);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_bootstrap_js_scrollspy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_bootstrap_js_scrollspy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__moveinc_rdc_tracking__ = __webpack_require__(212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__moveinc_rdc_tracking___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__moveinc_rdc_tracking__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_bootstrap_js_affix__ = __webpack_require__(1427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_bootstrap_js_affix___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_bootstrap_js_affix__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_bootstrap_js_alert__ = __webpack_require__(1428);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_bootstrap_js_alert___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_bootstrap_js_alert__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_rdc_next_legacy_js_libs_js_owl_carousel_min_js__ = __webpack_require__(1526);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_rdc_next_legacy_js_libs_js_owl_carousel_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_rdc_next_legacy_js_libs_js_owl_carousel_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_rdc_next_legacy_js_libs_js_jquery_mobile_js__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_rdc_next_legacy_js_libs_js_jquery_mobile_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_rdc_next_legacy_js_libs_js_jquery_mobile_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_rdc_next_legacy_js_libs_js_jquery_unveil_js__ = __webpack_require__(1525);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_rdc_next_legacy_js_libs_js_jquery_unveil_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_rdc_next_legacy_js_libs_js_jquery_unveil_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_rdc_next_legacy_js_libs_js_jquery_jcarousellite_min_js__ = __webpack_require__(1524);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_rdc_next_legacy_js_libs_js_jquery_jcarousellite_min_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19_rdc_next_legacy_js_libs_js_jquery_jcarousellite_min_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_jquery_cookie_jquery_cookie__ = __webpack_require__(1007);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_jquery_cookie_jquery_cookie___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_jquery_cookie_jquery_cookie__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_rdc_next_legacy_js_libs_js_jquery_appear_min__ = __webpack_require__(1523);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_rdc_next_legacy_js_libs_js_jquery_appear_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_rdc_next_legacy_js_libs_js_jquery_appear_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_rdc_next_legacy_js_libs_js_customSelect_jquery_min__ = __webpack_require__(1522);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_rdc_next_legacy_js_libs_js_customSelect_jquery_min___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_rdc_next_legacy_js_libs_js_customSelect_jquery_min__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_rdc_next_legacy_js_libs_js_bootstrap_select__ = __webpack_require__(1521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_rdc_next_legacy_js_libs_js_bootstrap_select___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_rdc_next_legacy_js_libs_js_bootstrap_select__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_rdc_next_legacy_js_libs_js_bootstrap_modal__ = __webpack_require__(1520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24_rdc_next_legacy_js_libs_js_bootstrap_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24_rdc_next_legacy_js_libs_js_bootstrap_modal__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_rdc_next_legacy_js_libs_js_bootstrap_dropdown__ = __webpack_require__(1519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25_rdc_next_legacy_js_libs_js_bootstrap_dropdown___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25_rdc_next_legacy_js_libs_js_bootstrap_dropdown__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_rdc_next_legacy_js_libs_js_adblock_detector__ = __webpack_require__(1518);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26_rdc_next_legacy_js_libs_js_adblock_detector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26_rdc_next_legacy_js_libs_js_adblock_detector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27_shared_critical_components_jquery_move_autocomplete__ = __webpack_require__(1388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_underscore__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__core_framework_move__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__core_framework_logger__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__workarounds_workaround_google_fonts__ = __webpack_require__(1285);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__workarounds_workaround_google_fonts___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_31__workarounds_workaround_google_fonts__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__workarounds_workaround_ad_blockers__ = __webpack_require__(1283);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__workarounds_workaround_ad_blockers___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_32__workarounds_workaround_ad_blockers__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__workarounds_workaround_safari__ = __webpack_require__(1286);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__workarounds_workaround_safari___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_33__workarounds_workaround_safari__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__workarounds_workaround_cleanup_hash__ = __webpack_require__(1284);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__workarounds_workaround_cleanup_hash___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_34__workarounds_workaround_cleanup_hash__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35_shared_critical_tracking__ = __webpack_require__(1393);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_shared_critical_calculate_page_load_time__ = __webpack_require__(1387);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_shared_critical_calculate_page_load_time___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_shared_critical_calculate_page_load_time__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_shared_critical_auto_complete__ = __webpack_require__(1385);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_37_shared_critical_auto_complete___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_37_shared_critical_auto_complete__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_shared_critical_user_activity__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_38_shared_critical_user_activity___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_38_shared_critical_user_activity__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_shared_critical_user_profile_lead_inputs__ = __webpack_require__(1394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_39_shared_critical_user_profile_lead_inputs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_39_shared_critical_user_profile_lead_inputs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_40_shared_critical_helper__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_41_shared_critical_map_helper__ = __webpack_require__(557);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_42_shared_critical_modal_helper__ = __webpack_require__(1390);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_43_shared_critical_dom_helper__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_44_shared_critical_format_helper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_shared_critical_search_helper__ = __webpack_require__(1391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_45_shared_critical_search_helper___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_45_shared_critical_search_helper__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_shared_critical_custom_smartbanner__ = __webpack_require__(1389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_46_shared_critical_custom_smartbanner___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_46_shared_critical_custom_smartbanner__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_47_shared_critical_branch__ = __webpack_require__(1386);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_48_shared_critical_store__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_qualtrics_feedback_for_ab_tests__ = __webpack_require__(1379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_49_qualtrics_feedback_for_ab_tests___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_49_qualtrics_feedback_for_ab_tests__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_50_shared_critical_constants__ = __webpack_require__(71);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_51_shared_critical_media__ = __webpack_require__(569);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_52_shared_critical_adblock_detector_config__ = __webpack_require__(1384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_media_mapvertising_js__ = __webpack_require__(1332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_53_media_mapvertising_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_53_media_mapvertising_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_media_placements_js__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_54_media_placements_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_54_media_placements_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_shared_critical_speedrum_js__ = __webpack_require__(1392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_55_shared_critical_speedrum_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_55_shared_critical_speedrum_js__);

























































/***/ }),

/***/ 33:
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {module.exports = global["jQuery"] = __webpack_require__(1196);
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(21)))

/***/ }),

/***/ 4:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isBlank */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return isPresent; });
/* unused harmony export updateOmnitureLeadJson */
/* unused harmony export updateOmnitureModalLeadJson */
/* unused harmony export pageLinking */
/* unused harmony export updateListingClickSource */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return getViewType; });
/* unused harmony export getPropertyLinksFromStorage */
/* unused harmony export setPropertyLinksToStorage */
/* unused harmony export updatePropertyLinksToStorage */
/* unused harmony export getSearchCriteriaFromCookie */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return hasSessionStorage; });
/* unused harmony export isPhone */
/* unused harmony export isCln */
/* unused harmony export isCountySearch */
/* unused harmony export getPropertyStatusForSearch */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return isRental; });
/* unused harmony export mapMovingAPIErrorCodeToName */
/* unused harmony export isPrintMode */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return detectViewPort; });
/* unused harmony export isInfiniteScrolling */
/* unused harmony export isMobile */
/* unused harmony export isLandscapeOrTablet */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return isMobileDevice; });
/* unused harmony export isDesktopOrTablet */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return isDesktopTablet; });
/* unused harmony export isDebugMode */
/* unused harmony export setCookieExpiry */
/* unused harmony export getPageNavTarget */
/* unused harmony export isPageType */
/* unused harmony export isLocationValidated */
/* unused harmony export isUrlValidated */
/* unused harmony export isInvalidCoordinates */
/* unused harmony export getPropertiesCount */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return isHomePage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return defaultNyConfigs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return getRealTipData; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ctaButtonName; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return formatDate; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getMobileOSType; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_underscore___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_underscore__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rdc_next_legacy_js_libs_js_jquery_mobile_js__ = __webpack_require__(621);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_rdc_next_legacy_js_libs_js_jquery_mobile_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_rdc_next_legacy_js_libs_js_jquery_mobile_js__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__srp_basecamp_constants__ = __webpack_require__(73);
/*global window, _, MOVE_DATA, localStorage, JST */





var isBlank = function isBlank(value) {
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_underscore__["isNull"])(value) || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_underscore__["isUndefined"])(value) || value === 0 || __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_underscore__["isEmpty"])(value);
};

var isPresent = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_underscore__["negate"])(isBlank);

// Update the guid value returned from the lead service in the adobeDTM lead object.
// This is very important for omniture to track the number of leads
var updateOmnitureLeadJson = function updateOmnitureLeadJson(leadData) {
  MOVE.DataStore.setData('leadAdobeDTM', leadData);
  if (typeof window.branch !== "undefined") {
    window.branch.track('leadSubmitted');
  }
};

var updateOmnitureModalLeadJson = function updateOmnitureModalLeadJson(modalLeadData) {
  MOVE.DataStore.setData('modalAdobeDTM', modalLeadData);
};

var pageLinking = function pageLinking() {
  $('#srp-list').find('.js-navigate-to').on('click', function (e) {
    var $this = $(this);

    if ($(e.target).hasClass('js-no-listing-click')) {
      return;
    }

    if ($this.hasClass('js-record-user-activity') && MOVE.SRP) {
      var params = [];
      //LGWEB-ImageCTR
      if (MOVE_DATA.ab_img_ctr_swap.indexOf('V') >= 0) params.img_swapped = $this[0] && $this[0].getAttribute('data-is-swapped');
      //end
      if (MOVE.SRP.SearchFacet) {
        var criteria = MOVE.SRP.SearchFacet.getSearchCriteria();
        MOVE.UserActivity.updateRecentSearches({
          searchType: MOVE.Helper.getPropertyStatusForSearch(criteria.search_controller),
          criteria: criteria
        }, true);
      }
      updateListingClickSource($this, params);
    }

    if (!$(e.target).is('a')) {
      // If quickview, we do not want SRP cards to go to LDP on page load
      if ($(e.currentTarget).closest('li').hasClass('js-quick-view')) {
        e.preventDefault();
        return;
      }

      if (e.metaKey || e.ctrlKey) {
        e.preventDefault();
        window.open($this.data('url'), '_blank');
      } else {
        window.location.href = $this.data('url');
      }
    }
  });
};

var updateListingClickSource = function updateListingClickSource(element, params) {
  var img_swap = void 0;
  if (params) img_swap = ':' + params.img_swapped;
  MOVE.UserActivity.updateSrpListingClicked({
    listingRanking: element.data('rank') || element.parent().data('rank'),
    dataSource: MOVE_DATA.adobeDTM.pageType == "ldp-quickview" ? "" : getViewType() + '-card' + img_swap,
    featured: element.data('featured') || element.parent().data('featured')
  });
};

// Get view type either "map" or "list"
var getViewType = function getViewType() {
  var type = $.cookie('ab_srp_viewtype'),
      cookie_arr = [__WEBPACK_IMPORTED_MODULE_2__srp_basecamp_constants__["a" /* AB_SRP_LAYOUT_COOKIE_MAP */], __WEBPACK_IMPORTED_MODULE_2__srp_basecamp_constants__["b" /* AB_SRP_LAYOUT_COOKIE_LIST */], __WEBPACK_IMPORTED_MODULE_2__srp_basecamp_constants__["c" /* AB_SRP_LAYOUT_COOKIE_MIXED */]];

  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_underscore__["contains"])(cookie_arr, type) ? type : __WEBPACK_IMPORTED_MODULE_2__srp_basecamp_constants__["c" /* AB_SRP_LAYOUT_COOKIE_MIXED */];
};

var getPropertyLinksFromStorage = function getPropertyLinksFromStorage() {
  var properties = MOVE.LocalStorage.isAvailable && window.localStorage.getItem('srpProperties');
  if (properties) {
    return JSON.parse(properties);
  }
  return null;
};

var setPropertyLinksToStorage = function setPropertyLinksToStorage(propertyLinks, totalCount, pageIndex) {
  var properties = getPropertyLinksFromStorage();
  if (!properties) {
    properties = {};
  }
  properties.totalCount = totalCount;
  properties.pageIndex = pageIndex;
  // Saving the unique property links so that crabwalk does not end in
  // infinite loop in case of multi listings.
  properties.links = $.unique(propertyLinks);
  if (MOVE.LocalStorage.isAvailable) {
    window.localStorage.setItem('srpProperties', JSON.stringify(properties));
  }
};

var updatePropertyLinksToStorage = function updatePropertyLinksToStorage(srpLinks) {
  if (MOVE.LocalStorage.isAvailable) {
    var properties = window.localStorage.getItem('srpProperties');
    if (properties) {
      properties = JSON.parse(properties);
      properties.links = _.uniq(properties.links.concat(srpLinks));
    }
    window.localStorage.setItem('srpProperties', JSON.stringify(properties));
  }
};

var getSearchCriteriaFromCookie = function getSearchCriteriaFromCookie() {
  var criteriaCookie = $.cookie('criteria');
  if (criteriaCookie) {
    var criterias = {};
    $.each(criteriaCookie.split('&'), function (index, value) {
      var v = value.split('=');
      criterias[v[0]] = v[1];
    });
    return criterias;
  }
};

var hasSessionStorage = function hasSessionStorage() {
  try {
    window.sessionStorage.setItem('sessiontest', {});
    window.sessionStorage.removeItem('sessiontest');
    return true;
  } catch (exception) {
    return false;
  }
};

var isPhone = function isPhone() {
  return MOVE.DataStore.getData('isPhone');
};

var isCln = function isCln() {
  return MOVE.DataStore.getData('isCln');
};

// Check if current search is county search
var isCountySearch = function isCountySearch() {
  return MOVE.DataStore.getData("locationType") === "county";
};

var getPropertyStatusForSearch = function getPropertyStatusForSearch(ctrlType) {
  return MOVE.CONSTANTS.PROPERTY_SEARCH_STATUS[ctrlType];
};

var isRental = function isRental() {
  var currentController = (MOVE.SRP.SearchFacet.getSearchCriteria() || {}).search_controller || '';
  return currentController === 'Search::ApartmentsController' || currentController === 'Search::HomesForRentController';
};

// returns form field name for validation messaging
var mapMovingAPIErrorCodeToName = function mapMovingAPIErrorCodeToName(code) {
  code = parseInt(code, 10);
  switch (code) {
    case 101:
      return "first-name";
    case 102:
      return "last-name";
    case 201:
      return "email";
    case 202:
    case 203:
    case 208:
    case 210:
    case 212:
      return "phone";
    case 401:
      return "move-from";
    case 501:
      return "move-to";
    default:
      return "unsupported";
  }
};

var isPrintMode = function isPrintMode() {
  return window.location.pathname.indexOf('/print/') === 0;
};

var detectViewPort = function detectViewPort() {
  var windowWidth = $(window).width();

  if (windowWidth >= 1280) {
    return 'large';
  } else if (windowWidth >= 996) {
    return 'medium';
  } else if (windowWidth >= 767) {
    return 'small';
  } else if (windowWidth >= 481 && windowWidth <= 766) {
    return 'x-small';
  } else if (windowWidth >= 0 && windowWidth <= 480) {
    return 'xx-small';
  } else {
    return 'xx-small';
  }
};

var isInfiniteScrolling = function isInfiniteScrolling() {
  return detectViewPort() === 'xx-small' || detectViewPort() === 'x-small';
};

var isMobile = function isMobile() {
  var viewport = detectViewPort();
  return viewport === 'x-small' || viewport === 'xx-small';
};

var isLandscapeOrTablet = function isLandscapeOrTablet() {
  var viewport = detectViewPort();
  var tabletSizes = ['medium', 'large'];
  return _.include(tabletSizes, viewport);
};

var isMobileDevice = function isMobileDevice() {
  return $.Device.isMobile(navigator.userAgent);
};

var isDesktopOrTablet = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_underscore__["negate"])(isMobileDevice);

//helper for detecting if the device is a Desktop or Tablet, added because the function isDesktopOrTablet() doesn't work for iPads
var isDesktopTablet = function isDesktopTablet() {
  return MOVE.Helper.detectViewPort() === "small" || MOVE.Helper.detectViewPort() === "medium" || MOVE.Helper.detectViewPort() === "large";
};

var isDebugMode = function isDebugMode() {
  return window.location.href.search("debug=1") > -1;
};

var setCookieExpiry = function setCookieExpiry(minutes) {
  var date = new Date();
  date.setTime(date.getTime() + minutes * 60000); // # of ms in 1 minute
  return date;
};

var getPageNavTarget = function getPageNavTarget(hsh) {
  return hsh.length ? hsh : $('[name=' + hsh.slice(1) + ']');
};

var isPageType = function isPageType(pageType) {
  return MOVE.DOMHelper.detectPageType() === pageType;
};

var isLocationValidated = function isLocationValidated(validatedLocation, onPageLoad) {
  return validatedLocation === undefined && $('#searchBox').val() === '' && !onPageLoad;
};

var isUrlValidated = function isUrlValidated(showIntent) {
  return !(showIntent === true && MOVE.DOMHelper.getUrlParams().pos !== undefined);
};

var isInvalidCoordinates = function isInvalidCoordinates(boundaries) {
  return _.compact(boundaries).length < 4;
};

var getPropertiesCount = function getPropertiesCount() {
  return MOVE.DataStore.getData('searchResults').properties_count;
};

var isHomePage = function isHomePage() {
  return MOVE.DOMHelper.detectPageType() === 'hp';
};

var ny_location_flag = void 0,
    locationSlugId = void 0;

// If Quick View, use property details to build
// location slug.
if (MOVE_DATA.propertyDetails) {
  var propertyData = MOVE_DATA.propertyDetails;
  locationSlugId = propertyData.city + "_" + propertyData.state_code;
  locationSlugId = locationSlugId.toLowerCase();
} else {
  locationSlugId = MOVE && MOVE.DataStore ? MOVE.DataStore.getData("slugId") : "";
}

ny_location_flag = locationSlugId ? locationSlugId : false;

//New York Experience
var defaultNyConfigs = {
  ny_exp: MOVE_DATA ? MOVE_DATA.NY_EXP || false : false,
  ny_location: MOVE.DataStore ? ny_location_flag : false
};

var getRealTipData = function getRealTipData(propertyData) {
  return propertyData && propertyData.real_tip;
};

var ctaButtonName = function ctaButtonName(_ref) {
  var propertyType = _ref.propertyType,
      textType = _ref.textType,
      leadPosition = _ref.leadPosition;

  var copy = textType == "request_details" ? "Request Details" : "Contact Agent";
  if (propertyType && propertyType == "new_plan") {
    return "Contact Builder";
  } else if (leadPosition === 'inline_cta' && MOVE_DATA.ft_inline_cta_is_enabled) {
    copy = MOVE_DATA.flg_inline_cta ? MOVE_DATA.flg_inline_cta : copy;
  } else if (leadPosition === 'lead_form' && MOVE_DATA.ft_leadform_cta_is_enabled) {
    copy = MOVE_DATA.flg_leadform_cta ? MOVE_DATA.flg_leadform_cta : copy;
  }
  return copy;
};

var formatDate = function formatDate(date) {
  var d = new Date(date),
      month = '' + (d.getMonth() + 1),
      day = '' + d.getDate(),
      year = d.getFullYear();

  if (month.length < 2) month = '0' + month;
  if (day.length < 2) day = '0' + day;

  return [month, day, year].join('/');
};

var getMobileOSType = function getMobileOSType() {
  var _navigator = navigator,
      platform = _navigator.platform;

  if (platform.indexOf('iP') > -1) return "ios";else if (platform.indexOf('Android') > -1) return "android";else return "other";
};

MOVE.Helper = {
  pageLinking: pageLinking,
  setPropertyLinksToStorage: setPropertyLinksToStorage,
  getPropertyLinksFromStorage: getPropertyLinksFromStorage,
  getSearchCriteriaFromCookie: getSearchCriteriaFromCookie,
  detectViewPort: detectViewPort,
  isInfiniteScrolling: isInfiniteScrolling,
  hasSessionStorage: hasSessionStorage,
  isPhone: isPhone,
  isCln: isCln,
  updateOmnitureLeadJson: updateOmnitureLeadJson,
  updateOmnitureModalLeadJson: updateOmnitureModalLeadJson,
  getPropertyStatusForSearch: getPropertyStatusForSearch,
  isRental: isRental,
  mapMovingAPIErrorCodeToName: mapMovingAPIErrorCodeToName,
  isMobile: isMobile,
  isMobileDevice: isMobileDevice,
  isLandscapeOrTablet: isLandscapeOrTablet,
  isPrintMode: isPrintMode,
  isCountySearch: isCountySearch,
  isDebugMode: isDebugMode,
  setCookieExpiry: setCookieExpiry,
  getPageNavTarget: getPageNavTarget,
  isPageType: isPageType,
  isLocationValidated: isLocationValidated,
  isUrlValidated: isUrlValidated,
  updatePropertyLinksToStorage: updatePropertyLinksToStorage,
  isInvalidCoordinates: isInvalidCoordinates,
  getPropertiesCount: getPropertiesCount,
  defaultNyConfigs: defaultNyConfigs,
  updateListingClickSource: updateListingClickSource
};

/***/ }),

/***/ 49:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return trackAdblock; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return trackRcmLead; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return trackMovingQuoteLead; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return trackCommuteTime; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return trackHomesNearStreetPinClick; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return trackHistoricalValueGraph; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return trackPaymentCalculator; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return trackBranchBannerClose; });
/* global RdcTracking */

// Direct call rules are any custom event that don't fit into any general category.

var DEFAULT_VALUE = 'unknown';

var trackAdblock = function trackAdblock(isAdBlockEnabled) {
  RdcTracking.trackEvent('adBlockerDetection', isAdBlockEnabled);
};

var trackRcmLead = function trackRcmLead(pd) {
  var props = {
    city: pd.listingCity,
    creditScore: pd.leadCreditScore,
    forSaleLeads: 'web:leads:' + pd.leadType + ':' + pd.leadPlacement,
    listingId: pd.listingId,
    listingPrice: pd.listingPrice,
    pageType: pd.pageType,
    state: pd.listingState,
    zip: pd.listingZip
  };
  RdcTracking.trackEvent('rcmLead', props);
};

var trackMovingQuoteLead = function trackMovingQuoteLead(selfIdentify, leadPlacement) {
  var props = {
    dsSegment: selfIdentify,
    movingQuotes: leadPlacement,
    modalName: leadPlacement
  };
  RdcTracking.trackEvent('movingQuoteLead', props);
};

var trackCommuteTime = function trackCommuteTime(pageType, commuteAddress, commuteOption) {
  var props = {
    linkName: pageType + ':property-info:calculate-commute:success',
    commuteAddress: commuteAddress,
    commuteOption: commuteOption
  };
  RdcTracking.trackEvent('click', props);
};

var trackHomesNearStreetPinClick = function trackHomesNearStreetPinClick() {
  var pd = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var props = {
    communityId: pd.communityId || pd.community_id,
    listingId: pd.listingID || pd.listing_id,
    planId: pd.planID || pd.plan_id,
    productType: pd.productType || pd.product_type,
    propertyStatus: pd.propertyStatus || pd.status,
    propertyStatusSub: pd.propertyStatusSub || DEFAULT_VALUE,
    searchId: pd.searchID || pd.search_id,
    subId: pd.subID || pd.subdivision_id
  };
  RdcTracking.trackEvent('srp:map:mini-card:impression', props);
};

var trackHistoricalValueGraph = function trackHistoricalValueGraph() {
  RdcTracking.trackEvent('click', { linkName: 'ldp:historical-value-graph:interact' });
};

var trackPaymentCalculator = function trackPaymentCalculator() {
  RdcTracking.trackEvent('click', { linkName: 'finance:calculator:success' });
};

var trackBranchBannerClose = function trackBranchBannerClose() {
  RdcTracking.trackEvent('click', { linkName: 'email:branch:close' });
};

/***/ }),

/***/ 55:
/***/ (function(module, exports) {

MOVE.UserActivity = function (MOVE) {
  var NOT_FOR_SALE = 'not_for_sale';

  var init = function init() {};

  var updateRecentSearches = function updateRecentSearches(data, updateItemsViewed) {
    var searchData = formatSearchData(data);

    if (!MOVE.LocalStorage.isAvailable) {
      return;
    }
    var recentSearches = getRecentSearches();

    var existingActivityData = existingSearchActivity(recentSearches, searchData);

    if (existingActivityData) {
      recentSearches = modifySearchData(searchData, updateItemsViewed);
    } else {
      recentSearches.push(searchData);
    }
    setLocalStorage('recent_searches', recentSearches);

    // Trigger custom event when search is updated
    $(document).trigger('recentSearchesUpdated');
  };

  var updateRecentViews = function updateRecentViews(data, viewType) {
    if (!MOVE.LocalStorage.isAvailable) {
      return;
    }
    var viewData = formatViewData(data, viewType),
        recentViews = getRecentViews(),
        subResourceUpdated = localStorage.getItem('subResourceUpdated');

    if (_.isNull(subResourceUpdated)) {
      recentViews = removeSubResourceForNFSAndNHC(recentViews);
      setLocalStorage('recent_views', recentViews);
      localStorage.setItem('subResourceUpdated', 'yes');
    }

    var existingActivityData = existingViewedActivity(recentViews, viewData);
    if (existingActivityData) {
      recentViews = modifyViewData(viewData);
    } else {
      recentViews.push(viewData);
    }
    setLocalStorage('recent_views', recentViews);

    // rendered from the server side
    // Trigger custom event when views is updated
    $(document).trigger('recentViewsUpdated');
  };

  var updateSrpListingClicked = function updateSrpListingClicked(data) {
    var listingData = {
      "rank": data.listingRanking,
      "src": data.dataSource,
      "featured": data.featured
    };

    $.cookie("SrpClickedListing", JSON.stringify(listingData), { path: '/' });
  };

  var removeNullValues = function removeNullValues(data) {
    return _.omit(data, function (value) {
      return _.isNull(value) || !_.isNumber(value) && _.isEmpty(value);
    });
  };

  var formatData = function formatData(data) {
    var formattedData = formatPropTypes(data);
    return removeNullValues(formattedData.criteria.facets);
  };

  var formatPropTypes = function formatPropTypes(data) {
    var propType = data.criteria.facets.prop_type;
    data.prop_type = getFormattedPropertyType(propType);
    data.sub_prop_type = getsubPropertyType(propType);
    return data;
  };

  var getFormattedPropertyType = function getFormattedPropertyType(propTypes) {
    if (MOVE.FormatHelper.isEmpty(propTypes)) {
      return 'single_family,condo,multi_family,farm,land';
    }
    var propertyTypes = propTypes.split(',');
    var formattedPropTypes = [];
    _.each(propertyTypes, function (value) {
      formattedPropTypes.push(getPropertyTypeValue(value));
    });
    return _.reject(formattedPropTypes, _.isNull).join(',');
  };

  var getPropertyTypeValue = function getPropertyTypeValue(value) {
    return MOVE.CONSTANTS.PROPERTY_TYPE_MAPPING[value] || value;
  };

  var getsubPropertyType = function getsubPropertyType(propType) {
    if (MOVE.FormatHelper.isEmpty(propType) || propType === 'condo-townhome-row-home-co-op') {
      return 'condo,co_op,cond_op,townhouse';
    }
  };

  var getQuery = function getQuery(data) {
    var criteria = data.criteria;
    var facetObj = criteria.facets !== undefined ? formatData(data) : {};
    var mlsid = criteria.mlslid ? '#' + criteria.mlslid : null;
    var street = criteria.school || criteria.school_district || criteria.university ? null : criteria.street;

    return removeNullValues(_.extend(facetObj, {
      city: criteria.city,
      state_code: criteria.state,
      postal_code: criteria.street ? null : criteria.postal,
      address: criteria.address,
      neighborhood: criteria.neighborhood,
      county: criteria.county,
      mlslid: mlsid,
      street: street,
      school: criteria.school,
      school_id: criteria.school_id,
      school_district: criteria.school_district,
      school_district_id: criteria.school_district_id,
      university: criteria.university,
      university_id: criteria.university_id,
      park: criteria.park,
      park_id: criteria.park_id
    }));
  };

  var existingSearchActivity = function existingSearchActivity(existingActivity, data) {
    return _.find(existingActivity, function (i) {
      return data.resource_type === i.resource_type && _.isEqual(data.query, i.query);
    });
  };

  var existingViewedActivity = function existingViewedActivity(existingActivity, data) {
    return _.find(existingActivity, function (i) {
      return data.resource_id === i.resource_id && data.sub_resource_id === i.sub_resource_id;
    });
  };

  var formatSearchData = function formatSearchData(data) {
    var dataObj = {
      "items_viewed": 0,
      "first_ran": new Date().toISOString(),
      "last_ran": new Date().toISOString(),
      "resource_type": data.searchType,
      "query": getQuery(data),
      "search_type": data.criteria.searchType,
      "isAjax": data.isAjax || false
    };
    if (data.criteria.search_controller === 'Search::ForeclosuresController') {
      _.extend(dataObj, { distressed: 'foreclosure' });
    }
    if (data.criteria.search_controller === 'Search::NewConstructionController') {
      _.extend(dataObj, { new_construction: true });
    }
    return dataObj;
  };

  var formatViewData = function formatViewData(data, viewType) {
    var viewData = {
      "views": 1,
      "last_viewed": new Date().toISOString(),
      "first_viewed": new Date().toISOString(),
      "resource_type": MOVE.CONSTANTS.LDP_PROPERTY_TYPES[viewType] || 'property',
      "resource_id": data.property_id
    };
    if (viewType !== NOT_FOR_SALE && viewType !== "new_community") {
      viewData.sub_resource_type = MOVE.CONSTANTS.LDP_SUB_PROPERTY_TYPES[viewType] || viewType;
      viewData.sub_resource_id = data.listing_id;
    }

    return viewData;
  };

  var modifySearchData = function modifySearchData(data, updateItemsViewed) {
    var recentSearchesArray = getRecentSearches();
    return _.map(recentSearchesArray, function (i) {
      if (_.isEqual(data.query, i.query)) {
        if (updateItemsViewed) {
          i.items_viewed++;
        }
        i.last_ran = new Date().toISOString();
      }
      return i;
    });
  };

  var modifyViewData = function modifyViewData(data) {
    var recentViewsArray = getRecentViews();
    return _.map(recentViewsArray, function (i) {
      if (data.resource_id === i.resource_id && data.sub_resource_id === i.sub_resource_id) {
        i.views++;
        i.last_viewed = new Date().toISOString();
      }
      /* This will change existing elements in storage to "rental" which have been set to "for_rent" before the code change for
         CORE-7295.
       */
      if (typeof i.sub_resource_type !== "undefined" && i.sub_resource_type === 'for_rent') {
        i.sub_resource_type = 'rental';
      }
      return i;
    });
  };

  // update recent views for incorrect sub_resource_type:
  // new home community and not for sale(recently sold/off market/sell summary)
  var removeSubResourceForNFSAndNHC = function removeSubResourceForNFSAndNHC(recentViews) {
    return _.map(recentViews, function (i) {
      if (i.sub_resource_type === NOT_FOR_SALE || i.resource_type === MOVE.CONSTANTS.LDP_PROPERTY_TYPES.new_community) {
        delete i.sub_resource_type;
        delete i.sub_resource_id;
      }
      return i;
    });
  };

  var setLocalStorage = function setLocalStorage(key, data) {
    localStorage.setItem(key, JSON.stringify(data));
  };

  var getRecentSearches = function getRecentSearches() {
    if (!MOVE.LocalStorage.isAvailable) {
      return [];
    }
    var recentSearches = Array.isArray(fetchLocalStorage('recent_searches')) ? fetchLocalStorage('recent_searches') : JSON.parse(fetchLocalStorage('recent_searches').value);
    return recentSearches;
  };

  var getRecentViews = function getRecentViews() {
    if (!MOVE.LocalStorage.isAvailable) {
      return [];
    }
    var recentViews = Array.isArray(fetchLocalStorage('recent_views')) ? fetchLocalStorage('recent_views') : JSON.parse(fetchLocalStorage('recent_views').value);
    return recentViews;
  };

  var fetchLocalStorage = function fetchLocalStorage(key) {
    if (localStorage.getItem(key) && localStorage.getItem(key) !== '') {
      return JSON.parse(localStorage.getItem(key));
    } else {
      localStorage.setItem(key, JSON.stringify([]));
      return JSON.parse(localStorage.getItem(key));
    }
  };

  var getSortedRecentSearches = function getSortedRecentSearches() {
    return MOVE.UserActivity.getRecentSearches().sort(function (a, b) {
      return new Date(b.last_ran) - new Date(a.last_ran);
    });
  };

  var getSortedRecentViews = function getSortedRecentViews() {
    return MOVE.UserActivity.getRecentViews().sort(function (a, b) {
      return new Date(b.last_viewed) - new Date(a.last_viewed);
    });
  };

  var getSortedNonAjaxRecentSearches = function getSortedNonAjaxRecentSearches() {
    var recentSearches = getSortedRecentSearches();
    return _.select(recentSearches, function (search) {
      if (!search.isAjax || search.isAjax === undefined) {
        return search;
      }
    });
  };

  MOVE.UserActivity = {
    init: init,
    updateRecentSearches: updateRecentSearches,
    updateRecentViews: updateRecentViews,
    updateSrpListingClicked: updateSrpListingClicked,
    getRecentSearches: getRecentSearches,
    getRecentViews: getRecentViews,
    getSortedRecentSearches: getSortedRecentSearches,
    getSortedNonAjaxRecentSearches: getSortedNonAjaxRecentSearches,
    getSortedRecentViews: getSortedRecentViews
  };
  return MOVE.UserActivity;
}(MOVE || {});

/***/ }),

/***/ 557:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return getMapOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return triggerOnDrag; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return bindInfoWindowCloseEvents; });
/* unused harmony export isRadiusSearch */
/* unused harmony export mapEnvironment */
/* unused harmony export initMapComponent */
/* unused harmony export getSizeInPixels */
/* unused harmony export getExtraZoom */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fitMaxBound; });
/* unused harmony export createMapMessage */
/* unused harmony export radiusBoundExist */
/* unused harmony export isRadiusSearchOnPageRefresh */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_message__ = __webpack_require__(1539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_maps__ = __webpack_require__(72);
/*global window, _, MOVE_DATA, google, localStorage, JST */




//This places the map controls to the top right corner of each map.
var getMapOptions = function getMapOptions() {
  return {
    zoomControlOptions: {
      style: window.google.maps.ZoomControlStyle.SMALL,
      position: window.google.maps.ControlPosition.TOP_RIGHT
    },
    mapTypeControlOptions: {
      position: window.google.maps.ControlPosition.TOP_RIGHT,
      style: window.google.maps.MapTypeControlStyle.DEFAULT,
      mapTypeIds: [window.google.maps.MapTypeId.ROADMAP, window.google.maps.MapTypeId.SATELLITE, window.google.maps.MapTypeId.HYBRID]
    }
  };
};

var triggerOnDrag = function triggerOnDrag($container) {
  var drag = 0,
      _touchEvents = { start: 'touchstart.map', move: 'touchmove.map', end: 'touchend.map' },
      _mouseEvents = { start: 'mousedown.map', move: 'mousemove.map', end: 'mouseup.map' },

  // our maps do not support touch dragging on desktops with touchscreens
  events = MOVE.Helper.isMobileDevice() ? _touchEvents : _mouseEvents;

  _.each(events, function (event) {
    $container.off(event);
  });

  $container.on(events.start, function () {
    return drag = 0;
  }).on(events.move, function () {
    return drag++;
  }).on(events.end, function (e) {
    $container.trigger({
      type: "drag.map",
      target: e.target,
      drag: drag,
      endEvent: e
    });

    drag = 0;
  });

  return $container;
};

var elementFromEvent = function elementFromEvent(_ref) {
  var event = _ref.event;

  // idea: use elementFromPoint if has coordinates
  // otherwise use target
  if (event.clientX && event.clientY) return document.elementFromPoint(event.clientX, event.clientY);else return event.target;
};

var bindInfoWindowCloseEvents = function bindInfoWindowCloseEvents($container, callback) {
  triggerOnDrag($container).on("drag.map", function (e) {
    var $element = $(elementFromEvent({ event: e.endEvent })),
        drag = e.drag;
    // the condition is less than 10
    // presumably we want to include small but exclude large drags
    // addresses scenario where jquery event.target does not provide
    // topmost element clicked
    if (drag <= 10 && !$element.hasClass('map-property-pin') && !$element.parent().hasClass('map-property-pin')) {
      callback(e);
    }
  });
};

// Check if radius search is on currently
var isRadiusSearch = function isRadiusSearch() {
  return _.has(MOVE.SRP, 'SearchFacet') && MOVE.SRP.SearchFacet.isRadiusSet();
};

var mapEnvironment = function mapEnvironment(config) {
  return config.google_maps_environment !== undefined ? config.google_maps_environment + "-" : "";
};

/*
  Initializes the Map Component.
  - Accepts a callback function and a forceCallback boolean
*/
var initMapComponent = function initMapComponent(callback, forceCallback) {
  var config = MOVE.DataStore.getData('mapConfiguration'),
      clientId = 'rdcV8',
      toolsVersion = '1.0.4',
      scriptsLoaded = function scriptsLoaded() {
    if (callback && typeof callback === 'function') {
      callback({ config: config, clientId: clientId, toolsVersion: toolsVersion });
    }
  };

  if (config) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_maps__["a" /* onMapLoad */])(scriptsLoaded);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_maps__["b" /* loadMaps */])("rdc-ldp-amenities");
  }

  if (forceCallback) {
    scriptsLoaded();
  }
};

// LatLngBounds bnds -> height and width as a Point
var getSizeInPixels = function getSizeInPixels(projection, bounds) {
  var sw = projection.fromLatLngToContainerPixel(bounds.getSouthWest());
  var ne = projection.fromLatLngToContainerPixel(bounds.getNorthEast());
  return new google.maps.Point(Math.abs(sw.y - ne.y), Math.abs(sw.x - ne.x));
};

//LatLngBounds b1, b2 -> zoom increment
var getExtraZoom = function getExtraZoom(projection, expectedBounds, actualBounds) {
  var expectedSize = getSizeInPixels(projection, expectedBounds),
      actualSize = getSizeInPixels(projection, actualBounds);

  if (Math.floor(expectedSize.x) === 0 || Math.floor(expectedSize.y) === 0) {
    return 0;
  }

  var qx = actualSize.x / expectedSize.x;
  var qy = actualSize.y / expectedSize.y;
  var min = Math.min(qx, qy);

  if (min < 1) {
    return 0;
  }
  return Math.floor(Math.log(min) / Math.log(2) /* = log2(min) */);
};

var fitMaxBound = function fitMaxBound(myMap, bounds) {
  myMap.fitBounds(bounds);
  var overlayHelper = new google.maps.OverlayView({ setMap: myMap });
  overlayHelper.draw = function () {
    if (!this.ready) {
      var projection = this.getProjection(),
          zoom = getExtraZoom(projection, bounds, myMap.getBounds());
      setZoomLevel(myMap, zoom);
      this.ready = true;
      google.maps.event.trigger(this, 'ready');
    }
  };
  overlayHelper.setMap(myMap);
};

var setZoomLevel = function setZoomLevel(myMap, zoom) {
  if (zoom > 0) {
    myMap.setZoom(myMap.getZoom() + zoom);
  }
  if (MOVE_DATA.pageType === "srp" && MOVE.Helper.getPropertiesCount() === 0) {
    myMap.setZoom(myMap.getZoom() - MOVE.CONSTANTS.GET_NORESULTS_ZOOM);
  }
};

// Create Map Message
var createMapMessage = function createMapMessage(component, callback) {
  var message = new __WEBPACK_IMPORTED_MODULE_0__components_message__["a" /* Message */]({
    mapContainer: component.options.container
  });
  component.message = message;
  if (callback) {
    callback(component);
  }
};

// Check if radius boundary exist in map cache
var radiusBoundExist = function radiusBoundExist() {
  try {
    return MOVE.SRP.MapView.map.areas.cache.data['search-entity'].items.hasOwnProperty(1);
  } catch (err) {
    return false;
  }
};

// Check if radius search in on after page refreshed
var isRadiusSearchOnPageRefresh = function isRadiusSearchOnPageRefresh() {
  return isRadiusSearch() && !radiusBoundExist() && !_.isNull(MOVE_DATA.radius_init_boundary) && !_.isUndefined(MOVE_DATA.radius_init_boundary);
};

MOVE.MapHelper = {
  getMapOptions: getMapOptions,
  radiusBoundExist: radiusBoundExist,
  isRadiusSearchOnPageRefresh: isRadiusSearchOnPageRefresh,
  isRadiusSearch: isRadiusSearch,
  initMapComponent: initMapComponent,
  fitMaxBound: fitMaxBound,
  createMapMessage: createMapMessage,
  triggerOnDrag: triggerOnDrag,
  bindInfoWindowCloseEvents: bindInfoWindowCloseEvents,
  mapEnvironment: mapEnvironment
};

/***/ }),

/***/ 569:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_critical_media_index_js__ = __webpack_require__(731);
/*global googletag, window*/



MOVE.Medias = function () {
  "use strict";

  var isProgrammaticAd = function isProgrammaticAd(slot) {
    var programmaticTargeting = slot.getTargeting('programmatic');
    if (programmaticTargeting && programmaticTargeting.length && programmaticTargeting[0]) return true;
    return false;
  };

  var firstTimeLoadPrebid = true;

  var refershPrebidAd = function refershPrebidAd(slots, prebidSlots) {
    if (prebidSlots.length > 0) {
      var isIE11 = !!navigator.userAgent.match(/Trident.*rv\:11\./);
      if (!isIE11 || firstTimeLoadPrebid) {
        firstTimeLoadPrebid = false;
        window.pbjs.refreshAds(prebidSlots);
      } else {
        var gptSlots = [];
        slots.forEach(function (slot) {
          if (slot && isProgrammaticAd(slot)) {
            gptSlots.push(slot);
          }
        });
        googletag.pubads().refresh(slots);
      }
    }
  };

  var loadPrebidderJsAds = function loadPrebidderJsAds(slots) {
    if (window.pbjs !== undefined && typeof window.pbjs.refreshAds === "function") {
      googletag.cmd.push(function () {
        var gptSlots = [];
        var prebidSlots = [];
        slots.forEach(function (slot) {
          if (slot) {
            if (isProgrammaticAd(slot)) {
              prebidSlots.push(slot.getSlotElementId());
            } else {
              gptSlots.push(slot);
            }
          }
        });
        refershPrebidAd(slots, prebidSlots);
        if (gptSlots.length > 0) {
          googletag.pubads().refresh(gptSlots);
        }
      });
    } else {
      googletag.cmd.push(function () {
        googletag.pubads().refresh(slots);
      });
    }
  };

  var loadProgrammaticAds = function loadProgrammaticAds(slots) {
    __WEBPACK_IMPORTED_MODULE_0_shared_critical_media_index_js__["a" /* LoadAmazonAds */](slots).then(function () {
      loadPrebidderJsAds(slots);
    });
  };

  var viewport = function viewport() {
    var e = window,
        a = 'inner';
    if (!('innerWidth' in window)) {
      a = 'client';
      e = document.documentElement || document.body;
    }
    return { width: e[a + 'Width'], height: e[a + 'Height'] };
  };

  var getWindowWidth = function getWindowWidth() {
    var iOS = /(iPad|iPhone|iPod)/g.test(navigator.userAgent);
    var android = /Android/i.test(navigator.userAgent);
    if (iOS || android) {
      return $(window).width();
    } else {
      return viewport().width;
    }
  };

  var windowWidth = getWindowWidth(),
      resizeTimer;

  //helper method to get the type of teh view
  var getType = function getType(type) {
    return type === "map" || type === "list" ? type : "list";
  };

  // Get view type either "map" or "list"
  var getViewType = function getViewType() {
    var type = void 0;
    if ($('.component_ab-view-switch').length) {
      // this is for the for new SRP AB test
      type = $.cookie('ab_srp_viewtype');
      return type === 'ab-list-view' ? 'list' : type === 'ab-mixed-view' ? 'map' : 'map-only';
    } else {
      type = $.cookie('srp.viewType');
      return getType(type);
    }
  };

  var hidePeelBackAds = function hidePeelBackAds() {
    $('#div-gpt-ad-oop').hide().removeClass('visible-lg-inline-block'); // this is for new peelback template
    $('div[data-studioassetid]').hide(); // this is for lagecy peelback ads created by gpt studio, they will go away eventually
  };

  var showPeelBackAds = function showPeelBackAds() {
    $('#div-gpt-ad-oop').show().addClass('visible-lg-inline-block'); // this is for new peelback template
    $('div[data-studioassetid]').show(); // this is for lagecy peelback ads created by gpt studio, they will go away eventually
  };

  var loadOOPAds = function loadOOPAds() {
    return getWindowWidth() >= 1280;
  };

  var concatSRPListViewAds = function concatSRPListViewAds(adsToBeRefreshed) {
    adsToBeRefreshed = adsToBeRefreshed.concat(window.gptAds.gptadslotsListViewOnly.targets);
    adsToBeRefreshed = adsToBeRefreshed.concat(__WEBPACK_IMPORTED_MODULE_0_shared_critical_media_index_js__["b" /* SrpCurrentStickMrect */]());
    if (loadOOPAds()) {
      adsToBeRefreshed = adsToBeRefreshed.concat(window.gptAds.gptadslotsOutOfPage.targets);
      showPeelBackAds();
    }
    return adsToBeRefreshed;
  };

  var addAdsToBeRefreshed = function addAdsToBeRefreshed(adsToBeRefreshed, ad) {
    if (ad.isLoaded) {
      adsToBeRefreshed = adsToBeRefreshed.concat(ad.targets);
    }
    return adsToBeRefreshed;
  };

  var setViewport = function setViewport() {
    var view_port = MOVE.Helper.detectViewPort();
    var viewport_mapping = { 'large': 'LRG',
      'medium': 'MED',
      'small': 'SM',
      'x-small': 'XS',
      'xx-small': 'XXS'
    };
    googletag.pubads().setTargeting('VIEWPORT', [viewport_mapping[view_port]]);
  };

  var refreshAds = function refreshAds() {
    var adsToBeRefreshed = window.gptAds.gptadslots.targets; // for auto load ads
    adsToBeRefreshed = adsToBeRefreshed.concat(window.gptAds.gptadslotsPreload.targets); // for preload ads
    var pageType = MOVE.DOMHelper.detectPageType();
    if (pageType === 'srp') {
      // check to make sure it is srp
      hidePeelBackAds();
      showSrpAdForView(getViewType());
      if (getViewType() === "list") {
        // for loaded list view ads
        __WEBPACK_IMPORTED_MODULE_0_shared_critical_media_index_js__["c" /* SrpResetStickyMrect */]();
        adsToBeRefreshed = adsToBeRefreshed.concat(window.gptAds.gptadslotsTXTINListView.loaded);
        if (window.gptAds.gptadslotsTILE1PreloadListView.isLoaded) adsToBeRefreshed = adsToBeRefreshed.concat(window.gptAds.gptadslotsTILE1PreloadListView.targets);
        adsToBeRefreshed = concatSRPListViewAds(adsToBeRefreshed);
      } else {
        adsToBeRefreshed = adsToBeRefreshed.concat(window.gptAds.gptadslotsTXTINMapView.loaded);
        if (window.gptAds.gptadslotsTILE1PreloadMapView.isLoaded) adsToBeRefreshed = adsToBeRefreshed.concat(window.gptAds.gptadslotsTILE1PreloadMapView.targets);
      }
      if (window.gptAds.gptadslotsQuickViewOnly.isLoaded) {
        adsToBeRefreshed = adsToBeRefreshed.concat(window.gptAds.gptadslotsQuickViewOnly.targets);
      }
      if (window.gptAds.gptadslotsFullPhotoGallery.isLoaded) {
        adsToBeRefreshed = adsToBeRefreshed.concat(window.gptAds.gptadslotsFullPhotoGallery.targets);
      }
    } else if (pageType === 'ldp' || pageType === 'mortgage') {
      hidePeelBackAds();
      if (loadOOPAds()) {
        adsToBeRefreshed = adsToBeRefreshed.concat(window.gptAds.gptadslotsOutOfPage.targets);
        showPeelBackAds();
      }
      adsToBeRefreshed = addAdsToBeRefreshed(adsToBeRefreshed, window.gptAds.gptadslotsFullPhotoGallery);
    }
    if (window.hp_cln) {
      adsToBeRefreshed = adsToBeRefreshed.concat(window.gptAds.gptadslotsCLN.targets);
    }

    setViewport();

    // for gptadslotsPhotoGallery, gptadslotsFullPhotoGallery, gptadslotsEMP, now the ads inside no need responsive support, so skip. If in future need, add code here
    loadProgrammaticAds(adsToBeRefreshed);
  };

  var resizer = function resizer() {
    if (resizeTimer) {
      clearTimeout(resizeTimer);
    }
    resizeTimer = setTimeout(refreshAds, 250);
  };

  var onResize = function onResize() {
    var newWindowWidth = getWindowWidth();
    if (newWindowWidth !== windowWidth) {
      windowWidth = newWindowWidth;
      $('#div-gpt-ad-TXTIN2').find('.txtinadslistview').removeClass('dap-size');
      $('#div-gpt-ad-TILELIST2').removeClass('dap-mrect');
      $('.ads-section').find('.ads').removeClass('fluid');
      resizer();
    }
  };

  var getDynamicAdsToBeLoaded = function getDynamicAdsToBeLoaded(adsUnitNames, adSlotArray) {
    var adsToBeRefreshed = [];
    $(adsUnitNames.split(",")).each(function (j, adUnitToDisplay) {
      if (adUnitToDisplay === "") {
        return;
      }
      adSlotArray.targets.forEach(function (slot) {
        if (slot && slot.getTargeting('pos').includes(adUnitToDisplay)) {
          adsToBeRefreshed.push(slot);
        }
      });
    });
    return adsToBeRefreshed;
  };

  var getTXTINAdsToBeLoaded = function getTXTINAdsToBeLoaded(view, includePreloadTile1) {
    var adsTXTINToBeRefreshed = [];
    var currentView = view || getViewType();
    var tileAdListToDisplay = __WEBPACK_IMPORTED_MODULE_0_shared_critical_media_index_js__["d" /* GetTileAdListToDisplay */](currentView);
    if (currentView === "list") {
      adsTXTINToBeRefreshed = getDynamicAdsToBeLoaded(tileAdListToDisplay, window.gptAds.gptadslotsTXTINListView);
      window.gptAds.gptadslotsTXTINListView.loaded = adsTXTINToBeRefreshed;
      if (includePreloadTile1) {
        adsTXTINToBeRefreshed = adsTXTINToBeRefreshed.concat(getDynamicAdsToBeLoaded(tileAdListToDisplay, window.gptAds.gptadslotsTILE1PreloadListView));
      }
    } else if (currentView === 'map' && !MOVE.Helper.isPhone()) {
      adsTXTINToBeRefreshed = getDynamicAdsToBeLoaded(tileAdListToDisplay, window.gptAds.gptadslotsTXTINMapView);
      window.gptAds.gptadslotsTXTINMapView.loaded = adsTXTINToBeRefreshed;
      if (includePreloadTile1) {
        adsTXTINToBeRefreshed = adsTXTINToBeRefreshed.concat(getDynamicAdsToBeLoaded(tileAdListToDisplay, window.gptAds.gptadslotsTILE1PreloadMapView));
      }
    }
    return adsTXTINToBeRefreshed;
  };

  var firstTimeLoadSrp = true;
  var showSrpAdForView = function showSrpAdForView(view) {
    if (firstTimeLoadSrp) {
      firstTimeLoadSrp = false;
    } else {
      $('.fluid_tile_ad').removeClass('fluid_tile_ad');
    }
    if (view === "list") {
      $('.txtinadslistview').removeClass('hide');
      $('.mcc_tile_card').addClass('hide');
    } else {
      $('.txtinadsmapview').removeClass('hide');
    }
  };

  var set_srp_zip1 = function set_srp_zip1() {
    if ($('.ad-data-post-code').length) {
      var postcode = $('.ad-data-post-code')[0].dataset['postcode'];
      if (postcode) {
        googletag.pubads().setTargeting('SRPZIP1', [postcode]);
      }
    }
  };

  var srpLoadAds = function srpLoadAds(view, includePreloadTile1) {
    view = view || getViewType();
    view = view.toLowerCase();
    hidePeelBackAds();
    googletag.cmd.push(function () {
      refreshAdsTargettingForViewChange(view);
      var adsToBeRefreshed = getTXTINAdsToBeLoaded(view, includePreloadTile1);
      if (view === "list") {
        adsToBeRefreshed = concatSRPListViewAds(adsToBeRefreshed);
      } else {
        adsToBeRefreshed = adsToBeRefreshed.concat(window.gptAds.gptadslotsMapViewOnly.targets);
      }
      set_srp_zip1();
      loadProgrammaticAds(adsToBeRefreshed);
      showSrpAdForView(view);
      __WEBPACK_IMPORTED_MODULE_0_shared_critical_media_index_js__["e" /* TileAdLazyLoad */](getDynamicAdsToBeLoaded, loadProgrammaticAds, view);
    });
  };

  var srpPageLoad = function srpPageLoad() {
    srpLoadAds('list');
  };

  var renderNormalAds = function renderNormalAds() {
    setViewport();

    var pagetype = MOVE.DOMHelper.detectPageType();
    if (pagetype === 'srp') {
      if (getViewType() === "list") {
        srpPageLoad();
      }
    } else {
      var adsToBeRefreshed = window.gptAds.gptadslots.targets;
      if (loadOOPAds()) {
        adsToBeRefreshed = adsToBeRefreshed.concat(window.gptAds.gptadslotsOutOfPage.targets);
      }
      if (window.hp_cln) {
        adsToBeRefreshed = adsToBeRefreshed.concat(window.gptAds.gptadslotsCLN.targets);
      }
      loadProgrammaticAds(adsToBeRefreshed);
    }
  };

  var initAds = function initAds() {

    renderNormalAds();

    $(window).on('resize orientationchange', onResize);

    if (MOVE.Helper.isPageType('srp')) {
      $(window).on('scroll', _.debounce(function () {
        __WEBPACK_IMPORTED_MODULE_0_shared_critical_media_index_js__["f" /* SrpOnScroll */](getViewType, loadProgrammaticAds);
      }, 200));
    }
  };

  var manualLoadAds = function manualLoadAds(options, adsClass, forceReload, setQuickViewTargeting) {
    if (window.ads_library.initialized) {
      googletag.cmd.push(function () {
        if (!options.isLoaded || forceReload) {
          options.isLoaded = true;
          if (adsClass) {
            $(adsClass).each(function () {
              googletag.display(this.getAttribute('id'));
            });
          }

          if (setQuickViewTargeting) {
            options.targets.forEach(function (slot) {
              if (slot) {
                $.each(window.gptAds.quickview_targeting, function (key, val) {
                  slot.setTargeting(key, [val.replace(/'/g, '')]);
                });
              }
            });
          }

          loadProgrammaticAds(options.targets);
        }
      });
    } else {
      setTimeout(function () {
        manualLoadAds(options, adsClass, forceReload, setQuickViewTargeting);
      }, 1000);
    }
  };

  var getVideoMrectAdsToBeLoaded = function getVideoMrectAdsToBeLoaded() {
    var adsVedioMrectToBeRefreshed = getDynamicAdsToBeLoaded(window.videoMrectAdUnitsToDisplay, window.gptAds.gptadslotsVideoMrect);
    window.gptAds.gptadslotsVideoMrect.loaded = adsVedioMrectToBeRefreshed;
    manualLoadAds(window.gptAds.gptadslotsVideoMrect, '.ads');
  };

  var srpListingsChange = function srpListingsChange() {
    srpLoadAds();
  };

  var srpSearchChange = function srpSearchChange() {
    srpLoadAds();
  };

  var srpMapLoad = function srpMapLoad() {
    if (!MOVE.Helper.isPhone()) {
      srpListingsChange();
    }
  };

  var refreshAdsEnhancementKeys = function refreshAdsEnhancementKeys() {
    try {
      window.amznads.getAdsCallback('3103', function () {
        window.amznads.setTargetingForGPTAsync('amznslots');
      });
      googletag.pubads().clearTargeting('amznslots');
    } catch (e) {/* ignore */}
  };

  var refreshAdsTargettingForViewChange = function refreshAdsTargettingForViewChange(view) {
    googletag.pubads().setTargeting('view', [view]);
    window.kxdl.view = view;
    refreshAdsEnhancementKeys();
  };

  var srpViewChange = function srpViewChange(view) {
    view = view || getViewType();
    view = view.toLowerCase();
    if (view === "list" || !MOVE.Helper.isPhone()) {
      srpLoadAds(view, true);
    }
  };

  var srpInitMapView = function srpInitMapView(isMapViewToggle) {
    if (getViewType() === 'map') {
      srpLoadAds('map', isMapViewToggle && window.SRPPreloadTile1Ad);
    }
  };

  var kruxPixel = function kruxPixel(pixelId, option) {
    try {
      window.Krux('admEvent', pixelId, option);
    } catch (e) {/* for ad block */}
  };

  var quickview_keys = ['cityldp', 'citystldp', 'zipldp', 'countyldp', 'agent_advertiser_id', 'broker_advertiser_id', 'office_advertiser_id', 'bkr', 'pldp', 'address', 'mlid', 'mprid', 'mls', 'bid', 'offbid', 'advertiser', 'customkv', 'ptldp', 'pfldp', 'garageldp', 'listingprice', 'agehom', 'lotldp', 'sqft', 'sqldp', 'bedldp', 'bathldp', 'add', 'lstat', 'openldp', 'rdpr', 't'];

  var resetQuickViewAds = function resetQuickViewAds() {
    window.gptAds.gptadslotsQuickViewPreloadOnly.isLoaded = false;
    window.gptAds.gptadslotsQuickViewOnly.isLoaded = false;
    window.gptAds.gptadslotsQuickViewMap.isLoaded = false;
    window.gptAds.gptadslotsQuickViewMapExp.isLoaded = false;
    window.gptAds.gptadslotsPhotoGallery.isLoaded = false;
    window.gptAds.gptadslotsFullPhotoGallery.isLoaded = false;
    window.gptAds.gptadslotsEMP.isLoaded = false;
    window.gptAds.gptadslotsPaymentOptionOnly.isLoaded = false;
    window.gptAds.gptadslotsQuickViewPropertyDetails.isLoaded = false;
    $('.ad-quick-view-preload').addClass('TXTLDPLoading');
  };

  var setQuickViewKeyValue = function setQuickViewKeyValue(targeting) {
    window.gptAds.quickview_targeting = targeting;
    $.each(targeting, function (key, val) {
      window.kxdl[key] = val.replace(/'/g, '');
    });
    googletag.cmd.push(function () {
      googletag.pubads().setTargeting('refresh', ['N']);
    });
  };

  var clearQuickViewKeyValue = function clearQuickViewKeyValue() {
    window.gptAds.quickview_targeting = {};
    $.each(quickview_keys, function (i, val) {
      delete window.kxdl[val];
    });
  };

  var reloadSrpAdOnQuickViewClose = function reloadSrpAdOnQuickViewClose() {
    //for now, we only reload srp ad when it is Collaps Card, which is variation2 of ab_id_SRPBCQV
    //if we productionize and select Collaps Card, we need remove the if condition.
    if (document.getElementById('ab_id_SRPBCQV:variation2')) {
      googletag.cmd.push(function () {
        googletag.pubads().setTargeting('refresh', ['Y']);
        srpLoadAds();
      });
    }
  };

  var gptTracking = function gptTracking(value, force_load) {
    googletag.cmd.push(function () {
      if (value) {
        window.gptAds.gptadslotsTracking.targets.forEach(function (element) {
          element.setTargeting('status', [value]);
          element.setTargeting('customkv', [value]);
        });
      }
      manualLoadAds(window.gptAds.gptadslotsTracking, 'pixel', force_load);
    });
  };

  var articleTrackingUsedKey = articleTrackingUsedKey || [];
  var articleTrackingAttributionData = articleTrackingAttributionData || [];
  var doArticleTracking = function doArticleTracking(attributionData) {
    $.each(articleTrackingUsedKey, function (index, key) {
      if (window.article_tracking_slot) {
        window.article_tracking_slot.setTargeting(key, []);
      }
    });

    // track via DFP
    if (attributionData) {
      $.each(attributionData, function (key, val) {
        if ($.inArray(key, articleTrackingUsedKey) < 0) {
          articleTrackingUsedKey.push(key);
        }
        if (window.article_tracking_slot) {
          window.article_tracking_slot.setTargeting(key, val);
          window.article_tracking_slot.setTargeting('random', Math.random());
        }
      });
    }
    manualLoadAds(window.gptAds.gptadslotsArticleTracking, '.article_tracking', true);
  };

  var articleTrackingTimer;
  var articleTrackingManager = function articleTrackingManager() {
    if (articleTrackingAttributionData.length > 0) {
      var attributionData = articleTrackingAttributionData.shift();
      doArticleTracking(attributionData);
    }
    if (articleTrackingAttributionData.length > 0) {
      setTimeout(articleTrackingManager, 1000);
    }
  };

  var articleTracking = function articleTracking(attributionData) {
    articleTrackingAttributionData.push(attributionData);
    if (articleTrackingTimer) {
      clearTimeout(articleTrackingTimer);
    }
    articleTrackingTimer = setTimeout(articleTrackingManager, 500);
  };

  var init = function init(preloadAdEnabled) {
    __WEBPACK_IMPORTED_MODULE_0_shared_critical_media_index_js__["g" /* MediaInit */]().then(function () {
      if (!preloadAdEnabled) {
        window.preloadAds();
      }
      initAds();
    }, function () {
      //do nothing if ad library not initialized
    });
  };

  var showViewCreditScoreAd = function showViewCreditScoreAd() {
    if (window.gptAds && window.gptAds.gptadslotsLeadOverlayOnly && window.gptAds.gptadslotsLeadOverlayOnly.targets.length) {
      MOVE.Medias.manualLoadAds(window.gptAds.gptadslotsLeadOverlayOnly, '.lead_thank_you', true);
      $('#div-gpt-ad-BTNLEAD1').removeClass('hide');
      $('#view_credit_scores_button').addClass('hide');
    } else {
      $('#div-gpt-ad-BTNLEAD1').addClass('hide');
      $('#view_credit_scores_button').removeClass('hide');
    }
  };

  var loadMCCOverlayAd = function loadMCCOverlayAd(movingModalSelectorId) {
    if (getViewType() === "list") {
      MOVE.Medias.manualLoadAds(window.gptAds.gptadslotsMCCModal, movingModalSelectorId + ' .ads');
    } else {
      MOVE.Medias.manualLoadAds(window.gptAds.gptadslotsMCCModalMap, movingModalSelectorId + ' .ads');
    }
  };

  var getEmptyTile1Ad = function getEmptyTile1Ad() {
    if (getViewType() === "list") {
      $('#div-gpt-ad-TILELIST1').parents('.txtinadslistview').addClass('hide');
      if (!MOVE.Helper.isPhone()) {
        $('.mcc_tile_card').removeClass('hide');
        MOVE.Medias.manualLoadAds(window.gptAds.gptadslotsMCCTile);
      }
    } else {
      $('#div-gpt-ad-TILEMAP1').parents('.txtinadsmapview').addClass('hide');
    }
  };

  var currentVET = "";
  var loadAFCALCOverlayAd = function loadAFCALCOverlayAd(affordabilityModal, vet) {
    if (vet !== currentVET) {
      currentVET = vet;
      window.googletag.pubads().setTargeting('VET', [vet]);
      if (getViewType() === "list") {
        MOVE.Medias.manualLoadAds(window.gptAds.gptadslotsAFCALCModalList, affordabilityModal + ' .ads', true);
      } else {
        MOVE.Medias.manualLoadAds(window.gptAds.gptadslotsAFCALCModalMap, affordabilityModal + ' .ads', true);
      }
    }
  };

  var currentVET2 = "";
  var currentVIEW = "";
  var loadPFILTERCOverlayAd = function loadPFILTERCOverlayAd(filter) {
    var vet = $('#affordability-vetbenefits').is(":checked") ? "Y" : "N";
    var view = getViewType();
    if (vet !== currentVET2 || view !== currentVIEW) {
      currentVET2 = vet;
      currentVIEW = view;
      window.googletag.pubads().setTargeting('VET', [vet]);
      if (view === "list") {
        MOVE.Medias.manualLoadAds(window.gptAds.gptadslotsPFILTERModalList, filter + ' .ads', true);
      } else {
        MOVE.Medias.manualLoadAds(window.gptAds.gptadslotsPFILTERModalMap, filter + ' .ads', true);
      }
    }
  };

  return {
    init: init,
    manualLoadAds: manualLoadAds,
    getVideoMrectAdsToBeLoaded: getVideoMrectAdsToBeLoaded,
    srpViewChange: srpViewChange,
    srpListingsChange: srpListingsChange,
    srpMapLoad: srpMapLoad,
    srpInitMapView: srpInitMapView,
    srpPagination: srpLoadAds,
    srpSearchChange: srpSearchChange,
    articleTracking: articleTracking,
    gptTracking: gptTracking,
    showViewCreditScoreAd: showViewCreditScoreAd,
    resetQuickViewAds: resetQuickViewAds,
    setQuickViewKeyValue: setQuickViewKeyValue,
    clearQuickViewKeyValue: clearQuickViewKeyValue,
    reloadSrpAdOnQuickViewClose: reloadSrpAdOnQuickViewClose,
    loadMCCOverlayAd: loadMCCOverlayAd,
    getEmptyTile1Ad: getEmptyTile1Ad,
    loadAFCALCOverlayAd: loadAFCALCOverlayAd,
    loadPFILTERCOverlayAd: loadPFILTERCOverlayAd,
    kruxPixel: kruxPixel
  };
}();

window.addEventListener("message", __WEBPACK_IMPORTED_MODULE_0_shared_critical_media_index_js__["h" /* HandleAdsMessage */], false);

/***/ }),

/***/ 583:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return abOpenHouseTimePicker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return abOpenHouseDatePicker; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return abPopulateForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return abSetDateTime; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shared_critical_helper__ = __webpack_require__(4);
function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }


var dateNow = new Date(),
    current = new Date(dateNow.getTime() + 86400000),
    formattedDate = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shared_critical_helper__["c" /* formatDate */])(current);

var abOpenHouseTimePicker = function abOpenHouseTimePicker() {
  if ($('.ab-datetimepicker').length >= 1) {
    var _$$datetimepicker;

    $('.ab-datetimepicker').datetimepicker((_$$datetimepicker = {
      format: 'LT',
      icons: {
        up: 'ra ra-angle-up',
        down: 'ra ra-angle-down'
      },
      ignoreReadonly: true,
      stepping: 15,
      keepOpen: false,
      enabledHours: [9, 10, 11, 12, 13, 14, 15, 16, 17, 18, 19],
      widgetPositioning: {
        horizontal: 'right',
        vertical: 'bottom'
      },
      allowInputToggle: true
    }, _defineProperty(_$$datetimepicker, 'ignoreReadonly', true), _defineProperty(_$$datetimepicker, 'focusOnShow', false), _defineProperty(_$$datetimepicker, 'useCurrent', false), _$$datetimepicker));
  }
};

var abOpenHouseDatePicker = function abOpenHouseDatePicker() {
  if ($('.ab-datepicker').length >= 1) {
    $('.ab-datepicker').datepicker({
      startDate: '+0d',
      todayHighlight: true,
      autoclose: true,
      orientation: 'bottom auto',
      onClose: function onClose() {
        $(this).change();
      }
    });
  }
};

var abPopulateForm = function abPopulateForm() {
  var $dateTimePickerForm = $('.ab-datetimepicker.oh-form input'),
      $datePickerForm = $('.ab-datepicker.oh-form input');
  if (MOVE_DATA.ab_schedule_tour === "V2" && !MOVE_DATA.is_flipped_market) {
    var date = $datePickerForm.val() || formattedDate;
    var time = $dateTimePickerForm.val() || "10:00 AM";
    var message = "I would like to request a showing on " + date + " at " + time;
    $("#request_showing_lead_message").val(message);
  }
};

var abSetDateTime = function abSetDateTime() {
  var $abDatePicker = $('.ab-datepicker'),
      $abDateTimePicker = $('.ab-datetimepicker'),
      $dateTimePickerInput = $('.ab-datetimepicker input'),
      $datePickerInput = $('.ab-datepicker input'),
      $dateTimePickerForm = $('.ab-datetimepicker.oh-form input'),
      $datePickerForm = $('.ab-datepicker.oh-form input');

  if ($abDatePicker && $abDateTimePicker) {
    //QV
    if (!$dateTimePickerInput.val()) $dateTimePickerInput.val("10:00 AM");
    if (!$datePickerInput.val()) $datePickerInput.val(formattedDate);

    //Forms
    if (!$dateTimePickerForm.val()) {
      $dateTimePickerForm.val("10:00 AM");
    } else {
      var newVal = $dateTimePickerInput.val();
      $dateTimePickerForm.val(newVal);
    }

    if (!$datePickerForm.val()) {
      $datePickerForm.val(formattedDate);
    } else {
      var _newVal = $datePickerInput.val();
      $datePickerForm.val(_newVal);
    }

    $datePickerInput.change(function () {
      abPopulateForm();
    });

    $datePickerForm.on('changeDate', function () {
      if (!$datePickerForm.val()) $datePickerForm.val(formattedDate);
    });

    $('.ab-datetimepicker.oh-form').on('dp.change', function () {
      abPopulateForm();
    });

    $abDatePicker.off('click').on('click', function () {
      $('.bootstrap-datetimepicker-widget').hide();
    });

    $abDateTimePicker.off('click').on('click', function () {
      $('.datepicker-dropdown').hide();
    });
  }
};

/***/ }),

/***/ 584:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return toggleOrTextMeBtn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return toggleOrEmailMeBtn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return showOnlyTextCta; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return hideTextCta; });
var toggleOrTextMeBtn = function toggleOrTextMeBtn(abOnlyTxtCta) {
  var textInputModal = $('#textInputModal');
  var orTextMeButton = $('#srp-lead-modal').find('.or-text-me-button');
  if (Boolean(abOnlyTxtCta)) {
    textInputModal.modal('hide');
    orTextMeButton.removeClass("hidden");
    if ($('#qv-sticky-text-cta').hasClass("texted")) {
      orTextMeButton.text("Texted").addClass("texted");
    }
  } else {
    orTextMeButton.addClass("hidden");
  }
};

var toggleOrEmailMeBtn = function toggleOrEmailMeBtn(target, abOnlyTxtCtaTextMe, abLeadSubmitted) {
  var emailMeButton = $(target).find('.or-email-me-button');
  if (Boolean(abOnlyTxtCtaTextMe)) {
    emailMeButton.removeClass("hidden");
    if (abLeadSubmitted && abLeadSubmitted.value === "yes") {
      emailMeButton.text('Contacted').removeClass('js-qv-contact-agent').addClass('contacted');
    }
  } else {
    emailMeButton.addClass("hidden");
  }
};

var showOnlyTextCta = function showOnlyTextCta() {
  $('.qv-footer-email-text-btn').addClass("hidden");
  $('.qv-footer-question-btn').removeClass("hidden");
};

var hideTextCta = function hideTextCta() {
  $('.qv-footer-email-text-btn').removeClass("hidden");
  $('.qv-footer-question-btn').addClass("hidden");
};

/***/ }),

/***/ 585:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setupLdpPageTracking; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ldp_clicks__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__shared_tracking_helper__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__quick_view_optimization_ab_open_panels__ = __webpack_require__(625);
/*global RdcTracking */




var DEFAULT_VALUE = 'unknown';

var setupLdpPageTracking = function setupLdpPageTracking() {
  if (MOVE_DATA && MOVE_DATA.adobeDTM) {
    var pageName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_tracking_helper__["a" /* getPageName */])(MOVE_DATA.adobeDTM.pageType, MOVE_DATA.adobeDTM.propertyStatus);
    var pageStatus = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_tracking_helper__["a" /* getPageName */])(MOVE_DATA.adobeDTM.pageType, MOVE_DATA.adobeDTM.propertyStatus, true);
    trackPageLoad(pageName);
    deleteListingClickSourceCookie();
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__ldp_clicks__["a" /* setupLdpClickTracking */])(pageStatus);
  }
};

var deleteListingClickSourceCookie = function deleteListingClickSourceCookie() {
  if ($.cookie("SrpClickedListing")) {
    $.removeCookie("SrpClickedListing", { path: '/' });
  }
};

var trackPageLoad = function trackPageLoad(pageName) {
  RdcTracking.trackPage(pageName, prepareLoadEventData(MOVE_DATA.adobeDTM));
};

var prepareLoadEventData = function prepareLoadEventData(pageData) {
  var pageType = pageData['pageType'];
  var listing = pageData['listing'] || {};
  var data = {
    additionalRRComId: pageData['additionalRR-comID'],
    additionalRRListingId: pageData['additionalRR-listingID'],
    advertiserIdAgent: pageData['advertiserID-agent'],
    advertiserIdBroker: pageData['advertiserID-broker'],
    advertiserIdListing: pageData['advertiserID-listing'],
    advertiserIdLocal: pageData['advertiserID-local'],
    advertiserIdOffice: pageData['advertiserID-office'],
    appVersion: pageData['appVersion'],
    city: pageData["listingCity"] || DEFAULT_VALUE,
    communityId: pageData["communityId"] || DEFAULT_VALUE,
    dsProducts: pageData["dataScienceProducts"],
    ldpPropertyStatus: getLdpPropertyStatus(pageType, pageData.propertyStatus, pageData.propertyStatusSub) || DEFAULT_VALUE,
    leadDelivery: listing["leadDelivery"],
    leadEnhancements: getLeadEnhancements(),
    listingActivity: attrWithPageType(pageData["listingActivity"], pageType),
    listingBaths: pageData['listingBaths'],
    listingBeds: pageData['listingBeds'],
    listingClickSource: getListingClickSource(),
    listingEnhancements: listing["enhancements"] || DEFAULT_VALUE,
    listingId: pageData["listingID"] || DEFAULT_VALUE,
    listingMls: pageData["listingSource"] || DEFAULT_VALUE,
    listingPrice: pageData["listingPrice"] || DEFAULT_VALUE,
    listingSqFt: pageData['listingSqFt'],
    mprId: pageData["mprID"] || DEFAULT_VALUE,
    neighborhood: pageData["listingNeighborhood"],
    pageId: pageData["pageID"],
    pageType: pageType,
    photoCount: pageData["listingPhotoCt"] || DEFAULT_VALUE,
    planId: pageData["planID"] || DEFAULT_VALUE,
    productType: attrWithPageType(pageData["productType"], pageType),
    propertyStatus: getPropertyStatus(pageData["propertyStatus"], pageType) || DEFAULT_VALUE,
    propertyStatusSub: pageData["propertyStatusSub"] || DEFAULT_VALUE,
    propertyType: attrWithPageType(pageData["propertyType"], pageType) || DEFAULT_VALUE,
    rankingOnSrp: pageData["listingRank"] || DEFAULT_VALUE,
    realtipPresent: pageData["realtipPresent"] || 'n',
    realtipCount: pageData["realtipCount"],
    rentalDataSource: pageData["dataSourceType"] || DEFAULT_VALUE,
    roleType: pageData["roleType"],
    searchId: pageData["searchID"],
    siteSection: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__shared_tracking_helper__["a" /* getPageName */])(pageType, pageData["propertyStatus"], true),
    smartBanner: pageData["smartBanner"] || 'n',
    state: pageData["listingState"] || DEFAULT_VALUE,
    subId: pageData["subID"] || DEFAULT_VALUE,
    zip: pageData["listingZip"] || DEFAULT_VALUE,
    tempLdpConfig: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_2__quick_view_optimization_ab_open_panels__["d" /* addOpenPanelsABTracking */])(),
    imageSwapped: MOVE_DATA.qv_imgctr_swapped === true ? 'y' : 'n'
  };
  if (pageType === "ldp-quickview") {
    // LGWEB-40
    if (MOVE_DATA.ab_vitality) {
      data['vitalityWidgetImpression'] = 'views_on_rdc_' + (pageData.property_vitality && pageData.property_vitality['ldp_pageview_count'] > 0 ? 'y' : 'n') + ':saved_' + (pageData.property_vitality && pageData.property_vitality['saved_count'] > 0 ? 'y' : 'n') + ':shared_' + (pageData.property_vitality && pageData.property_vitality['shares_count'] > 0 ? 'y' : 'n');
    }
    // LGWEB-40
    return Object.assign({}, data, { abTestSrp: getAbTestVariables() });
  } else {
    return Object.assign({}, data, { abTestLdp: getAbTestVariables() });
  }
};

var getListingClickSource = function getListingClickSource() {
  var presentCookieValue = '';
  if ($.cookie("SrpClickedListing")) {
    presentCookieValue = JSON.parse($.cookie("SrpClickedListing")).src;
  }
  return presentCookieValue;
};

var attrWithPageType = function attrWithPageType(attr, pageType) {
  if (attr) {
    return pageType + ':' + attr;
  }
};

var getAbTestVariables = function getAbTestVariables() {
  var elems = document.querySelectorAll("input[data-optimizely]");
  var retValue = '';
  for (var i = 0; i < elems.length; i++) {
    if (i > 0) {
      retValue += ',';
    }
    retValue += elems[i].getAttribute("data-optimizely");
  }
  return retValue;
};

var getPropertyStatus = function getPropertyStatus(propertyStatus, pageType) {
  return pageType === 'bdp' ? null : propertyStatus;
};

var getLdpPropertyStatus = function getLdpPropertyStatus(pageType, propertyStatus, propertyStatusSub) {
  if (pageType === 'bdp') {
    return;
  }
  return propertyStatusSub ? pageType + ':' + propertyStatus + ':' + propertyStatusSub : pageType + ':' + propertyStatus;
};

var getLeadEnhancements = function getLeadEnhancements() {
  if (!MOVE_DATA.propertyDetails || !MOVE_DATA.propertyDetails.lead_attributes || !MOVE_DATA.propertyDetails.lead_attributes.lead_type || MOVE_DATA.propertyDetails.lead_attributes.lead_type === 'none') {
    return '';
  }
  return MOVE_DATA.propertyDetails.lead_attributes.show_contact_a_lender ? MOVE_DATA.is_lcm_enabled ? 'classic,lcm' : 'classic,rcm' : 'classic';
};

/***/ }),

/***/ 619:
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;//     Underscore.js 1.8.3
//     http://underscorejs.org
//     (c) 2009-2015 Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
//     Underscore may be freely distributed under the MIT license.

(function() {

  // Baseline setup
  // --------------

  // Establish the root object, `window` in the browser, or `exports` on the server.
  var root = this;

  // Save the previous value of the `_` variable.
  var previousUnderscore = root._;

  // Save bytes in the minified (but not gzipped) version:
  var ArrayProto = Array.prototype, ObjProto = Object.prototype, FuncProto = Function.prototype;

  // Create quick reference variables for speed access to core prototypes.
  var
    push             = ArrayProto.push,
    slice            = ArrayProto.slice,
    toString         = ObjProto.toString,
    hasOwnProperty   = ObjProto.hasOwnProperty;

  // All **ECMAScript 5** native function implementations that we hope to use
  // are declared here.
  var
    nativeIsArray      = Array.isArray,
    nativeKeys         = Object.keys,
    nativeBind         = FuncProto.bind,
    nativeCreate       = Object.create;

  // Naked function reference for surrogate-prototype-swapping.
  var Ctor = function(){};

  // Create a safe reference to the Underscore object for use below.
  var _ = function(obj) {
    if (obj instanceof _) return obj;
    if (!(this instanceof _)) return new _(obj);
    this._wrapped = obj;
  };

  // Export the Underscore object for **Node.js**, with
  // backwards-compatibility for the old `require()` API. If we're in
  // the browser, add `_` as a global object.
  if (true) {
    if (typeof module !== 'undefined' && module.exports) {
      exports = module.exports = _;
    }
    exports._ = _;
  } else {
    root._ = _;
  }

  // Current version.
  _.VERSION = '1.8.3';

  // Internal function that returns an efficient (for current engines) version
  // of the passed-in callback, to be repeatedly applied in other Underscore
  // functions.
  var optimizeCb = function(func, context, argCount) {
    if (context === void 0) return func;
    switch (argCount == null ? 3 : argCount) {
      case 1: return function(value) {
        return func.call(context, value);
      };
      case 2: return function(value, other) {
        return func.call(context, value, other);
      };
      case 3: return function(value, index, collection) {
        return func.call(context, value, index, collection);
      };
      case 4: return function(accumulator, value, index, collection) {
        return func.call(context, accumulator, value, index, collection);
      };
    }
    return function() {
      return func.apply(context, arguments);
    };
  };

  // A mostly-internal function to generate callbacks that can be applied
  // to each element in a collection, returning the desired result — either
  // identity, an arbitrary callback, a property matcher, or a property accessor.
  var cb = function(value, context, argCount) {
    if (value == null) return _.identity;
    if (_.isFunction(value)) return optimizeCb(value, context, argCount);
    if (_.isObject(value)) return _.matcher(value);
    return _.property(value);
  };
  _.iteratee = function(value, context) {
    return cb(value, context, Infinity);
  };

  // An internal function for creating assigner functions.
  var createAssigner = function(keysFunc, undefinedOnly) {
    return function(obj) {
      var length = arguments.length;
      if (length < 2 || obj == null) return obj;
      for (var index = 1; index < length; index++) {
        var source = arguments[index],
            keys = keysFunc(source),
            l = keys.length;
        for (var i = 0; i < l; i++) {
          var key = keys[i];
          if (!undefinedOnly || obj[key] === void 0) obj[key] = source[key];
        }
      }
      return obj;
    };
  };

  // An internal function for creating a new object that inherits from another.
  var baseCreate = function(prototype) {
    if (!_.isObject(prototype)) return {};
    if (nativeCreate) return nativeCreate(prototype);
    Ctor.prototype = prototype;
    var result = new Ctor;
    Ctor.prototype = null;
    return result;
  };

  var property = function(key) {
    return function(obj) {
      return obj == null ? void 0 : obj[key];
    };
  };

  // Helper for collection methods to determine whether a collection
  // should be iterated as an array or as an object
  // Related: http://people.mozilla.org/~jorendorff/es6-draft.html#sec-tolength
  // Avoids a very nasty iOS 8 JIT bug on ARM-64. #2094
  var MAX_ARRAY_INDEX = Math.pow(2, 53) - 1;
  var getLength = property('length');
  var isArrayLike = function(collection) {
    var length = getLength(collection);
    return typeof length == 'number' && length >= 0 && length <= MAX_ARRAY_INDEX;
  };

  // Collection Functions
  // --------------------

  // The cornerstone, an `each` implementation, aka `forEach`.
  // Handles raw objects in addition to array-likes. Treats all
  // sparse array-likes as if they were dense.
  _.each = _.forEach = function(obj, iteratee, context) {
    iteratee = optimizeCb(iteratee, context);
    var i, length;
    if (isArrayLike(obj)) {
      for (i = 0, length = obj.length; i < length; i++) {
        iteratee(obj[i], i, obj);
      }
    } else {
      var keys = _.keys(obj);
      for (i = 0, length = keys.length; i < length; i++) {
        iteratee(obj[keys[i]], keys[i], obj);
      }
    }
    return obj;
  };

  // Return the results of applying the iteratee to each element.
  _.map = _.collect = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length,
        results = Array(length);
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      results[index] = iteratee(obj[currentKey], currentKey, obj);
    }
    return results;
  };

  // Create a reducing function iterating left or right.
  function createReduce(dir) {
    // Optimized iterator function as using arguments.length
    // in the main function will deoptimize the, see #1991.
    function iterator(obj, iteratee, memo, keys, index, length) {
      for (; index >= 0 && index < length; index += dir) {
        var currentKey = keys ? keys[index] : index;
        memo = iteratee(memo, obj[currentKey], currentKey, obj);
      }
      return memo;
    }

    return function(obj, iteratee, memo, context) {
      iteratee = optimizeCb(iteratee, context, 4);
      var keys = !isArrayLike(obj) && _.keys(obj),
          length = (keys || obj).length,
          index = dir > 0 ? 0 : length - 1;
      // Determine the initial value if none is provided.
      if (arguments.length < 3) {
        memo = obj[keys ? keys[index] : index];
        index += dir;
      }
      return iterator(obj, iteratee, memo, keys, index, length);
    };
  }

  // **Reduce** builds up a single result from a list of values, aka `inject`,
  // or `foldl`.
  _.reduce = _.foldl = _.inject = createReduce(1);

  // The right-associative version of reduce, also known as `foldr`.
  _.reduceRight = _.foldr = createReduce(-1);

  // Return the first value which passes a truth test. Aliased as `detect`.
  _.find = _.detect = function(obj, predicate, context) {
    var key;
    if (isArrayLike(obj)) {
      key = _.findIndex(obj, predicate, context);
    } else {
      key = _.findKey(obj, predicate, context);
    }
    if (key !== void 0 && key !== -1) return obj[key];
  };

  // Return all the elements that pass a truth test.
  // Aliased as `select`.
  _.filter = _.select = function(obj, predicate, context) {
    var results = [];
    predicate = cb(predicate, context);
    _.each(obj, function(value, index, list) {
      if (predicate(value, index, list)) results.push(value);
    });
    return results;
  };

  // Return all the elements for which a truth test fails.
  _.reject = function(obj, predicate, context) {
    return _.filter(obj, _.negate(cb(predicate)), context);
  };

  // Determine whether all of the elements match a truth test.
  // Aliased as `all`.
  _.every = _.all = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (!predicate(obj[currentKey], currentKey, obj)) return false;
    }
    return true;
  };

  // Determine if at least one element in the object matches a truth test.
  // Aliased as `any`.
  _.some = _.any = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = !isArrayLike(obj) && _.keys(obj),
        length = (keys || obj).length;
    for (var index = 0; index < length; index++) {
      var currentKey = keys ? keys[index] : index;
      if (predicate(obj[currentKey], currentKey, obj)) return true;
    }
    return false;
  };

  // Determine if the array or object contains a given item (using `===`).
  // Aliased as `includes` and `include`.
  _.contains = _.includes = _.include = function(obj, item, fromIndex, guard) {
    if (!isArrayLike(obj)) obj = _.values(obj);
    if (typeof fromIndex != 'number' || guard) fromIndex = 0;
    return _.indexOf(obj, item, fromIndex) >= 0;
  };

  // Invoke a method (with arguments) on every item in a collection.
  _.invoke = function(obj, method) {
    var args = slice.call(arguments, 2);
    var isFunc = _.isFunction(method);
    return _.map(obj, function(value) {
      var func = isFunc ? method : value[method];
      return func == null ? func : func.apply(value, args);
    });
  };

  // Convenience version of a common use case of `map`: fetching a property.
  _.pluck = function(obj, key) {
    return _.map(obj, _.property(key));
  };

  // Convenience version of a common use case of `filter`: selecting only objects
  // containing specific `key:value` pairs.
  _.where = function(obj, attrs) {
    return _.filter(obj, _.matcher(attrs));
  };

  // Convenience version of a common use case of `find`: getting the first object
  // containing specific `key:value` pairs.
  _.findWhere = function(obj, attrs) {
    return _.find(obj, _.matcher(attrs));
  };

  // Return the maximum element (or element-based computation).
  _.max = function(obj, iteratee, context) {
    var result = -Infinity, lastComputed = -Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value > result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed > lastComputed || computed === -Infinity && result === -Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Return the minimum element (or element-based computation).
  _.min = function(obj, iteratee, context) {
    var result = Infinity, lastComputed = Infinity,
        value, computed;
    if (iteratee == null && obj != null) {
      obj = isArrayLike(obj) ? obj : _.values(obj);
      for (var i = 0, length = obj.length; i < length; i++) {
        value = obj[i];
        if (value < result) {
          result = value;
        }
      }
    } else {
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index, list) {
        computed = iteratee(value, index, list);
        if (computed < lastComputed || computed === Infinity && result === Infinity) {
          result = value;
          lastComputed = computed;
        }
      });
    }
    return result;
  };

  // Shuffle a collection, using the modern version of the
  // [Fisher-Yates shuffle](http://en.wikipedia.org/wiki/Fisher–Yates_shuffle).
  _.shuffle = function(obj) {
    var set = isArrayLike(obj) ? obj : _.values(obj);
    var length = set.length;
    var shuffled = Array(length);
    for (var index = 0, rand; index < length; index++) {
      rand = _.random(0, index);
      if (rand !== index) shuffled[index] = shuffled[rand];
      shuffled[rand] = set[index];
    }
    return shuffled;
  };

  // Sample **n** random values from a collection.
  // If **n** is not specified, returns a single random element.
  // The internal `guard` argument allows it to work with `map`.
  _.sample = function(obj, n, guard) {
    if (n == null || guard) {
      if (!isArrayLike(obj)) obj = _.values(obj);
      return obj[_.random(obj.length - 1)];
    }
    return _.shuffle(obj).slice(0, Math.max(0, n));
  };

  // Sort the object's values by a criterion produced by an iteratee.
  _.sortBy = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    return _.pluck(_.map(obj, function(value, index, list) {
      return {
        value: value,
        index: index,
        criteria: iteratee(value, index, list)
      };
    }).sort(function(left, right) {
      var a = left.criteria;
      var b = right.criteria;
      if (a !== b) {
        if (a > b || a === void 0) return 1;
        if (a < b || b === void 0) return -1;
      }
      return left.index - right.index;
    }), 'value');
  };

  // An internal function used for aggregate "group by" operations.
  var group = function(behavior) {
    return function(obj, iteratee, context) {
      var result = {};
      iteratee = cb(iteratee, context);
      _.each(obj, function(value, index) {
        var key = iteratee(value, index, obj);
        behavior(result, value, key);
      });
      return result;
    };
  };

  // Groups the object's values by a criterion. Pass either a string attribute
  // to group by, or a function that returns the criterion.
  _.groupBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key].push(value); else result[key] = [value];
  });

  // Indexes the object's values by a criterion, similar to `groupBy`, but for
  // when you know that your index values will be unique.
  _.indexBy = group(function(result, value, key) {
    result[key] = value;
  });

  // Counts instances of an object that group by a certain criterion. Pass
  // either a string attribute to count by, or a function that returns the
  // criterion.
  _.countBy = group(function(result, value, key) {
    if (_.has(result, key)) result[key]++; else result[key] = 1;
  });

  // Safely create a real, live array from anything iterable.
  _.toArray = function(obj) {
    if (!obj) return [];
    if (_.isArray(obj)) return slice.call(obj);
    if (isArrayLike(obj)) return _.map(obj, _.identity);
    return _.values(obj);
  };

  // Return the number of elements in an object.
  _.size = function(obj) {
    if (obj == null) return 0;
    return isArrayLike(obj) ? obj.length : _.keys(obj).length;
  };

  // Split a collection into two arrays: one whose elements all satisfy the given
  // predicate, and one whose elements all do not satisfy the predicate.
  _.partition = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var pass = [], fail = [];
    _.each(obj, function(value, key, obj) {
      (predicate(value, key, obj) ? pass : fail).push(value);
    });
    return [pass, fail];
  };

  // Array Functions
  // ---------------

  // Get the first element of an array. Passing **n** will return the first N
  // values in the array. Aliased as `head` and `take`. The **guard** check
  // allows it to work with `_.map`.
  _.first = _.head = _.take = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[0];
    return _.initial(array, array.length - n);
  };

  // Returns everything but the last entry of the array. Especially useful on
  // the arguments object. Passing **n** will return all the values in
  // the array, excluding the last N.
  _.initial = function(array, n, guard) {
    return slice.call(array, 0, Math.max(0, array.length - (n == null || guard ? 1 : n)));
  };

  // Get the last element of an array. Passing **n** will return the last N
  // values in the array.
  _.last = function(array, n, guard) {
    if (array == null) return void 0;
    if (n == null || guard) return array[array.length - 1];
    return _.rest(array, Math.max(0, array.length - n));
  };

  // Returns everything but the first entry of the array. Aliased as `tail` and `drop`.
  // Especially useful on the arguments object. Passing an **n** will return
  // the rest N values in the array.
  _.rest = _.tail = _.drop = function(array, n, guard) {
    return slice.call(array, n == null || guard ? 1 : n);
  };

  // Trim out all falsy values from an array.
  _.compact = function(array) {
    return _.filter(array, _.identity);
  };

  // Internal implementation of a recursive `flatten` function.
  var flatten = function(input, shallow, strict, startIndex) {
    var output = [], idx = 0;
    for (var i = startIndex || 0, length = getLength(input); i < length; i++) {
      var value = input[i];
      if (isArrayLike(value) && (_.isArray(value) || _.isArguments(value))) {
        //flatten current level of array or arguments object
        if (!shallow) value = flatten(value, shallow, strict);
        var j = 0, len = value.length;
        output.length += len;
        while (j < len) {
          output[idx++] = value[j++];
        }
      } else if (!strict) {
        output[idx++] = value;
      }
    }
    return output;
  };

  // Flatten out an array, either recursively (by default), or just one level.
  _.flatten = function(array, shallow) {
    return flatten(array, shallow, false);
  };

  // Return a version of the array that does not contain the specified value(s).
  _.without = function(array) {
    return _.difference(array, slice.call(arguments, 1));
  };

  // Produce a duplicate-free version of the array. If the array has already
  // been sorted, you have the option of using a faster algorithm.
  // Aliased as `unique`.
  _.uniq = _.unique = function(array, isSorted, iteratee, context) {
    if (!_.isBoolean(isSorted)) {
      context = iteratee;
      iteratee = isSorted;
      isSorted = false;
    }
    if (iteratee != null) iteratee = cb(iteratee, context);
    var result = [];
    var seen = [];
    for (var i = 0, length = getLength(array); i < length; i++) {
      var value = array[i],
          computed = iteratee ? iteratee(value, i, array) : value;
      if (isSorted) {
        if (!i || seen !== computed) result.push(value);
        seen = computed;
      } else if (iteratee) {
        if (!_.contains(seen, computed)) {
          seen.push(computed);
          result.push(value);
        }
      } else if (!_.contains(result, value)) {
        result.push(value);
      }
    }
    return result;
  };

  // Produce an array that contains the union: each distinct element from all of
  // the passed-in arrays.
  _.union = function() {
    return _.uniq(flatten(arguments, true, true));
  };

  // Produce an array that contains every item shared between all the
  // passed-in arrays.
  _.intersection = function(array) {
    var result = [];
    var argsLength = arguments.length;
    for (var i = 0, length = getLength(array); i < length; i++) {
      var item = array[i];
      if (_.contains(result, item)) continue;
      for (var j = 1; j < argsLength; j++) {
        if (!_.contains(arguments[j], item)) break;
      }
      if (j === argsLength) result.push(item);
    }
    return result;
  };

  // Take the difference between one array and a number of other arrays.
  // Only the elements present in just the first array will remain.
  _.difference = function(array) {
    var rest = flatten(arguments, true, true, 1);
    return _.filter(array, function(value){
      return !_.contains(rest, value);
    });
  };

  // Zip together multiple lists into a single array -- elements that share
  // an index go together.
  _.zip = function() {
    return _.unzip(arguments);
  };

  // Complement of _.zip. Unzip accepts an array of arrays and groups
  // each array's elements on shared indices
  _.unzip = function(array) {
    var length = array && _.max(array, getLength).length || 0;
    var result = Array(length);

    for (var index = 0; index < length; index++) {
      result[index] = _.pluck(array, index);
    }
    return result;
  };

  // Converts lists into objects. Pass either a single array of `[key, value]`
  // pairs, or two parallel arrays of the same length -- one of keys, and one of
  // the corresponding values.
  _.object = function(list, values) {
    var result = {};
    for (var i = 0, length = getLength(list); i < length; i++) {
      if (values) {
        result[list[i]] = values[i];
      } else {
        result[list[i][0]] = list[i][1];
      }
    }
    return result;
  };

  // Generator function to create the findIndex and findLastIndex functions
  function createPredicateIndexFinder(dir) {
    return function(array, predicate, context) {
      predicate = cb(predicate, context);
      var length = getLength(array);
      var index = dir > 0 ? 0 : length - 1;
      for (; index >= 0 && index < length; index += dir) {
        if (predicate(array[index], index, array)) return index;
      }
      return -1;
    };
  }

  // Returns the first index on an array-like that passes a predicate test
  _.findIndex = createPredicateIndexFinder(1);
  _.findLastIndex = createPredicateIndexFinder(-1);

  // Use a comparator function to figure out the smallest index at which
  // an object should be inserted so as to maintain order. Uses binary search.
  _.sortedIndex = function(array, obj, iteratee, context) {
    iteratee = cb(iteratee, context, 1);
    var value = iteratee(obj);
    var low = 0, high = getLength(array);
    while (low < high) {
      var mid = Math.floor((low + high) / 2);
      if (iteratee(array[mid]) < value) low = mid + 1; else high = mid;
    }
    return low;
  };

  // Generator function to create the indexOf and lastIndexOf functions
  function createIndexFinder(dir, predicateFind, sortedIndex) {
    return function(array, item, idx) {
      var i = 0, length = getLength(array);
      if (typeof idx == 'number') {
        if (dir > 0) {
            i = idx >= 0 ? idx : Math.max(idx + length, i);
        } else {
            length = idx >= 0 ? Math.min(idx + 1, length) : idx + length + 1;
        }
      } else if (sortedIndex && idx && length) {
        idx = sortedIndex(array, item);
        return array[idx] === item ? idx : -1;
      }
      if (item !== item) {
        idx = predicateFind(slice.call(array, i, length), _.isNaN);
        return idx >= 0 ? idx + i : -1;
      }
      for (idx = dir > 0 ? i : length - 1; idx >= 0 && idx < length; idx += dir) {
        if (array[idx] === item) return idx;
      }
      return -1;
    };
  }

  // Return the position of the first occurrence of an item in an array,
  // or -1 if the item is not included in the array.
  // If the array is large and already in sort order, pass `true`
  // for **isSorted** to use binary search.
  _.indexOf = createIndexFinder(1, _.findIndex, _.sortedIndex);
  _.lastIndexOf = createIndexFinder(-1, _.findLastIndex);

  // Generate an integer Array containing an arithmetic progression. A port of
  // the native Python `range()` function. See
  // [the Python documentation](http://docs.python.org/library/functions.html#range).
  _.range = function(start, stop, step) {
    if (stop == null) {
      stop = start || 0;
      start = 0;
    }
    step = step || 1;

    var length = Math.max(Math.ceil((stop - start) / step), 0);
    var range = Array(length);

    for (var idx = 0; idx < length; idx++, start += step) {
      range[idx] = start;
    }

    return range;
  };

  // Function (ahem) Functions
  // ------------------

  // Determines whether to execute a function as a constructor
  // or a normal function with the provided arguments
  var executeBound = function(sourceFunc, boundFunc, context, callingContext, args) {
    if (!(callingContext instanceof boundFunc)) return sourceFunc.apply(context, args);
    var self = baseCreate(sourceFunc.prototype);
    var result = sourceFunc.apply(self, args);
    if (_.isObject(result)) return result;
    return self;
  };

  // Create a function bound to a given object (assigning `this`, and arguments,
  // optionally). Delegates to **ECMAScript 5**'s native `Function.bind` if
  // available.
  _.bind = function(func, context) {
    if (nativeBind && func.bind === nativeBind) return nativeBind.apply(func, slice.call(arguments, 1));
    if (!_.isFunction(func)) throw new TypeError('Bind must be called on a function');
    var args = slice.call(arguments, 2);
    var bound = function() {
      return executeBound(func, bound, context, this, args.concat(slice.call(arguments)));
    };
    return bound;
  };

  // Partially apply a function by creating a version that has had some of its
  // arguments pre-filled, without changing its dynamic `this` context. _ acts
  // as a placeholder, allowing any combination of arguments to be pre-filled.
  _.partial = function(func) {
    var boundArgs = slice.call(arguments, 1);
    var bound = function() {
      var position = 0, length = boundArgs.length;
      var args = Array(length);
      for (var i = 0; i < length; i++) {
        args[i] = boundArgs[i] === _ ? arguments[position++] : boundArgs[i];
      }
      while (position < arguments.length) args.push(arguments[position++]);
      return executeBound(func, bound, this, this, args);
    };
    return bound;
  };

  // Bind a number of an object's methods to that object. Remaining arguments
  // are the method names to be bound. Useful for ensuring that all callbacks
  // defined on an object belong to it.
  _.bindAll = function(obj) {
    var i, length = arguments.length, key;
    if (length <= 1) throw new Error('bindAll must be passed function names');
    for (i = 1; i < length; i++) {
      key = arguments[i];
      obj[key] = _.bind(obj[key], obj);
    }
    return obj;
  };

  // Memoize an expensive function by storing its results.
  _.memoize = function(func, hasher) {
    var memoize = function(key) {
      var cache = memoize.cache;
      var address = '' + (hasher ? hasher.apply(this, arguments) : key);
      if (!_.has(cache, address)) cache[address] = func.apply(this, arguments);
      return cache[address];
    };
    memoize.cache = {};
    return memoize;
  };

  // Delays a function for the given number of milliseconds, and then calls
  // it with the arguments supplied.
  _.delay = function(func, wait) {
    var args = slice.call(arguments, 2);
    return setTimeout(function(){
      return func.apply(null, args);
    }, wait);
  };

  // Defers a function, scheduling it to run after the current call stack has
  // cleared.
  _.defer = _.partial(_.delay, _, 1);

  // Returns a function, that, when invoked, will only be triggered at most once
  // during a given window of time. Normally, the throttled function will run
  // as much as it can, without ever going more than once per `wait` duration;
  // but if you'd like to disable the execution on the leading edge, pass
  // `{leading: false}`. To disable execution on the trailing edge, ditto.
  _.throttle = function(func, wait, options) {
    var context, args, result;
    var timeout = null;
    var previous = 0;
    if (!options) options = {};
    var later = function() {
      previous = options.leading === false ? 0 : _.now();
      timeout = null;
      result = func.apply(context, args);
      if (!timeout) context = args = null;
    };
    return function() {
      var now = _.now();
      if (!previous && options.leading === false) previous = now;
      var remaining = wait - (now - previous);
      context = this;
      args = arguments;
      if (remaining <= 0 || remaining > wait) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        previous = now;
        result = func.apply(context, args);
        if (!timeout) context = args = null;
      } else if (!timeout && options.trailing !== false) {
        timeout = setTimeout(later, remaining);
      }
      return result;
    };
  };

  // Returns a function, that, as long as it continues to be invoked, will not
  // be triggered. The function will be called after it stops being called for
  // N milliseconds. If `immediate` is passed, trigger the function on the
  // leading edge, instead of the trailing.
  _.debounce = function(func, wait, immediate) {
    var timeout, args, context, timestamp, result;

    var later = function() {
      var last = _.now() - timestamp;

      if (last < wait && last >= 0) {
        timeout = setTimeout(later, wait - last);
      } else {
        timeout = null;
        if (!immediate) {
          result = func.apply(context, args);
          if (!timeout) context = args = null;
        }
      }
    };

    return function() {
      context = this;
      args = arguments;
      timestamp = _.now();
      var callNow = immediate && !timeout;
      if (!timeout) timeout = setTimeout(later, wait);
      if (callNow) {
        result = func.apply(context, args);
        context = args = null;
      }

      return result;
    };
  };

  // Returns the first function passed as an argument to the second,
  // allowing you to adjust arguments, run code before and after, and
  // conditionally execute the original function.
  _.wrap = function(func, wrapper) {
    return _.partial(wrapper, func);
  };

  // Returns a negated version of the passed-in predicate.
  _.negate = function(predicate) {
    return function() {
      return !predicate.apply(this, arguments);
    };
  };

  // Returns a function that is the composition of a list of functions, each
  // consuming the return value of the function that follows.
  _.compose = function() {
    var args = arguments;
    var start = args.length - 1;
    return function() {
      var i = start;
      var result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  };

  // Returns a function that will only be executed on and after the Nth call.
  _.after = function(times, func) {
    return function() {
      if (--times < 1) {
        return func.apply(this, arguments);
      }
    };
  };

  // Returns a function that will only be executed up to (but not including) the Nth call.
  _.before = function(times, func) {
    var memo;
    return function() {
      if (--times > 0) {
        memo = func.apply(this, arguments);
      }
      if (times <= 1) func = null;
      return memo;
    };
  };

  // Returns a function that will be executed at most one time, no matter how
  // often you call it. Useful for lazy initialization.
  _.once = _.partial(_.before, 2);

  // Object Functions
  // ----------------

  // Keys in IE < 9 that won't be iterated by `for key in ...` and thus missed.
  var hasEnumBug = !{toString: null}.propertyIsEnumerable('toString');
  var nonEnumerableProps = ['valueOf', 'isPrototypeOf', 'toString',
                      'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString'];

  function collectNonEnumProps(obj, keys) {
    var nonEnumIdx = nonEnumerableProps.length;
    var constructor = obj.constructor;
    var proto = (_.isFunction(constructor) && constructor.prototype) || ObjProto;

    // Constructor is a special case.
    var prop = 'constructor';
    if (_.has(obj, prop) && !_.contains(keys, prop)) keys.push(prop);

    while (nonEnumIdx--) {
      prop = nonEnumerableProps[nonEnumIdx];
      if (prop in obj && obj[prop] !== proto[prop] && !_.contains(keys, prop)) {
        keys.push(prop);
      }
    }
  }

  // Retrieve the names of an object's own properties.
  // Delegates to **ECMAScript 5**'s native `Object.keys`
  _.keys = function(obj) {
    if (!_.isObject(obj)) return [];
    if (nativeKeys) return nativeKeys(obj);
    var keys = [];
    for (var key in obj) if (_.has(obj, key)) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve all the property names of an object.
  _.allKeys = function(obj) {
    if (!_.isObject(obj)) return [];
    var keys = [];
    for (var key in obj) keys.push(key);
    // Ahem, IE < 9.
    if (hasEnumBug) collectNonEnumProps(obj, keys);
    return keys;
  };

  // Retrieve the values of an object's properties.
  _.values = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var values = Array(length);
    for (var i = 0; i < length; i++) {
      values[i] = obj[keys[i]];
    }
    return values;
  };

  // Returns the results of applying the iteratee to each element of the object
  // In contrast to _.map it returns an object
  _.mapObject = function(obj, iteratee, context) {
    iteratee = cb(iteratee, context);
    var keys =  _.keys(obj),
          length = keys.length,
          results = {},
          currentKey;
      for (var index = 0; index < length; index++) {
        currentKey = keys[index];
        results[currentKey] = iteratee(obj[currentKey], currentKey, obj);
      }
      return results;
  };

  // Convert an object into a list of `[key, value]` pairs.
  _.pairs = function(obj) {
    var keys = _.keys(obj);
    var length = keys.length;
    var pairs = Array(length);
    for (var i = 0; i < length; i++) {
      pairs[i] = [keys[i], obj[keys[i]]];
    }
    return pairs;
  };

  // Invert the keys and values of an object. The values must be serializable.
  _.invert = function(obj) {
    var result = {};
    var keys = _.keys(obj);
    for (var i = 0, length = keys.length; i < length; i++) {
      result[obj[keys[i]]] = keys[i];
    }
    return result;
  };

  // Return a sorted list of the function names available on the object.
  // Aliased as `methods`
  _.functions = _.methods = function(obj) {
    var names = [];
    for (var key in obj) {
      if (_.isFunction(obj[key])) names.push(key);
    }
    return names.sort();
  };

  // Extend a given object with all the properties in passed-in object(s).
  _.extend = createAssigner(_.allKeys);

  // Assigns a given object with all the own properties in the passed-in object(s)
  // (https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Object/assign)
  _.extendOwn = _.assign = createAssigner(_.keys);

  // Returns the first key on an object that passes a predicate test
  _.findKey = function(obj, predicate, context) {
    predicate = cb(predicate, context);
    var keys = _.keys(obj), key;
    for (var i = 0, length = keys.length; i < length; i++) {
      key = keys[i];
      if (predicate(obj[key], key, obj)) return key;
    }
  };

  // Return a copy of the object only containing the whitelisted properties.
  _.pick = function(object, oiteratee, context) {
    var result = {}, obj = object, iteratee, keys;
    if (obj == null) return result;
    if (_.isFunction(oiteratee)) {
      keys = _.allKeys(obj);
      iteratee = optimizeCb(oiteratee, context);
    } else {
      keys = flatten(arguments, false, false, 1);
      iteratee = function(value, key, obj) { return key in obj; };
      obj = Object(obj);
    }
    for (var i = 0, length = keys.length; i < length; i++) {
      var key = keys[i];
      var value = obj[key];
      if (iteratee(value, key, obj)) result[key] = value;
    }
    return result;
  };

   // Return a copy of the object without the blacklisted properties.
  _.omit = function(obj, iteratee, context) {
    if (_.isFunction(iteratee)) {
      iteratee = _.negate(iteratee);
    } else {
      var keys = _.map(flatten(arguments, false, false, 1), String);
      iteratee = function(value, key) {
        return !_.contains(keys, key);
      };
    }
    return _.pick(obj, iteratee, context);
  };

  // Fill in a given object with default properties.
  _.defaults = createAssigner(_.allKeys, true);

  // Creates an object that inherits from the given prototype object.
  // If additional properties are provided then they will be added to the
  // created object.
  _.create = function(prototype, props) {
    var result = baseCreate(prototype);
    if (props) _.extendOwn(result, props);
    return result;
  };

  // Create a (shallow-cloned) duplicate of an object.
  _.clone = function(obj) {
    if (!_.isObject(obj)) return obj;
    return _.isArray(obj) ? obj.slice() : _.extend({}, obj);
  };

  // Invokes interceptor with the obj, and then returns obj.
  // The primary purpose of this method is to "tap into" a method chain, in
  // order to perform operations on intermediate results within the chain.
  _.tap = function(obj, interceptor) {
    interceptor(obj);
    return obj;
  };

  // Returns whether an object has a given set of `key:value` pairs.
  _.isMatch = function(object, attrs) {
    var keys = _.keys(attrs), length = keys.length;
    if (object == null) return !length;
    var obj = Object(object);
    for (var i = 0; i < length; i++) {
      var key = keys[i];
      if (attrs[key] !== obj[key] || !(key in obj)) return false;
    }
    return true;
  };


  // Internal recursive comparison function for `isEqual`.
  var eq = function(a, b, aStack, bStack) {
    // Identical objects are equal. `0 === -0`, but they aren't identical.
    // See the [Harmony `egal` proposal](http://wiki.ecmascript.org/doku.php?id=harmony:egal).
    if (a === b) return a !== 0 || 1 / a === 1 / b;
    // A strict comparison is necessary because `null == undefined`.
    if (a == null || b == null) return a === b;
    // Unwrap any wrapped objects.
    if (a instanceof _) a = a._wrapped;
    if (b instanceof _) b = b._wrapped;
    // Compare `[[Class]]` names.
    var className = toString.call(a);
    if (className !== toString.call(b)) return false;
    switch (className) {
      // Strings, numbers, regular expressions, dates, and booleans are compared by value.
      case '[object RegExp]':
      // RegExps are coerced to strings for comparison (Note: '' + /a/i === '/a/i')
      case '[object String]':
        // Primitives and their corresponding object wrappers are equivalent; thus, `"5"` is
        // equivalent to `new String("5")`.
        return '' + a === '' + b;
      case '[object Number]':
        // `NaN`s are equivalent, but non-reflexive.
        // Object(NaN) is equivalent to NaN
        if (+a !== +a) return +b !== +b;
        // An `egal` comparison is performed for other numeric values.
        return +a === 0 ? 1 / +a === 1 / b : +a === +b;
      case '[object Date]':
      case '[object Boolean]':
        // Coerce dates and booleans to numeric primitive values. Dates are compared by their
        // millisecond representations. Note that invalid dates with millisecond representations
        // of `NaN` are not equivalent.
        return +a === +b;
    }

    var areArrays = className === '[object Array]';
    if (!areArrays) {
      if (typeof a != 'object' || typeof b != 'object') return false;

      // Objects with different constructors are not equivalent, but `Object`s or `Array`s
      // from different frames are.
      var aCtor = a.constructor, bCtor = b.constructor;
      if (aCtor !== bCtor && !(_.isFunction(aCtor) && aCtor instanceof aCtor &&
                               _.isFunction(bCtor) && bCtor instanceof bCtor)
                          && ('constructor' in a && 'constructor' in b)) {
        return false;
      }
    }
    // Assume equality for cyclic structures. The algorithm for detecting cyclic
    // structures is adapted from ES 5.1 section 15.12.3, abstract operation `JO`.

    // Initializing stack of traversed objects.
    // It's done here since we only need them for objects and arrays comparison.
    aStack = aStack || [];
    bStack = bStack || [];
    var length = aStack.length;
    while (length--) {
      // Linear search. Performance is inversely proportional to the number of
      // unique nested structures.
      if (aStack[length] === a) return bStack[length] === b;
    }

    // Add the first object to the stack of traversed objects.
    aStack.push(a);
    bStack.push(b);

    // Recursively compare objects and arrays.
    if (areArrays) {
      // Compare array lengths to determine if a deep comparison is necessary.
      length = a.length;
      if (length !== b.length) return false;
      // Deep compare the contents, ignoring non-numeric properties.
      while (length--) {
        if (!eq(a[length], b[length], aStack, bStack)) return false;
      }
    } else {
      // Deep compare objects.
      var keys = _.keys(a), key;
      length = keys.length;
      // Ensure that both objects contain the same number of properties before comparing deep equality.
      if (_.keys(b).length !== length) return false;
      while (length--) {
        // Deep compare each member
        key = keys[length];
        if (!(_.has(b, key) && eq(a[key], b[key], aStack, bStack))) return false;
      }
    }
    // Remove the first object from the stack of traversed objects.
    aStack.pop();
    bStack.pop();
    return true;
  };

  // Perform a deep comparison to check if two objects are equal.
  _.isEqual = function(a, b) {
    return eq(a, b);
  };

  // Is a given array, string, or object empty?
  // An "empty" object has no enumerable own-properties.
  _.isEmpty = function(obj) {
    if (obj == null) return true;
    if (isArrayLike(obj) && (_.isArray(obj) || _.isString(obj) || _.isArguments(obj))) return obj.length === 0;
    return _.keys(obj).length === 0;
  };

  // Is a given value a DOM element?
  _.isElement = function(obj) {
    return !!(obj && obj.nodeType === 1);
  };

  // Is a given value an array?
  // Delegates to ECMA5's native Array.isArray
  _.isArray = nativeIsArray || function(obj) {
    return toString.call(obj) === '[object Array]';
  };

  // Is a given variable an object?
  _.isObject = function(obj) {
    var type = typeof obj;
    return type === 'function' || type === 'object' && !!obj;
  };

  // Add some isType methods: isArguments, isFunction, isString, isNumber, isDate, isRegExp, isError.
  _.each(['Arguments', 'Function', 'String', 'Number', 'Date', 'RegExp', 'Error'], function(name) {
    _['is' + name] = function(obj) {
      return toString.call(obj) === '[object ' + name + ']';
    };
  });

  // Define a fallback version of the method in browsers (ahem, IE < 9), where
  // there isn't any inspectable "Arguments" type.
  if (!_.isArguments(arguments)) {
    _.isArguments = function(obj) {
      return _.has(obj, 'callee');
    };
  }

  // Optimize `isFunction` if appropriate. Work around some typeof bugs in old v8,
  // IE 11 (#1621), and in Safari 8 (#1929).
  if (typeof /./ != 'function' && typeof Int8Array != 'object') {
    _.isFunction = function(obj) {
      return typeof obj == 'function' || false;
    };
  }

  // Is a given object a finite number?
  _.isFinite = function(obj) {
    return isFinite(obj) && !isNaN(parseFloat(obj));
  };

  // Is the given value `NaN`? (NaN is the only number which does not equal itself).
  _.isNaN = function(obj) {
    return _.isNumber(obj) && obj !== +obj;
  };

  // Is a given value a boolean?
  _.isBoolean = function(obj) {
    return obj === true || obj === false || toString.call(obj) === '[object Boolean]';
  };

  // Is a given value equal to null?
  _.isNull = function(obj) {
    return obj === null;
  };

  // Is a given variable undefined?
  _.isUndefined = function(obj) {
    return obj === void 0;
  };

  // Shortcut function for checking if an object has a given property directly
  // on itself (in other words, not on a prototype).
  _.has = function(obj, key) {
    return obj != null && hasOwnProperty.call(obj, key);
  };

  // Utility Functions
  // -----------------

  // Run Underscore.js in *noConflict* mode, returning the `_` variable to its
  // previous owner. Returns a reference to the Underscore object.
  _.noConflict = function() {
    root._ = previousUnderscore;
    return this;
  };

  // Keep the identity function around for default iteratees.
  _.identity = function(value) {
    return value;
  };

  // Predicate-generating functions. Often useful outside of Underscore.
  _.constant = function(value) {
    return function() {
      return value;
    };
  };

  _.noop = function(){};

  _.property = property;

  // Generates a function for a given object that returns a given property.
  _.propertyOf = function(obj) {
    return obj == null ? function(){} : function(key) {
      return obj[key];
    };
  };

  // Returns a predicate for checking whether an object has a given set of
  // `key:value` pairs.
  _.matcher = _.matches = function(attrs) {
    attrs = _.extendOwn({}, attrs);
    return function(obj) {
      return _.isMatch(obj, attrs);
    };
  };

  // Run a function **n** times.
  _.times = function(n, iteratee, context) {
    var accum = Array(Math.max(0, n));
    iteratee = optimizeCb(iteratee, context, 1);
    for (var i = 0; i < n; i++) accum[i] = iteratee(i);
    return accum;
  };

  // Return a random integer between min and max (inclusive).
  _.random = function(min, max) {
    if (max == null) {
      max = min;
      min = 0;
    }
    return min + Math.floor(Math.random() * (max - min + 1));
  };

  // A (possibly faster) way to get the current timestamp as an integer.
  _.now = Date.now || function() {
    return new Date().getTime();
  };

   // List of HTML entities for escaping.
  var escapeMap = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#x27;',
    '`': '&#x60;'
  };
  var unescapeMap = _.invert(escapeMap);

  // Functions for escaping and unescaping strings to/from HTML interpolation.
  var createEscaper = function(map) {
    var escaper = function(match) {
      return map[match];
    };
    // Regexes for identifying a key that needs to be escaped
    var source = '(?:' + _.keys(map).join('|') + ')';
    var testRegexp = RegExp(source);
    var replaceRegexp = RegExp(source, 'g');
    return function(string) {
      string = string == null ? '' : '' + string;
      return testRegexp.test(string) ? string.replace(replaceRegexp, escaper) : string;
    };
  };
  _.escape = createEscaper(escapeMap);
  _.unescape = createEscaper(unescapeMap);

  // If the value of the named `property` is a function then invoke it with the
  // `object` as context; otherwise, return it.
  _.result = function(object, property, fallback) {
    var value = object == null ? void 0 : object[property];
    if (value === void 0) {
      value = fallback;
    }
    return _.isFunction(value) ? value.call(object) : value;
  };

  // Generate a unique integer id (unique within the entire client session).
  // Useful for temporary DOM ids.
  var idCounter = 0;
  _.uniqueId = function(prefix) {
    var id = ++idCounter + '';
    return prefix ? prefix + id : id;
  };

  // By default, Underscore uses ERB-style template delimiters, change the
  // following template settings to use alternative delimiters.
  _.templateSettings = {
    evaluate    : /<%([\s\S]+?)%>/g,
    interpolate : /<%=([\s\S]+?)%>/g,
    escape      : /<%-([\s\S]+?)%>/g
  };

  // When customizing `templateSettings`, if you don't want to define an
  // interpolation, evaluation or escaping regex, we need one that is
  // guaranteed not to match.
  var noMatch = /(.)^/;

  // Certain characters need to be escaped so that they can be put into a
  // string literal.
  var escapes = {
    "'":      "'",
    '\\':     '\\',
    '\r':     'r',
    '\n':     'n',
    '\u2028': 'u2028',
    '\u2029': 'u2029'
  };

  var escaper = /\\|'|\r|\n|\u2028|\u2029/g;

  var escapeChar = function(match) {
    return '\\' + escapes[match];
  };

  // JavaScript micro-templating, similar to John Resig's implementation.
  // Underscore templating handles arbitrary delimiters, preserves whitespace,
  // and correctly escapes quotes within interpolated code.
  // NB: `oldSettings` only exists for backwards compatibility.
  _.template = function(text, settings, oldSettings) {
    if (!settings && oldSettings) settings = oldSettings;
    settings = _.defaults({}, settings, _.templateSettings);

    // Combine delimiters into one regular expression via alternation.
    var matcher = RegExp([
      (settings.escape || noMatch).source,
      (settings.interpolate || noMatch).source,
      (settings.evaluate || noMatch).source
    ].join('|') + '|$', 'g');

    // Compile the template source, escaping string literals appropriately.
    var index = 0;
    var source = "__p+='";
    text.replace(matcher, function(match, escape, interpolate, evaluate, offset) {
      source += text.slice(index, offset).replace(escaper, escapeChar);
      index = offset + match.length;

      if (escape) {
        source += "'+\n((__t=(" + escape + "))==null?'':_.escape(__t))+\n'";
      } else if (interpolate) {
        source += "'+\n((__t=(" + interpolate + "))==null?'':__t)+\n'";
      } else if (evaluate) {
        source += "';\n" + evaluate + "\n__p+='";
      }

      // Adobe VMs need the match returned to produce the correct offest.
      return match;
    });
    source += "';\n";

    // If a variable is not specified, place data values in local scope.
    if (!settings.variable) source = 'with(obj||{}){\n' + source + '}\n';

    source = "var __t,__p='',__j=Array.prototype.join," +
      "print=function(){__p+=__j.call(arguments,'');};\n" +
      source + 'return __p;\n';

    try {
      var render = new Function(settings.variable || 'obj', '_', source);
    } catch (e) {
      e.source = source;
      throw e;
    }

    var template = function(data) {
      return render.call(this, data, _);
    };

    // Provide the compiled source as a convenience for precompilation.
    var argument = settings.variable || 'obj';
    template.source = 'function(' + argument + '){\n' + source + '}';

    return template;
  };

  // Add a "chain" function. Start chaining a wrapped Underscore object.
  _.chain = function(obj) {
    var instance = _(obj);
    instance._chain = true;
    return instance;
  };

  // OOP
  // ---------------
  // If Underscore is called as a function, it returns a wrapped object that
  // can be used OO-style. This wrapper holds altered versions of all the
  // underscore functions. Wrapped objects may be chained.

  // Helper function to continue chaining intermediate results.
  var result = function(instance, obj) {
    return instance._chain ? _(obj).chain() : obj;
  };

  // Add your own custom functions to the Underscore object.
  _.mixin = function(obj) {
    _.each(_.functions(obj), function(name) {
      var func = _[name] = obj[name];
      _.prototype[name] = function() {
        var args = [this._wrapped];
        push.apply(args, arguments);
        return result(this, func.apply(_, args));
      };
    });
  };

  // Add all of the Underscore functions to the wrapper object.
  _.mixin(_);

  // Add all mutator Array functions to the wrapper.
  _.each(['pop', 'push', 'reverse', 'shift', 'sort', 'splice', 'unshift'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      var obj = this._wrapped;
      method.apply(obj, arguments);
      if ((name === 'shift' || name === 'splice') && obj.length === 0) delete obj[0];
      return result(this, obj);
    };
  });

  // Add all accessor Array functions to the wrapper.
  _.each(['concat', 'join', 'slice'], function(name) {
    var method = ArrayProto[name];
    _.prototype[name] = function() {
      return result(this, method.apply(this._wrapped, arguments));
    };
  });

  // Extracts the result from a wrapped and chained object.
  _.prototype.value = function() {
    return this._wrapped;
  };

  // Provide unwrapping proxy for some methods used in engine operations
  // such as arithmetic and JSON stringification.
  _.prototype.valueOf = _.prototype.toJSON = _.prototype.value;

  _.prototype.toString = function() {
    return '' + this._wrapped;
  };

  // AMD registration happens at the end for compatibility with AMD loaders
  // that may not enforce next-turn semantics on modules. Even though general
  // practice for AMD registration is to be anonymous, underscore registers
  // as a named module because, like jQuery, it is a base library that is
  // popular enough to be bundled in a third party lib, but not be part of
  // an AMD load request. Those cases could generate an error when an
  // anonymous define() is called outside of a loader request.
  if (true) {
    !(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
      return _;
    }.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
  }
}.call(this));


/***/ }),

/***/ 621:
/***/ (function(module, exports) {

(function ($) {
    $.Device = {
        isIPad: /ipad/i.test(navigator.userAgent.toLowerCase()),
        isIPhone: /iphone/i.test(navigator.userAgent.toLowerCase()),
        isIPod: /ipod/i.test(navigator.userAgent.toLowerCase()),
        isIDevice: /ipad|iphone|ipod/i.test(navigator.userAgent.toLowerCase()),
        isAndroid: /android/i.test(navigator.userAgent.toLowerCase()),
        isBlackBerry: /blackberry/i.test(navigator.userAgent.toLowerCase()),
        isWebOS: /webos/i.test(navigator.userAgent.toLowerCase()),
        isWindowsPhone: /windows phone/i.test(navigator.userAgent.toLowerCase()),
        isMobile: function (a) {
            return /android|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(ad|hone|od)|iris|kindle|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|symbian|tablet|treo|up\.(browser|link)|vodafone|wap|webos|windows (ce|phone)|xda|xiino/i.test(a) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|e\-|e\/|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(di|rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|xda(\-|2|g)|yas\-|your|zeto|zte\-/i.test(a.substr(0, 4));
        }
    };
})(jQuery);


/***/ }),

/***/ 625:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return abTestOpenSections; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return propertyDetailsAHListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return propertyDetailsSetStorage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return addOpenPanelsABTracking; });
var $propertyDetailsAH = $("#aj-qv-sec-property-details").find(".accordion-heading"),
    $openHouseAH = $("#aj-qv-open-house").find(".accordion-heading");

var abTestOpenSections = function abTestOpenSections() {
  var sections = void 0;
  if (MOVE.LocalStorage.isAvailable) {
    if (MOVE_DATA.ab_qv_open_card === "V1") {
      sections = '#collapse-open-house';
    } else if (MOVE_DATA.ab_qv_open_card === "V2") {
      sections = '#collapse-open-house, #collapse-property-details';
    }
  }
  return sections;
};

var propertyDetailsAHListener = function propertyDetailsAHListener() {
  $propertyDetailsAH.click(function () {
    if (MOVE_DATA.ab_qv_open_card === "V1" && !$propertyDetailsAH.hasClass("collapsed")) {
      var isOHOpen = localStorage.getItem('quickview-sections') === "#collapse-open-house";
      if (isOHOpen) {
        var localStorageItems = localStorage.getItem('quickview-sections');
        localStorage.setItem('quickview-sections', [localStorageItems, "#collapse-property-details"].join(","));
      }
    }
  });
};

var propertyDetailsSetStorage = function propertyDetailsSetStorage() {
  $propertyDetailsAH.click(function () {
    if (MOVE_DATA.ab_qv_open_card === "V1" && !$propertyDetailsAH.hasClass("collapsed")) {
      var isOHOpen = localStorage.getItem('quickview-sections') === "#collapse-open-house";
      if (isOHOpen) {
        var localStorageItems = localStorage.getItem('quickview-sections');
        localStorage.setItem('quickview-sections', [localStorageItems, "#collapse-property-details"].join(","));
      }
    }
  });
};

var addOpenPanelsABTracking = function addOpenPanelsABTracking() {
  var trackingSections = "no_sections_open";
  if ($propertyDetailsAH && !$propertyDetailsAH.hasClass("collapsed")) trackingSections = "collapse-property-details";
  if ($openHouseAH && !$openHouseAH.hasClass("collapsed")) trackingSections = "collapse-open-house";
  if ($propertyDetailsAH && $openHouseAH) {
    if (!$propertyDetailsAH.hasClass("collapsed") && !$openHouseAH.hasClass("collapsed")) trackingSections = "collapse-open-house, collapse-property-details";
  }
  return trackingSections;
};

/***/ }),

/***/ 626:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return trackPhoneLead; });
/* global RdcTracking */

var trackPhoneLead = function trackPhoneLead(propertyStatus, leadDelivery, leadPlacement, dataSourceType) {
  var linkName = 'web:ldp:leads:phone:' + propertyStatus + ':' + leadDelivery;
  var rentalDataSource = propertyStatus === 'for_rent' ? dataSourceType : '';
  var props = { linkName: linkName, phoneLeads: linkName, leadPlacement: leadPlacement, rentalDataSource: rentalDataSource };
  var evt = void 0;
  if (propertyStatus === 'for_sale') {
    if (['showcase', 'advantage_pro'].includes(leadDelivery)) {
      evt = "forSaleAdvantagePhoneLead";
    } else if (['cobroke', 'co_broke'].includes(leadDelivery)) {
      evt = "forSaleCobrokePhoneLead";
    }
  } else if (propertyStatus === 'for_rent') {
    if (leadDelivery === 'basic') {
      evt = "rentalBasicPhoneLead";
    } else if (['showcase', 'advantage_pro'].includes(leadDelivery)) {
      evt = "rentalShowcasePhoneLead";
    }
  }
  RdcTracking.trackEvent(evt, props);
};

/***/ }),

/***/ 650:
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),

/***/ 674:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return loadScript; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_shared_critical_tracking_pages_ldp_ldp_page_load__ = __webpack_require__(585);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_shared_critical_instant_app_detection__ = __webpack_require__(1027);



function showDisabledCookieInformation() {
  if (navigator.cookieEnabled === false) {
    $('#notification-cookies').removeClass('no-show');
  }
};

function sync_load(first, second) {
  if (first && second) {
    loadScript(first).done(function () {
      loadScript(second);
    });
  }
}

function downloadJSAtOnload(scriptsToLoad) {
  var sync_scripts = [];
  if (scriptsToLoad.length === 1) {
    return loadScript(scriptsToLoad[0]);
  }
  while (scriptsToLoad.length > 0) {
    sync_scripts.push(scriptsToLoad.splice(0, 2));
  }
  $.each(sync_scripts, function (i, v) {
    sync_load(v[0], v[1]);
  });
}

function lazyLoadJs(scriptsToLoad) {
  MOVE.logger.debug('loading', scriptsToLoad);
  var pageType = MOVE.DOMHelper.detectPageType();
  //check to load scripts non lazily for edge browser
  //This is a hack since few specific version(s) of edge browsers
  //are not firing load event.So the only alternate is to depend upon
  //DOMContentLoaded and give time of 300ms and load non critical scripts.
  //Edge should gracefully fix this in near future and we should revert this.
  if (/Edge/.test(navigator.userAgent) && pageType == "srp") {
    window.addEventListener("DOMContentLoaded", function () {
      window.setTimeout(function () {
        lazyScriptsLoad(scriptsToLoad);
      }, 600);
    });
  } else if (window.addEventListener) {
    window.addEventListener("load", function () {
      lazyScriptsLoad(scriptsToLoad);
    });
  }
}

function lazyScriptsLoad(scriptsToLoad) {
  downloadJSAtOnload(scriptsToLoad);
  MOVE.CalculatePageLoadTime.init();
}

function setPerformanceDtm() {
  if (MOVE_DATA.adobeDTM) {
    MOVE_DATA.adobeDTM.getPerformance = function () {
      return {
        timeToLoadStart: getPerformance('navigationStart', 'loadEventStart'),
        timeToLoadEnd: getPerformance('navigationStart', 'loadEventEnd')
      };
    };
  }
}

function getPerformance(start, end) {
  if (window.performance && window.performance.timing) {
    var time = 0;
    if (window.performance.timing[end] !== 0) {
      time = window.performance.timing[end] - window.performance.timing[start];
    }
    return {
      time: time,
      startEvent: start,
      endEvent: end
    };
  }
}

function init() {
  var pageType = MOVE.DOMHelper.detectPageType();

  if (pageType === 'ldp') {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0_shared_critical_tracking_pages_ldp_ldp_page_load__["a" /* setupLdpPageTracking */])();
  }

  setPerformanceDtm();

  MOVE.performanceMark('critical_init_start');

  showDisabledCookieInformation();

  _.forEach(workarounds, function (workaround) {
    workaround.init();
  });

  // Initialize page specific scripts.
  switch (pageType) {
    case 'ldp':
      // Load Building page js if it is builing.
      if (MOVE_DATA.is_building) {
        MOVE.BDP.init();
        MOVE.BDP.Building.init();
      } else {
        MOVE.LDP.init();
        MOVE.LDP.PropertyDetails.init();
      }

      break;
    case 'srp':
      MOVE.SRP.init();
      MOVE.SRP.SearchResults.init();
      break;
    case 'hp':
      MOVE.HOMEPAGE.init();
      MOVE.HOMEPAGE.HomePageSearch.init();
      break;
    case 'local':
      MOVE.LOCAL.init();
      break;
    case 'sell':
      MOVE.SELL.init();
      break;
    case 'property_records':
      MOVE.PropertyRecords.init();
      MOVE.PropertyRecords.page.init();
      break;
    case 'news_and_advice':
      MOVE.ARTICLE.init();
      break;
    default:
      break;
  }

  lazyLoadJs(MOVE.DataStore.getData('app_js'));

  if (MOVE.DataStore.getData('isIosOrAndroid')) {
    MOVE.CustomSmartbanner.init();
  }

  if (MOVE_DATA.isAndroid && ['srp', 'ldp'].indexOf(MOVE_DATA.pageType) >= 0) {
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1_shared_critical_instant_app_detection__["a" /* default */])(loadScript);
  }

  // initialize the Qualtrics JS only when any of the A/B tests are running
  if ($("#qualtrics_feedback").length) {
    MOVE.FeedbackForABTests.init();
  }

  /* eslint-disable*/
  //setting Foresee Invite Cookie
  $(window).on('load', function () {
    invokeForseeSnippet();
  });

  function setForeseeCookie() {
    fsReady(function () {
      FSR.onInviteShown.subscribe(function () {
        document.cookie = "FS_Survey=true; path=/";
      }, true, true);
    });
  }

  function invokeForseeSnippet() {
    setTimeout(function () {
      try {
        setForeseeCookie();
      } catch (err) {
        console.log(err);
      }
    }, 6000);
  }
  /* eslint-enable */

  MOVE.UserProfileLeadInputs.setLeadInputs();

  MOVE.performanceMark('critical_init_end');
};

function performanceMark(name) {
  if (window.performance && window.performance.mark) {
    window.performance.mark(name);
  }
};

var workarounds = [];
function addWorkaround(module) {
  workarounds.push(module);
};

window.MOVE = {
  site: "renovate",
  addWorkaround: addWorkaround,
  init: init,
  lazyLoadJs: lazyLoadJs,
  performanceMark: performanceMark
};

var loadScript = function loadScript(url) {
  var loaded = $.Deferred();
  var script = document.createElement("script");
  script.type = "text/javascript";
  if (script.readyState) {
    //IE
    script.onreadystatechange = function () {
      if (script.readyState === "loaded" || script.readyState === "complete") {
        script.onreadystatechange = null;
        loaded.resolve(true);
      }
    };
  } else {
    //Others
    script.onload = function () {
      loaded.resolve(true);
    };

    script.onerror = function (event) {
      return loaded.reject(event);
    };
  }
  script.src = url;
  document.body.appendChild(script);
  return loaded;
};

/***/ }),

/***/ 71:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_keys__ = __webpack_require__(24);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__format_helper__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants_index__ = __webpack_require__(1540);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__constants_index__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__constants_index__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__constants_index__["c"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_2__constants_index__["d"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__constants_index__["e"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__constants_index__["f"]; });




MOVE.CONSTANTS = function (MOVE) {

  var PRICE_FACET_PIVOT_VALUE = 1 / 4;
  var DEFAULT_MEDIAN_PRICE_FOR_SALE = 200000;
  var DEFAULT_MEDIAN_PRICE_FOR_RENT = 1111;
  var LOADING_ICON = '<span class="loading-graphic"></span>';
  var LOADING_ICON_CLASS = 'loading-graphic';
  var CACHED_USER_INPUT_STOREAGE_NAME = 'user_lead_inputs';
  var CACHED_USER_PROFILE_LEAD_INPUTS = 'user_profile_lead_inputs';
  var DEFAULT_LAZY_LOADING_IMG_OPTIONS = {
    visibleOnly: false,
    edgeY: 600,
    throttle: 100
  };
  var DEFAULT_ZOOM = 10;
  var DEFAULT_PIN_HEIGHT = 25;

  var IS_IPAD = navigator.userAgent.match(/iPad/i) !== null;

  var DEFAULT_LANDING_PAGE_LOCATION = 'San Francisco, CA';
  var LANDING_PAGE_DEFAULT_CARD_SIZE = '5';
  var DEFAULT_FACET_PAGE_TYPE = 'srp-list';

  var LANDER_FS_NEW_LISTING_CARD = 'fs_new_listing';
  var LANDER_FS_OPEN_HOUSE_CARD = 'fs_open_house';
  var LANDER_FS_MEDIAN_HOMES_CARD = 'fs_median_homes';
  var LANDER_FS_LUXURY_HOMES_CARD = 'fs_luxury_homes';
  var LANDER_FS_AFFORD_HOMES_CARD = 'fs_affordable_homes';
  var LANDER_FS_PRICE_REDUCED_CARD = 'fs_pricereduced_homes';
  var LANDER_FS_FORECLOSURE_CARD = 'fs_foreclosure_homes';
  var LANDER_FS_NEW_HOMES_CARD = 'fs_new_homes';
  var LANDER_FS_NEW_CONSTRUCTION_CARD = 'fs_new_construction';
  var LANDER_FR_PET_FRIENDLY_CARD = 'fr_pet_friendly';
  var LANDER_FR_WITH_POOL_CARD = 'fr_listings_with_pool';
  var LANDER_FR_WITH_LAUNDRY_CARD = 'fr_listings_with_laundry';
  var LANDER_FR_RECREATION_FACILITIES_CARD = 'fr_recreation_facilities';
  var LANDER_FR_STUDIO_APARTMENTS_CARD = 'fr_studio_apartments';
  var LANDER_FR_RENTAL_HOMES_CARD = 'fr_rental_homes';
  var LANDER_RS_JUST_SOLD_CARD = 'rs_just_sold_homes';
  var LANDER_RS_MEDIAN_HOMES_CARD = 'rs_median_homes';
  var LANDER_RS_LUXURY_HOMES_CARD = 'rs_luxury_homes';
  var LANDER_RS_AFFORD_HOMES_CARD = 'rs_affordable_homes';
  var GET_NORESULTS_ZOOM = 2;

  var RDC_URL_STEMS = {
    LOCAL: 'local',
    MORTGAGE: 'mortgage'
  };

  var ALLOWED_SCHOOL_PAGETYPE = ['ldp', 'landers_sale', 'hp'];

  var PROPERTY_STATUS = {
    forSale: 'for_sale',
    forRent: 'for_rent',
    recentlySold: 'recently_sold',
    propertyRecords: 'property_records',
    newCommunity: 'new_community',
    newPlan: 'new_plan',
    foreclosure: 'foreclosure'
  };

  var PROPERTY_TYPE_MAPPING = {
    'single-family-home': 'single_family',
    'condo-townhome-row-home-co-op': 'condo',
    'farms-ranches': 'farm',
    'land': 'land',
    'multi-family-home': 'multi_family'
  };

  var PROPERTY_SEARCH_STATUS = {
    'Search::PropertiesController': 'for_sale',
    'Search::NewCommunitiesController': 'new_home',
    'Search::RecentlySoldController': 'not_for_sale',
    'Search::NewConstructionController': 'for_sale',
    'Search::ForeclosuresController': 'for_sale',
    'Search::ApartmentsController': 'rental',
    'Search::HomesForRentController': 'rental'
  };

  var LDP_PROPERTY_TYPES = {
    new_community: 'new_home_community',
    new_plan: 'new_home_community'
  };

  var LDP_SUB_PROPERTY_TYPES = {
    new_community: '',
    new_plan: 'new_home_plan',
    for_rent: 'rental'
  };

  var LANDING_PAGE_SUB_DIRS = {
    forSale: 'realestateforsale',
    forRent: 'rentals'
  };

  // Please make sure to change this constant file whenever any changes are
  //made to the search controller names.
  var SEARCH_CONTROLLER_TYPE = {
    forSale: 'Search::PropertiesController',
    forRent: 'Search::ApartmentsController',
    recentlySold: 'Search::RecentlySoldController',
    propertyRecords: 'PropertyRecordsController',
    newCommunity: 'Search::NewCommunitiesController',
    newPlan: 'Search::NewConstructionController',
    foreclosure: 'Search::ForeclosuresController'
  };

  var ADVERTISER_FORM_NAME_MAPPING = {
    'Listing Agent': 'business_card',
    'Listing Broker': 'business_card',
    'office': 'listing_provider'
  };

  var ADVERTISER_TARGET_MAPPING = {
    'Listing Agent': 'seller_agent',
    'Listing Broker': 'seller_office',
    'office': 'seller_office'
  };

  var SRP_PAGINATION_MAX_PROPERTY_NUMBER = 9900;
  var PROP_TYPE_VALUE_TO_CRIT_MAPPING = {
    single_family: 'single-family-home',
    townhome: 'townhouse',
    condo: 'condo-townhome-row-home-co-op',
    mobile: 'mfd-mobile-home',
    farm: 'farms-ranches',
    land: 'land',
    multi_family: 'multi-family-home',
    apartments: 'apartments',
    others: 'others',
    condo_townhome: 'condo_townhome',
    coop: 'coop'
  };

  var PROP_TYPE_CRIT_TO_VALUE_MAPPING = {
    'single-family-home': 'single_family',
    'townhouse': 'townhome',
    'condo-townhome-row-home-co-op': 'condo',
    'mfd-mobile-home': 'mobile',
    'farms-ranches': 'farm',
    'land': 'land',
    'multi-family-home': 'multi_family',
    'apartments': 'apartments',
    'others': 'others',
    'condo_townhome': 'condo_townhome',
    'coop': 'coop'
  };

  MOVE.CONSTANTS = {
    LOADING_ICON: LOADING_ICON,
    LOADING_ICON_CLASS: LOADING_ICON_CLASS,
    IS_IPAD: IS_IPAD,
    DEFAULT_LAZY_LOADING_IMG_OPTIONS: DEFAULT_LAZY_LOADING_IMG_OPTIONS,
    PROPERTY_STATUS: PROPERTY_STATUS,
    PROPERTY_SEARCH_STATUS: PROPERTY_SEARCH_STATUS,
    LANDING_PAGE_SUB_DIRS: LANDING_PAGE_SUB_DIRS,
    LDP_PROPERTY_TYPES: LDP_PROPERTY_TYPES,
    SEARCH_CONTROLLER_TYPE: SEARCH_CONTROLLER_TYPE,
    PRICE_FACET_PIVOT_VALUE: PRICE_FACET_PIVOT_VALUE,
    DEFAULT_MEDIAN_PRICE_FOR_SALE: DEFAULT_MEDIAN_PRICE_FOR_SALE,
    DEFAULT_MEDIAN_PRICE_FOR_RENT: DEFAULT_MEDIAN_PRICE_FOR_RENT,
    DEFAULT_ZOOM: DEFAULT_ZOOM,
    DEFAULT_PIN_HEIGHT: DEFAULT_PIN_HEIGHT,
    LDP_SUB_PROPERTY_TYPES: LDP_SUB_PROPERTY_TYPES,
    RDC_URL_STEMS: RDC_URL_STEMS,
    PROPERTY_TYPE_MAPPING: PROPERTY_TYPE_MAPPING,
    CACHED_USER_INPUT_STOREAGE_NAME: CACHED_USER_INPUT_STOREAGE_NAME,
    CACHED_USER_PROFILE_LEAD_INPUTS: CACHED_USER_PROFILE_LEAD_INPUTS,
    ADVERTISER_FORM_NAME_MAPPING: ADVERTISER_FORM_NAME_MAPPING,
    ADVERTISER_TARGET_MAPPING: ADVERTISER_TARGET_MAPPING,
    DEFAULT_LANDING_PAGE_LOCATION: DEFAULT_LANDING_PAGE_LOCATION,
    LANDING_PAGE_DEFAULT_CARD_SIZE: LANDING_PAGE_DEFAULT_CARD_SIZE,
    DEFAULT_FACET_PAGE_TYPE: DEFAULT_FACET_PAGE_TYPE,
    LANDER_FS_NEW_LISTING_CARD: LANDER_FS_NEW_LISTING_CARD,
    LANDER_FS_OPEN_HOUSE_CARD: LANDER_FS_OPEN_HOUSE_CARD,
    LANDER_FS_NEW_HOMES_CARD: LANDER_FS_NEW_HOMES_CARD,
    LANDER_FS_MEDIAN_HOMES_CARD: LANDER_FS_MEDIAN_HOMES_CARD,
    LANDER_FS_LUXURY_HOMES_CARD: LANDER_FS_LUXURY_HOMES_CARD,
    LANDER_FS_AFFORD_HOMES_CARD: LANDER_FS_AFFORD_HOMES_CARD,
    LANDER_FR_PET_FRIENDLY_CARD: LANDER_FR_PET_FRIENDLY_CARD,
    LANDER_FR_WITH_POOL_CARD: LANDER_FR_WITH_POOL_CARD,
    LANDER_FR_WITH_LAUNDRY_CARD: LANDER_FR_WITH_LAUNDRY_CARD,
    LANDER_FR_RECREATION_FACILITIES_CARD: LANDER_FR_RECREATION_FACILITIES_CARD,
    LANDER_FR_STUDIO_APARTMENTS_CARD: LANDER_FR_STUDIO_APARTMENTS_CARD,
    LANDER_FR_RENTAL_HOMES_CARD: LANDER_FR_RENTAL_HOMES_CARD,
    LANDER_RS_JUST_SOLD_CARD: LANDER_RS_JUST_SOLD_CARD,
    LANDER_RS_MEDIAN_HOMES_CARD: LANDER_RS_MEDIAN_HOMES_CARD,
    LANDER_RS_LUXURY_HOMES_CARD: LANDER_RS_LUXURY_HOMES_CARD,
    LANDER_RS_AFFORD_HOMES_CARD: LANDER_RS_AFFORD_HOMES_CARD,
    SRP_PAGINATION_MAX_PROPERTY_NUMBER: SRP_PAGINATION_MAX_PROPERTY_NUMBER,
    PROP_TYPE_CRIT_TO_VALUE_MAPPING: PROP_TYPE_CRIT_TO_VALUE_MAPPING,
    PROP_TYPE_VALUE_TO_CRIT_MAPPING: PROP_TYPE_VALUE_TO_CRIT_MAPPING,
    ENTER_KEY: __WEBPACK_IMPORTED_MODULE_0__constants_keys__["a" /* ENTER_KEY */],
    BACKSPACE_KEY: __WEBPACK_IMPORTED_MODULE_0__constants_keys__["e" /* BACKSPACE_KEY */],
    DELETE_KEY: __WEBPACK_IMPORTED_MODULE_0__constants_keys__["f" /* DELETE_KEY */],
    UP_KEY: __WEBPACK_IMPORTED_MODULE_0__constants_keys__["g" /* UP_KEY */],
    DOWN_KEY: __WEBPACK_IMPORTED_MODULE_0__constants_keys__["h" /* DOWN_KEY */],
    LANDER_FS_PRICE_REDUCED_CARD: LANDER_FS_PRICE_REDUCED_CARD,
    LANDER_FS_FORECLOSURE_CARD: LANDER_FS_FORECLOSURE_CARD,
    LANDER_FS_NEW_CONSTRUCTION_CARD: LANDER_FS_NEW_CONSTRUCTION_CARD,
    ALLOWED_SCHOOL_PAGETYPE: ALLOWED_SCHOOL_PAGETYPE,
    GET_NORESULTS_ZOOM: GET_NORESULTS_ZOOM

  };
  return __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__format_helper__["b" /* constantize */])(MOVE.CONSTANTS);
}(MOVE || {});



/***/ }),

/***/ 72:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return onMapLoad; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return loadMaps; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__core_framework_move__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__config__ = __webpack_require__(1008);
/* global AppConfig */




// wrap loadScript in native promise
var loadDeferred = function () {
  var dfd = void 0;

  // to address race condition
  // while promise is pending avoid loading script again
  // if promise is rejected
  // additional calls to this method will try to load the script
  return function (url) {
    if (dfd) return dfd;else return dfd = Promise.resolve(__webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__core_framework_move__["a" /* loadScript */])(url)).catch(function () {
      return dfd = undefined;
    });
  };
}();

var mapsApi = "https://maps.googleapis.com/maps/api/js";

var callbacks = [];

var onMapLoad = function onMapLoad(fn) {
  return callbacks.push(fn);
};

var executeCallbacks = function executeCallbacks(src) {
  callbacks.forEach(function (fn) {
    return fn(src);
  });
  callbacks = [];
};

var loadMaps = function loadMaps(channel) {
  return loadDeferred(googleMapsUrl(channel)).then(function () {
    return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 1692));
  }).then(executeCallbacks);
};

var getCredentials = function getCredentials() {
  if (!__WEBPACK_IMPORTED_MODULE_1__config__["b" /* config */]) throw "mapConfiguration not set in gon data!";

  var clientId = __WEBPACK_IMPORTED_MODULE_1__config__["b" /* config */].clientId,
      apiKey = __WEBPACK_IMPORTED_MODULE_1__config__["b" /* config */].apiKey;

  if (clientId) return "client=" + clientId;else if (apiKey) return "key=" + apiKey;else throw "clientId or apiKey is required";
};

var withPrefix = function withPrefix(channel) {
  if (__WEBPACK_IMPORTED_MODULE_1__config__["b" /* config */].environment) return __WEBPACK_IMPORTED_MODULE_1__config__["b" /* config */].environment + "-" + channel;else return channel;
};

var googleMapsUrl = function googleMapsUrl(channel) {
  if (!channel) throw "must specify channel!";

  var creds = getCredentials();

  return mapsApi + "?v=" + __WEBPACK_IMPORTED_MODULE_1__config__["b" /* config */].version + "&" + creds + "&channel=" + withPrefix(channel);
};

/***/ }),

/***/ 729:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoadAmazonAds; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants_js__ = __webpack_require__(730);
/*global googletag, window*/



/**
 * LoadAmazonAds
 *
 * @class LoadAmazonAds
 * @constructor
 * @param {slots} slots of ads to load
 * @param {loadAds} callback to load ads
 */

var getWindowDimensions = function getWindowDimensions() {
  var width = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
  var height = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
  return [width, height];
};

var parseSizeMappings = function parseSizeMappings(windowDimensions, sizeMappings) {
  try {
    // filter mappings that are valid by confirming that the current screen dimensions
    // are both greater than or equal to the breakpoint [x, y] minimums specified in the first position in the mapping
    var validMappings = sizeMappings.filter(function (m) {
      return m[0][0] <= windowDimensions[0] && m[0][1] <= windowDimensions[1];
    });

    // return the leftmost mapping's sizes or an empty array
    return validMappings.length > 0 ? validMappings[0][1] : [];
  } catch (e) {
    // fallback to last size mapping supplied
    return sizeMappings[sizeMappings.length - 1][1];
  }
};

var arrayMatch = function arrayMatch(array1, array2) {
  return array1[0] === array2[0] && array1[1] === array2[1];
};

var isAmazonSize = function isAmazonSize(adSize) {
  if (!Array.isArray(adSize)) {
    return false;
  }
  if (adSize.length != 2) {
    return false;
  }
  for (var i = 0; i < __WEBPACK_IMPORTED_MODULE_0__constants_js__["a" /* AMAZON_AD_SIZES */].length; i++) {
    if (arrayMatch(adSize, __WEBPACK_IMPORTED_MODULE_0__constants_js__["a" /* AMAZON_AD_SIZES */][i])) {
      return true;
    }
  }
  return false;
};

var formatAmazonSize = function formatAmazonSize(adSizes) {
  for (var i = adSizes.length; i >= 0; i--) {
    if (!isAmazonSize(adSizes[i])) {
      adSizes.splice(i, 1);
    }
  }
  return adSizes;
};

var getAmazonSlotForCurrentSize = function getAmazonSlotForCurrentSize(amazon_slot, windowDimensions) {
  var adSizes = amazon_slot.size_mappings ? parseSizeMappings(windowDimensions, amazon_slot.size_mappings) : amazon_slot.sizes;
  return {
    slotID: amazon_slot.slotID,
    slotName: amazon_slot.slotName,
    sizes: formatAmazonSize(adSizes)
  };
};

var getAmazonSlots = function getAmazonSlots(slots) {
  var windowDimensions = getWindowDimensions();
  var amazonSlotsForCurrentSize = [];
  slots.forEach(function (slot) {
    if (slot) {
      var amazon_slot = window.amazon_slots.filter(function (m) {
        return m.slotID === slot.getSlotElementId();
      });
      if (amazon_slot.length > 0) {
        var amazonSlot = getAmazonSlotForCurrentSize(amazon_slot[0], windowDimensions);
        if (amazonSlot.sizes.length > 0) {
          amazonSlotsForCurrentSize.push(amazonSlot);
        }
      }
    }
  });
  return amazonSlotsForCurrentSize;
};

var ApstagInit = function ApstagInit() {
  //Initialize Amazon Library
  window.apstag.init({
    pubID: '3103',
    adServer: 'googletag'
  });
};

var LoadAmazonAdSlots = function LoadAmazonAdSlots(slots) {
  return new Promise(function (resolve) {
    var amazonSlots = [];
    if (window.apstag !== undefined) {
      amazonSlots = getAmazonSlots(slots);
    }
    if (amazonSlots.length) {
      ApstagInit();
      window.apstag.fetchBids({
        slots: amazonSlots,
        timeout: 2e3
      }, function () {
        googletag.cmd.push(function () {
          window.apstag.setDisplayBids();
          resolve();
        });
      });
    } else {
      resolve();
    }
  });
};

var LoadAmazonAds = LoadAmazonAdSlots;

/***/ }),

/***/ 73:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AB_SRP_LAYOUT_COOKIE_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AB_SRP_LAYOUT_COOKIE_LIST; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AB_SRP_LAYOUT_COOKIE_MIXED; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RESIZE_MAP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return VIEW_CHANGE; });
var AB_SRP_LAYOUT_COOKIE_MAP = 'ab-map-view';
var AB_SRP_LAYOUT_COOKIE_LIST = 'ab-list-view';
var AB_SRP_LAYOUT_COOKIE_MIXED = 'ab-mixed-view';

var RESIZE_MAP = "BC.MAP.RESIZE";
var VIEW_CHANGE = "BC.SET.VIEW.TYPE";

/***/ }),

/***/ 730:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AMAZON_AD_SIZES; });
var AMAZON_AD_SIZES = [[300, 250], [300, 600], [728, 90], [320, 50]];

/***/ }),

/***/ 731:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__amazon__ = __webpack_require__(729);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__amazon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__message__ = __webpack_require__(733);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_1__message__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__srp_sticky__ = __webpack_require__(734);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__srp_sticky__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__srp_sticky__["b"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_2__srp_sticky__["c"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__init__ = __webpack_require__(732);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_3__init__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__tile__ = __webpack_require__(735);
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_4__tile__["a"]; });
/* harmony namespace reexport (by used) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__tile__["b"]; });






/***/ }),

/***/ 732:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MediaInit; });
/*global googletag, window*/

/**
 * MediaInit
 *
 * @class MediaInit
 * @param {initAds} callback to initialize ads after initialize library
 */

var initializeAdsLibrary = function initializeAdsLibrary() {
  window.ads_library.initialized = true;
  //in case gpt.js is completely blocked, googletag.pubads() is not set up, assign an object to this function so that does not cause js error
  if (!window.googletag || !googletag.apiReady) {
    googletag.pubads = function () {
      return {
        refresh: function refresh() {},
        setTargeting: function setTargeting() {},
        setCategoryExclusion: function setCategoryExclusion() {}
      };
    };
    googletag.display = function () {};
    $('.ads').hide();
    $('.ad-srp-inline').hide();
    $('.facet-bar').attr('data-offset-top', '48px');
    window.pbjs = function () {
      return {
        refreshAds: function refreshAds() {}
      };
    };
    return false;
  }
  return true;
};

var MediaInitialze = function MediaInitialze() {
  return new Promise(function (resolve, reject) {
    if (!initializeAdsLibrary()) {
      reject(new TypeError('No Ad Library.'));
    }

    googletag.cmd.push(function () {
      $('.ads').each(function () {
        googletag.display(this.getAttribute('id'));
      });

      if (window.Krux) {
        googletag.pubads().setTargeting('ksg', window.Krux.segments);
        googletag.pubads().setTargeting('kuid', window.Krux.user);
      }

      setTimeout(function () {
        resolve();
      }, 20);
    });
  });
};

var MediaInit = MediaInitialze;

/***/ }),

/***/ 733:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return HandleAdsMessage; });
/*global window*/

/**
 * HandleAdsMessage
 *
 * @class HandleAdsMessage
 * @param {event} message sent to current window
 */

var recalculatePropertyFeatureHeight = function recalculatePropertyFeatureHeight() {
  var fluidPropertyFeatureHeight = 120;
  var propertyFeatures = $('.load-more-features');
  var expandedHeight = propertyFeatures.data('expandedHeight');
  var newHeight = expandedHeight + fluidPropertyFeatureHeight;
  $('#div-gpt-ad-HOMSVC1, #div-gpt-ad-HOMSVC2, #div-gpt-ad-HOMSVC3').addClass('fluid-property_feature');
  $('#div-gpt-ad-HOMSVC1, #div-gpt-ad-HOMSVC2, #div-gpt-ad-HOMSVC3').css({ 'height': fluidPropertyFeatureHeight });

  propertyFeatures.data('expandedHeight', newHeight);
  propertyFeatures.css({ 'height': newHeight });
};

var swipePhoto = function swipePhoto(photos, left, right) {
  if (photos.length === 0) {
    return;
  }
  if (left) {
    photos.trigger('next.owl.carousel');
  } else if (right) {
    photos.trigger('prev.owl.carousel');
  }
};

var homepageRibbon = function homepageRibbon(jsonMsg) {
  if (jsonMsg.ad_type === 'vu') {
    $('.vu-disclaimer-border').removeClass('hide');
  }
};

var DapCTA = function DapCTA(jsonMsg) {
  var phoneNumber = jsonMsg.phoneNumber.replace(/\(|\)| |-/g, '');
  window.location.href = 'tel://' + phoneNumber;
};

var processJsonMessage = function processJsonMessage(jsonMsg) {
  switch (jsonMsg.type) {
    case 'DAP_CTA':
      DapCTA(jsonMsg);
      break;
    case 'HOMSVC_AD':
      $('.header-subsection-home-service').removeClass(jsonMsg.ad_unit_empty);
      break;
    case 'HOMEPAGERIBBON':
      homepageRibbon(jsonMsg);
      break;
  }
};

var handleJsonMessage = function handleJsonMessage(msg) {
  try {
    var jsonMsg = JSON.parse(msg);
    processJsonMessage(jsonMsg);
  } catch (e) {/* ignore */}
};

var handleMdnAdsMessage = function handleMdnAdsMessage(event) {
  switch (event.data) {
    case 'VU_OVERLAY':
      window._satellite.track('ldp:ads:overlay:veterans');
      break;
    case 'VU_GUIDEPOST':
      window._satellite.track('ldp:ads:guidePost:veterans');
      break;
  }
  if (event.data === 'VU_POPS_UP') {
    var expiration = MOVE.Helper.setCookieExpiry(60 * 24 * 6);
    $.cookie('VU_POPS_UP', 1, { expires: expiration, path: '/' });
  }
};

var handleGooglesyndicationAdsMessage = function handleGooglesyndicationAdsMessage(event) {
  switch (event.data) {
    case 'SWPIE_LEFT':
      swipePhoto($('#cmtPhotoGallery'), true, false);
      break;
    case 'SWPIE_RIGHT':
      swipePhoto($('#cmtPhotoGallery'), false, true);
      break;
  }
  if (event.data === 'TXTIN2_DAP') {
    $('#div-gpt-ad-TXTIN2').find('.txtinadslistview').addClass('dap-size');
    $('#div-gpt-ad-TILELIST2').addClass('dap-mrect');
  }

  if (isJson(event.data) && JSON.parse(event.data).type === 'HOMSVC_AD') {
    recalculatePropertyFeatureHeight();
  }
  handleJsonMessage(event.data);
};

var isJson = function isJson(str) {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};
//this function listen to message fired from ads inside iframe
var handleAdsMessage = function handleAdsMessage(event) {
  var origin = event.origin || event.originalEvent.origin;
  //s0.2mdn.net is CDN of gpt ads static files
  if (origin === "http://s0.2mdn.net" || origin === "https://s0.2mdn.net") {
    handleMdnAdsMessage(event);
  }
  //tpc.googlesyndication.com is another CDN of gpt ads static files
  if (origin === 'http://tpc.googlesyndication.com' || origin === 'https://tpc.googlesyndication.com') {
    handleGooglesyndicationAdsMessage(event);
  }
};

var HandleAdsMessage = handleAdsMessage;

/***/ }),

/***/ 734:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return SrpOnScroll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SrpCurrentStickMrect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return SrpResetStickyMrect; });
/*global window*/

var stickMrectEndPos = 0,
    stickyMrectStartPos,
    currentStickyMrect,
    scrollTimer;

var getWindowsTop = function getWindowsTop() {
  return $(window).scrollTop();
};

var resetStickyMrect = function resetStickyMrect() {
  currentStickyMrect = '';
  stickyMrectStartPos = getWindowsTop();
  var pageBottomPosition = $('.srp-local-research').position();
  if (pageBottomPosition) {
    stickMrectEndPos = pageBottomPosition.top;
  }
};

var setCurrentStickMrect = function setCurrentStickMrect(newStickMrect) {
  var stickyMrect = [];
  if (newStickMrect > currentStickyMrect) {
    currentStickyMrect = newStickMrect;
    window.gptAds.gptadslotsSrpStickyMrect.targets.forEach(function (element) {
      if (element && element.getSlotElementId() === currentStickyMrect) {
        stickyMrect.push(element);
      }
    });
    $('.srp-sticky-ad').hide();
    $('#' + currentStickyMrect).parent().show();
  }
  return stickyMrect;
};

var withinStickyRang = function withinStickyRang(currentWindowTop) {
  return currentWindowTop >= stickyMrectStartPos && (stickMrectEndPos === 0 || currentWindowTop <= stickMrectEndPos);
};

var getNewStickMrect = function getNewStickMrect(currentWindowTop) {
  var newStickMrect = '';
  if (currentWindowTop < stickyMrectStartPos + 1300) {
    newStickMrect = 'div-gpt-ad-MRECTSTICKY_1';
  } else if (currentWindowTop < stickyMrectStartPos + 2400) {
    newStickMrect = 'div-gpt-ad-MRECTSTICKY_2';
  } else if (currentWindowTop < stickyMrectStartPos + 3500) {
    newStickMrect = 'div-gpt-ad-MRECTSTICKY_3';
  } else {
    newStickMrect = 'div-gpt-ad-MRECTSTICKY_4';
  }
  return newStickMrect;
};

var getCurrentStickMrect = function getCurrentStickMrect() {
  var currentWindowTop = getWindowsTop();
  if (withinStickyRang(currentWindowTop)) {
    var newStickMrect = getNewStickMrect(currentWindowTop);
    return setCurrentStickMrect(newStickMrect);
  }
  return [];
};

var stickyAdScroller = function stickyAdScroller(stickyMrect, loadProgrammaticAds) {
  if (scrollTimer) {
    clearTimeout(scrollTimer);
  }
  scrollTimer = setTimeout(function () {
    loadProgrammaticAds(stickyMrect);
  }, 250);
};

var onScroll = function onScroll(getViewType, loadProgrammaticAds) {
  if (getViewType() === "list") {
    var stickyMrect = getCurrentStickMrect();
    if (stickyMrect.length > 0) {
      stickyAdScroller(stickyMrect, loadProgrammaticAds);
    }
  }
};

var SrpOnScroll = onScroll;
var SrpCurrentStickMrect = getCurrentStickMrect;
var SrpResetStickyMrect = resetStickyMrect;

/***/ }),

/***/ 735:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GetTileAdListToDisplay; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return TileAdLazyLoad; });
/*global googletag, window*/

var GetTileAdListToDisplay = function GetTileAdListToDisplay(view) {
  var adUnitsListToDisplay = [];
  $('.ad-data-' + view + '-view').each(function (i, item) {
    if (!$(item).hasClass('lazy_load')) {
      var adUnit = item.dataset['adUnit'];
      if (adUnit) {
        adUnitsListToDisplay.push(adUnit);
      }
    }
  });
  return adUnitsListToDisplay.join(',');
};

var TileAdLazyLoading = function TileAdLazyLoading(getDynamicAdsToBeLoaded, loadProgrammaticAds, view) {
  var listview = view.toLowerCase() === 'list';
  var viewList = listview ? '.ad-data-list-view.lazy_load' : '.ad-data-map-view.lazy_load';
  var gptadslotsForView = listview ? window.gptAds.gptadslotsTXTINListView : window.gptAds.gptadslotsTXTINMapView;
  $(viewList).each(function (i, item) {
    var adUnit = item.dataset['adUnit'];
    if (adUnit && !$(item).hasClass('registered')) {
      $(item).addClass('registered');
      var adUnitsListToDisplay = [];
      adUnitsListToDisplay.push(adUnit);
      var adsToLoad = getDynamicAdsToBeLoaded(adUnitsListToDisplay.join(','), gptadslotsForView);
      adsToLoad.forEach(function (slot) {
        var threshold = MOVE.Helper.isPhone() ? 7000 : 800;
        MOVE.DOMHelper.unveilLoadContent($('#' + slot.getSlotElementId()), $('.srp-card-wrapper'), threshold, function () {
          googletag.cmd.push(function () {
            var adsToLoad = [];
            adsToLoad.push(slot);
            loadProgrammaticAds(adsToLoad);
          });
        });
      });
    }
  });
};

var TileAdLazyLoad = function TileAdLazyLoad(getDynamicAdsToBeLoaded, loadProgrammaticAds, view) {
  if (!view || view === 'map-only') {
    return;
  }
  setTimeout(function () {
    TileAdLazyLoading(getDynamicAdsToBeLoaded, loadProgrammaticAds, view);
  }, 500);
};

/***/ }),

/***/ 737:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return focusRequestLead; });
var focusRequestLead = function focusRequestLead() {
  $('#srp-lead-modal, #ldpBottomLeadModal, #request-private-showing, #ldpStickyBottomLeadModal').on('shown.bs.modal', function () {
    var requestLeadName = $(this).find('.fullName'),
        requestLeadEmail = $(this).find('.email'),
        requestLeadPhone = $(this).find('.phone');

    var modalContent = $(this).find('.modal-content');
    requestLeadName.on('focus', function () {
      // get textarea's offset top position
      modalContent.animate({
        scrollTop: MOVE_DATA.ab_lf_redesgin ? 42 : 52
      });
    });
    requestLeadEmail.on('focus', function () {
      // get textarea's offset top position
      modalContent.animate({
        scrollTop: MOVE_DATA.ab_lf_redesgin ? 90 : 100
      });
    });
    requestLeadPhone.on('focus', function () {
      // get textarea's offset top position
      modalContent.animate({
        scrollTop: MOVE_DATA.ab_lf_redesgin ? 138 : 148
      });
    });

    if (!requestLeadName.val()) {
      requestLeadName.trigger("focus");
    } else if (!requestLeadEmail.val()) {
      requestLeadEmail.trigger("focus");
    }
  });
};

/***/ }),

/***/ 8:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return DataStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return LocalStorage; });
/*global MOVE_DATA, localStorage*/
MOVE.DataStore = function (MOVE) {
    "use strict";

    var getData = function getData(key) {
        return MOVE_DATA[key];
    };

    var setData = function setData(key, data) {
        MOVE_DATA[key] = data;
    };

    var clearData = function clearData(key) {
        MOVE_DATA[key] = null;
    };

    MOVE.DataStore = {
        getData: getData,
        setData: setData,
        clearData: clearData
    };

    return MOVE.DataStore;
}(MOVE || {});

MOVE.LocalStorage = function (MOVE) {
    "use strict";

    var checkAvailability = function checkAvailability() {
        var test = 'test';
        try {
            localStorage.setItem(test, test);
            localStorage.removeItem(test);
            return true;
        } catch (e) {
            return false;
        }
    };

    MOVE.LocalStorage = {
        isAvailable: checkAvailability()
    };

    return MOVE.LocalStorage;
}(MOVE || {});

var DataStore = MOVE.DataStore;
var LocalStorage = MOVE.LocalStorage;

/***/ }),

/***/ 81:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return trackSave; });
/* global RdcTracking */

var trackSave = function trackSave(saveItem, saveAction) {
  var listingId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'unknown';

  var props = {
    saveItem: saveItem,
    saveAction: saveAction,
    listingId: listingId
  };
  RdcTracking.trackEvent('savedItem', props);
};

/***/ }),

/***/ 877:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.parseQueryParams = parseQueryParams;
exports.readCookie = readCookie;
exports.getCurrentDateWithWeek = getCurrentDateWithWeek;
function parseQueryParams(queryString) {
  var query = {};
  var pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
  for (var i = 0; i < pairs.length; i++) {
    var pair = pairs[i].split('=');
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
  }
  return query;
};

function readCookie(name) {
  var nameEQ = name + "=";
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1, c.length);
    }
    if (c.indexOf(nameEQ) === 0) {
      return c.substring(nameEQ.length, c.length);
    }
  }
  return null;
};

function getCurrentDateWithWeek(now) {
  /*
    Using the format "YYYYMMDDWW" gives Omniture a lot of flexibity in creating
    a segment to choose hits INBETWEEN 2 dates, which isn't supported right now
     
    We Offset UTC behind 6 Hours to get Mountain Time, This helps us tackle and
    hopefully eradicate the "Daylight Saving" Problems
  */
  now.setUTCHours(now.getUTCHours() - 7);
  return lpad(now.getUTCFullYear().toString(), "0", 4) + lpad((now.getUTCMonth() + 1).toString(), "0", 2) + lpad(now.getUTCDate().toString(), "0", 2) + "W" + lpad(getWeek(now).toString(), "0", 2);
};

function lpad(str, padString, length) {
  while (str.length < length) {
    str = padString + str;
  }return str;
};

function getWeek(now) {
  /*
     Custom Property to get week of the year
     The first week of the year is the week with atleast 4 days from from the new year hence Jan 4th is used
  */
  var jan4th = new Date(now.getUTCFullYear(), 0, 4);
  return Math.ceil(((now - jan4th) / 86400000 + jan4th.getUTCDay() + 1) / 7);
}

/***/ }),

/***/ 878:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function buildPlacement(placementData) {
  /*
     take pageType, pageSection and pageAction
     pageAction is optional and for clicks, such as to open modals.
     pageLoad doesn't require the action
     can take a string if using old omtag placement names
  */
  if (!placementData) {
    return '';
  } else if (typeof placementData === 'string') {
    return placementData;
  } else if ((typeof placementData === 'undefined' ? 'undefined' : _typeof(placementData)) === 'object') {
    var type = placementData.pageType,
        section = placementData.pageSection,
        action = placementData.pageAction ? ':' + placementData.pageAction : '';

    return type + ':' + section + action;
  }
}

module.exports = {
  buildPlacement: buildPlacement
};

/***/ }),

/***/ 879:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function getLeadEnhancements(leadType, showContactALender, isLcmEnabled) {
  if (leadType === 'none') {
    return '';
  } else if (showContactALender) {
    if (isLcmEnabled) {
      return 'classic,lcm';
    } else {
      return 'classic,rcm';
    }
  } else {
    return 'classic';
  }
}

function getChannel(propertyType) {
  if (propertyType && propertyType.includes('rent')) {
    return 'rentals';
  } else {
    return 'homes';
  }
}

function getDataSourceType() {
  var flags = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var source = arguments[1];

  if (flags.is_aptlist) {
    return 'aptlist';
  } else if (flags.is_costar) {
    return 'costar';
  } else {
    return source;
  }
}

function getLeadDelivery(propertyStatus, opts) {
  switch (propertyStatus) {
    case 'for_sale':
      return opts.leadType === 'none' ? '' : opts.leadType;
    case 'new_plan':
    case 'new_community':
      return 'showcase';
    case 'for_rent':
      if (opts.leadType === 'advantage_pro') {
        return 'advantage_pro';
      } else {
        return getDataSourceType(opts.flags, opts.source) !== 'mls' && opts.flags && opts.flags.is_showcase ? 'showcase' : 'basic';
      }
    case 'not_for_sale':
      return 'seller';
    default:
      return '';
  }
}

module.exports = {
  getLeadEnhancements: getLeadEnhancements,
  getChannel: getChannel,
  getDataSourceType: getDataSourceType,
  getLeadDelivery: getLeadDelivery
};

/***/ }),

/***/ 880:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = setQueue;
// Queue for MOVEAnalytics in case it is not yet loaded.

function setQueue() {
  if (typeof window !== 'undefined') {
    window.MOVEAnalytics = window.MOVEAnalytics || { q: [], init: function init() {
        this.q.push({ t: 'init', a: arguments });
      }, trackPage: function trackPage() {
        this.q.push({ t: 'trackPage', a: arguments });
      }, trackEvent: function trackEvent() {
        this.q.push({ t: 'trackEvent', a: arguments });
      } };
  }
}

/***/ }),

/***/ 881:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getSuperProperties;

var _dom_helper = __webpack_require__(877);

function getSuperProperties() {
  var queryParams = (0, _dom_helper.parseQueryParams)(window.location.search),
      identityId = getIdentityId(queryParams.identityID),
      date = Date.now();
  var superProps = {
    abTestCluster: (0, _dom_helper.readCookie)('split'),
    abTestClusterThreshold: (0, _dom_helper.readCookie)('split_tcv'),
    application: 'rdc',
    aid: queryParams.aid || null,
    brandExperience: 'rdc-responsive',
    contentId: queryParams.content_id || null,
    currentDate: (0, _dom_helper.getCurrentDateWithWeek)(new Date(date)),
    edwSessionId: (0, _dom_helper.readCookie)('__ssn'),
    edwVisitorId: (0, _dom_helper.readCookie)('__vst'),
    loginStatus: identityId ? 'y' : 'n',
    mid: queryParams.mid || null,
    rdcTrackingEnabled: 'y',
    publisher: getPublisher(queryParams.cid, queryParams.pid),
    registeredUserActivity: identityId ? 'registered-user' : 'not-registered',
    rid: queryParams.rid || null,
    identityId: identityId,
    sessionStartTime: (0, _dom_helper.readCookie)('__ssnstarttime'),
    threshold: (0, _dom_helper.readCookie)('threshold_value'),
    utcTimestamp: date
  };
  if (typeof window.rdcxreferrer !== 'undefined') {
    superProps.referrer = window.rdcxreferrer;
  };
  return superProps;
} // superProperties are the data that need to be sent on every single track event in all rdc web apps
;

var getPublisher = function getPublisher(cid, pid) {
  cid = cid || null;
  pid = pid || null;
  return cid && cid.toLowerCase().includes('cj_') ? 'cj:' + pid : pid;
};

var getIdentityId = function getIdentityId(identityId) {
  return (0, _dom_helper.parseQueryParams)((0, _dom_helper.readCookie)("REMEMBER_ME") || '').regID || identityId || null;
};

/***/ }),

/***/ 89:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fadeInOutAnimation */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initPopOver; });
/* unused harmony export closePopOver */
/* unused harmony export closePopOversOnResize */
/* unused harmony export closePopOverHover */
/* unused harmony export unveilLoadImages */
/* unused harmony export unveilLoadContent */
/* unused harmony export detectPageType */
/* unused harmony export appendLoading */
/* unused harmony export prependLoading */
/* unused harmony export removeLoading */
/* unused harmony export findPropertyPage */
/* unused harmony export findNearestDomFromScroll */
/* unused harmony export asyncTracking */
/* unused harmony export loadAsyncLib */
/* unused harmony export highlightThumbnail */
/* unused harmony export getUrlParts */
/* unused harmony export validatePhone */
/* unused harmony export getPageNumber */
/* unused harmony export loadCarouselThumbnails */
/* unused harmony export movingQuoteErrorPlacement */
/* unused harmony export disableCrabwalk */
/* unused harmony export enableCrabwalk */
/* unused harmony export isCrabwalkDisable */
/* unused harmony export setSelectPickerDefaultValue */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getUrlParams; });
/* unused harmony export getUrlWithParams */
/* unused harmony export closeTooltips */
/* unused harmony export DOMHelper */
/*global window, _, MOVE_DATA, localStorage, JST */

var fadeInOutAnimation = function fadeInOutAnimation(headLines, headlineSpan) {
  var headlineCycleFadeIn,
      rotationCounter = 0,
      curHeadline = 0;
  var headlineCycleFadeOut = function headlineCycleFadeOut() {
    headlineSpan.fadeOut(2000, function () {
      curHeadline++;
      if (curHeadline < headLines.length) {
        headlineSpan.html(headLines[curHeadline]);
        headlineCycleFadeIn();
      } else {
        if (rotationCounter === headLines.length) {
          headlineSpan.html(headLines[0]);
          headlineSpan.fadeIn(2000);
        } else {
          rotationCounter++;
          curHeadline = -1;
          headlineCycleFadeOut();
        }
      }
    });
  };
  headlineCycleFadeIn = function headlineCycleFadeIn() {
    headlineSpan.fadeIn(2000, function () {
      headlineCycleFadeOut();
    });
  };
  if (headLines) {
    headlineCycleFadeOut();
  }
};
// General popover javascript for HTML content popovers
var initPopOver = function initPopOver(form, container) {
  form.find('[rel="popover"]').popover({
    container: container || 'body',
    html: true,
    trigger: 'click',
    clickAutoClose: true,
    content: function content() {
      var clone = $($(this).data('popover-content')).clone(true).removeClass('hide');
      return clone;
    }
  }).click(function (e) {
    e.preventDefault();
  });
};

var closePopOver = function closePopOver(form) {
  var $popOver = form.find('[rel="popover"]');
  if ($popOver.length > 0) {
    $popOver.popover('hide');
  }
};

var closePopOversOnResize = function closePopOversOnResize() {
  closePopOver($("#ldp-listing-provider"));
  closePopOver($("#ldp-additional-info"));
  closePopOver($("#ldp-pricewrap"));
  closePopOver($("#market-summary-data"));
  closePopOver($("#footer"));
  closePopOver($("#summary-pg-price-section"));
  closePopOver($("#ldp-home-advisor-widget"));
  closePopOver($("#veteran-popover-content"));
  closePopOver($("#mortgage_calculator_form"));
  closePopOver($("#estimate-commute-time-popover"));
  closePopOver($("#MortgageLegendList"));
  closePopOver($("#ldp-homes-with-similar-mortgage"));
};

// Pop over on hover for desktop and click on mobile
var initPopOverHover = function initPopOverHover($section) {
  var $popoverCta = $section.find('[rel="popover-hover"]');
  var trigger = MOVE.Helper.isMobile() || MOVE.Helper.isMobileDevice() || MOVE.Helper.detectViewPort() === 'small';

  $popoverCta.popover({
    container: 'body',
    html: true,
    trigger: trigger ? 'click' : 'hover',
    clickAutoClose: true,
    content: function content() {
      return $($(this).data('popover-content')).clone(true).removeClass('hide');
    }
  });

  // Bind body click/touch event so the popover would close if user clicks outside popover
  if (trigger) {
    $('body').on('click touchstart', function (e) {
      var $target = $(e.target);
      if (!$target.is($popoverCta) && $target.parents('[rel="popover-hover"]').length === 0 && $popoverCta.length > 0) {
        $popoverCta.popover('hide');
      }
    });
  }
};

// Closing function popOverHover
var closePopOverHover = function closePopOverHover($section) {
  var $popOverHover = $section.find('[rel="popover-hover"]');
  if ($popOverHover.length > 0) {
    $popOverHover.popover('hide');
  }
};

/**
 *
 * @param target : selector of images to be lazy loaded
 * @param options: extra option for lazy loading https://github.com/ressio/lazy-load-xt/#options
 * @param container: parent tag where all the images to be lazy loaded// (optional)
 */
var unveilLoadImages = function unveilLoadImages(target, options, $container, callback) {
  $(document).ready(function () {
    $(target).filter(":not(.owl-lazy)").unveil(800, $container, callback);
    // 800px before they appear on the screen
  });
};

/**
 *
 * @param target : selector of images to be lazy loaded
 * @param container: parent tag where all the content to be lazy loaded (optional)
 * @param threshold: px before they appear on the screen (optional)
 * @param callback: callback function after trigger content unveil (optional)
 */
var unveilLoadContent = function unveilLoadContent($target, $container, threshold, callback) {
  var th = threshold || 800;
  $target.unveil(th, $container, callback);
};

/*
  switch (MOVE.DOMHelper.detectPageType()) {
  case 'srp':
  //srp code
  break;
  case 'ldp':
  //lcdp code
  break;
  case 'hp':
  //homepage code
  break;
  default:
  break;
  }
*/
var detectPageType = function detectPageType() {
  return MOVE.DataStore.getData('pageType');
};

var appendLoading = function appendLoading($target) {
  $target.append(MOVE.CONSTANTS.LOADING_ICON);
};

var prependLoading = function prependLoading($target) {
  $target.prepend(MOVE.CONSTANTS.LOADING_ICON);
};

var removeLoading = function removeLoading($target) {
  $target.find('.' + MOVE.CONSTANTS.LOADING_ICON_CLASS).remove();
};

// Find current page on click by finding closest page anchor below click.
var findPropertyPage = function findPropertyPage($dom, clickPos) {
  var anchorPosition = 99999,
      anchor;
  _.each($dom.toArray(), function (i) {
    var currentDomAnchor = $(i).offset().top - clickPos;
    if (currentDomAnchor < anchorPosition && currentDomAnchor > 0) {
      anchorPosition = currentDomAnchor;
      anchor = i;
    }
  });
  return anchor;
};

var findNearestDomFromScroll = function findNearestDomFromScroll($dom) {
  return _.find($dom.toArray(), function (i) {
    var position = $(i).position().top - $(window).scrollTop();
    if (position <= 1000) {
      return false;
    } else {
      return true;
    }
  });
};

var asyncTracking = function asyncTracking(url) {
  var lib = document.createElement('script');
  lib.async = true;
  lib.type = "text/javascript";
  lib.src = url;
  var node = document.getElementsByTagName("script")[0];
  node.parentNode.insertBefore(lib, node);
};

var loadAsyncLib = function loadAsyncLib(url, callback) {
  var lib = document.createElement('script');
  lib.async = true;
  lib.type = "text/javascript";
  var useSSL = "https:" === document.location.protocol;
  if (callback) {
    lib.onload = lib.onreadystatechange = function () {
      if (!this.readyState || this.readyState === "loaded" || this.readyState === "complete") {
        callback();
      }
    };
  }
  lib.src = (useSSL ? "https:" : "http:") + url;
  var node = document.getElementsByTagName("script")[0];
  node.parentNode.insertBefore(lib, node);
};

//highlight and jump to the selected thumbnail.
var highlightThumbnail = function highlightThumbnail(index, $thumbnails) {
  if ($thumbnails) {
    var curThumbnail = $thumbnails.find("div.owl-item:not('.clone')").eq(index);
    if (!curThumbnail.hasClass("highlight")) {
      $thumbnails.find("div.highlight").removeClass("highlight");
      $thumbnails.trigger("to.owl.carousel", [index, 200, true]);
      curThumbnail.addClass("highlight");
    }
  }
};

var getUrlParts = function getUrlParts() {
  return _.chain(location.pathname.split('/')).compact().value();
};

// returns false when user enters anything other than numbers
// Key codes
// 8  : Backspace
// 48 : Number zero
// 57 : Number nine
var validatePhone = function validatePhone(e) {
  if (e.which !== 8 && e.which !== 0 && (e.which < 48 || e.which > 57)) {
    return false;
  }
};

var getPageNumber = function getPageNumber() {
  var pageNumber = _.find(getUrlParts(), function (i) {
    return i.indexOf('pg-') >= 0;
  });
  if (pageNumber) {
    return parseInt(pageNumber.split('-')[1], 10);
  } else {
    return false;
  }
};

var loadCarouselThumbnails = function loadCarouselThumbnails($thumbnails) {
  $thumbnails.owlCarousel({
    lazyLoad: true,
    margin: 10,
    nav: true,
    dots: false,
    responsiveClass: true,
    responsive: {
      767: { items: 10 },
      820: { items: 11 },
      930: { items: 13 },
      1200: { items: 15 },
      1400: { items: 18 },
      1600: { items: 21 }
    },
    navText: ["<div class='gallery-arrows arrow-left'><i class='ra ra-chevron-left'></i></div>", "<div class='gallery-arrows arrow-right'><i class='ra ra-chevron-right'></i></div>"]
  });
};

var movingQuoteErrorPlacement = function movingQuoteErrorPlacement(error, $element) {
  if ($element.hasClass("date")) {
    $element.parent().after(error);
  } else {
    error.insertAfter($element);
  }
};

var disableCrabwalk = function disableCrabwalk() {
  if (MOVE.LocalStorage.isAvailable) {
    window.localStorage.setItem('disable_crabwalk', 'true');
  }
};

var enableCrabwalk = function enableCrabwalk() {
  if (MOVE.LocalStorage.isAvailable) {
    window.localStorage.setItem('disable_crabwalk', '');
  }
};

var isCrabwalkDisable = function isCrabwalkDisable() {
  return MOVE.LocalStorage.isAvailable && window.localStorage.getItem('disable_crabwalk') === 'true';
};

/**
   Set the default value on a Select picker.
*/
var setSelectPickerDefaultValue = function setSelectPickerDefaultValue(target, value) {
  if (value !== null) {
    $(target).selectpicker('val', value);
  }
};

var getUrlParams = function getUrlParams() {
  return _.chain(location.search.slice(1).split('&')).map(function (item) {
    if (item) {
      return item.split('=');
    }
  }).compact().object().value();
};

var getUrlWithParams = function getUrlWithParams(url, params) {
  return url + '?' + $.param(params);
};

// Close Bootstrap tooltips on tap of page for iphone
var closeTooltips = function closeTooltips() {
  if (navigator.userAgent.match(/iPhone/i)) {
    // Apply only when a tooltip is shown
    $('[data-toggle="tooltip"]').on("shown.bs.tooltip", function () {
      $('body').css('cursor', 'pointer');
    });

    // Return cursor to default value when tooltip hidden.
    $('[data-toggle="tooltip"]').on("hide.bs.tooltip", function () {
      $('body').css('cursor', 'auto');
    });
  }
};

MOVE.DOMHelper = {
  fadeInOutAnimation: fadeInOutAnimation,
  initPopOver: initPopOver,
  initPopOverHover: initPopOverHover,
  closePopOversOnResize: closePopOversOnResize,
  closePopOverHover: closePopOverHover,
  unveilLoadImages: unveilLoadImages,
  unveilLoadContent: unveilLoadContent,
  appendLoading: appendLoading,
  prependLoading: prependLoading,
  removeLoading: removeLoading,
  findNearestDomFromScroll: findNearestDomFromScroll,
  findPropertyPage: findPropertyPage,
  detectPageType: detectPageType,
  loadAsyncLib: loadAsyncLib,
  asyncTracking: asyncTracking,
  getUrlParts: getUrlParts,
  getUrlParams: getUrlParams,
  getUrlWithParams: getUrlWithParams,
  highlightThumbnail: highlightThumbnail,
  loadCarouselThumbnails: loadCarouselThumbnails,
  movingQuoteErrorPlacement: movingQuoteErrorPlacement,
  disableCrabwalk: disableCrabwalk,
  enableCrabwalk: enableCrabwalk,
  isCrabwalkDisable: isCrabwalkDisable,
  setSelectPickerDefaultValue: setSelectPickerDefaultValue,
  validatePhone: validatePhone,
  getPageNumber: getPageNumber,
  closeTooltips: closeTooltips
};

var DOMHelper = MOVE.DOMHelper;

/***/ }),

/***/ 938:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.trackPage = trackPage;
exports.trackEvent = trackEvent;
exports.trackLead = trackLead;
exports.trackModalImpression = trackModalImpression;

var _super_properties = __webpack_require__(881);

var _super_properties2 = _interopRequireDefault(_super_properties);

var _queue = __webpack_require__(880);

var _queue2 = _interopRequireDefault(_queue);

var _lead_helper = __webpack_require__(879);

var _lead_helper2 = _interopRequireDefault(_lead_helper);

var _helper = __webpack_require__(878);

var _helper2 = _interopRequireDefault(_helper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _queue2.default)();

function trackPage(pageName, props, _integrations) {
  try {
    var properties = Object.assign({}, props, (0, _super_properties2.default)());
    MOVEAnalytics.trackPage(pageName, properties, _integrations);
  } catch (e) {
    console.log(e);
  }
}

function trackEvent(eventName, props, _integrations) {
  var _sendEventOnNextPage = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  try {
    var properties = Object.assign({}, (0, _super_properties2.default)(), props);
    MOVEAnalytics.trackEvent(eventName, properties, _integrations, _sendEventOnNextPage);
  } catch (e) {
    console.log(e);
  }
}

/* trackLead is a helper function used by RDC-BASECAMP.
   In RDC-X, we keep the lead tracking logic there, and directly call trackEvent.
   I would recommend NOT using this below function, but please keep it in tact for basecamp usage.
*/
function trackLead(props, opts) {
  var propertyStatus = opts.isBdp ? 'for_sale' : opts.propertyStatus;
  var listingLeadDelivery = _lead_helper2.default.getLeadDelivery(propertyStatus, opts) || '';
  var dataSourceType = _lead_helper2.default.getDataSourceType(opts.flags, opts.source);
  var placement = _helper2.default.buildPlacement(opts.placementData);
  var eventToTrack = void 0;

  switch (propertyStatus) {
    case 'new_plan':
    case 'new_community':
    case 'for_sale':
      if (opts.leadFlow === 'mal') {
        props.forSaleLeads = 'web:leads:' + propertyStatus + ':' + listingLeadDelivery + ':mal:' + placement;
      } else {
        props.forSaleLeads = 'web:leads:' + propertyStatus + ':' + listingLeadDelivery + ':' + placement;
      }
      if (listingLeadDelivery === 'showcase' || listingLeadDelivery.includes('advantage_pro')) {
        eventToTrack = 'advantageLead';
      } else if (listingLeadDelivery === 'cobroke' || listingLeadDelivery === 'co_broke') {
        eventToTrack = 'cobrokeLead';
      }

      break;
    case 'not_for_sale':
      props.notForSaleLeads = 'web:leads:not_for_sale:' + listingLeadDelivery + ':' + placement;
      eventToTrack = 'notForSaleLead';
      break;
    case 'for_rent':
      props.rentalLeads = 'web:leads:for_rent:' + (dataSourceType || '') + ':' + listingLeadDelivery + ':' + placement;
      if (listingLeadDelivery === 'basic') {
        eventToTrack = 'rentalBasicLead';
      } else if (listingLeadDelivery === 'showcase' || listingLeadDelivery === 'advantage_pro') {
        eventToTrack = 'rentalShowcaseLead';
      }
      break;
  }

  var additionalData = {
    channel: _lead_helper2.default.getChannel(opts.propertyStatus),
    leadDelivery: listingLeadDelivery,
    leadEnhancements: _lead_helper2.default.getLeadEnhancements(opts.leadType, opts.showContactALender, opts.isLcmEnabled) || opts.leadAdditions,
    leadPlacement: placement,
    leadAttributes: opts.leadAdditions === 'military' ? 'veterans_lead' : '',
    leadFlow: opts.leadFlow
  };

  trackEvent(eventToTrack, Object.assign({}, props, additionalData));
}

function trackModalImpression(modalName, placementData) {
  var modalTrigger = _helper2.default.buildPlacement(placementData);
  var modalData = {
    modalName: modalName,
    modalTrigger: modalTrigger
  };
  trackEvent('modalImpression', modalData);
}

exports.default = {
  trackPage: trackPage,
  trackEvent: trackEvent,
  trackLead: trackLead,
  trackModalImpression: trackModalImpression
};

/***/ }),

/***/ 95:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setupSrpPageTracking; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return trackSrpPageLoad; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__srp_tracking_helper__ = __webpack_require__(180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__srp_clicks__ = __webpack_require__(1242);
/*global RdcTracking */



var DEFAULT_VALUE = 'unknown';

var searchFacetDidFire = false;

// source is optional and only needed to keep pagination and search facet from double firing in some instances.
var setupSrpPageTracking = function setupSrpPageTracking(source) {
  if (MOVE_DATA && MOVE_DATA.adobeDTM) {
    var pageName = __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__srp_tracking_helper__["a" /* getPageName */])();
    trackSrpPageLoad(pageName, source);
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__srp_clicks__["a" /* setupSrpClickTracking */])(pageName);

    // To track control for recommended search/smart notification
    if (!MOVE_DATA.srpNotificationFooter && RdcTracking) {
      RdcTracking.trackEvent('srpUpdateFeedImpression', { linkName: 'RECOMMENDED_SEARCH:control:no_update' });
    }
  }
};

var trackSrpPageLoad = function trackSrpPageLoad(pageName) {
  var source = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'unspecified';

  var fireTracking = function fireTracking() {
    return RdcTracking.trackPage(pageName, prepareLoadEventData(MOVE_DATA.adobeDTM));
  };
  if (source === 'searchFacet') {
    searchFacetDidFire = true;
    fireTracking();
  } else if (source === 'pagination' && searchFacetDidFire) {
    searchFacetDidFire = false;
  } else if (MOVE.DataStore.getData('NotifyTab') === 'notification-tab') {
    searchFacetDidFire = false;
  } else {
    fireTracking();
  }
};

var prepareLoadEventData = function prepareLoadEventData() {
  var adobeDTM = MOVE_DATA.adobeDTM;
  return {
    abTestSrp: getAbTestVariables(),
    city: adobeDTM['searchCity'] || DEFAULT_VALUE,
    communityIdShowcase: adobeDTM['communityID-showcase'],
    communityIdBasic: adobeDTM['communityID-basic'],
    communityIdFeatured: adobeDTM['communityID-featured'],
    county: adobeDTM['searchCounty'] || DEFAULT_VALUE,
    listingActivity: adobeDTM['searchListingActivity'] ? adobeDTM['searchListingActivity'].toString() : DEFAULT_VALUE,
    listingIdAdvantage: getListingIdAdvantage(adobeDTM['listingID-advantage']),
    listingIdBasicoo: getListingIdBasicoo(adobeDTM['listingID-basicoo']),
    listingIdBasic: adobeDTM['listingID-basic'],
    listingIdShowcase: adobeDTM['listingID-showcase'],
    listingIdCobroke: adobeDTM['listingID-cobroke'],
    neighborhood: adobeDTM['searchNeighborhood'],
    neighborhoodCount: adobeDTM['neighborhoodCount'],
    pageId: adobeDTM['pageId'] || DEFAULT_VALUE,
    pageSize: "srp:" + adobeDTM['searchPageSize'],
    pageType: adobeDTM['pageType'],
    pagination: "srp:" + adobeDTM['searchPage'],
    planIdShowcase: adobeDTM['planID-showcase'],
    propertyStatus: adobeDTM['propertyStatus'] || DEFAULT_VALUE,
    propertyStatusSub: adobeDTM['propertyStatusSub'] || DEFAULT_VALUE,
    propertyType: "srp:" + adobeDTM['searchPropertyType'] || DEFAULT_VALUE,
    searchBedrooms: adobeDTM['searchBedrooms'],
    searchBathrooms: adobeDTM['searchBathrooms'],
    searchCityState: adobeDTM['searchCity'] + ", " + adobeDTM['searchState'],
    searchFacets: "web:facets:" + adobeDTM['searchFacets'],
    searchFeatures: "web:features:" + adobeDTM['searchFeatures'],
    searchId: adobeDTM['searchID'],
    searchMinPrice: adobeDTM['searchMinPrice'],
    searchMaxPrice: adobeDTM['searchMaxPrice'],
    searchMod: adobeDTM['searchMod'],
    searchProductType: adobeDTM['productType'],
    searchRadius: "srp:" + adobeDTM['searchRadius'],
    searchResults: adobeDTM['searchResultCount'],
    searchSqFt: adobeDTM['searchSqFt'],
    searchType: MOVE_DATA.customSearchType || adobeDTM['searchType'],
    siteSection: __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__srp_tracking_helper__["b" /* getSiteSection */])(adobeDTM['propertyStatus']),
    sortResults: adobeDTM['searchSortResults'],
    srpColumns: adobeDTM['srpColumns'],
    srpHotBuyCount: adobeDTM['srpHotBuyCount'],
    srpPropertyStatus: "srp:" + getSrpPropertyStatus(adobeDTM['propertyStatus'], adobeDTM['propertyStatusSub']),
    srpResultType: getSrpResultType(),
    state: adobeDTM['searchState'] || DEFAULT_VALUE,
    subIdShowcase: adobeDTM['subID-showcase'],
    userStatus: "web:" + $.cookie('userStatus'),
    zip: adobeDTM['searchZip'] || DEFAULT_VALUE,
    imageSwappedCount: MOVE.DataStore && MOVE.DataStore.getData('abImgCtrSwapCount')
  };
};

var getAbTestVariables = function getAbTestVariables() {
  var elems = document.querySelectorAll("input[data-optimizely]"),
      retValue = '';
  for (var j = 0; j < elems.length; j++) {
    if (j > 0) {
      retValue += ',';
    }
    retValue += elems[j].getAttribute("data-optimizely");
  }
  return retValue;
};

var getListingIdAdvantage = function getListingIdAdvantage(val) {
  var lid = decodeURIComponent(val),
      ary1 = lid.split(','),
      retAry = '';
  ary1.forEach(function (id) {
    var ary2 = id.split(':');
    if (ary2.length > 1) {
      retAry += ary2[0] + ':' + ary2[1] + ',';
    }
  });
  return retAry.slice(0, retAry.length - 1);
};

var getListingIdBasicoo = function getListingIdBasicoo(val) {
  var lid = decodeURIComponent(val),
      ary1 = lid.split(','),
      retAry = [];
  for (var i = 0; i < ary1.length; i++) {
    var ary2 = ary1[i].split(':');
    if (ary2.length > 1) {
      retAry.push(ary2[0] + ':' + ary2[1]);
    }
  }
  return retAry.toString();
};

var getSrpPropertyStatus = function getSrpPropertyStatus(propertyStatus, propertyStatusSub) {
  return propertyStatusSub ? propertyStatus + ':' + propertyStatusSub : propertyStatus;
};

var getSrpResultType = function getSrpResultType() {
  var resultCnt = MOVE_DATA.adobeDTM.searchResultCount,
      resultNearByCnt = MOVE_DATA.adobeDTM.searchNearByResultCount,
      //not exist
  resultType = MOVE_DATA.adobeDTM.resultType,
      searchType = MOVE_DATA.adobeDTM.searchType; // Remove search Type condition oncce NearBy issue is fixed

  if (searchType == "school" && resultType) return resultType;
  if (resultCnt > 0) return "normal";
  if (resultNearByCnt > 0) return "nearby";

  return "no result";
};

/***/ }),

/***/ 96:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return setupClickTracking; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return trackClick; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__shares__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__phone_leads__ = __webpack_require__(626);
/* global RdcTracking */




var SAVE_SHARE_KEYWORDS = ['save', 'unsave', ':hide', ':unhide', ':calculate-commute'],
    PHOTO_KEYWORDS = ['photo:next', 'photo:prev', 'photo_next', 'photo_prev', 'photo_thumbnail', 'open-slideshow'];

var setupClickTracking = function setupClickTracking(pageName) {
  // Loading quick view calls the page load event, so this is in place so to not add this click handler multiple times.
  if (!window.rdcTrackingInitialized) {
    window.rdcTrackingInitialized = true;
    $(document).on('mouseup', function (e) {
      handleOmtag(e.target, pageName, 0);
      handlePhoneTracking(e.target);
    });
  }
};

var handleOmtag = function handleOmtag(target, pageName, count) {
  // allow digging into parent element up to 3 times as the omtag might not always be on the target but on the parent
  if (target && target.attributes['data-omtag']) {
    var omtag = target.attributes['data-omtag'].value;
    if (['fb', 'tw', 'pt', 'gp'].indexOf(omtag) >= 0) {
      __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_0__shares__["b" /* trackShare */])(omtag);
    } else {
      trackClick(omtag, pageName);
    }
  } else if (count < 3) {
    count++;
    if (target && target.parentElement) {
      handleOmtag(target.parentElement, pageName, count);
    }
  }
};

// trackClick is exported so that we can manually call it whenever the global click handler doesn't work.
var trackClick = function trackClick(omtag, pageName) {
  var eventName = 'click',
      linkName = omtag;
  if (omtag.includes("phone_lead")) {
    var dtm = MOVE_DATA.adobeDTM;

    var modifiedOmTag = leadPlacementHandler(omtag);

    var propertyStatus = dtm.propertyStatus,
        leadDelivery = dtm.listing && dtm.listing.leadDelivery,
        leadPlacement = modifiedOmTag,
        dataSourceType = dtm.dataSourceType;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__phone_leads__["a" /* trackPhoneLead */])(propertyStatus, leadDelivery, leadPlacement, dataSourceType);
  } else {
    if (isSpecialClick(omtag, PHOTO_KEYWORDS)) {
      eventName = 'highTrafficClick';
    } else if (isSpecialClick(omtag, SAVE_SHARE_KEYWORDS)) {
      linkName = pageName && omtagHasPageName(omtag, pageName) ? omtag : pageName + ':' + omtag;
    }
  }

  RdcTracking.trackEvent(eventName, { linkName: linkName });
};

var omtagHasPageName = function omtagHasPageName() {
  var omtag = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var pageName = arguments[1];

  return omtag.includes(pageName) || omtag.includes('for_sale') || omtag.includes('for_rent');
};

var isSpecialClick = function isSpecialClick(omtag) {
  var keywords = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];

  for (var i = 0; i < keywords.length; i++) {
    if (omtag.includes(keywords[i])) {
      return true;
    }
  }
  return false;
};

var handlePhoneTracking = function handlePhoneTracking(target) {
  var dtm = MOVE_DATA.adobeDTM;

  if (target && target.attributes['data-phone-click-tracking']) {
    var trackingTag = target.attributes['data-phone-click-tracking'].value;

    var modifiedtrackingTag = leadPlacementHandler(trackingTag);

    var propertyStatus = dtm.propertyStatus,
        leadDelivery = dtm.listing && dtm.listing.leadDelivery,
        leadPlacement = modifiedtrackingTag,
        dataSourceType = dtm.dataSourceType;
    __webpack_require__.i(__WEBPACK_IMPORTED_MODULE_1__phone_leads__["a" /* trackPhoneLead */])(propertyStatus, leadDelivery, leadPlacement, dataSourceType);
  }
};

var leadPlacementHandler = function leadPlacementHandler(trackingTag) {
  //Check for srp, qv or ldp and replace lead_placeholder
  var isSRP = document.getElementById('srp-list') ? true : false;
  var field = 'view';
  var url = window.location.href;
  var isLDPQV = url.indexOf('?' + field + '=') != -1;
  var isLDPModal = document.getElementById('ldpStickyBottomLeadModal') ? true : false;
  if (isLDPQV || isLDPModal) return trackingTag.replace("lead_placeholder", "ldp_modal_form");else if (isSRP) return trackingTag.replace("lead_placeholder", "srp_lead_form");else return trackingTag.replace("lead_placeholder", "ldp_exposed_form");
};

/***/ }),

/***/ 980:
/***/ (function(module, exports) {

MOVE.ADS = function (MOVE) {
  var retrieveKruxValue = function retrieveKruxValue(n) {
    var k = 'kx' + n;
    if (MOVE.LocalStorage.isAvailable) {
      return window.localStorage[k] || "";
    } else if (navigator.cookieEnabled) {
      return $.cookie(k);
    } else {
      return '';
    }
  };

  var initNavItemClickTrackingPixel = function initNavItemClickTrackingPixel() {
    var headerNavbar = $('#header-navbar');
    headerNavbar.find("a[data-omtag='header-menu:rent:geo-apartments'],a[data-omtag='header-menu:rent:apartments']").click(function () {
      MOVE.Medias.kruxPixel('KUbPeVsu', { listing_type: 'apt' });
      return true;
    });
    headerNavbar.find("a[data-omtag='header-menu:rent:geo-single-family-homes']").click(function () {
      MOVE.Medias.kruxPixel('KUbPeVsu', { listing_type: 'homes' });
      return true;
    });
    headerNavbar.find("a[data-omtag='header-menu:rent:geo-condo/townhouses'],a[data-omtag='header-menu:rent:condo/townhouses']").click(function () {
      MOVE.Medias.kruxPixel('KUbPeVsu', { listing_type: 'condo' });
      return true;
    });
    headerNavbar.find("a[data-omtag='header-menu:rent:all-geo-rentals'],a[data-omtag='header-menu:rent:all-rentals']").click(function () {
      MOVE.Medias.kruxPixel('KUbPeVsu', { listing_type: 'all' });
      return true;
    });
  };

  var init = function init() {
    window.Krux.user = retrieveKruxValue('user');
    window.Krux.segments = retrieveKruxValue('segs') && retrieveKruxValue('segs').split(',') || [];
    window.kxdl = {};

    window.addEventListener("load", initNavItemClickTrackingPixel);
  };

  MOVE.ADS = {
    init: init
  };
  return MOVE.ADS;
}(MOVE || {});
MOVE.ADS.init();

/***/ })

/******/ });


// WEBPACK FOOTER //
// application_critical-263851e1e65d9a7a6899.js